webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(293);
	
	__webpack_require__(295);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(211);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(291);
	__webpack_require__(292);
	module.exports = __webpack_require__(9);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(4)
	  , has            = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , META           = __webpack_require__(22).KEY
	  , $fails         = __webpack_require__(7)
	  , shared         = __webpack_require__(23)
	  , setToStringTag = __webpack_require__(24)
	  , uid            = __webpack_require__(19)
	  , wks            = __webpack_require__(25)
	  , wksExt         = __webpack_require__(26)
	  , wksDefine      = __webpack_require__(27)
	  , keyOf          = __webpack_require__(29)
	  , enumKeys       = __webpack_require__(42)
	  , isArray        = __webpack_require__(45)
	  , anObject       = __webpack_require__(12)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , createDesc     = __webpack_require__(17)
	  , _create        = __webpack_require__(46)
	  , gOPNExt        = __webpack_require__(49)
	  , $GOPD          = __webpack_require__(51)
	  , $DP            = __webpack_require__(11)
	  , $keys          = __webpack_require__(30)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f  = $propertyIsEnumerable;
	  __webpack_require__(43).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(28)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 4 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 5 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , core      = __webpack_require__(9)
	  , hide      = __webpack_require__(10)
	  , redefine  = __webpack_require__(18)
	  , ctx       = __webpack_require__(20)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 9 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11)
	  , createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(12)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , toPrimitive    = __webpack_require__(16)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function(){
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , document = __webpack_require__(4).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , hide      = __webpack_require__(10)
	  , has       = __webpack_require__(5)
	  , SRC       = __webpack_require__(19)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 19 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(19)('meta')
	  , isObject = __webpack_require__(13)
	  , has      = __webpack_require__(5)
	  , setDesc  = __webpack_require__(11).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f
	  , has = __webpack_require__(5)
	  , TAG = __webpack_require__(25)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(23)('wks')
	  , uid        = __webpack_require__(19)
	  , Symbol     = __webpack_require__(4).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(4)
	  , core           = __webpack_require__(9)
	  , LIBRARY        = __webpack_require__(28)
	  , wksExt         = __webpack_require__(26)
	  , defineProperty = __webpack_require__(11).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(31)
	  , enumBugKeys = __webpack_require__(41);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(5)
	  , toIObject    = __webpack_require__(32)
	  , arrayIndexOf = __webpack_require__(36)(false)
	  , IE_PROTO     = __webpack_require__(40)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(33)
	  , defined = __webpack_require__(35);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37)
	  , toIndex   = __webpack_require__(39);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys')
	  , uid    = __webpack_require__(19);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30)
	  , gOPS    = __webpack_require__(43)
	  , pIE     = __webpack_require__(44);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 44 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(12)
	  , dPs         = __webpack_require__(47)
	  , enumBugKeys = __webpack_require__(41)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(48).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(11)
	  , anObject = __webpack_require__(12)
	  , getKeys  = __webpack_require__(30);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4).document && document.documentElement;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32)
	  , gOPN      = __webpack_require__(50).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(31)
	  , hiddenKeys = __webpack_require__(41).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(44)
	  , createDesc     = __webpack_require__(17)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , has            = __webpack_require__(5)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(46)});

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperty: __webpack_require__(11).f});

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperties: __webpack_require__(47)});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(32)
	  , $getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	__webpack_require__(56)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8)
	  , core    = __webpack_require__(9)
	  , fails   = __webpack_require__(7);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(58)
	  , $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(56)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(5)
	  , toObject    = __webpack_require__(58)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58)
	  , $keys    = __webpack_require__(30);
	
	__webpack_require__(56)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(56)('getOwnPropertyNames', function(){
	  return __webpack_require__(49).f;
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;
	
	__webpack_require__(56)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(69)});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(30)
	  , gOPS     = __webpack_require__(43)
	  , pIE      = __webpack_require__(44)
	  , toObject = __webpack_require__(58)
	  , IObject  = __webpack_require__(33)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {is: __webpack_require__(71)});

/***/ },
/* 71 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(73).set});

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13)
	  , anObject = __webpack_require__(12);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75)
	  , test    = {};
	test[__webpack_require__(25)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(18)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34)
	  , TAG = __webpack_require__(25)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', {bind: __webpack_require__(77)});

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(21)
	  , isObject   = __webpack_require__(13)
	  , invoke     = __webpack_require__(78)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11).f
	  , createDesc = __webpack_require__(17)
	  , has        = __webpack_require__(5)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(13)
	  , getPrototypeOf = __webpack_require__(59)
	  , HAS_INSTANCE   = __webpack_require__(25)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(11).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt
	  , $trim     = __webpack_require__(83).trim
	  , ws        = __webpack_require__(84)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , defined = __webpack_require__(35)
	  , fails   = __webpack_require__(7)
	  , spaces  = __webpack_require__(84)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat
	  , $trim       = __webpack_require__(83).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , has               = __webpack_require__(5)
	  , cof               = __webpack_require__(34)
	  , inheritIfRequired = __webpack_require__(88)
	  , toPrimitive       = __webpack_require__(16)
	  , fails             = __webpack_require__(7)
	  , gOPN              = __webpack_require__(50).f
	  , gOPD              = __webpack_require__(51).f
	  , dP                = __webpack_require__(11).f
	  , $trim             = __webpack_require__(83).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(46)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(13)
	  , setPrototypeOf = __webpack_require__(73).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , toInteger    = __webpack_require__(38)
	  , aNumberValue = __webpack_require__(90)
	  , repeat       = __webpack_require__(91)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $fails       = __webpack_require__(7)
	  , aNumberValue = __webpack_require__(90)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(8)
	  , _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(96)});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(8)
	  , isInteger = __webpack_require__(96)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8)
	  , log1p   = __webpack_require__(104)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 104 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8)
	  , sign    = __webpack_require__(108);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 108 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8)
	  , $expm1  = __webpack_require__(112);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 112 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(8)
	  , sign      = __webpack_require__(108)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(104)});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {sign: __webpack_require__(108)});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(8)
	  , toIndex        = __webpack_require__(39)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(127)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(128)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(28)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , hide           = __webpack_require__(10)
	  , has            = __webpack_require__(5)
	  , Iterators      = __webpack_require__(129)
	  , $iterCreate    = __webpack_require__(130)
	  , setToStringTag = __webpack_require__(24)
	  , getPrototypeOf = __webpack_require__(59)
	  , ITERATOR       = __webpack_require__(25)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(46)
	  , descriptor     = __webpack_require__(17)
	  , setToStringTag = __webpack_require__(24)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(25)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(8)
	  , toLength  = __webpack_require__(37)
	  , context   = __webpack_require__(133)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(134)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13)
	  , cof      = __webpack_require__(34)
	  , MATCH    = __webpack_require__(25)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(25)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(8)
	  , context  = __webpack_require__(133)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(135)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(8)
	  , toLength    = __webpack_require__(37)
	  , context     = __webpack_require__(133)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(140)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , defined = __webpack_require__(35)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(140)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(140)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(140)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(140)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(140)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(140)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(140)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(140)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(140)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(140)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(140)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(140)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(8)
	  , toObject    = __webpack_require__(58)
	  , toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(18)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(158));

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(45)});

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(20)
	  , $export        = __webpack_require__(8)
	  , toObject       = __webpack_require__(58)
	  , call           = __webpack_require__(161)
	  , isArrayIter    = __webpack_require__(162)
	  , toLength       = __webpack_require__(37)
	  , createProperty = __webpack_require__(163)
	  , getIterFn      = __webpack_require__(164);
	
	$export($export.S + $export.F * !__webpack_require__(165)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(129)
	  , ITERATOR   = __webpack_require__(25)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11)
	  , createDesc      = __webpack_require__(17);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(75)
	  , ITERATOR  = __webpack_require__(25)('iterator')
	  , Iterators = __webpack_require__(129);
	module.exports = __webpack_require__(9).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(25)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(8)
	  , createProperty = __webpack_require__(163);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(33) != Object || !__webpack_require__(168)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(7);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(8)
	  , html       = __webpack_require__(48)
	  , cof        = __webpack_require__(34)
	  , toIndex    = __webpack_require__(39)
	  , toLength   = __webpack_require__(37)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , fails     = __webpack_require__(7)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(168)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(8)
	  , $forEach = __webpack_require__(172)(0)
	  , STRICT   = __webpack_require__(168)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(20)
	  , IObject  = __webpack_require__(33)
	  , toObject = __webpack_require__(58)
	  , toLength = __webpack_require__(37)
	  , asc      = __webpack_require__(173);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(174);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , isArray  = __webpack_require__(45)
	  , SPECIES  = __webpack_require__(25)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $map    = __webpack_require__(172)(1);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $filter = __webpack_require__(172)(2);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $some   = __webpack_require__(172)(3);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $every  = __webpack_require__(172)(4);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , IObject   = __webpack_require__(33)
	  , toLength  = __webpack_require__(37);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);
	
	$export($export.P + $export.F * !__webpack_require__(168)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , $indexOf      = __webpack_require__(36)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , toIObject     = __webpack_require__(32)
	  , toInteger     = __webpack_require__(38)
	  , toLength      = __webpack_require__(37)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(185)});
	
	__webpack_require__(186)('copyWithin');

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(25)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', {fill: __webpack_require__(188)});
	
	__webpack_require__(186)('fill');

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(192)('Array');

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(4)
	  , dP          = __webpack_require__(11)
	  , DESCRIPTORS = __webpack_require__(6)
	  , SPECIES     = __webpack_require__(25)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(186)
	  , step             = __webpack_require__(194)
	  , Iterators        = __webpack_require__(129)
	  , toIObject        = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(128)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 194 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(4)
	  , inheritIfRequired = __webpack_require__(88)
	  , dP                = __webpack_require__(11).f
	  , gOPN              = __webpack_require__(50).f
	  , isRegExp          = __webpack_require__(134)
	  , $flags            = __webpack_require__(196)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function(){
	  re2[__webpack_require__(25)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(192)('RegExp');

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(198);
	var anObject    = __webpack_require__(12)
	  , $flags      = __webpack_require__(196)
	  , DESCRIPTORS = __webpack_require__(6)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(7)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(6) && /./g.flags != 'g')__webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(196)
	});

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(200)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(10)
	  , redefine = __webpack_require__(18)
	  , fails    = __webpack_require__(7)
	  , defined  = __webpack_require__(35)
	  , wks      = __webpack_require__(25);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(200)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(200)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(200)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(134)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(28)
	  , global             = __webpack_require__(4)
	  , ctx                = __webpack_require__(20)
	  , classof            = __webpack_require__(75)
	  , $export            = __webpack_require__(8)
	  , isObject           = __webpack_require__(13)
	  , aFunction          = __webpack_require__(21)
	  , anInstance         = __webpack_require__(205)
	  , forOf              = __webpack_require__(206)
	  , speciesConstructor = __webpack_require__(207)
	  , task               = __webpack_require__(208).set
	  , microtask          = __webpack_require__(209)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(210)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(24)($Promise, PROMISE);
	__webpack_require__(192)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(165)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(20)
	  , call        = __webpack_require__(161)
	  , isArrayIter = __webpack_require__(162)
	  , anObject    = __webpack_require__(12)
	  , toLength    = __webpack_require__(37)
	  , getIterFn   = __webpack_require__(164)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(12)
	  , aFunction = __webpack_require__(21)
	  , SPECIES   = __webpack_require__(25)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(20)
	  , invoke             = __webpack_require__(78)
	  , html               = __webpack_require__(48)
	  , cel                = __webpack_require__(15)
	  , global             = __webpack_require__(4)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(34)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , macrotask = __webpack_require__(208).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(213)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(11).f
	  , create      = __webpack_require__(46)
	  , redefineAll = __webpack_require__(210)
	  , ctx         = __webpack_require__(20)
	  , anInstance  = __webpack_require__(205)
	  , defined     = __webpack_require__(35)
	  , forOf       = __webpack_require__(206)
	  , $iterDefine = __webpack_require__(128)
	  , step        = __webpack_require__(194)
	  , setSpecies  = __webpack_require__(192)
	  , DESCRIPTORS = __webpack_require__(6)
	  , fastKey     = __webpack_require__(22).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , $export           = __webpack_require__(8)
	  , redefine          = __webpack_require__(18)
	  , redefineAll       = __webpack_require__(210)
	  , meta              = __webpack_require__(22)
	  , forOf             = __webpack_require__(206)
	  , anInstance        = __webpack_require__(205)
	  , isObject          = __webpack_require__(13)
	  , fails             = __webpack_require__(7)
	  , $iterDetect       = __webpack_require__(165)
	  , setToStringTag    = __webpack_require__(24)
	  , inheritIfRequired = __webpack_require__(88);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(213)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(172)(0)
	  , redefine     = __webpack_require__(18)
	  , meta         = __webpack_require__(22)
	  , assign       = __webpack_require__(69)
	  , weak         = __webpack_require__(216)
	  , isObject     = __webpack_require__(13)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(213)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(210)
	  , getWeak           = __webpack_require__(22).getWeak
	  , anObject          = __webpack_require__(12)
	  , isObject          = __webpack_require__(13)
	  , anInstance        = __webpack_require__(205)
	  , forOf             = __webpack_require__(206)
	  , createArrayMethod = __webpack_require__(172)
	  , $has              = __webpack_require__(5)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(216);
	
	// 23.4 WeakSet Objects
	__webpack_require__(213)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $typed       = __webpack_require__(219)
	  , buffer       = __webpack_require__(220)
	  , anObject     = __webpack_require__(12)
	  , toIndex      = __webpack_require__(39)
	  , toLength     = __webpack_require__(37)
	  , isObject     = __webpack_require__(13)
	  , ArrayBuffer  = __webpack_require__(4).ArrayBuffer
	  , speciesConstructor = __webpack_require__(207)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(192)(ARRAY_BUFFER);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , hide   = __webpack_require__(10)
	  , uid    = __webpack_require__(19)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(4)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , LIBRARY        = __webpack_require__(28)
	  , $typed         = __webpack_require__(219)
	  , hide           = __webpack_require__(10)
	  , redefineAll    = __webpack_require__(210)
	  , fails          = __webpack_require__(7)
	  , anInstance     = __webpack_require__(205)
	  , toInteger      = __webpack_require__(38)
	  , toLength       = __webpack_require__(37)
	  , gOPN           = __webpack_require__(50).f
	  , dP             = __webpack_require__(11).f
	  , arrayFill      = __webpack_require__(188)
	  , setToStringTag = __webpack_require__(24)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(219).ABV, {
	  DataView: __webpack_require__(220).DataView
	});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(6)){
	  var LIBRARY             = __webpack_require__(28)
	    , global              = __webpack_require__(4)
	    , fails               = __webpack_require__(7)
	    , $export             = __webpack_require__(8)
	    , $typed              = __webpack_require__(219)
	    , $buffer             = __webpack_require__(220)
	    , ctx                 = __webpack_require__(20)
	    , anInstance          = __webpack_require__(205)
	    , propertyDesc        = __webpack_require__(17)
	    , hide                = __webpack_require__(10)
	    , redefineAll         = __webpack_require__(210)
	    , toInteger           = __webpack_require__(38)
	    , toLength            = __webpack_require__(37)
	    , toIndex             = __webpack_require__(39)
	    , toPrimitive         = __webpack_require__(16)
	    , has                 = __webpack_require__(5)
	    , same                = __webpack_require__(71)
	    , classof             = __webpack_require__(75)
	    , isObject            = __webpack_require__(13)
	    , toObject            = __webpack_require__(58)
	    , isArrayIter         = __webpack_require__(162)
	    , create              = __webpack_require__(46)
	    , getPrototypeOf      = __webpack_require__(59)
	    , gOPN                = __webpack_require__(50).f
	    , getIterFn           = __webpack_require__(164)
	    , uid                 = __webpack_require__(19)
	    , wks                 = __webpack_require__(25)
	    , createArrayMethod   = __webpack_require__(172)
	    , createArrayIncludes = __webpack_require__(36)
	    , speciesConstructor  = __webpack_require__(207)
	    , ArrayIterators      = __webpack_require__(193)
	    , Iterators           = __webpack_require__(129)
	    , $iterDetect         = __webpack_require__(165)
	    , setSpecies          = __webpack_require__(192)
	    , arrayFill           = __webpack_require__(188)
	    , arrayCopyWithin     = __webpack_require__(185)
	    , $DP                 = __webpack_require__(11)
	    , $GOPD               = __webpack_require__(51)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , anObject  = __webpack_require__(12)
	  , rApply    = (__webpack_require__(4).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(8)
	  , create     = __webpack_require__(46)
	  , aFunction  = __webpack_require__(21)
	  , anObject   = __webpack_require__(12)
	  , isObject   = __webpack_require__(13)
	  , fails      = __webpack_require__(7)
	  , bind       = __webpack_require__(77)
	  , rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(11)
	  , $export     = __webpack_require__(8)
	  , anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(8)
	  , gOPD     = __webpack_require__(51).f
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(130)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , isObject       = __webpack_require__(13)
	  , anObject       = __webpack_require__(12);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(51)
	  , $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(8)
	  , getProto = __webpack_require__(59)
	  , anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(8)
	  , anObject      = __webpack_require__(12)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(243)});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(50)
	  , gOPS     = __webpack_require__(43)
	  , anObject = __webpack_require__(12)
	  , Reflect  = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(8)
	  , anObject           = __webpack_require__(12)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(11)
	  , gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , createDesc     = __webpack_require__(17)
	  , anObject       = __webpack_require__(12)
	  , isObject       = __webpack_require__(13);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(8)
	  , setProto = __webpack_require__(73);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(8)
	  , $includes = __webpack_require__(36)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(186)('includes');

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37)
	  , repeat   = __webpack_require__(91)
	  , defined  = __webpack_require__(35);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(8)
	  , defined     = __webpack_require__(35)
	  , toLength    = __webpack_require__(37)
	  , isRegExp    = __webpack_require__(134)
	  , getFlags    = __webpack_require__(196)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(130)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(27)('asyncIterator');

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(27)('observable');

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(8)
	  , ownKeys        = __webpack_require__(243)
	  , toIObject      = __webpack_require__(32)
	  , gOPD           = __webpack_require__(51)
	  , createProperty = __webpack_require__(163);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8)
	  , $values = __webpack_require__(259)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32)
	  , isEnum    = __webpack_require__(44).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(8)
	  , $entries = __webpack_require__(259)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(28)|| !__webpack_require__(7)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(4)[K];
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(267)('Map')});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75)
	  , from    = __webpack_require__(268);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(206);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(267)('Set')});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', {global: __webpack_require__(4)});

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8)
	  , cof     = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(211)
	  , $export = __webpack_require__(8)
	  , shared  = __webpack_require__(23)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(215)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(214)
	  , from                    = __webpack_require__(268)
	  , metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , getPrototypeOf          = __webpack_require__(59)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , aFunction                 = __webpack_require__(21)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(8)
	  , microtask = __webpack_require__(209)()
	  , process   = __webpack_require__(4).process
	  , isNode    = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(8)
	  , global      = __webpack_require__(4)
	  , core        = __webpack_require__(9)
	  , microtask   = __webpack_require__(209)()
	  , OBSERVABLE  = __webpack_require__(25)('observable')
	  , aFunction   = __webpack_require__(21)
	  , anObject    = __webpack_require__(12)
	  , anInstance  = __webpack_require__(205)
	  , redefineAll = __webpack_require__(210)
	  , hide        = __webpack_require__(10)
	  , forOf       = __webpack_require__(206)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(192)('Observable');

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(4)
	  , $export    = __webpack_require__(8)
	  , invoke     = __webpack_require__(78)
	  , partial    = __webpack_require__(289)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(290)
	  , invoke    = __webpack_require__(78)
	  , aFunction = __webpack_require__(21);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , $task   = __webpack_require__(208);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(193)
	  , redefine      = __webpack_require__(18)
	  , global        = __webpack_require__(4)
	  , hide          = __webpack_require__(10)
	  , Iterators     = __webpack_require__(129)
	  , wks           = __webpack_require__(25)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(294)))

/***/ },
/* 294 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(296);
	module.exports = __webpack_require__(9).RegExp.escape;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8)
	  , $re     = __webpack_require__(297)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 297 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularSanitize = __webpack_require__(372);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	__webpack_require__(374);
	
	__webpack_require__(376);
	
	__webpack_require__(378);
	
	__webpack_require__(380);
	
	__webpack_require__(382);
	
	var _angularPermission = __webpack_require__(384);
	
	var _highcharts = __webpack_require__(388);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _exporting = __webpack_require__(389);
	
	var _exporting2 = _interopRequireDefault(_exporting);
	
	var _drilldown = __webpack_require__(390);
	
	var _drilldown2 = _interopRequireDefault(_drilldown);
	
	__webpack_require__(391);
	
	var _angularMaterialDataTable = __webpack_require__(393);
	
	var _angularMaterialDataTable2 = _interopRequireDefault(_angularMaterialDataTable);
	
	__webpack_require__(395);
	
	__webpack_require__(396);
	
	var _environment = __webpack_require__(397);
	
	var _environment2 = _interopRequireDefault(_environment);
	
	var _root = __webpack_require__(398);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _common = __webpack_require__(400);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(434);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _materialTheme = __webpack_require__(755);
	
	var _materialTheme2 = _interopRequireDefault(_materialTheme);
	
	var _http = __webpack_require__(756);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _httpTransform = __webpack_require__(757);
	
	var _httpTransform2 = _interopRequireDefault(_httpTransform);
	
	var _permissions = __webpack_require__(758);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	__webpack_require__(759);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _exporting2.default)(_highcharts2.default);
	// import highchartsTheme from './config/highcharts-theme';
	
	(0, _drilldown2.default)(_highcharts2.default);
	// Highcharts.theme = highchartsTheme;
	// Highcharts.setOptions(highchartsTheme);
	window.Highcharts = _highcharts2.default; // necessary for https://github.com/highcharts/highcharts/issues/4994
	
	exports.default = _angular2.default.module('root', [_angularUiRouter2.default, _angularSanitize2.default, 'LocalStorageModule', 'ngMaterial', 'highcharts-ng', 'ngAnimate', 'ngMessages', 'ame.lightbox', 'ngFileUpload', _angularPermission.permission, _angularPermission.uiPermission, _angularMaterialDataTable2.default, _common2.default, _components2.default]).component('root', _root2.default).config(_materialTheme2.default).config(['$httpProvider', _http2.default]).config(['$httpProvider', _httpTransform2.default]).config(["$locationProvider", function ($locationProvider) {
	  'ngInject';
	
	  $locationProvider.html5Mode(true);
	}]).config(["$compileProvider", function ($compileProvider) {
	  'ngInject';
	
	  $compileProvider.debugInfoEnabled(_environment2.default.debugInfoEnabled);
	  $compileProvider.preAssignBindingsEnabled(true);
	}]).run(_permissions2.default).run(["$state", "$transitions", "LoadingService", "ToastService", function ($state, $transitions, LoadingService, ToastService) {
	  'ngInject';
	
	  $transitions.onStart({}, function (trans) {
	    LoadingService.start();
	    trans.promise.finally(function () {
	      return LoadingService.stop();
	    });
	  });
	
	  $state.defaultErrorHandler(function (error) {
	    // Ignore transition errors
	    if (error && error.message && error.message === 'The transition has been superseded by a different transition') {
	      return;
	    }
	
	    ToastService.showError(error);
	  });
	}]).name;

/***/ },
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.12 (2017-05-24)
	 Exporting module
	
	 (c) 2010-2017 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(k){"object"===typeof module&&module.exports?module.exports=k:k(Highcharts)})(function(k){(function(f){var k=f.defaultOptions,p=f.doc,A=f.Chart,w=f.addEvent,I=f.removeEvent,E=f.fireEvent,t=f.createElement,B=f.discardElement,v=f.css,n=f.merge,C=f.pick,h=f.each,F=f.objectEach,u=f.extend,J=f.isTouchDevice,D=f.win,G=D.navigator.userAgent,K=f.Renderer.prototype.symbols;/Edge\/|Trident\/|MSIE /.test(G);/firefox/i.test(G);u(k.lang,{printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",
	downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});k.navigation={buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}};n(!0,k.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",background:"none",color:"#333333",fontSize:J?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",
	color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{fill:"#ffffff",stroke:"none",padding:5}}});k.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",_titleKey:"contextButtonTitle",menuItems:[{textKey:"printChart",onclick:function(){this.print()}},{separator:!0},{textKey:"downloadPNG",onclick:function(){this.exportChart()}},
	{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}]}}};f.post=function(a,b,e){var c=t("form",n({method:"post",action:a,enctype:"multipart/form-data"},e),{display:"none"},p.body);F(b,function(a,b){t("input",{type:"hidden",name:b,value:a},null,c)});c.submit();B(c)};u(A.prototype,{sanitizeSVG:function(a,
	b){if(b&&b.exporting&&b.exporting.allowHTML){var e=a.match(/<\/svg>(.*?$)/);e&&e[1]&&(e='\x3cforeignObject x\x3d"0" y\x3d"0" width\x3d"'+b.chart.width+'" height\x3d"'+b.chart.height+'"\x3e\x3cbody xmlns\x3d"http://www.w3.org/1999/xhtml"\x3e'+e[1]+"\x3c/body\x3e\x3c/foreignObject\x3e",a=a.replace("\x3c/svg\x3e",e+"\x3c/svg\x3e"))}a=a.replace(/zIndex="[^"]+"/g,"").replace(/isShadow="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(\S+)("|&quot;)\)/g,
	"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'\x3csvg xmlns:xlink\x3d"http://www.w3.org/1999/xlink" ').replace(/ (NS[0-9]+\:)?href=/g," xlink:href\x3d").replace(/\n/," ").replace(/<\/svg>.*?$/,"\x3c/svg\x3e").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1\x3d"rgb($2)" $1-opacity\x3d"$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");return a=a.replace(/<IMG /g,"\x3cimage ").replace(/<(\/?)TITLE>/g,"\x3c$1title\x3e").replace(/height=([^" ]+)/g,
	'height\x3d"$1"').replace(/width=([^" ]+)/g,'width\x3d"$1"').replace(/hc-svg-href="([^"]+)">/g,'xlink:href\x3d"$1"/\x3e').replace(/ id=([^" >]+)/g,' id\x3d"$1"').replace(/class=([^" >]+)/g,'class\x3d"$1"').replace(/ transform /g," ").replace(/:(path|rect)/g,"$1").replace(/style="([^"]+)"/g,function(a){return a.toLowerCase()})},getChartHTML:function(){return this.container.innerHTML},getSVG:function(a){var b,e,c,r,m,g=n(this.options,a);p.createElementNS||(p.createElementNS=function(a,b){return p.createElement(b)});
	e=t("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},p.body);c=this.renderTo.style.width;m=this.renderTo.style.height;c=g.exporting.sourceWidth||g.chart.width||/px$/.test(c)&&parseInt(c,10)||600;m=g.exporting.sourceHeight||g.chart.height||/px$/.test(m)&&parseInt(m,10)||400;u(g.chart,{animation:!1,renderTo:e,forExport:!0,renderer:"SVGRenderer",width:c,height:m});g.exporting.enabled=!1;delete g.data;g.series=[];h(this.series,function(a){r=n(a.userOptions,
	{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});r.isInternal||g.series.push(r)});h(this.axes,function(a){a.userOptions.internalKey||(a.userOptions.internalKey=f.uniqueKey())});b=new f.Chart(g,this.callback);a&&h(["xAxis","yAxis","series"],function(c){var d={};a[c]&&(d[c]=a[c],b.update(d))});h(this.axes,function(a){var c=f.find(b.axes,function(b){return b.options.internalKey===a.userOptions.internalKey}),d=a.getExtremes(),e=d.userMin,d=d.userMax;!c||void 0===e&&void 0===d||
	c.setExtremes(e,d,!0,!1)});c=b.getChartHTML();c=this.sanitizeSVG(c,g);g=null;b.destroy();B(e);return c},getSVGForExport:function(a,b){var e=this.options.exporting;return this.getSVG(n({chart:{borderRadius:0}},e.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||e.sourceWidth,sourceHeight:a&&a.sourceHeight||e.sourceHeight}}))},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=n(this.options.exporting,a);f.post(a.url,{filename:a.filename||"chart",type:a.type,width:a.width||0,scale:a.scale,
	svg:b},a.formAttributes)},print:function(){var a=this,b=a.container,e=[],c=b.parentNode,f=p.body,m=f.childNodes,g=a.options.exporting.printMaxWidth,d,H;if(!a.isPrinting){a.isPrinting=!0;a.pointer.reset(null,0);E(a,"beforePrint");if(H=g&&a.chartWidth>g)d=[a.options.chart.width,void 0,!1],a.setSize(g,void 0,!1);h(m,function(a,b){1===a.nodeType&&(e[b]=a.style.display,a.style.display="none")});f.appendChild(b);D.focus();D.print();setTimeout(function(){c.appendChild(b);h(m,function(a,b){1===a.nodeType&&
	(a.style.display=e[b])});a.isPrinting=!1;H&&a.setSize.apply(a,d);E(a,"afterPrint")},1E3)}},contextMenu:function(a,b,e,c,f,m,g){var d=this,r=d.options.navigation,k=d.chartWidth,q=d.chartHeight,n="cache-"+a,l=d[n],x=Math.max(f,m),y,z;l||(d[n]=l=t("div",{className:a},{position:"absolute",zIndex:1E3,padding:x+"px"},d.container),y=t("div",{className:"highcharts-menu"},null,l),v(y,u({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},r.menuStyle)),z=function(){v(l,
	{display:"none"});g&&g.setState(0);d.openMenu=!1},d.exportEvents.push(w(l,"mouseleave",function(){l.hideTimer=setTimeout(z,500)}),w(l,"mouseenter",function(){clearTimeout(l.hideTimer)}),w(p,"mouseup",function(b){d.pointer.inClass(b.target,a)||z()})),h(b,function(a){if(a){var b;a.separator?b=t("hr",null,null,y):(b=t("div",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();z();a.onclick&&a.onclick.apply(d,arguments)},innerHTML:a.text||d.options.lang[a.textKey]},null,y),b.onmouseover=
	function(){v(this,r.menuItemHoverStyle)},b.onmouseout=function(){v(this,r.menuItemStyle)},v(b,u({cursor:"pointer"},r.menuItemStyle)));d.exportDivElements.push(b)}}),d.exportDivElements.push(y,l),d.exportMenuWidth=l.offsetWidth,d.exportMenuHeight=l.offsetHeight);b={display:"block"};e+d.exportMenuWidth>k?b.right=k-e-f-x+"px":b.left=e-x+"px";c+m+d.exportMenuHeight>q&&"top"!==g.alignOptions.verticalAlign?b.bottom=q-c-x+"px":b.top=c+m-x+"px";v(l,b);d.openMenu=!0},addButton:function(a){var b=this,e=b.renderer,
	c=n(b.options.navigation.buttonOptions,a),f=c.onclick,m=c.menuItems,g,d,k=c.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==c.enabled){var h=c.theme,q=h.states,p=q&&q.hover,q=q&&q.select,l;delete h.states;f?l=function(a){a.stopPropagation();f.call(b,a)}:m&&(l=function(){b.contextMenu(d.menuClassName,m,d.translateX,d.translateY,d.width,d.height,d);d.setState(2)});c.text&&c.symbol?h.paddingLeft=C(h.paddingLeft,25):c.text||u(h,{width:c.width,
	height:c.height,padding:0});d=e.button(c.text,0,0,l,h,p,q).addClass(a.className).attr({"stroke-linecap":"round",title:b.options.lang[c._titleKey],zIndex:3});d.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;c.symbol&&(g=e.symbol(c.symbol,c.symbolX-k/2,c.symbolY-k/2,k,k).addClass("highcharts-button-symbol").attr({zIndex:1}).add(d),g.attr({stroke:c.symbolStroke,fill:c.symbolFill,"stroke-width":c.symbolStrokeWidth||1}));d.add().align(u(c,{width:d.width,x:C(c.x,b.buttonOffset)}),!0,"spacingBox");
	b.buttonOffset+=(d.width+c.buttonSpacing)*("right"===c.align?-1:1);b.exportSVGElements.push(d,g)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var e=b.exportDivElements,c=b.exportEvents,f;a&&(h(a,function(a,c){a&&(a.onclick=a.ontouchstart=null,f="cache-"+a.menuClassName,b[f]&&delete b[f],b.exportSVGElements[c]=a.destroy())}),a.length=0);e&&(h(e,function(a,c){clearTimeout(a.hideTimer);I(a,"mouseleave");b.exportDivElements[c]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=
	null;B(a)}),e.length=0);c&&(h(c,function(a){a()}),c.length=0)}});K.menu=function(a,b,e,c){return["M",a,b+2.5,"L",a+e,b+2.5,"M",a,b+c/2+.5,"L",a+e,b+c/2+.5,"M",a,b+c-1.5,"L",a+e,b+c-1.5]};A.prototype.renderExporting=function(){var a=this,b=a.options.exporting,e=b.buttons,c=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();c&&!1!==b.enabled&&(a.exportEvents=[],F(e,function(b){a.addButton(b)}),a.isDirtyExporting=!1);w(a,"destroy",a.destroyExport)};A.prototype.callbacks.push(function(a){a.renderExporting();
	w(a,"redraw",a.renderExporting);h(["exporting","navigation"],function(b){a[b]={update:function(e,c){a.isDirtyExporting=!0;n(!0,a.options[b],e);C(c,!0)&&a.redraw()}}})})})(k)});


/***/ },
/* 390 */
/***/ function(module, exports) {

	/*
	 Highcharts JS v5.0.12 (2017-05-24)
	 Highcharts Drilldown module
	
	 Author: Torstein Honsi
	 License: www.highcharts.com/license
	
	*/
	(function(n){"object"===typeof module&&module.exports?module.exports=n:n(Highcharts)})(function(n){(function(f){var n=f.noop,y=f.color,z=f.defaultOptions,h=f.each,p=f.extend,G=f.format,A=f.objectEach,B=f.pick,u=f.wrap,q=f.Chart,v=f.seriesTypes,C=v.pie,r=v.column,D=f.Tick,w=f.fireEvent,E=f.inArray,F=1;p(z.lang,{drillUpText:"\u25c1 Back to {series.name}"});z.drilldown={activeAxisLabelStyle:{cursor:"pointer",color:"#003399",fontWeight:"bold",textDecoration:"underline"},activeDataLabelStyle:{cursor:"pointer",
	color:"#003399",fontWeight:"bold",textDecoration:"underline"},animation:{duration:500},drillUpButton:{position:{align:"right",x:-10,y:10}}};f.SVGRenderer.prototype.Element.prototype.fadeIn=function(b){this.attr({opacity:.1,visibility:"inherit"}).animate({opacity:B(this.newOpacity,1)},b||{duration:250})};q.prototype.addSeriesAsDrilldown=function(b,a){this.addSingleSeriesAsDrilldown(b,a);this.applyDrilldown()};q.prototype.addSingleSeriesAsDrilldown=function(b,a){var d=b.series,c=d.xAxis,e=d.yAxis,g,
	l=[],k=[],t,m,x;x={color:b.color||d.color};this.drilldownLevels||(this.drilldownLevels=[]);t=d.options._levelNumber||0;(m=this.drilldownLevels[this.drilldownLevels.length-1])&&m.levelNumber!==t&&(m=void 0);a=p(p({_ddSeriesId:F++},x),a);g=E(b,d.points);h(d.chart.series,function(a){a.xAxis!==c||a.isDrilling||(a.options._ddSeriesId=a.options._ddSeriesId||F++,a.options._colorIndex=a.userOptions._colorIndex,a.options._levelNumber=a.options._levelNumber||t,m?(l=m.levelSeries,k=m.levelSeriesOptions):(l.push(a),
	k.push(a.options)))});b=p({levelNumber:t,seriesOptions:d.options,levelSeriesOptions:k,levelSeries:l,shapeArgs:b.shapeArgs,bBox:b.graphic?b.graphic.getBBox():{},color:b.isNull?(new f.Color(y)).setOpacity(0).get():y,lowerSeriesOptions:a,pointOptions:d.options.data[g],pointIndex:g,oldExtremes:{xMin:c&&c.userMin,xMax:c&&c.userMax,yMin:e&&e.userMin,yMax:e&&e.userMax}},x);this.drilldownLevels.push(b);c&&c.names&&(c.names.length=0);a=b.lowerSeries=this.addSeries(a,!1);a.options._levelNumber=t+1;c&&(c.oldPos=
	c.pos,c.userMin=c.userMax=null,e.userMin=e.userMax=null);d.type===a.type&&(a.animate=a.animateDrilldown||n,a.options.animation=!0)};q.prototype.applyDrilldown=function(){var b=this.drilldownLevels,a;b&&0<b.length&&(a=b[b.length-1].levelNumber,h(this.drilldownLevels,function(b){b.levelNumber===a&&h(b.levelSeries,function(c){c.options&&c.options._levelNumber===a&&c.remove(!1)})}));this.redraw();this.showDrillUpButton()};q.prototype.getDrilldownBackText=function(){var b=this.drilldownLevels;if(b&&0<
	b.length)return b=b[b.length-1],b.series=b.seriesOptions,G(this.options.lang.drillUpText,b)};q.prototype.showDrillUpButton=function(){var b=this,a=this.getDrilldownBackText(),d=b.options.drilldown.drillUpButton,c,e;this.drillUpButton?this.drillUpButton.attr({text:a}).align():(e=(c=d.theme)&&c.states,this.drillUpButton=this.renderer.button(a,null,null,function(){b.drillUp()},c,e&&e.hover,e&&e.select).addClass("highcharts-drillup-button").attr({align:d.position.align,zIndex:7}).add().align(d.position,
	!1,d.relativeTo||"plotBox"))};q.prototype.drillUp=function(){for(var b=this,a=b.drilldownLevels,d=a[a.length-1].levelNumber,c=a.length,e=b.series,g,l,k,f,m=function(a){var c;h(e,function(b){b.options._ddSeriesId===a._ddSeriesId&&(c=b)});c=c||b.addSeries(a,!1);c.type===k.type&&c.animateDrillupTo&&(c.animate=c.animateDrillupTo);a===l.seriesOptions&&(f=c)};c--;)if(l=a[c],l.levelNumber===d){a.pop();k=l.lowerSeries;if(!k.chart)for(g=e.length;g--;)if(e[g].options.id===l.lowerSeriesOptions.id&&e[g].options._levelNumber===
	d+1){k=e[g];break}k.xData=[];h(l.levelSeriesOptions,m);w(b,"drillup",{seriesOptions:l.seriesOptions});f.type===k.type&&(f.drilldownLevel=l,f.options.animation=b.options.drilldown.animation,k.animateDrillupFrom&&k.chart&&k.animateDrillupFrom(l));f.options._levelNumber=d;k.remove(!1);f.xAxis&&(g=l.oldExtremes,f.xAxis.setExtremes(g.xMin,g.xMax,!1),f.yAxis.setExtremes(g.yMin,g.yMax,!1))}w(b,"drillupall");this.redraw();0===this.drilldownLevels.length?this.drillUpButton=this.drillUpButton.destroy():this.drillUpButton.attr({text:this.getDrilldownBackText()}).align();
	this.ddDupes.length=[]};r.prototype.supportsDrilldown=!0;r.prototype.animateDrillupTo=function(b){if(!b){var a=this,d=a.drilldownLevel;h(this.points,function(a){var c=a.dataLabel;a.graphic&&a.graphic.hide();c&&(c.hidden="hidden"===c.attr("visibility"),c.hidden||(c.hide(),a.connector&&a.connector.hide()))});setTimeout(function(){a.points&&h(a.points,function(a,b){b=b===(d&&d.pointIndex)?"show":"fadeIn";var c="show"===b?!0:void 0,e=a.dataLabel;if(a.graphic)a.graphic[b](c);if(e&&!e.hidden&&(e[b](c),
	a.connector))a.connector[b](c)})},Math.max(this.chart.options.drilldown.animation.duration-50,0));this.animate=n}};r.prototype.animateDrilldown=function(b){var a=this,d=this.chart.drilldownLevels,c,e=this.chart.options.drilldown.animation,g=this.xAxis;b||(h(d,function(b){a.options._ddSeriesId===b.lowerSeriesOptions._ddSeriesId&&(c=b.shapeArgs,c.fill=b.color)}),c.x+=B(g.oldPos,g.pos)-g.pos,h(this.points,function(b){b.shapeArgs.fill=b.color;b.graphic&&b.graphic.attr(c).animate(p(b.shapeArgs,{fill:b.color||
	a.color}),e);b.dataLabel&&b.dataLabel.fadeIn(e)}),this.animate=null)};r.prototype.animateDrillupFrom=function(b){var a=this.chart.options.drilldown.animation,d=this.group,c=d!==this.chart.seriesGroup,e=this;h(e.trackerGroups,function(a){if(e[a])e[a].on("mouseover")});c&&delete this.group;h(this.points,function(e){var g=e.graphic,k=b.shapeArgs,h=function(){g.destroy();d&&c&&(d=d.destroy())};g&&(delete e.graphic,k.fill=b.color,a?g.animate(k,f.merge(a,{complete:h})):(g.attr(k),h()))})};C&&p(C.prototype,
	{supportsDrilldown:!0,animateDrillupTo:r.prototype.animateDrillupTo,animateDrillupFrom:r.prototype.animateDrillupFrom,animateDrilldown:function(b){var a=this.chart.drilldownLevels[this.chart.drilldownLevels.length-1],d=this.chart.options.drilldown.animation,c=a.shapeArgs,e=c.start,g=(c.end-e)/this.points.length;b||(h(this.points,function(b,k){var h=b.shapeArgs;c.fill=a.color;h.fill=b.color;if(b.graphic)b.graphic.attr(f.merge(c,{start:e+k*g,end:e+(k+1)*g}))[d?"animate":"attr"](h,d)}),this.animate=
	null)}});f.Point.prototype.doDrilldown=function(b,a,d){var c=this.series.chart,e=c.options.drilldown,g=(e.series||[]).length,f;c.ddDupes||(c.ddDupes=[]);for(;g--&&!f;)e.series[g].id===this.drilldown&&-1===E(this.drilldown,c.ddDupes)&&(f=e.series[g],c.ddDupes.push(this.drilldown));w(c,"drilldown",{point:this,seriesOptions:f,category:a,originalEvent:d,points:void 0!==a&&this.series.xAxis.getDDPoints(a).slice(0)},function(a){var c=a.point.series&&a.point.series.chart,d=a.seriesOptions;c&&d&&(b?c.addSingleSeriesAsDrilldown(a.point,
	d):c.addSeriesAsDrilldown(a.point,d))})};f.Axis.prototype.drilldownCategory=function(b,a){A(this.getDDPoints(b),function(d){d&&d.series&&d.series.visible&&d.doDrilldown&&d.doDrilldown(!0,b,a)});this.chart.applyDrilldown()};f.Axis.prototype.getDDPoints=function(b){var a=[];h(this.series,function(d){var c,e=d.xData,f=d.points;for(c=0;c<e.length;c++)if(e[c]===b&&d.options.data[c]&&d.options.data[c].drilldown){a.push(f?f[c]:!0);break}});return a};D.prototype.drillable=function(){var b=this.pos,a=this.label,
	d=this.axis,c="xAxis"===d.coll&&d.getDDPoints,e=c&&d.getDDPoints(b);c&&(a&&e.length?(a.drillable=!0,a.basicStyles||(a.basicStyles=f.merge(a.styles)),a.addClass("highcharts-drilldown-axis-label").css(d.chart.options.drilldown.activeAxisLabelStyle).on("click",function(a){d.drilldownCategory(b,a)})):a&&a.drillable&&(a.styles={},a.css(a.basicStyles),a.on("click",null),a.removeClass("highcharts-drilldown-axis-label")))};u(D.prototype,"addLabel",function(b){b.call(this);this.drillable()});u(f.Point.prototype,
	"init",function(b,a,d,c){var e=b.call(this,a,d,c);c=(b=a.xAxis)&&b.ticks[c];e.drilldown&&f.addEvent(e,"click",function(b){a.xAxis&&!1===a.chart.options.drilldown.allowPointDrilldown?a.xAxis.drilldownCategory(e.x,b):e.doDrilldown(void 0,void 0,b)});c&&c.drillable();return e});u(f.Series.prototype,"drawDataLabels",function(b){var a=this.chart.options.drilldown.activeDataLabelStyle,d=this.chart.renderer;b.call(this);h(this.points,function(b){var c={};b.drilldown&&b.dataLabel&&("contrast"===a.color&&
	(c.color=d.getContrast(b.color||this.color)),b.dataLabel.addClass("highcharts-drilldown-data-label"),b.dataLabel.css(a).css(c))},this)});var H=function(b){b.call(this);h(this.points,function(a){a.drilldown&&a.graphic&&(a.graphic.addClass("highcharts-drilldown-point"),a.graphic.css({cursor:"pointer"}))})};A(v,function(b){b.prototype.supportsDrilldown&&u(b.prototype,"drawTracker",H)})})(n)});


/***/ },
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  debugInfoEnabled: false,
	  baseUrl: 'https://naersadmin.nasc.cc'
	};

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _root = __webpack_require__(399);
	
	var _root2 = _interopRequireDefault(_root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  templateUrl: _root2.default
	};

/***/ },
/* 399 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/root.html';
	var html = "<div flex layout=column> <div ui-view flex layout=column> <div flex layout=column layout-align=\"center center\" ng-if=$root.loadingView id=root-loading> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adverseEvents = __webpack_require__(401);
	
	var _adverseEvents2 = _interopRequireDefault(_adverseEvents);
	
	var _alert = __webpack_require__(403);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _animalType = __webpack_require__(404);
	
	var _animalType2 = _interopRequireDefault(_animalType);
	
	var _array = __webpack_require__(405);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _auth = __webpack_require__(406);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _category = __webpack_require__(407);
	
	var _category2 = _interopRequireDefault(_category);
	
	var _company = __webpack_require__(409);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _ingredient = __webpack_require__(410);
	
	var _ingredient2 = _interopRequireDefault(_ingredient);
	
	var _feedback = __webpack_require__(411);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _loading = __webpack_require__(412);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _people = __webpack_require__(413);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _product = __webpack_require__(414);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _regulator = __webpack_require__(415);
	
	var _regulator2 = _interopRequireDefault(_regulator);
	
	var _report = __webpack_require__(416);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _session = __webpack_require__(417);
	
	var _session2 = _interopRequireDefault(_session);
	
	var _toast = __webpack_require__(418);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _usageData = __webpack_require__(419);
	
	var _usageData2 = _interopRequireDefault(_usageData);
	
	var _directives = __webpack_require__(420);
	
	var _directives2 = _interopRequireDefault(_directives);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common', [_directives2.default]).service('AdverseEventsService', _adverseEvents2.default).service('AnimalTypeService', _animalType2.default).service('AlertService', _alert2.default).service('ArrayService', _array2.default).service('AuthService', _auth2.default).service('CategoryService', _category2.default).service('CompanyService', _company2.default).service('FeedbackService', _feedback2.default).service('IngredientService', _ingredient2.default).service('LoadingService', _loading2.default).service('PeopleService', _people2.default).service('ProductService', _product2.default).service('RegulatorService', _regulator2.default).service('ReportService', _report2.default).service('SessionService', _session2.default).service('ToastService', _toast2.default).service('UsageDataService', _usageData2.default).name;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _roles = __webpack_require__(402);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdverseEventsService = function () {
	  AdverseEventsService.$inject = ["$http"];
	  function AdverseEventsService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdverseEventsService);
	
	    this.$http = $http;
	  }
	
	  _createClass(AdverseEventsService, [{
	    key: 'setQuery',
	    value: function setQuery(query) {
	      this.query = query;
	    }
	  }, {
	    key: 'getAdverseEvents',
	    value: function getAdverseEvents() {
	      return this.$http.get('/api/ae/list', {
	        params: _extends({}, this.query)
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByReportDate',
	    value: function getAdverseEventsByReportDate(reportDate) {
	      return this.$http.get('/api/ae/search_by_report_date', {
	        params: _extends({}, this.query, {
	          reportDate: reportDate.toISOString()
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByProduct',
	    value: function getAdverseEventsByProduct(productId) {
	      return this.$http.get('/api/ae/search_by_product', {
	        params: _extends({}, this.query, {
	          productId: productId
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByMember',
	    value: function getAdverseEventsByMember(memberId) {
	      return this.$http.get('/api/ae/search_by_member', {
	        params: _extends({}, this.query, {
	          memberId: memberId
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByIngredient',
	    value: function getAdverseEventsByIngredient(ingredientId) {
	      return this.$http.get('/api/ae/search_by_user_ingredient', {
	        params: _extends({}, this.query, {
	          userIngredientId: ingredientId
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsBySystemIngredient',
	    value: function getAdverseEventsBySystemIngredient(systemIngredientId) {
	      return this.$http.get('/api/ae/search_by_system_ingredient', {
	        params: _extends({}, this.query, {
	          systemIngredientId: systemIngredientId
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByType',
	    value: function getAdverseEventsByType(selectedSymptoms, shouldMatchAll) {
	      var url = shouldMatchAll ? 'search_by_all_symptom' : 'search_by_any_symptom';
	
	      return this.$http.get('/api/ae/' + url, {
	        params: _extends({}, this.query, {
	          selectedSymptoms: selectedSymptoms
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsBySpecies',
	    value: function getAdverseEventsBySpecies(species) {
	      return this.$http.get('/api/ae/search_by_species', {
	        params: _extends({}, this.query, {
	          selectedSpecies: species
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsMissingInfo',
	    value: function getAdverseEventsMissingInfo() {
	      return this.$http.get('/api/ae/search_by_missing_info', {
	        params: _extends({}, this.query)
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByText',
	    value: function getAdverseEventsByText(text) {
	      return this.$http.get('/api/ae/search_by_text', {
	        params: _extends({}, this.query, {
	          searchText: text
	        })
	      });
	    }
	  }, {
	    key: 'getAdverseEventsByStatus',
	    value: function getAdverseEventsByStatus(status) {
	      return this.$http.get('/api/ae/search_by_status', {
	        params: _extends({}, this.query, {
	          status: status
	        })
	      });
	    }
	  }, {
	    key: 'getEventTypes',
	    value: function getEventTypes() {
	      return [{
	        name: 'Diarrhea',
	        id: 0
	      }, {
	        name: 'Stomach Upset/Vomiting',
	        id: 1
	      }, {
	        name: 'Colic (Horse)',
	        id: 2
	      }, {
	        name: 'Skin/Allergic Reaction',
	        id: 3
	      }, {
	        name: 'Seizures',
	        id: 4
	      }, {
	        name: 'Death',
	        id: 5
	      }, {
	        name: 'Lameness',
	        id: 6
	      }, {
	        name: 'Accidental Ingestion',
	        id: 7
	      }, {
	        name: 'Other',
	        id: 8
	      }];
	    }
	  }, {
	    key: 'getSearchTypes',
	    value: function getSearchTypes() {
	      return [{
	        name: 'All Adverse Events',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Open Adverse Events',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Report Date',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Product Name',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Ingredient Name',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by System Ingredient',
	        permission: ['' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Event (any events)',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Event (all matched events)',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Member',
	        permission: ['' + _roles.SYS_ADMIN, '' + _roles.REGULATOR]
	      }, {
	        name: 'Search by Species',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Text',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
	        // }, {
	        //   name: 'Missing Event Information',
	        //   permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
	      }];
	    }
	  }, {
	    key: 'getAlerts',
	    value: function getAlerts() {
	      return this.$http.get('/api/alert/load_alert_ae');
	    }
	  }, {
	    key: 'getOpenAdverseEventsPreviousMonth',
	    value: function getOpenAdverseEventsPreviousMonth() {
	      return this.$http.get('/api/ae/previous_month');
	    }
	  }]);
	
	  return AdverseEventsService;
	}();
	
	exports.default = AdverseEventsService;

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SYS_ADMIN = exports.SYS_ADMIN = 'SYS_ADMIN';
	var COMPANY_ADMIN = exports.COMPANY_ADMIN = 'COMPANY_ADMIN';
	var USER = exports.USER = 'USER';
	var REGULATOR = exports.REGULATOR = 'REGULATOR';
	var REGULATOR_ADMIN = exports.REGULATOR_ADMIN = 'REGULATOR_ADMIN';
	var ANONYMOUS = exports.ANONYMOUS = 'ANONYMOUS';

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AlertService = function () {
	  AlertService.$inject = ["$http"];
	  function AlertService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AlertService);
	
	    this.$http = $http;
	  }
	
	  _createClass(AlertService, [{
	    key: 'getAlerts',
	    value: function getAlerts() {
	      return this.$http.get('/api/alert/load_alert');
	    }
	  }]);
	
	  return AlertService;
	}();
	
	exports.default = AlertService;

/***/ },
/* 404 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnimalTypeService = function () {
	  AnimalTypeService.$inject = ["$http"];
	  function AnimalTypeService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AnimalTypeService);
	
	    this.$http = $http;
	  }
	
	  _createClass(AnimalTypeService, [{
	    key: 'getAnimalTypes',
	    value: function getAnimalTypes() {
	      return this.$http.get('/api/animal_type');
	    }
	  }, {
	    key: 'minimumAnimalWeight',
	    value: function minimumAnimalWeight(animalType) {
	      if (!animalType) {
	        return 0.0;
	      }
	
	      switch (animalType) {
	        case 'Horse':
	          return 100.0;
	        case 'Dog':
	        case 'Cat':
	          return 0.1;
	        default:
	          return 0.1;
	      }
	    }
	  }, {
	    key: 'maximumAnimalWeight',
	    value: function maximumAnimalWeight(animalType) {
	      if (!animalType) {
	        return 2500.0;
	      }
	
	      switch (animalType) {
	        case 'Horse':
	          return 2500.0;
	        case 'Dog':
	          return 200.0;
	        case 'Cat':
	          return 30.0;
	        default:
	          return 2500.0;
	      }
	    }
	  }]);
	
	  return AnimalTypeService;
	}();
	
	exports.default = AnimalTypeService;

/***/ },
/* 405 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayService = function () {
	  function ArrayService() {
	    'ngInject';
	
	    _classCallCheck(this, ArrayService);
	  }
	
	  _createClass(ArrayService, [{
	    key: 'add',
	    value: function add(array, obj) {
	      return [].concat(_toConsumableArray(array), [obj]);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(array, obj) {
	      var index = array.indexOf(obj);
	
	      if (index === -1) {
	        throw new Error('Object does not exist in array!');
	      }
	
	      return [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1)));
	    }
	  }, {
	    key: 'update',
	    value: function update(array, obj, index) {
	      if (index === -1) {
	        throw new Error('Object does not exist in array!');
	      }
	
	      return [].concat(_toConsumableArray(array.slice(0, index)), [obj], _toConsumableArray(array.slice(index + 1)));
	    }
	  }]);
	
	  return ArrayService;
	}();
	
	exports.default = ArrayService;

/***/ },
/* 406 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuthService = function () {
	  AuthService.$inject = ["$http", "$state", "SessionService"];
	  function AuthService($http, $state, SessionService) {
	    'ngInject';
	
	    _classCallCheck(this, AuthService);
	
	    Object.assign(this, { $http: $http, $state: $state, SessionService: SessionService });
	  }
	
	  _createClass(AuthService, [{
	    key: 'getUserInfo',
	    value: function getUserInfo() {
	      return this.$http.get('/api/account/user_info');
	    }
	  }, {
	    key: 'login',
	    value: function login(credentials) {
	      var _this = this;
	
	      var data = 'grant_type=password&username=' + encodeURIComponent(credentials.userName) + '&password=' + encodeURIComponent(credentials.password);
	
	      return this.$http.post('/token', data, {
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function (r) {
	        _this.SessionService.authToken = r.data.access_token;
	
	        return _this.$http.get('/api/account/user_info');
	      }).then(function (r) {
	        _this.SessionService.user = r.data;
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.$state.go('login');
	      this.SessionService.destroy();
	    }
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword(userName) {
	      return this.$http.post('/api/account/forgot_password?userName=' + userName);
	    }
	  }, {
	    key: 'getAccessLevels',
	    value: function getAccessLevels() {
	      var accessLevels = [{
	        id: 1,
	        desc: 'Level 1'
	      }, {
	        id: 2,
	        desc: 'Level 2'
	      }, {
	        id: 3,
	        desc: 'Level 3'
	      }];
	
	      return accessLevels;
	    }
	  }, {
	    key: 'isLoggedIn',
	    get: function get() {
	      return this.SessionService.user != null && this.SessionService.authToken != null;
	    }
	  }, {
	    key: 'isSysAdmin',
	    get: function get() {
	      if (!this.SessionService.user) {
	        return false;
	      }
	
	      return this.SessionService.user.UserType === 'SystemAdministrator';
	    }
	  }, {
	    key: 'isCompanyAdmin',
	    get: function get() {
	      if (!this.SessionService.user) {
	        return false;
	      }
	
	      return this.SessionService.user.UserType === 'Member' && this.SessionService.user.LevelOfAccess === 3;
	    }
	  }, {
	    key: 'isRegulator',
	    get: function get() {
	      if (!this.SessionService.user) {
	        return false;
	      }
	
	      return this.SessionService.user.UserType === 'Regulator';
	    }
	  }, {
	    key: 'isRegulatorAdmin',
	    get: function get() {
	      return this.isRegulator && this.SessionService.user.LevelOfAccess === 3;
	    }
	  }, {
	    key: 'isUser',
	    get: function get() {
	      if (!this.SessionService.user) {
	        return false;
	      }
	
	      return this.SessionService.user.UserType === 'Member' && this.SessionService.user.LevelOfAccess === 1;
	    }
	  }]);
	
	  return AuthService;
	}();
	
	exports.default = AuthService;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CategoryService = function () {
	  CategoryService.$inject = ["$http"];
	  function CategoryService($http) {
	    'ngInject';
	
	    _classCallCheck(this, CategoryService);
	
	    this.$http = $http;
	  }
	
	  _createClass(CategoryService, [{
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'ProductCategoryName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(category) {
	      return this.$http.post('/api/product_category', category);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/product_category/' + id);
	    }
	  }, {
	    key: 'update',
	    value: function update(category) {
	      return this.$http.put('/api/product_category/' + category.ProductCategoryId, category);
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/ProductCategoryOData', {
	        params: _extends({
	          $select: 'ProductCategoryId, ProductCategoryName, ProductCount, ReportShortName'
	        }, query.take && { $top: query.take }, query.page && { $skip: query.calculateSkip() }, {
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }]);
	
	  return CategoryService;
	}();
	
	exports.default = CategoryService;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.transformODataResponse = exports.getQuery = exports.getLimitOptions = undefined;
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLimitOptions = exports.getLimitOptions = function getLimitOptions() {
	  return [5, 10, 25, 50, 100];
	};
	var getQuery = exports.getQuery = function getQuery() {
	  return _angular2.default.copy({
	    take: 10,
	    page: 1,
	    calculateSkip: function calculateSkip() {
	      return this.take * (this.page - 1);
	    }
	  });
	};
	
	var transformODataResponse = exports.transformODataResponse = function transformODataResponse(r) {
	  return {
	    Count: r.data['@odata.count'],
	    Data: r.data.value
	  };
	};

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompanyService = function () {
	  CompanyService.$inject = ["$http"];
	  function CompanyService($http) {
	    'ngInject';
	
	    _classCallCheck(this, CompanyService);
	
	    this.$http = $http;
	  }
	
	  _createClass(CompanyService, [{
	    key: 'getCompany',
	    value: function getCompany(id) {
	      return this.$http.get('/api/member/' + id);
	    }
	  }, {
	    key: 'update',
	    value: function update(company) {
	      return this.$http.put('/api/member/' + company.MemberId, company);
	    }
	  }, {
	    key: 'add',
	    value: function add(company) {
	      return this.$http.post('/api/member', company);
	    }
	  }, {
	    key: 'updateCompliance',
	    value: function updateCompliance(company) {
	      return this.$http.put('/api/member/' + company.MemberId + '/compliance', company);
	    }
	  }, {
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'MemberName',
	        direction: 'asc'
	      });
	    }
	
	    /* eslint-disable max-len */
	
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/MemberOData', {
	        params: _extends({
	          $select: 'MemberId, MemberName, IsActive, IsLogOut, IsRequireMonthlyCompliance, IsNascAudited, DateBecameAudited',
	          $top: query.take
	        }, query.page && { $skip: query.calculateSkip() }, {
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	    /* eslint-enable max-len */
	
	  }]);
	
	  return CompanyService;
	}();
	
	exports.default = CompanyService;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IngredientService = function () {
	  IngredientService.$inject = ["$http"];
	  function IngredientService($http) {
	    'ngInject';
	
	    _classCallCheck(this, IngredientService);
	
	    this.$http = $http;
	  }
	
	  _createClass(IngredientService, [{
	    key: 'getDefaultSystemIngredientQuery',
	    value: function getDefaultSystemIngredientQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        take: 200,
	        orderBy: 'SystemIngredientName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'getDefaultUserIngredientQuery',
	    value: function getDefaultUserIngredientQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        take: 200,
	        orderBy: 'UserIngredientName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'searchSystemIngredients',
	    value: function searchSystemIngredients(query) {
	      return this.$http.get('/odata/SystemIngredientOData', {
	        params: _extends({
	          $select: 'SystemIngredientId, SystemIngredientName, IUtoMgConversiontRate'
	        }, query.top && { $top: query.take }, query.calculateSkip && { $skip: query.calculateSkip() }, {
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'searchUserIngredients',
	    value: function searchUserIngredients(query) {
	      return this.$http.get('/odata/UserIngredientOData', {
	        params: _extends({
	          $select: 'UserIngredientId, UserIngredientName, ProductCount',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'addSystemIngredientMapping',
	    value: function addSystemIngredientMapping(systemIngredientId, userIngredientIds) {
	      return this.$http.post('/api/system_ingredient/' + systemIngredientId + '/user_ingredients', {
	        systemIngredientId: systemIngredientId,
	        userIngredientIds: userIngredientIds
	      });
	    }
	  }, {
	    key: 'removeSystemIngredientMapping',
	    value: function removeSystemIngredientMapping(systemIngredientId, userIngredientIds) {
	      return this.$http.delete('/api/system_ingredient/' + systemIngredientId + '/user_ingredients', {
	        data: {
	          systemIngredientId: systemIngredientId,
	          userIngredientIds: userIngredientIds
	        }
	      });
	    }
	  }]);
	
	  return IngredientService;
	}();
	
	exports.default = IngredientService;

/***/ },
/* 411 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FeedbackService = function () {
	  FeedbackService.$inject = ["$http"];
	  function FeedbackService($http) {
	    'ngInject';
	
	    _classCallCheck(this, FeedbackService);
	
	    this.$http = $http;
	  }
	
	  _createClass(FeedbackService, [{
	    key: 'submit',
	    value: function submit(feedback) {
	      return this.$http.post('/api/feedback', {
	        feedback: feedback
	      });
	    }
	  }]);
	
	  return FeedbackService;
	}();
	
	exports.default = FeedbackService;

/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoadingService = function () {
	  LoadingService.$inject = ["$rootScope"];
	  function LoadingService($rootScope) {
	    'ngInject';
	
	    _classCallCheck(this, LoadingService);
	
	    Object.assign(this, { $rootScope: $rootScope });
	  }
	
	  _createClass(LoadingService, [{
	    key: 'stop',
	    value: function stop() {
	      this.$rootScope.loadingView = false;
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.$rootScope.loadingView = true;
	    }
	  }]);
	
	  return LoadingService;
	}();
	
	exports.default = LoadingService;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PeopleService = function () {
	  PeopleService.$inject = ["$http"];
	  function PeopleService($http) {
	    'ngInject';
	
	    _classCallCheck(this, PeopleService);
	
	    this.$http = $http;
	  }
	
	  _createClass(PeopleService, [{
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'LastName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/PeopleOData', {
	        params: _extends({
	          $select: 'PeopleId, UserId, FirstName, LastName, Email, Username, LevelOfAccess, IsLocked',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }]);
	
	  return PeopleService;
	}();
	
	exports.default = PeopleService;

/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductService = function () {
	  ProductService.$inject = ["$http", "Upload"];
	  function ProductService($http, Upload) {
	    'ngInject';
	
	    _classCallCheck(this, ProductService);
	
	    this.$http = $http;
	    this.Upload = Upload;
	  }
	
	  _createClass(ProductService, [{
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/ProductOData', {
	        params: _extends({
	          $select: 'ProductId, ProductName',
	          $top: query.take
	        }, query.page && { $skip: query.calculateSkip() }, {
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'searchProductsByName',
	    value: function searchProductsByName(name) {
	      return this.$http.get('/api/product/search_by_name?name=' + name);
	    }
	  }, {
	    key: 'searchProductsByNameForCopy',
	    value: function searchProductsByNameForCopy(name, isTreat) {
	      return this.$http.get('/api/product/search_by_name_for_copy?name=' + name + '&isTreat=' + isTreat);
	    }
	  }, {
	    key: 'getProduct',
	    value: function getProduct(id) {
	      return this.$http.get('/api/product/' + id);
	    }
	  }, {
	    key: 'create',
	    value: function create(product) {
	      return this.$http.post('/api/product/', product);
	    }
	  }, {
	    key: 'update',
	    value: function update(product) {
	      return this.$http.put('/api/product/' + product.ProductId, product);
	    }
	  }, {
	    key: 'uploadLabel',
	    value: function uploadLabel(productId, label) {
	      return this.Upload.upload({
	        url: '/api/product_label/' + productId,
	        data: {
	          label: label
	        }
	      });
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel(id) {
	      return this.$http.get('/api/product_label/' + id);
	    }
	  }, {
	    key: 'getLabelDetails',
	    value: function getLabelDetails(id) {
	      return this.$http.get('/api/product_label/' + id + '/request');
	    }
	  }, {
	    key: 'getAdministrationUnits',
	    value: function getAdministrationUnits() {
	      return this.$http.get('/api/product/container_types');
	    }
	  }, {
	    key: 'getAdministrationUnitsForSupplements',
	    value: function getAdministrationUnitsForSupplements() {
	      return this.$http.get('/api/product/valid_container_types_for_supplements');
	    }
	  }, {
	    key: 'getAdministrationUnitsForTreats',
	    value: function getAdministrationUnitsForTreats() {
	      return this.$http.get('/api/product/valid_container_types_for_treats');
	    }
	  }, {
	    key: 'getFrequencies',
	    value: function getFrequencies() {
	      return this.$http.get('/api/product/get_frequency_type');
	    }
	  }, {
	    key: 'getPlantParts',
	    value: function getPlantParts() {
	      return this.$http.get('/api/product/get_plant_part');
	    }
	  }, {
	    key: 'getWeightUnits',
	    value: function getWeightUnits() {
	      return this.$http.get('/api/product/get_weight_unit');
	    }
	  }, {
	    key: 'getHerbRatioFrom',
	    value: function getHerbRatioFrom() {
	      return this.$http.get('/api/product/get_herb_ratio_from');
	    }
	  }, {
	    key: 'getHerbRatioTo',
	    value: function getHerbRatioTo() {
	      return this.$http.get('/api/product/get_herb_ratio_to');
	    }
	  }, {
	    key: 'getHerbForms',
	    value: function getHerbForms() {
	      return this.$http.get('/api/product/get_herb_forms');
	    }
	  }, {
	    key: 'signOff',
	    value: function signOff(productId, signature) {
	      return this.$http.post('/api/product/' + productId + '/sign', {
	        productId: productId,
	        signature: signature
	      });
	    }
	  }, {
	    key: 'getUnitsDisplay',
	    value: function getUnitsDisplay(product) {
	      if (product.ProductForm) {
	        if (product.ProductForm.indexOf('(s)') !== -1) {
	          return product.ProductForm.toLowerCase();
	        }
	        return product.ProductForm.toLowerCase() + 's';
	      }
	
	      return 'units';
	    }
	  }, {
	    key: 'copyProduct',
	    value: function copyProduct(copyToProduct, copyFromProduct, copyAreas) {
	      var copiedProduct = _extends({}, copyToProduct, {
	        Signature: null,
	        SignDate: null
	      });
	
	      for (var i = 0; i < copyAreas.length; i += 1) {
	        if (copyAreas[i] === 'Product Information') {
	          copiedProduct = _extends({}, copiedProduct, this.copyInformation(copyFromProduct));
	        }if (copyAreas[i] === 'Administrations') {
	          copiedProduct = _extends({}, copiedProduct, this.copyAdministrations(copyFromProduct));
	        }if (copyAreas[i] === 'Product Ingredients') {
	          copiedProduct = _extends({}, copiedProduct, this.copyIngredients(copyFromProduct));
	        }
	        // if (copyAreas[i] === ('Usage Data')) {
	        //   copiedProduct = {
	        //     ...copiedProduct,
	        //     ...this.copyUsageData(copyFromProduct)
	        //   };
	        // }
	      }
	
	      return copiedProduct;
	    }
	  }, {
	    key: 'copyInformation',
	    value: function copyInformation(product) {
	      return {
	        ProductCategoryIds: product.ProductCategoryIds,
	        ProductName: product.ProductName,
	        SKU: product.SKU,
	        // make them supply a new date for the new version/reformulation  DateIntroduced: product.DateIntroduced,
	        ProductForm: product.ProductForm,
	        UnitPerContainer: product.UnitPerContainer,
	        WarningNote: product.WarningNote,
	        FeedingNote: product.FeedingNote,
	        HasLoading: product.HasLoading,
	        UPC: product.UPC,
	        TakeAsNeeded: product.TakeAsNeeded,
	        IsBulkQty: product.IsBulkQty,
	        IsSample: product.IsSample,
	        IsTreat: product.IsTreat
	      };
	    }
	  }, {
	    key: 'copyAdministrations',
	    value: function copyAdministrations(product) {
	      product.tblDoses = product.tblDoses || [];
	
	      // eslint-disable-next-line no-restricted-syntax
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = product.tblDoses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var u = _step.value;
	
	          u.DoseId = 0;
	          u.ProductId = 0;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return {
	        tblDoses: product.tblDoses || []
	      };
	    }
	  }, {
	    key: 'copyIngredients',
	    value: function copyIngredients(product) {
	      product.tblProduct_UserIngredient = product.tblProduct_UserIngredient || [];
	
	      // eslint-disable-next-line no-restricted-syntax
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = product.tblProduct_UserIngredient[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var u = _step2.value;
	
	          u.Id = 0;
	          u.ProductId = 0;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return {
	        tblProduct_UserIngredient: product.tblProduct_UserIngredient
	      };
	    }
	
	    // copyUsageData(product) {
	    //   product.tblUsages = product.tblUsages || [];
	
	    //   // eslint-disable-next-line no-restricted-syntax
	    //   for (const u of product.tblUsages) {
	    //     u.UsageId = 0;
	    //     u.ProductId = 0;
	    //   }
	
	    //   return {
	    //     tblUsages: product.tblUsages
	    //   };
	    // }
	
	  }, {
	    key: 'transformUsages',
	    value: function transformUsages(productId, dateFirstSold, usages) {
	      if (!dateFirstSold || !usages) {
	        return [];
	      }
	
	      var validUsages = usages.filter(function (u) {
	        return u.UsageYear >= dateFirstSold.getFullYear();
	      });
	
	      var curYear = new Date().getFullYear();
	
	      var _loop = function _loop(i) {
	        if (validUsages.some(function (u) {
	          return u.UsageYear === i;
	        }) === false) {
	          validUsages.push({
	            Encry: false,
	            ProductId: productId || 0,
	            Q1: null,
	            Q2: null,
	            Q3: null,
	            Q4: null,
	            UsageId: 0,
	            UsageYear: i
	          });
	        }
	      };
	
	      for (var i = dateFirstSold.getFullYear(); i <= curYear; i += 1) {
	        _loop(i);
	      }
	
	      return [].concat(_toConsumableArray(validUsages.sort(function (a, b) {
	        return a.UsageYear - b.UsageYear;
	      })));
	    }
	
	    // TODO: Refactor to OData call
	
	  }, {
	    key: 'getCategories',
	    value: function getCategories() {
	      return this.$http.get('/api/product_category/all');
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/product/' + id);
	    }
	  }]);
	
	  return ProductService;
	}();
	
	exports.default = ProductService;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegulatorService = function () {
	  RegulatorService.$inject = ["$http"];
	  function RegulatorService($http) {
	    'ngInject';
	
	    _classCallCheck(this, RegulatorService);
	
	    this.$http = $http;
	  }
	
	  _createClass(RegulatorService, [{
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'AgentName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(id) {
	      return this.$http.get('/api/regulator/' + id);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/regulator/' + id);
	    }
	  }, {
	    key: 'add',
	    value: function add(regulator) {
	      return this.$http.post('/api/regulator', regulator);
	    }
	  }, {
	    key: 'update',
	    value: function update(regulator) {
	      return this.$http.put('/api/regulator/' + regulator.RegulatorId, regulator);
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/RegulatorOData', {
	        params: _extends({
	          $select: 'RegulatorId, AgentName',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }]);
	
	  return RegulatorService;
	}();
	
	exports.default = RegulatorService;

/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportService = function () {
	  ReportService.$inject = ["$http"];
	  function ReportService($http) {
	    'ngInject';
	
	    _classCallCheck(this, ReportService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(ReportService, [{
	    key: 'getReportTypes',
	    value: function getReportTypes() {
	      return [{
	        name: 'Administrations by Category (Bar)',
	        state: 'administrationsByCategoryBar',
	        enabled: true
	      }, {
	        name: 'Administrations by Category (Area)',
	        state: 'administrationsByCategoryArea',
	        enabled: true
	      }, {
	        name: 'Administrations by Category (Pie)',
	        state: 'administrationsByCategoryPie',
	        enabled: true
	      }, {
	        name: 'Administrations Trend',
	        state: 'administrationTrend',
	        enabled: true
	      }, {
	        name: 'Ingredient Risk',
	        state: 'ingredientRisk',
	        enabled: true
	      }, {
	        name: 'Risk by Year',
	        state: 'riskByYear',
	        enabled: true
	      }, {
	        name: 'Serious Risk by Year',
	        state: 'seriousRiskByYear',
	        enabled: true
	      }, {
	        name: 'System Metrics',
	        state: 'systemMetrics',
	        enabled: true
	      }];
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var date = new Date();
	      var years = [];
	      var currentYear = date.getFullYear();
	
	      for (var i = currentYear; i > currentYear - 10; i -= 1) {
	        years.push(i);
	      }
	
	      return years;
	    }
	  }]);
	
	  return ReportService;
	}();
	
	exports.default = ReportService;

/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-underscore-dangle */
	var SessionService = function () {
	  SessionService.$inject = ["localStorageService"];
	  function SessionService(localStorageService) {
	    'ngInject';
	
	    _classCallCheck(this, SessionService);
	
	    this.localStorageService = localStorageService;
	
	    this._user = JSON.parse(localStorageService.get('session.user'));
	    this._authToken = localStorageService.get('session.authToken');
	    this._reportParams = JSON.parse(localStorageService.get('session.reportParams'));
	  }
	
	  _createClass(SessionService, [{
	    key: 'destroy',
	    value: function destroy() {
	      this.user = null;
	      this.authToken = null;
	    }
	  }, {
	    key: 'user',
	    get: function get() {
	      return this._user;
	    },
	    set: function set(user) {
	      this._user = user;
	      this.localStorageService.set('session.user', JSON.stringify(user));
	    }
	  }, {
	    key: 'reportParams',
	    get: function get() {
	      return this._reportParams;
	    },
	    set: function set(params) {
	      this._reportParams = params;
	      this.localStorageService.set('session.reportParams', JSON.stringify(params));
	    }
	  }, {
	    key: 'authToken',
	    get: function get() {
	      return this._authToken;
	    },
	    set: function set(token) {
	      this._authToken = token;
	      this.localStorageService.set('session.authToken', token);
	    }
	  }]);
	
	  return SessionService;
	}();
	
	exports.default = SessionService;

/***/ },
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ToastService = function () {
	  ToastService.$inject = ["$log", "$mdToast"];
	  function ToastService($log, $mdToast) {
	    'ngInject';
	
	    _classCallCheck(this, ToastService);
	
	    Object.assign(this, {
	      $log: $log,
	      $mdToast: $mdToast
	    });
	
	    this.duration = 3000;
	  }
	
	  _createClass(ToastService, [{
	    key: 'showError',
	    value: function showError(error, message) {
	      this.$log.error(error);
	
	      this.$mdToast.show(this.$mdToast.simple().textContent(message && message.length ? message : 'Error! Something went wrong!').hideDelay(this.duration).toastClass('error').position('bottom right'));
	    }
	  }, {
	    key: 'showWarning',
	    value: function showWarning(message) {
	      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(this.duration).toastClass('error').position('bottom right'));
	    }
	  }, {
	    key: 'showSuccess',
	    value: function showSuccess(message, opts) {
	      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(opts && opts.duration ? opts.duration : this.duration).toastClass('success').position('bottom right'));
	    }
	  }]);
	
	  return ToastService;
	}();
	
	exports.default = ToastService;

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsageDataService = function () {
	  UsageDataService.$inject = ["$http"];
	  function UsageDataService($http) {
	    'ngInject';
	
	    _classCallCheck(this, UsageDataService);
	
	    this.$http = $http;
	  }
	
	  _createClass(UsageDataService, [{
	    key: 'getMissingUsageData',
	    value: function getMissingUsageData() {
	      return this.$http.get('/api/usage/all_missing_usage');
	    }
	  }, {
	    key: 'getMissingQuarterUsageData',
	    value: function getMissingQuarterUsageData() {
	      return this.$http.get('/api/usage/all_missing_usage_current_qarter');
	    }
	  }, {
	    key: 'getQ4Value',
	    value: function getQ4Value(productId, year) {
	      return this.$http.get('/api/usage/q4_value/' + productId + '/' + year);
	    }
	  }, {
	    key: 'getMissingProductUsageData',
	    value: function getMissingProductUsageData(productId) {
	      return this.$http.get('/api/usage/product_missing_usage/' + productId);
	    }
	  }, {
	    key: 'updateMissingUsageData',
	    value: function updateMissingUsageData(usages) {
	      return this.$http.post('/api/usage/update_missing_usage', {
	        usages: usages
	      });
	    }
	  }]);
	
	  return UsageDataService;
	}();
	
	exports.default = UsageDataService;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _strongPassword = __webpack_require__(421);
	
	var _strongPassword2 = _interopRequireDefault(_strongPassword);
	
	var _compareTo = __webpack_require__(422);
	
	var _compareTo2 = _interopRequireDefault(_compareTo);
	
	var _uniqueIngredientName = __webpack_require__(423);
	
	var _uniqueIngredientName2 = _interopRequireDefault(_uniqueIngredientName);
	
	var _uniqueSystemIngredientName = __webpack_require__(424);
	
	var _uniqueSystemIngredientName2 = _interopRequireDefault(_uniqueSystemIngredientName);
	
	var _onFileChanged = __webpack_require__(425);
	
	var _onFileChanged2 = _interopRequireDefault(_onFileChanged);
	
	var _stopEvent = __webpack_require__(426);
	
	var _stopEvent2 = _interopRequireDefault(_stopEvent);
	
	var _greaterThan = __webpack_require__(427);
	
	var _greaterThan2 = _interopRequireDefault(_greaterThan);
	
	var _lessThan = __webpack_require__(428);
	
	var _lessThan2 = _interopRequireDefault(_lessThan);
	
	var _backgroundImage = __webpack_require__(429);
	
	var _backgroundImage2 = _interopRequireDefault(_backgroundImage);
	
	var _compareToNotEqual = __webpack_require__(430);
	
	var _compareToNotEqual2 = _interopRequireDefault(_compareToNotEqual);
	
	var _uniqueUsername = __webpack_require__(431);
	
	var _uniqueUsername2 = _interopRequireDefault(_uniqueUsername);
	
	var _notNull = __webpack_require__(432);
	
	var _notNull2 = _interopRequireDefault(_notNull);
	
	var _phoneNumber = __webpack_require__(433);
	
	var _phoneNumber2 = _interopRequireDefault(_phoneNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.directives', []).directive('uniqueUsername', _uniqueUsername2.default.directiveFactory).directive('notNull', _notNull2.default.directiveFactory).directive('phoneNumber', _phoneNumber2.default.directiveFactory).directive('strongPassword', _strongPassword2.default.directiveFactory).directive('compareTo', _compareTo2.default.directiveFactory).directive('uniqueUserIngredientName', _uniqueIngredientName2.default.directiveFactory).directive('uniqueSystemIngredientName', _uniqueSystemIngredientName2.default.directiveFactory).directive('onFileChanged', _onFileChanged2.default.directiveFactory).directive('stopEvent', _stopEvent2.default.directiveFactory).directive('greaterThan', _greaterThan2.default.directiveFactory).directive('lessThan', _lessThan2.default.directiveFactory).directive('backgroundImage', _backgroundImage2.default.directiveFactory).directive('compareToNotEqual', _compareToNotEqual2.default.directiveFactory).name;

/***/ },
/* 421 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StrongPassword = function () {
	  function StrongPassword() {
	    'ngInject';
	
	    _classCallCheck(this, StrongPassword);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(StrongPassword, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      ctrl.$validators.strongPassword = function (modelValue) {
	        // check if contains uppercase
	        if (!/[A-Z]/.test(modelValue)) {
	          return false;
	        }
	
	        // check if contains lowercase
	        if (!/[a-z]/.test(modelValue)) {
	          return false;
	        }
	
	        // check if contains number
	        if (!/[0-9]/.test(modelValue)) {
	          return false;
	        }
	
	        if (modelValue.length < 8) {
	          return false;
	        }
	
	        return true;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new StrongPassword();
	    }
	  }]);
	
	  return StrongPassword;
	}();
	
	exports.default = StrongPassword;

/***/ },
/* 422 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompareTo = function () {
	  function CompareTo() {
	    'ngInject';
	
	    _classCallCheck(this, CompareTo);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	    this.scope = {
	      otherModelValue: '=compareTo'
	    };
	  }
	
	  _createClass(CompareTo, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      $scope.$watch('otherModelValue', function () {
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.compareTo = function (modelValue) {
	        return modelValue === $scope.otherModelValue;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new CompareTo();
	    }
	  }]);
	
	  return CompareTo;
	}();
	
	exports.default = CompareTo;

/***/ },
/* 423 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UniqueIngredientName = function () {
	  UniqueIngredientName.$inject = ["$q", "UserIngredientsService"];
	  function UniqueIngredientName($q, UserIngredientsService) {
	    'ngInject';
	
	    _classCallCheck(this, UniqueIngredientName);
	
	    Object.assign(this, {
	      $q: $q,
	      UserIngredientsService: UserIngredientsService
	    });
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(UniqueIngredientName, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      var _this = this;
	
	      var ingredientId = null;
	
	      if (attrs.ingredientId) {
	        ingredientId = attrs.ingredientId;
	      }
	
	      // Async validator requires resolve or reject to set validity
	      ctrl.$asyncValidators.uniqueUserIngredientName = function (ingredientName) {
	        var defer = _this.$q.defer();
	
	        _this.UserIngredientsService.isUniqueIngredientName(ingredientName, ingredientId).then(function (r) {
	          if (r.data) {
	            defer.resolve();
	          }
	
	          defer.reject();
	        }).catch(function () {
	          return defer.reject();
	        });
	
	        return defer.promise;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$q", "UserIngredientsService", function directiveFactory($q, UserIngredientsService) {
	      'ngInject';
	
	      return new UniqueIngredientName($q, UserIngredientsService);
	    }]
	  }]);
	
	  return UniqueIngredientName;
	}();
	
	exports.default = UniqueIngredientName;

/***/ },
/* 424 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UniqueSystemIngredientName = function () {
	  UniqueSystemIngredientName.$inject = ["$q", "SystemIngredientsService"];
	  function UniqueSystemIngredientName($q, SystemIngredientsService) {
	    'ngInject';
	
	    _classCallCheck(this, UniqueSystemIngredientName);
	
	    Object.assign(this, {
	      $q: $q,
	      SystemIngredientsService: SystemIngredientsService
	    });
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(UniqueSystemIngredientName, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      var _this = this;
	
	      var ingredientId = null;
	
	      if (attrs.ingredientId) {
	        ingredientId = attrs.ingredientId;
	      }
	
	      // Async validator requires resolve or reject to set validity
	      ctrl.$asyncValidators.uniqueSystemIngredientName = function (ingredientName) {
	        var defer = _this.$q.defer();
	
	        _this.SystemIngredientsService.isUniqueIngredientName(ingredientName, ingredientId).then(function (r) {
	          if (r.data) {
	            defer.resolve();
	          }
	
	          defer.reject();
	        }).catch(function () {
	          return defer.reject();
	        });
	
	        return defer.promise;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$q", "SystemIngredientsService", function directiveFactory($q, SystemIngredientsService) {
	      'ngInject';
	
	      return new UniqueSystemIngredientName($q, SystemIngredientsService);
	    }]
	  }]);
	
	  return UniqueSystemIngredientName;
	}();
	
	exports.default = UniqueSystemIngredientName;

/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OnFileChanged = function () {
	  OnFileChanged.$inject = ["$parse"];
	  function OnFileChanged($parse) {
	    'ngInject';
	
	    _classCallCheck(this, OnFileChanged);
	
	    this.restrict = 'A';
	    Object.assign(this, { $parse: $parse });
	  }
	
	  _createClass(OnFileChanged, [{
	    key: 'link',
	    value: function link($scope, element, attrs) {
	      var attrHandler = this.$parse(attrs.onFileChanged);
	
	      var handler = function handler(e) {
	        $scope.$apply(function () {
	          attrHandler($scope, { $event: e, files: e.target.files });
	        });
	      };
	
	      element[0].addEventListener('change', handler, false);
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$parse", function directiveFactory($parse) {
	      'ngInject';
	
	      return new OnFileChanged($parse);
	    }]
	  }]);
	
	  return OnFileChanged;
	}();
	
	exports.default = OnFileChanged;

/***/ },
/* 426 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StopEvent = function () {
	  function StopEvent() {
	    'ngInject';
	
	    _classCallCheck(this, StopEvent);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(StopEvent, [{
	    key: 'link',
	    value: function link($scope, element, attrs) {
	      if (attrs && attrs.stopEvent) {
	        element.bind(attrs.stopEvent, function (e) {
	          // e.stopPropagation();
	          e.stopImmediatePropagation();
	        });
	      }
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new StopEvent();
	    }
	  }]);
	
	  return StopEvent;
	}();
	
	exports.default = StopEvent;

/***/ },
/* 427 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GreaterThan = function () {
	  function GreaterThan() {
	    'ngInject';
	
	    _classCallCheck(this, GreaterThan);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(GreaterThan, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      var compareTo = attrs.greaterThan;
	
	      $scope.$watch(attrs.greaterThan, function () {
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.greaterThan = function (modelValue) {
	        var watchVal = $scope.$eval(compareTo);
	
	        if (modelValue === undefined || watchVal === undefined) {
	          return true;
	        }
	
	        return modelValue > watchVal;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new GreaterThan();
	    }
	  }]);
	
	  return GreaterThan;
	}();
	
	exports.default = GreaterThan;

/***/ },
/* 428 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LessThan = function () {
	  function LessThan() {
	    'ngInject';
	
	    _classCallCheck(this, LessThan);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(LessThan, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      var compareTo = attrs.lessThan;
	
	      $scope.$watch(attrs.lessThan, function () {
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.lessThan = function (modelValue) {
	        var watchVal = $scope.$eval(compareTo);
	
	        if (modelValue === undefined || watchVal === undefined) {
	          return true;
	        }
	
	        return !(modelValue > watchVal);
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new LessThan();
	    }
	  }]);
	
	  return LessThan;
	}();
	
	exports.default = LessThan;

/***/ },
/* 429 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BackgroundImage = function () {
	  function BackgroundImage() {
	    'ngInject';
	
	    _classCallCheck(this, BackgroundImage);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(BackgroundImage, [{
	    key: 'link',
	    value: function link($scope, element, attrs) {
	      var url = attrs.backgroundImage;
	      element.css({
	        background: 'url(\'' + url + '\') no-repeat center center fixed',
	        'background-size': 'cover'
	      });
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new BackgroundImage();
	    }
	  }]);
	
	  return BackgroundImage;
	}();
	
	exports.default = BackgroundImage;

/***/ },
/* 430 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CompareToNotEqual = function () {
	  function CompareToNotEqual() {
	    'ngInject';
	
	    _classCallCheck(this, CompareToNotEqual);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	    this.scope = {
	      otherModelValue: '=compareToNotEqual'
	    };
	  }
	
	  _createClass(CompareToNotEqual, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      $scope.$watch('otherModelValue', function () {
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.compareToNotEqual = function (modelValue) {
	        return modelValue !== $scope.otherModelValue;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new CompareToNotEqual();
	    }
	  }]);
	
	  return CompareToNotEqual;
	}();
	
	exports.default = CompareToNotEqual;

/***/ },
/* 431 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UniqueUsername = function () {
	  UniqueUsername.$inject = ["$q", "AccountService"];
	  function UniqueUsername($q, AccountService) {
	    'ngInject';
	
	    _classCallCheck(this, UniqueUsername);
	
	    Object.assign(this, {
	      $q: $q,
	      AccountService: AccountService
	    });
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(UniqueUsername, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      var _this = this;
	
	      var userId = null;
	
	      if (attrs.userId) {
	        userId = attrs.userId;
	      }
	
	      // Async validator requires resolve or reject to set validity
	      ctrl.$asyncValidators.uniqueUsername = function (username) {
	        var defer = _this.$q.defer();
	
	        _this.AccountService.isUniqueUsername(username, userId).then(function (r) {
	          if (r.data) {
	            defer.resolve();
	          }
	
	          defer.reject();
	        }).catch(function () {
	          return defer.reject();
	        });
	
	        return defer.promise;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: ["$q", "AccountService", function directiveFactory($q, AccountService) {
	      'ngInject';
	
	      return new UniqueUsername($q, AccountService);
	    }]
	  }]);
	
	  return UniqueUsername;
	}();
	
	exports.default = UniqueUsername;

/***/ },
/* 432 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotNull = function () {
	  function NotNull() {
	    'ngInject';
	
	    _classCallCheck(this, NotNull);
	
	    this.restrict = 'A';
	  }
	
	  _createClass(NotNull, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      ctrl.$validators.notNull = function (modelValue) {
	        return true && modelValue;
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new NotNull();
	    }
	  }]);
	
	  return NotNull;
	}();
	
	exports.default = NotNull;

/***/ },
/* 433 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PhoneNumber = function () {
	  function PhoneNumber() {
	    'ngInject';
	
	    _classCallCheck(this, PhoneNumber);
	
	    this.require = 'ngModel';
	    this.restrict = 'A';
	  }
	
	  _createClass(PhoneNumber, [{
	    key: 'link',
	    value: function link($scope, element, attrs, ctrl) {
	      ctrl.$validators.phoneNumber = function (modelValue) {
	        if (!(modelValue && modelValue.length)) {
	          return true;
	        }
	
	        var pattern = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
	        return modelValue.match(pattern);
	      };
	    }
	  }], [{
	    key: 'directiveFactory',
	    value: function directiveFactory() {
	      'ngInject';
	
	      return new PhoneNumber();
	    }
	  }]);
	
	  return PhoneNumber;
	}();
	
	exports.default = PhoneNumber;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(435);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _auth = __webpack_require__(735);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('app.components', [_app2.default, _auth2.default]).name;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _app = __webpack_require__(436);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _admin = __webpack_require__(438);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _account = __webpack_require__(517);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _adverseEvent = __webpack_require__(521);
	
	var _adverseEvent2 = _interopRequireDefault(_adverseEvent);
	
	var _adverseEvents = __webpack_require__(555);
	
	var _adverseEvents2 = _interopRequireDefault(_adverseEvents);
	
	var _common = __webpack_require__(563);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _dashboard = __webpack_require__(617);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _product = __webpack_require__(631);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _treatProduct = __webpack_require__(668);
	
	var _treatProduct2 = _interopRequireDefault(_treatProduct);
	
	var _products = __webpack_require__(680);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _reports = __webpack_require__(692);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app', [_angularUiRouter2.default, _admin2.default, _account2.default, _adverseEvent2.default, _adverseEvents2.default, _common2.default, _dashboard2.default, _product2.default, _treatProduct2.default, _products2.default, _reports2.default]).component('app', _app2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('app', {
	    redirectTo: 'dashboard',
	    url: '/app',
	    // data: {
	    //   permissions: {
	    //     except: ['ANONYMOUS'],
	    //     redirectTo: 'login'
	    //   }
	    // },
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      currentUser: ["SessionService", function currentUser(SessionService) {
	        return SessionService.user;
	      }]
	    },
	    component: 'app'
	  });
	}]).name;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(437);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _app2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    currentUser: '<'
	  },
	  controller: function () {
	    AppComponent.$inject = ["$mdDialog", "$mdMedia", "$mdSidenav", "$state", "$scope", "AuthService", "FeedbackService", "ToastService"];
	    function AppComponent($mdDialog, $mdMedia, $mdSidenav, $state, $scope, AuthService, FeedbackService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AppComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $mdMedia: $mdMedia,
	        $mdSidenav: $mdSidenav,
	        $state: $state,
	        $scope: $scope,
	        AuthService: AuthService,
	        FeedbackService: FeedbackService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AppComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.showHamburgerMenu = {
	          value: !this.$mdMedia('gt-md')
	        };
	      }
	    }, {
	      key: 'logout',
	      value: function logout() {
	        var _this = this;
	
	        return this.authService.logout().then(function () {
	          return _this.$state.go('login');
	        });
	      }
	    }, {
	      key: 'addFeedback',
	      value: function addFeedback() {
	        var _this2 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onFeedbackSubmitted: function onFeedbackSubmitted($event) {
	            return _this2.onFeedbackSubmitted($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          scope: scope,
	          fullscreen: true,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <feedback\n                on-feedback-submitted="onFeedbackSubmitted($event)">\n              </feedback>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onFeedbackSubmitted',
	      value: function onFeedbackSubmitted($event) {
	        var _this3 = this;
	
	        if ($event && $event.feedback) {
	          this.FeedbackService.submit($event.feedback).then(function () {
	            _this3.$mdDialog.hide();
	            _this3.ToastService.showSuccess('Feedback submitted successfully!');
	          }).catch(function (error) {
	            return _this3.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        this.$mdSidenav('left').toggle();
	      }
	    }]);
	
	    return AppComponent;
	  }()
	};

/***/ },
/* 437 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/app.html';
	var html = "<div layout=row flex style=height:100%> <app-menu layout=column current-user=$ctrl.currentUser></app-menu> <div role=main id=main layout=column flex> <app-toolbar> <toolbar-buttons-left> <md-button class=md-icon-button aria-label=\"Show Menu\" ng-show=\"!$ctrl.$mdMedia('gt-sm')\" ng-click=$ctrl.toggleMenu()> <md-tooltip>Show Menu</md-tooltip> <md-icon md-font-set=material-icons style=color:#fff>menu</md-icon> </md-button> </toolbar-buttons-left> <toolbar-buttons-right> <md-button class=\"md-raised md-accent no-print\" ng-click=$ctrl.addFeedback() permission permission-only=\"['USER', 'COMPANY_ADMIN']\"> <md-icon md-font-set=material-icons>feedback</md-icon> Submit Feedback </md-button> </toolbar-buttons-right> </app-toolbar> <md-content md-scroll-y layout=column flex id=main-content> <div flex=100 layout=column layout-align=\"center center\" layout-fill ng-if=$root.loadingView id=app-loading> <md-progress-circular md-mode=indeterminate></md-progress-circular> </div> <ui-view layout=column flex=noshrink ng-hide=$root.loadingView></ui-view> </md-content> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _categories = __webpack_require__(439);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _companies = __webpack_require__(447);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _company = __webpack_require__(465);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _mapCategories = __webpack_require__(474);
	
	var _mapCategories2 = _interopRequireDefault(_mapCategories);
	
	var _mapIngredients = __webpack_require__(479);
	
	var _mapIngredients2 = _interopRequireDefault(_mapIngredients);
	
	var _memberCompliance = __webpack_require__(483);
	
	var _memberCompliance2 = _interopRequireDefault(_memberCompliance);
	
	var _memberComplianceProcess = __webpack_require__(493);
	
	var _memberComplianceProcess2 = _interopRequireDefault(_memberComplianceProcess);
	
	var _regulator = __webpack_require__(494);
	
	var _regulator2 = _interopRequireDefault(_regulator);
	
	var _userIngredients = __webpack_require__(503);
	
	var _userIngredients2 = _interopRequireDefault(_userIngredients);
	
	var _systemIngredients = __webpack_require__(510);
	
	var _systemIngredients2 = _interopRequireDefault(_systemIngredients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin', [_angularUiRouter2.default, _categories2.default, _companies2.default, _company2.default, _mapCategories2.default, _mapIngredients2.default, _memberCompliance2.default, _memberComplianceProcess2.default, _regulator2.default, _userIngredients2.default, _systemIngredients2.default]).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    parent: 'app',
	    template: '<ui-view flex layout="column"></ui-view>',
	    url: '/admin',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _categories = __webpack_require__(440);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _categoryForm = __webpack_require__(444);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.categories', [_angularUiRouter2.default, _categoryForm2.default]).component('categories', _categories2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('categories', {
	    parent: 'admin',
	    url: '/categories',
	    component: 'categories',
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      }
	    }
	  });
	}]).name;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _messages = __webpack_require__(442);
	
	var _query = __webpack_require__(408);
	
	var _categories = __webpack_require__(443);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _categories2.default,
	  bindings: {
	    flex: '@',
	    layout: '@'
	  },
	  controller: function () {
	    CategoriesComponent.$inject = ["$mdDialog", "$scope", "$state", "CategoryService", "ToastService"];
	    function CategoriesComponent($mdDialog, $scope, $state, CategoryService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, CategoriesComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        CategoryService: CategoryService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(CategoriesComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.columns = [{
	          FieldName: 'ProductCategoryName',
	          DisplayName: 'Category'
	        }, {
	          FieldName: 'ProductCount',
	          DisplayName: 'Product Count'
	        }];
	
	        this.selectedCategories = [];
	        this.query = this.CategoryService.getDefaultQuery();
	        this.refreshResults();
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(_ref) {
	        var searchText = _ref.searchText;
	
	        this.selectedCategories = [];
	        this.searchText = searchText;
	        this.query = _extends({}, this.query, {
	          filter: (0, _odataFilterBuilder2.default)().contains('ProductCategoryName', searchText)
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref2) {
	        var query = _ref2.query;
	
	        this.selectedCategories = [];
	        this.query = query;
	        this.refreshResults();
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this = this;
	
	        this.promise = this.CategoryService.search(this.query);
	        this.promise.then(function (r) {
	          _this.categories = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'canDeleteCategories',
	      value: function canDeleteCategories(categories) {
	        if (!(categories && categories.length)) {
	          return false;
	        }
	
	        return !categories.some(function (x) {
	          return x.ProductCount > 0;
	        });
	      }
	    }, {
	      key: 'categoryAdd',
	      value: function categoryAdd() {
	        var _this2 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          categoryChanged: function categoryChanged($event) {
	            return _this2.onCategoryAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <category-form\n                dialog-title="Add New Category"\n                submit-title="Add Category"\n                category-changed="categoryChanged($event)">\n              </category-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onCategoryAdded',
	      value: function onCategoryAdded(_ref3) {
	        var _this3 = this;
	
	        var category = _ref3.category;
	
	        this.CategoryService.add(category).then(function () {
	          _this3.$mdDialog.hide();
	          _this3.refreshResults();
	          _this3.ToastService.showSuccess(_messages.CATEGORY_ADDED);
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'categoryEdit',
	      value: function categoryEdit(category) {
	        var _this4 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          categoryChanged: function categoryChanged($event) {
	            return _this4.onCategoryEdited($event);
	          },
	          category: _angular2.default.copy(category)
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <category-form\n                category="category"\n                dialog-title="Edit Category"\n                submit-title="Save Changes"\n                category-changed="categoryChanged($event)">\n              </category-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'categoryDelete',
	      value: function categoryDelete(categories) {
	        var _this5 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected categories cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = categories.length - 1; i >= 0; i -= 1) {
	            promises.push(_this5.CategoryService.delete(categories[i].ProductCategoryId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this5.ToastService.showSuccess(_messages.CATEGORY_DELETED);
	            _this5.selectedCategories = [];
	            _this5.refreshResults();
	          }).catch(function (error) {
	            if (error.statusText === 'Bad Request' && error.data && error.data.Message) {
	              _this5.ToastService.showError(error, error.data.Message);
	            } else {
	              _this5.ToastService.showError(error);
	            }
	          });
	        });
	      }
	    }, {
	      key: 'onCategoryEdited',
	      value: function onCategoryEdited(_ref4) {
	        var _this6 = this;
	
	        var category = _ref4.category;
	
	        this.CategoryService.update(category).then(function () {
	          _this6.$mdDialog.hide();
	          _this6.selectedCategories = [];
	          _this6.refreshResults();
	          _this6.ToastService.showSuccess(_messages.CATEGORY_EDITED);
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return CategoriesComponent;
	  }()
	};

/***/ },
/* 441 */
/***/ function(module, exports) {

	'use strict';
	
	function ODataFilterBuilder$1() {
	  var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'and';
	
	  if (!(this instanceof ODataFilterBuilder$1)) {
	    return new ODataFilterBuilder$1(condition);
	  }
	
	  this._condition = condition;
	  this._source = {
	    condition: condition,
	    rules: []
	  };
	}
	
	function isODataFilterBuilder(obj) {
	  return obj instanceof ODataFilterBuilder$1;
	}
	
	function inputFieldToString(field) {
	  return typeof field === 'function' ? field(canonicalFunctions) : field;
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isString(value) {
	  return typeof value === 'string';
	}
	
	function isDate(value) {
	  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	function normaliseValue(value) {
	  if (isString(value)) {
	    return '\'' + value + '\'';
	  }
	
	  if (isDate(value)) {
	    return value.toISOString();
	  }
	
	  return value;
	}
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function canonicalFunction(functionName, field, values) {
	  var normaliseValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var reverse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // make sure that field is string
	  field = inputFieldToString(field);
	
	  if (typeof values === 'undefined') {
	    values = [];
	  } else if (!Array.isArray(values)) {
	    values = [values];
	  }
	
	  if (values.length === 0) {
	    return functionName + '(' + field + ')';
	  }
	
	  if (normaliseValues) {
	    values = values.map(normaliseValue);
	  }
	
	  var functionArgs = !reverse ? [field].concat(_toConsumableArray(values)) : [].concat(_toConsumableArray(values), [field]);
	
	  return functionName + '(' + functionArgs.join(', ') + ')';
	}
	
	function contains$1(field, value) {
	  return canonicalFunction('contains', field, value);
	}
	
	function startsWith$1(field, value) {
	  return canonicalFunction('startswith', field, value);
	}
	
	function endsWith$1(field, value) {
	  return canonicalFunction('endswith', field, value);
	}
	
	/**
	 * The tolower function returns the input parameter string value with all uppercase characters converted to lowercase.
	 * @example
	 * f().eq(x => x.toLower('CompanyName'), 'alfreds futterkiste')
	 * // tolower(CompanyName) eq 'alfreds futterkiste'
	 * @param {string|InputFieldExpression} field - Field
	 * @returns {string} A function string
	 */
	function toLower(field) {
	  return canonicalFunction('tolower', field);
	}
	
	/**
	 * The toupper function returns the input parameter string value with all lowercase characters converted to uppercase.
	 * @example
	 * f().eq(x => x.toUpper('CompanyName'), 'ALFREDS FUTTERKISTE')
	 * // toupper(CompanyName) eq 'ALFREDS FUTTERKISTE'
	 * @param {string|InputFieldExpression} field - Field
	 * @returns {string} A function string
	 */
	function toUpper(field) {
	  return canonicalFunction('toupper', field);
	}
	
	/**
	 * The trim function returns the input parameter string value with all leading and trailing whitespace characters, removed.
	 * @example
	 * f().eq(x => x.trim('CompanyName'), 'CompanyName')
	 * // trim(CompanyName) eq CompanyName
	 * @param {string|InputFieldExpression} field - Field
	 * @returns {string} A function string
	 */
	function trim(field) {
	  return canonicalFunction('trim', field);
	}
	
	/**
	 * @example
	 * f().eq(f.functions.substring('CompanyName', 1), 'lfreds Futterkiste');
	 * f().eq(x => x.substring('CompanyName', 1), 'lfreds Futterkiste');
	 * // substring(CompanyName, 1) eq 'lfreds Futterkiste'
	 *
	 * @example
	 * f().eq(x => x.substring('CompanyName', 1, 2), 'lf').toString();
	 * f().eq(f.functions.substring('CompanyName', 1, 2), 'lf')
	 * // substring(CompanyName, 1, 2) eq 'lf'
	 *
	 * @param {string|InputFieldExpression} field - The first function parameter
	 * @param {...number} values - Second or second and third function parameters
	 *
	 * @returns {string} A function string
	 */
	function substring(field) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  return canonicalFunction('substring', field, values);
	}
	
	/**
	 * @param {string|InputFieldExpression} field - The first function parameter
	 * @param {string} value - The second function parameter
	 * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	 * @example
	 * f().eq(x => x.concat(y => y.concat('City',', '), 'Country', false), 'Berlin, Germany');
	 * // concat(concat(City, ', '), 'Country') eq 'Berlin, Germany'
	 * @returns {string} A function string
	 */
	function concat(field, value, normaliseValue$$1) {
	  return canonicalFunction('concat', field, [value], normaliseValue$$1);
	}
	
	/**
	 * The length function returns the number of characters in the parameter value.
	 * @example
	 * f().eq(x => x.length('CompanyName'), 19)
	 * // length(CompanyName) eq 19
	 * @param {string|InputFieldExpression} field - Field
	 * @returns {string} A function string
	 */
	function length(field) {
	  return canonicalFunction('length', field);
	}
	
	/**
	 * The indexof function returns the zero-based character position of the first occurrence of the second parameter value in the first parameter value.
	 * @example
	 * f().eq(f.functions.indexOf('CompanyName', 'lfreds'), 1)
	 * f().eq(x => x.indexOf('CompanyName', 'lfreds'), 1)
	 * // indexof(CompanyName,'lfreds') eq 1
	 *
	 * @param {string|InputFieldExpression} field - The first function parameter
	 * @param {string} value - The second function parameter
	 *
	 * @returns {string} A function string
	 */
	function indexOf(field, value) {
	  return canonicalFunction('indexof', field, [value]);
	}
	
	
	
	var canonicalFunctions = Object.freeze({
		canonicalFunction: canonicalFunction,
		contains: contains$1,
		startsWith: startsWith$1,
		endsWith: endsWith$1,
		toLower: toLower,
		toUpper: toUpper,
		trim: trim,
		substring: substring,
		concat: concat,
		length: length,
		indexOf: indexOf
	});
	
	/**
	 * Reduce source with new rule and/or condition
	 * @param {Object} source - Source rule
	 * @param {Object|string} rule - Rule to add
	 * @param {string} [condition] - Condition for rule to add(and/or)
	 * @returns {Object} updated rule
	 * @private
	 */
	function reduceSourceWithRule(source, rule, condition) {
	  if (rule) {
	    if (condition && source.condition !== condition) {
	      // if source rules condition different from rule condition
	      // update source condition
	
	      source = {
	        condition: condition,
	        // if has more then one rules
	        // regroup source rules tree
	        rules: source.rules.length > 1 ? [source] : source.rules
	      };
	    }
	
	    // add new rule
	    source.rules.push(rule);
	  }
	  return source;
	}
	
	function inputRuleToString(rule) {
	  if (typeof rule === 'function') {
	    rule = rule(new ODataFilterBuilder$1());
	  }
	
	  return rule && rule.toString();
	}
	
	function joinRulesWithCondition(rules, condition) {
	  return rules.map(function (r) {
	    return sourceRuleToString(r, true);
	  }).join(' ' + condition + ' ');
	}
	
	function sourceRuleToString(rule) {
	  var wrapInParenthesis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof rule !== 'string') {
	    // if child rules more then one join child rules by condition
	    // and wrap in brackets every child rule
	    rule = rule.rules.length === 1 ? sourceRuleToString(rule.rules[0]) : joinRulesWithCondition(rule.rules, rule.condition);
	  }
	
	  return wrapInParenthesis ? '(' + rule + ')' : rule;
	}
	
	function not$1(rule) {
	  var ruleString = inputRuleToString(rule);
	  if (ruleString) {
	    return 'not (' + ruleString + ')';
	  }
	}
	
	function compare(field, operator, value) {
	  var normaliseValue$$1 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  // make sure that field is string
	  field = inputFieldToString(field);
	
	  if (normaliseValue$$1) {
	    value = normaliseValue(value);
	  }
	
	  return field + ' ' + operator + ' ' + value;
	}
	
	function compareMap(field, operator, values) {
	  var normaliseValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!values) {
	    return [];
	  }
	
	  // make sure that field is string
	  field = inputFieldToString(field);
	
	  if (!Array.isArray(values)) {
	    return [compare(field, operator, values, normaliseValues)];
	  }
	
	  return values.map(function (value) {
	    return compare(field, operator, value, normaliseValues);
	  });
	}
	
	function eq$1(field, value, normaliseValue$$1) {
	  return compare(field, 'eq', value, normaliseValue$$1);
	}
	
	function ne$1(field, value, normaliseValue$$1) {
	  return compare(field, 'ne', value, normaliseValue$$1);
	}
	
	function gt$1(field, value, normaliseValue$$1) {
	  return compare(field, 'gt', value, normaliseValue$$1);
	}
	
	function ge$1(field, value, normaliseValue$$1) {
	  return compare(field, 'ge', value, normaliseValue$$1);
	}
	
	function lt$1(field, value, normaliseValue$$1) {
	  return compare(field, 'lt', value, normaliseValue$$1);
	}
	
	function le$1(field, value, normaliseValue$$1) {
	  return compare(field, 'le', value, normaliseValue$$1);
	}
	
	function joinRules(rules, condition) {
	  return rules.join(' ' + condition + ' ');
	}
	
	function compareIn(field, values, normaliseValues) {
	  return joinRules(compareMap(field, 'eq', values, normaliseValues), 'or');
	}
	
	function compareNotIn(field, values, normaliseValues) {
	  // return joinRules(compareMap(field, 'ne', values, normaliseValues), 'and')
	  return not$1(compareIn(field, values, normaliseValues));
	}
	
	var proto = {
	  constructor: ODataFilterBuilder$1,
	
	  /**
	   * The 'add' method adds new filter rule with AND or OR condition
	   * if condition not provided. Source condition is used (AND by default)
	   * @this {ODataFilterBuilder}
	   * @param {string|ODataFilterBuilder|InputRuleExpression} rule - Rule to add
	   * @param {string} [condition] - Condition for rule to add(and/or)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   * @private
	   */
	  _add: function _add(rule) {
	    var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._condition;
	
	    // NOTE: if condition not provider, source condition uses
	    this._source = reduceSourceWithRule(this._source, inputRuleToString(rule), condition);
	    return this;
	  },
	
	
	  /*
	   * Logical Operators
	   */
	
	  /**
	   * Logical And
	   * @param {string|ODataFilterBuilder|InputRuleExpression} rule - Rule to add
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  and: function and(rule) {
	    return this._add(rule, 'and');
	  },
	
	
	  /**
	   * Logical Or
	   * @param {string|ODataFilterBuilder|InputRuleExpression} rule - Rule to add
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  or: function or(rule) {
	    return this._add(rule, 'or');
	  },
	
	
	  /**
	   * Logical Negation
	   * @param {string|ODataFilterBuilder|InputRuleExpression} rule - Rule to add
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  not: function not(rule) {
	    return this._add(not$1(rule));
	  },
	
	
	  /**
	   * Equal
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  eq: function eq(field, value, normaliseValue) {
	    return this._add(eq$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * Not Equal
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  ne: function ne(field, value, normaliseValue) {
	    return this._add(ne$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * Greater Than
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  gt: function gt(field, value, normaliseValue) {
	    return this._add(gt$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * Greater than or Equal
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  ge: function ge(field, value, normaliseValue) {
	    return this._add(ge$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * Less Than
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  lt: function lt(field, value, normaliseValue) {
	    return this._add(lt$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * Less than or Equal
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string|number|*} value - A value to compare with
	   * @param {boolean} [normaliseValue=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  le: function le(field, value, normaliseValue) {
	    return this._add(le$1(field, value, normaliseValue));
	  },
	
	
	  /**
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string[]|string} values - Values to compare with
	   * @param {boolean} [normaliseValues=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  in: function _in(field, values, normaliseValues) {
	    return this._add(compareIn(field, values, normaliseValues));
	  },
	
	
	  /**
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {Array} values - Values to compare with
	   * @param {boolean} [normaliseValues=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  notIn: function notIn(field, values, normaliseValues) {
	    return this._add(compareNotIn(field, values, normaliseValues));
	  },
	
	
	  // Canonical Functions
	
	  /**
	   * The contains function returns true if the second parameter string value is a substring of the first parameter string value.
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string} value - Value to compare
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  contains: function contains(field, value) {
	    return this._add(contains$1(field, value));
	  },
	
	
	  /**
	   * The startswith function returns true if the first parameter string value starts with the second parameter string value.
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string} value - Value to compare
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  startsWith: function startsWith(field, value) {
	    return this._add(startsWith$1(field, value));
	  },
	
	
	  /**
	   * The endswith function returns true if the first parameter string value ends with the second parameter string value.
	   * @param {string|InputFieldExpression} field - Field to compare
	   * @param {string} value - Value to compare
	   * @returns {ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  endsWith: function endsWith(field, value) {
	    return this._add(endsWith$1(field, value));
	  },
	
	
	  /**
	   * Custom function
	   * @param {string} functionName - Name of generated function
	   * @param {string|InputFieldExpression} field - The first function parameter
	   * @param {string|number|Array} values - The second function parameter
	   * @param {boolean} [normaliseValues=true] - Convert string "value" to "'value'" or not. (Convert by default)
	   * @param {boolean} [reverse=false] - Swap field and value params in output. (Don't swap by default)
	   * @returns {*|ODataFilterBuilder} The {@link ODataFilterBuilder} instance
	   */
	  fn: function fn(functionName, field, values, normaliseValues, reverse) {
	    return this._add(canonicalFunction(functionName, field, values, normaliseValues, reverse));
	  },
	  isEmpty: function isEmpty() {
	    return this._source.rules.length === 0;
	  },
	
	
	  /**
	   * Convert filter builder instance to string
	   * @this {ODataFilterBuilder}
	   * @returns {string} A source string representation
	   */
	  toString: function toString() {
	    return sourceRuleToString(this._source);
	  }
	};
	
	ODataFilterBuilder$1.and = function () {
	  return new ODataFilterBuilder$1('and');
	};
	ODataFilterBuilder$1.or = function () {
	  return new ODataFilterBuilder$1('or');
	};
	
	ODataFilterBuilder$1.functions = canonicalFunctions;
	ODataFilterBuilder$1.isODataFilterBuilder = isODataFilterBuilder;
	ODataFilterBuilder$1.prototype = proto;
	
	module.exports = ODataFilterBuilder$1;


/***/ },
/* 442 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable max-len */
	var USER_ADDED = exports.USER_ADDED = 'User successfully added!';
	var USER_EDITED = exports.USER_EDITED = 'User successfully modified!';
	var USER_DELETED = exports.USER_DELETED = 'User successfully removed!';
	
	var COMPANY_ADDED = exports.COMPANY_ADDED = 'Company successfully added!';
	var COMPANY_EDITED = exports.COMPANY_EDITED = 'Company successfully modified!';
	var COMPANY_DELETED = exports.COMPANY_DELETED = 'Company successfully removed!';
	
	var REGULATOR_ADDED = exports.REGULATOR_ADDED = 'Regulator successfully added!';
	var REGULATOR_EDITED = exports.REGULATOR_EDITED = 'Regulator successfully modified!';
	var REGULATOR_DELETED = exports.REGULATOR_DELETED = 'Regulator successfully removed!';
	
	var ACCOUNT_EDITED = exports.ACCOUNT_EDITED = 'Account information successfully saved!';
	var ACCOUNT_LOCKOUT_EDITED = exports.ACCOUNT_LOCKOUT_EDITED = 'Account lockout status successfully saved!';
	
	var ADVERSE_EVENT_ATTESTED = exports.ADVERSE_EVENT_ATTESTED = 'Attested successfully!';
	var ADVERSE_EVENT_DELETED = exports.ADVERSE_EVENT_DELETED = 'Adverse event(s) successfully removed!';
	
	var USAGE_DATA_UPDATED = exports.USAGE_DATA_UPDATED = 'Shipping data successfully saved!';
	
	var PRODUCT_ADDED = exports.PRODUCT_ADDED = 'Product successfully added!';
	var PRODUCT_EDITED = exports.PRODUCT_EDITED = 'Product changes successfully saved!';
	var PRODUCT_DELETED = exports.PRODUCT_DELETED = 'Product(s) successfully removed!';
	var PRODUCT_DELETE_GUIDANCE = exports.PRODUCT_DELETE_GUIDANCE = 'Member products will be moved to membertest. Once deleted from membertest, the selected product(s) cannot be recovered!';
	var PRODUCT_COPIED = exports.PRODUCT_COPIED = 'Product copied successfully! Save the product for changes to take effect.';
	
	var PRODUCT_SIGNATURE_ADDED = exports.PRODUCT_SIGNATURE_ADDED = 'Product signature successfully applied!';
	var PRODUCT_SIGNATURE_DELETED = exports.PRODUCT_SIGNATURE_DELETED = 'Product signature successfully removed!';
	
	var PRODUCT_DISCONTINUED_EDITED = exports.PRODUCT_DISCONTINUED_EDITED = 'Product discontinued status successfully saved!';
	var DISCONTINUED_PREFERENCE_CHANGED = exports.DISCONTINUED_PREFERENCE_CHANGED = 'Product discontinued preference successfully saved!';
	var PRODUCT_DISCONTINUATION_GUIDANCE = exports.PRODUCT_DISCONTINUATION_GUIDANCE = 'Products should only be discontinued if they are no longer being sold or if there has been a formulation change. For other changes, such as label updates or corrections, the product should be unsigned instead. Please contact your account manager if needed.';
	
	var PRODUCT_LABEL_COMMITTED = exports.PRODUCT_LABEL_COMMITTED = 'Product label successfully changed!';
	var PRODUCT_LABEL_CHANGED = exports.PRODUCT_LABEL_CHANGED = 'Product label successfully changed! Save the product for changes to take effect.';
	var PRODUCT_LABEL_CHANGED_ERROR = exports.PRODUCT_LABEL_CHANGED_ERROR = 'Unable to upload file! Try again in Google Chrome, Firefox, Safari, Edge, or IE10.';
	
	var ADMINISTRATION_ADDED = exports.ADMINISTRATION_ADDED = 'Administration successfully added!';
	var ADMINISTRATION_EDITED = exports.ADMINISTRATION_EDITED = 'Administration changes successfully saved!';
	var ADMINISTRATION_DELETED = exports.ADMINISTRATION_DELETED = 'Administration successfully removed!';
	
	var PRODUCT_INGREDIENT_ADDED = exports.PRODUCT_INGREDIENT_ADDED = 'Ingredient successfully added!';
	var PRODUCT_INGREDIENT_EDITED = exports.PRODUCT_INGREDIENT_EDITED = 'Ingredient changes successfully saved!';
	var PRODUCT_INGREDIENT_DELETED = exports.PRODUCT_INGREDIENT_DELETED = 'Ingredient successfully removed!';
	
	var ADVERSE_EVENT_ADDED = exports.ADVERSE_EVENT_ADDED = 'Adverse event successfully added!';
	var ADVERSE_EVENT_EDITED = exports.ADVERSE_EVENT_EDITED = 'Adverse event changes successfully saved!';
	var ADVERSE_EVENT_CLOSED = exports.ADVERSE_EVENT_CLOSED = 'Adverse event successfully closed!';
	
	var PASSWORD_CHANGED = exports.PASSWORD_CHANGED = 'Password successfully changed!';
	var PASSWORD_RESET = exports.PASSWORD_RESET = 'Password successfully reset.';
	var FORGOT_PASSWORD_CONFIRMED = exports.FORGOT_PASSWORD_CONFIRMED = 'Please check your email to retrieve your NASC credentials!';
	
	var SYSTEM_INGREDIENT_ADDED = exports.SYSTEM_INGREDIENT_ADDED = 'System ingredient successfully added!';
	var SYSTEM_INGREDIENT_EDITED = exports.SYSTEM_INGREDIENT_EDITED = 'System ingredient changes successfully saved!';
	var SYSTEM_INGREDIENT_DELETED = exports.SYSTEM_INGREDIENT_DELETED = 'System ingredient successfully removed!';
	
	var USER_INGREDIENT_ADDED = exports.USER_INGREDIENT_ADDED = 'User ingredient successfully added!';
	var USER_INGREDIENT_EDITED = exports.USER_INGREDIENT_EDITED = 'User ingredient changes successfully saved!';
	var USER_INGREDIENT_DELETED = exports.USER_INGREDIENT_DELETED = 'User ingredient successfully removed!';
	var USER_INGREDIENT_DELETE_CONFIRMATION = exports.USER_INGREDIENT_DELETE_CONFIRMATION = 'Once deleted, the selected ingredient(s) cannot be recovered. They will also be removed from any products containing them.';
	
	var CATEGORY_ADDED = exports.CATEGORY_ADDED = 'Category successfully added!';
	var CATEGORY_EDITED = exports.CATEGORY_EDITED = 'Category changes successfully saved!';
	var CATEGORY_DELETED = exports.CATEGORY_DELETED = 'Category successfully removed!';
	
	var SYSTEM_MESSAGE_CHANGED = exports.SYSTEM_MESSAGE_CHANGED = 'System message changes successfully saved!';
	var COMPANY_MESSAGE_CHANGED = exports.COMPANY_MESSAGE_CHANGED = 'Company message changes successfully saved!';
	
	var INGREDIENT_RISK_REPORT_GENERATED = exports.INGREDIENT_RISK_REPORT_GENERATED = 'Ingredient risk report successfully generated!';
	/* eslint-enable max-len */

/***/ },
/* 443 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/categories/categories.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Categories</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.categoryAdd()> <md-tooltip md-direction=top>Add Category</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedCategories && $ctrl.selectedCategories.length === 1\" ng-click=$ctrl.categoryEdit($ctrl.selectedCategories[0]) ng-if=\"$ctrl.selectedCategories && $ctrl.selectedCategories.length === 1\"> <md-tooltip md-direction=top>Edit Category</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=$ctrl.canDeleteCategories($ctrl.selectedCategories) ng-click=$ctrl.categoryDelete($ctrl.selectedCategories)> <md-tooltip md-direction=top>Delete Category</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <item-list items=$ctrl.categories selected-items=$ctrl.selectedCategories columns=$ctrl.columns query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) search-text-changed=$ctrl.onSearchTextChanged($event) display-name-plural=Categories layout=column flex> </item-list> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoryForm = __webpack_require__(445);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.admin.categories.categoryForm', []).component('categoryForm', _categoryForm2.default).name;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _categoryForm = __webpack_require__(446);
	
	var _categoryForm2 = _interopRequireDefault(_categoryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _categoryForm2.default,
	  bindings: {
	    category: '<',
	    dialogTitle: '@',
	    submitTitle: '@',
	    categoryChanged: '&'
	  },
	  controller: function () {
	    CategoryFormComponent.$inject = ["EventEmitter"];
	    function CategoryFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, CategoryFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(CategoryFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.categoryChanged(this.EventEmitter({
	          category: this.category
	        }));
	      }
	    }]);
	
	    return CategoryFormComponent;
	  }()
	};

/***/ },
/* 446 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/categories/category-form/category-form.html';
	var html = "<form name=$ctrl.categoryForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex> <label>Category Name</label> <input ng-model=$ctrl.category.ProductCategoryName name=categoryName required> <div ng-messages=$ctrl.categoryForm.categoryName.$error md-auto-hide=false> <div ng-message=required> Category name is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.categoryForm.$valid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _query = __webpack_require__(408);
	
	var _companyList = __webpack_require__(448);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	var _regulatorList = __webpack_require__(451);
	
	var _regulatorList2 = _interopRequireDefault(_regulatorList);
	
	var _adminUserList = __webpack_require__(454);
	
	var _adminUserList2 = _interopRequireDefault(_adminUserList);
	
	var _adminUserAddForm = __webpack_require__(457);
	
	var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);
	
	var _adminUserEditForm = __webpack_require__(460);
	
	var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);
	
	var _companies = __webpack_require__(463);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.companies', [_angularUiRouter2.default, _companyList2.default, _regulatorList2.default, _adminUserList2.default, _adminUserAddForm2.default, _adminUserEditForm2.default]).component('companies', _companies2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('companies', {
	    parent: 'admin',
	    url: '/companies',
	    component: 'companies',
	    resolve: {
	      companyQuery: ["CompanyService", function companyQuery(CompanyService) {
	        return CompanyService.getDefaultQuery();
	      }],
	      user: ["currentUser", function user(currentUser) {
	        return currentUser;
	      }],
	      companies: ["CompanyService", "companyQuery", function companies(CompanyService, companyQuery) {
	        return CompanyService.search(companyQuery).then(function (r) {
	          return (0, _query.transformODataResponse)(r);
	        });
	      }],
	      regulatorQuery: ["RegulatorService", function regulatorQuery(RegulatorService) {
	        return RegulatorService.getDefaultQuery();
	      }],
	      regulators: ["regulatorQuery", "RegulatorService", function regulators(regulatorQuery, RegulatorService) {
	        return RegulatorService.search(regulatorQuery).then(function (r) {
	          return (0, _query.transformODataResponse)(r);
	        });
	      }],
	      adminUsersQuery: ["PeopleService", function adminUsersQuery(PeopleService) {
	        return PeopleService.getDefaultQuery();
	      }],
	      adminUsers: ["adminUsersQuery", "PeopleService", function adminUsers(adminUsersQuery, PeopleService) {
	        return PeopleService.search(adminUsersQuery).then(function (r) {
	          return (0, _query.transformODataResponse)(r);
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _companyList = __webpack_require__(449);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.account.company-list', []).component('companyList', _companyList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _companyList = __webpack_require__(450);
	
	var _companyList2 = _interopRequireDefault(_companyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _companyList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    query: '<',
	    companies: '<',
	    userLockoutChanged: '&',
	    queryChanged: '&',
	    searchTextChanged: '&',
	    complianceChanged: '&'
	  },
	  controller: function () {
	    CompanyListComponent.$inject = ["EventEmitter"];
	    function CompanyListComponent(EventEmitter) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, CompanyListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.onQueryChange(_extends({}, _this.query, {
	          page: page,
	          take: take
	        }));
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.onQueryChange(_extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        }));
	      };
	    }
	
	    _createClass(CompanyListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'onQueryChange',
	      value: function onQueryChange(query) {
	        this.queryChanged(this.EventEmitter({
	          query: query
	        }));
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(searchText) {
	        this.searchTextChanged(this.EventEmitter({
	          searchText: searchText
	        }));
	      }
	    }, {
	      key: 'onComplianceChanged',
	      value: function onComplianceChanged(company) {
	        this.complianceChanged(this.EventEmitter({
	          company: company
	        }));
	      }
	    }]);
	
	    return CompanyListComponent;
	  }()
	};

/***/ },
/* 450 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/companies/company-list/company-list.html';
	var html = "<md-card-content layout=column flex> <md-input-container class=md-block> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChanged($ctrl.searchText)> </md-input-container> <div layout=column flex ng-show=\"$ctrl.companies.Data && $ctrl.companies.Count\"> <md-table-container layout=column flex> <table md-table md-progress=$ctrl.promise> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=MemberName><span>Company Name</span></th> <th md-column md-order-by=IsActive><span>Active Member</span></th> <th md-column md-order-by=IsLogOut><span>Locked out</span></th> <th md-column md-order-by=IsRequireMonthlyCompliance><span>Monthly Compliance</span></th> <th md-column md-order-by=IsNascAudited><span>NASC Audited</span></th> <th md-column><span>&nbsp;</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"company in $ctrl.companies.Data\"> <td md-cell>{{company.MemberName}}</td> <td md-cell> <md-checkbox ng-model=company.IsActive ng-change=$ctrl.onComplianceChanged(company) aria-label=\"Active Member\"></md-checkbox> </td> <td md-cell> <md-checkbox ng-model=company.IsLogOut ng-change=$ctrl.onComplianceChanged(company) aria-label=\"Locked out\"></md-checkbox> </td> <td md-cell> <md-checkbox ng-model=company.IsRequireMonthlyCompliance ng-change=$ctrl.onComplianceChanged(company) aria-label=\"Monthly Compliance\"></md-checkbox> </td> <td md-cell> <md-checkbox ng-model=company.IsNascAudited ng-change=$ctrl.onComplianceChanged(company) aria-label=\"NASC Audited\"></md-checkbox> </td> <td md-cell style=text-align:right> <a ui-sref=\"company({id: company.MemberId})\" class=md-primary>View</a> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.companies.Count}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Companies per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.companies.Data && $ctrl.companies.Count\"> <p class=md-body-1> There are no companies matching the specified criteria. </p> </div> </md-card-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _regulatorList = __webpack_require__(452);
	
	var _regulatorList2 = _interopRequireDefault(_regulatorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.account.regulator-list', []).component('regulatorList', _regulatorList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _regulatorList = __webpack_require__(453);
	
	var _regulatorList2 = _interopRequireDefault(_regulatorList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _regulatorList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    query: '<',
	    regulators: '<',
	    selectedRegulators: '<',
	    userLockoutChanged: '&',
	    queryChanged: '&',
	    searchTextChanged: '&'
	  },
	  controller: function () {
	    RegulatorListComponent.$inject = ["EventEmitter"];
	    function RegulatorListComponent(EventEmitter) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, RegulatorListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.onQueryChange(_extends({}, _this.query, {
	          page: page,
	          take: take
	        }));
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.onQueryChange(_extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        }));
	      };
	    }
	
	    _createClass(RegulatorListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'onQueryChange',
	      value: function onQueryChange(query) {
	        this.queryChanged(this.EventEmitter({
	          query: query
	        }));
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(searchText) {
	        this.searchTextChanged(this.EventEmitter({
	          searchText: searchText
	        }));
	      }
	    }]);
	
	    return RegulatorListComponent;
	  }()
	};

/***/ },
/* 453 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/companies/regulator-list/regulator-list.html';
	var html = "<md-card-content layout=column flex> <md-input-container class=md-block> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChanged($ctrl.searchText)> </md-input-container> <div flex ng-show=\"$ctrl.regulators.Data && $ctrl.regulators.Count\"> <md-table-container layout=column flex> <table md-table md-row-select=true md-progress=$ctrl.promise ng-model=$ctrl.selectedRegulators multiple=true> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=AgentName><span>Organization Name</span></th> <th md-column><span>&nbsp;</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"regulator in $ctrl.regulators.Data\" md-auto-select md-select=regulator md-auto-select> <td md-cell>{{regulator.AgentName}}</td> <td md-cell style=text-align:right> <a ui-sref=\"regulator({id: regulator.RegulatorId})\" class=md-primary>View</a> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.regulators.Count}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Regulators per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.regulators.Data && $ctrl.regulators.Count\"> <p class=md-body-1> There are no regulators matching the specified criteria. </p> </div> </md-card-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adminUserList = __webpack_require__(455);
	
	var _adminUserList2 = _interopRequireDefault(_adminUserList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.admin-user-list', []).component('adminUserList', _adminUserList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _adminUserList = __webpack_require__(456);
	
	var _adminUserList2 = _interopRequireDefault(_adminUserList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminUserList2.default,
	  bindings: {
	    users: '<',
	    selectedUsers: '<',
	    userLockoutChanged: '&',
	    locked: '<',
	    query: '<',
	    queryChanged: '&',
	    searchTextChanged: '&',
	    showColumns: '<'
	  },
	  controller: function () {
	    AdminUserListComponent.$inject = ["EventEmitter"];
	    function AdminUserListComponent(EventEmitter) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, AdminUserListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.onQueryChange(_extends({}, _this.query, {
	          page: page,
	          take: take
	        }));
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.onQueryChange(_extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        }));
	      };
	    }
	
	    _createClass(AdminUserListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'setUserLocked',
	      value: function setUserLocked(user) {
	        this.userLockoutChanged(this.EventEmitter({
	          userId: user.UserId,
	          isLocked: !user.IsLocked
	        }));
	      }
	    }, {
	      key: 'onQueryChange',
	      value: function onQueryChange(query) {
	        this.queryChanged(this.EventEmitter({
	          query: query
	        }));
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(searchText) {
	        this.searchTextChanged(this.EventEmitter({
	          searchText: searchText
	        }));
	      }
	    }, {
	      key: 'shouldShowColumn',
	      value: function shouldShowColumn(columnName) {
	        if (!(this.showColumns && this.showColumns.length)) {
	          return false;
	        }
	
	        return this.showColumns.indexOf(columnName) > -1;
	      }
	    }]);
	
	    return AdminUserListComponent;
	  }()
	};

/***/ },
/* 456 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/admin-users/admin-user-list/admin-user-list.html';
	var html = "<md-card-content layout=column flex> <md-input-container class=md-block> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChanged($ctrl.searchText)> </md-input-container> <div layout=column flex ng-show=\"$ctrl.users.Data && $ctrl.users.Count\"> <md-table-container layout=column flex> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedUsers md-progress=$ctrl.promise> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=FirstName><span>First Name</span></th> <th md-column md-order-by=LastName><span>Last Name</span></th> <th md-column md-order-by=Username><span>Username</span></th> <th md-column md-order-by=Email><span>Email</span></th> <th md-column md-order-by=IsLocked><span>Locked out</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"user in $ctrl.users.Data\" md-select=user> <td md-cell>{{user.FirstName}}</td> <td md-cell>{{user.LastName}}</td> <td md-cell>{{user.Username}}</td> <td md-cell>{{user.Email}}</td> <td md-cell stop-event=click> <md-checkbox ng-model=user.IsLocked ng-click=$ctrl.setUserLocked(user) aria-label=\"Locked out\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.users.Count}} md-page-select=true md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Users per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.users.Data && $ctrl.users.Count\"> <p class=md-body-1> There are no users matching the specified criteria. </p> </div> </md-card-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adminUserAddForm = __webpack_require__(458);
	
	var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.adminUserAddForm', []).component('adminUserAddForm', _adminUserAddForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminUserAddForm = __webpack_require__(459);
	
	var _adminUserAddForm2 = _interopRequireDefault(_adminUserAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminUserAddForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    onUserChanged: '&'
	  },
	  controller: function () {
	    AdminUserAddFormComponent.$inject = ["EventEmitter"];
	    function AdminUserAddFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, AdminUserAddFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(AdminUserAddFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.user = this.user || {};
	        this.user.UserTypeId = 4;
	        this.user.TypeReferenceId = -1;
	        this.user.LevelOfAccess = 4;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onUserChanged(this.EventEmitter({
	          user: this.user
	        }));
	      }
	    }]);
	
	    return AdminUserAddFormComponent;
	  }()
	};

/***/ },
/* 459 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/admin-users/admin-user-add-form/admin-user-add-form.html';
	var html = "<form name=$ctrl.userForm layout=column flex ng-submit=$ctrl.onSubmit() novalidate> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Add New System Admin User</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>First Name</label> <input ng-model=$ctrl.user.FirstName name=firstName required> <div ng-messages=$ctrl.userForm.firstName.$error md-auto-hide=false> <div ng-message=required> First name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Last Name</label> <input ng-model=$ctrl.user.LastName name=lastName required> <div ng-messages=$ctrl.userForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Email</label> <input ng-model=$ctrl.user.Email name=email type=email required> <div ng-messages=$ctrl.userForm.email.$error md-auto-hide=false> <div ng-message=required> Email address is required. </div> <div ng-message=email> Email address must be valid. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Username</label> <input ng-model=$ctrl.user.Username name=username data-user-id={{$ctrl.user.UserId}} required min-length=5 unique-username> <div ng-messages=$ctrl.userForm.username.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> <div ng-message=minLength> Username does not meet minimum length requirements. </div> <div ng-message=uniqueUsername> Username is already taken! Please choose a unique username. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Password</label> <input ng-model=$ctrl.user.Password name=password type=password required min-length=5 strong-password> <div ng-messages=$ctrl.userForm.password.$error md-auto-hide=false> <div ng-message=required> Password is required. </div> <div ng-message=strongPassword> Password must be at least eight characters long, containing at least one uppercase character, one lowercase character, and one digit (0-9). </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end end\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.userForm.$valid> Add User </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adminUserEditForm = __webpack_require__(461);
	
	var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.adminUserEditForm', []).component('adminUserEditForm', _adminUserEditForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminUserEditForm = __webpack_require__(462);
	
	var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminUserEditForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    user: '<',
	    onUserChanged: '&'
	  },
	  controller: function () {
	    AdminUserEditFormComponent.$inject = ["EventEmitter"];
	    function AdminUserEditFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, AdminUserEditFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(AdminUserEditFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.user = this.user || {};
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onUserChanged(this.EventEmitter({
	          user: this.user
	        }));
	      }
	    }]);
	
	    return AdminUserEditFormComponent;
	  }()
	};

/***/ },
/* 462 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/admin-users/admin-user-edit-form/admin-user-edit-form.html';
	var html = "<form name=$ctrl.userForm layout=column flex ng-submit=$ctrl.onSubmit() novalidate> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage System Admin Account</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>First Name</label> <input ng-model=$ctrl.user.FirstName name=firstName required> <div ng-messages=$ctrl.userForm.firstName.$error md-auto-hide=false> <div ng-message=required> First name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Last Name</label> <input ng-model=$ctrl.user.LastName name=lastName required> <div ng-messages=$ctrl.userForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Email</label> <input ng-model=$ctrl.user.Email name=email type=email required> <div ng-messages=$ctrl.userForm.email.$error md-auto-hide=false> <div ng-message=required> Email address is required. </div> <div ng-message=email> Email address must be valid. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Username</label> <input ng-model=$ctrl.user.Username name=username data-user-id={{$ctrl.user.UserId}} required min-length=5 unique-username ng-readonly=true> <div ng-messages=$ctrl.userForm.username.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> <div ng-message=minLength> Username does not meet minimum length requirements. </div> <div ng-message=uniqueUsername> Username is already taken! Please choose a unique username. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end end\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.userForm.$valid> Save Changes </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _messages = __webpack_require__(442);
	
	var _companies = __webpack_require__(464);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _companies2.default,
	  bindings: {
	    companies: '<',
	    regulators: '<',
	    adminUsers: '<',
	    companyQuery: '<',
	    regulatorQuery: '<',
	    adminUsersQuery: '<',
	    user: '<',
	    limitOptions: '<'
	  },
	  controller: function () {
	    CompaniesComponent.$inject = ["$mdDialog", "$scope", "$state", "AccountService", "AuthService", "CompanyService", "PeopleService", "RegulatorService", "ToastService"];
	    function CompaniesComponent($mdDialog, $scope, $state, AccountService, AuthService, CompanyService, PeopleService, RegulatorService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, CompaniesComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        AuthService: AuthService,
	        CompanyService: CompanyService,
	        PeopleService: PeopleService,
	        RegulatorService: RegulatorService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(CompaniesComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.selectedRegulators = [];
	        this.selectedAdminUsers = [];
	        this.company = -1;
	        this.refreshAdminUsers(); // need to do from here to apply the 'admin users' filter to the People OData query
	      }
	    }, {
	      key: 'refreshCompanies',
	      value: function refreshCompanies() {
	        var _this = this;
	
	        this.promise = this.CompanyService.search(this.companyQuery);
	        this.promise.then(function (r) {
	          _this.companies = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onCompanySearchTextChanged',
	      value: function onCompanySearchTextChanged(_ref) {
	        var searchText = _ref.searchText;
	
	        this.companyQuery = _extends({}, this.companyQuery, {
	          filter: (0, _odataFilterBuilder2.default)().contains('MemberName', searchText)
	        });
	
	        this.refreshCompanies();
	      }
	    }, {
	      key: 'onCompanyQueryChanged',
	      value: function onCompanyQueryChanged(_ref2) {
	        var query = _ref2.query;
	
	        this.companyQuery = query;
	        this.refreshCompanies();
	      }
	    }, {
	      key: 'refreshRegulators',
	      value: function refreshRegulators() {
	        var _this2 = this;
	
	        this.promise = this.RegulatorService.search(this.regulatorQuery);
	        this.promise.then(function (r) {
	          _this2.regulators = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onRegulatorSearchTextChanged',
	      value: function onRegulatorSearchTextChanged(_ref3) {
	        var searchText = _ref3.searchText;
	
	        this.regulatorQuery = _extends({}, this.regulatorQuery, {
	          filter: (0, _odataFilterBuilder2.default)().contains('AgentName', searchText)
	        });
	
	        this.refreshRegulators();
	      }
	    }, {
	      key: 'onRegulatorQueryChanged',
	      value: function onRegulatorQueryChanged(_ref4) {
	        var query = _ref4.query;
	
	        this.regulatorQuery = query;
	        this.refreshRegulators();
	      }
	    }, {
	      key: 'showCompanyAdd',
	      value: function showCompanyAdd() {
	        var _this3 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onCompanyAdded: function onCompanyAdded($event) {
	            return _this3.onCompanyAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <company-add-form\n                on-company-changed="onCompanyAdded($event)">\n              </company-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onCompanyAdded',
	      value: function onCompanyAdded(_ref5) {
	        var _this4 = this;
	
	        var company = _ref5.company;
	
	        if (company) {
	          this.CompanyService.add(company).then(function (r) {
	            _this4.$mdDialog.hide();
	            _this4.ToastService.showSuccess(_messages.COMPANY_ADDED);
	
	            var companyId = r.data.Id;
	            _this4.$state.go('company', { id: companyId });
	          }).catch(function (error) {
	            return _this4.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showRegulatorAdd',
	      value: function showRegulatorAdd() {
	        var _this5 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onRegulatorAdded: function onRegulatorAdded($event) {
	            return _this5.onRegulatorAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <regulator-add-form\n                dialog-title="Add New Regulator"\n                submit-title="Add Regulator"\n                on-regulator-changed="onRegulatorAdded($event)">\n              </regulator-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onRegulatorAdded',
	      value: function onRegulatorAdded(_ref6) {
	        var _this6 = this;
	
	        var regulator = _ref6.regulator;
	
	        if (regulator) {
	          this.RegulatorService.add(regulator).then(function () {
	            _this6.ToastService.showSuccess(_messages.REGULATOR_ADDED);
	            _this6.$mdDialog.hide();
	            _this6.refreshRegulators();
	          }).catch(function (error) {
	            return _this6.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showChangeOwnPassword',
	      value: function showChangeOwnPassword() {
	        var _this7 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ownPasswordChanged: function ownPasswordChanged($event) {
	            return _this7.onOwnPasswordChanged($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="ownPasswordChanged($event)">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onOwnPasswordChanged',
	      value: function onOwnPasswordChanged(_ref7) {
	        var _this8 = this;
	
	        var credentials = _ref7.credentials;
	
	        if (credentials && this.user.Username) {
	          this.AccountService.changePassword(_extends({
	            Username: this.user.Username
	          }, credentials)).then(function () {
	            _this8.$mdDialog.hide();
	            _this8.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	          }).catch(function (error) {
	            return _this8.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'updateAccount',
	      value: function updateAccount(_ref8) {
	        var _this9 = this;
	
	        var user = _ref8.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this9.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	            _this9.$state.reload();
	          }).catch(function (error) {
	            return _this9.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'updateCompliance',
	      value: function updateCompliance(_ref9) {
	        var _this10 = this;
	
	        var company = _ref9.company;
	
	        this.CompanyService.updateCompliance(company).then(function () {
	          _this10.ToastService.showSuccess(_messages.COMPANY_EDITED);
	        }).catch(function (error) {
	          return _this10.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'showUserAdd',
	      value: function showUserAdd() {
	        var _this11 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.AuthService.getAccessLevels(),
	          onUserAdded: function onUserAdded($event) {
	            return _this11.onUserAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <user-add-form\n              require-user-type-selection="true"\n              access-levels="accessLevels"\n              on-user-changed="onUserAdded($event)">\n            </user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
	        });
	      }
	    }, {
	      key: 'onUserAdded',
	      value: function onUserAdded(_ref10) {
	        var _this12 = this;
	
	        var user = _ref10.user;
	
	        if (user) {
	          this.AccountService.addAccount(_extends({}, user)).then(function () {
	            _this12.$mdDialog.hide();
	            _this12.ToastService.showSuccess(_messages.USER_ADDED);
	          }).catch(function (error) {
	            return _this12.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'regulatorDelete',
	      value: function regulatorDelete(regulators) {
	        var _this13 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Delete selected regulators?').textContent('Once deleted, the selected regulator(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = regulators.length - 1; i >= 0; i -= 1) {
	            promises.push(_this13.RegulatorService.delete(regulators[i].RegulatorId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this13.ToastService.showSuccess(_messages.REGULATOR_DELETED);
	            _this13.selectedRegulators = [];
	            _this13.refreshRegulators();
	          }).catch(function (error) {
	            return _this13.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'refreshAdminUsers',
	      value: function refreshAdminUsers() {
	        var _this14 = this;
	
	        this.selectedAdminUsers = [];
	        var filter = (0, _odataFilterBuilder2.default)();
	
	        if (this.searchText && this.searchText.length) {
	          filter = filter.contains('LastName', this.searchText).or(function (x) {
	            return x.contains('FirstName', _this14.searchText);
	          });
	        }
	
	        filter = filter.and(function (x) {
	          return x.eq('UserTypeName', 'System Administrator');
	        }).and(function (x) {
	          return x.ne('UserId', _this14.user.UserId);
	        }).and(function (x) {
	          return x.eq('IsSysAdminOwner', false);
	        }).and(function (x) {
	          return x.eq('TypeReferenceId', -1);
	        });
	
	        this.promise = this.PeopleService.search(_extends({}, this.adminUsersQuery, {
	          filter: filter
	        }));
	
	        this.promise.then(function (r) {
	          _this14.adminUsers = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this14.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onAdminSearchTextChanged',
	      value: function onAdminSearchTextChanged(_ref11) {
	        var searchText = _ref11.searchText;
	
	        this.searchText = searchText;
	        this.refreshAdminUsers();
	      }
	    }, {
	      key: 'onAdminQueryChanged',
	      value: function onAdminQueryChanged(_ref12) {
	        var query = _ref12.query;
	
	        this.query = query;
	        this.refreshAdminUsers();
	      }
	    }, {
	      key: 'adminUserAdd',
	      value: function adminUserAdd() {
	        var _this15 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onAdminUserAdded: function onAdminUserAdded($event) {
	            return _this15.onAdminUserAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <admin-user-add-form\n              on-user-changed="onAdminUserAdded($event)">\n            </admin-user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
	        });
	      }
	    }, {
	      key: 'onAdminUserAdded',
	      value: function onAdminUserAdded(_ref13) {
	        var _this16 = this;
	
	        var user = _ref13.user;
	
	        if (user) {
	          this.AccountService.addAccount(_extends({}, user)).then(function () {
	            _this16.$mdDialog.hide();
	            _this16.ToastService.showSuccess(_messages.USER_ADDED);
	            _this16.refreshAdminUsers();
	          }).catch(function (error) {
	            return _this16.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'adminUserEdit',
	      value: function adminUserEdit(user) {
	        var _this17 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          user: _angular2.default.copy(user),
	          onAdminUserEdited: function onAdminUserEdited($event) {
	            return _this17.onAdminUserEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <admin-user-edit-form\n                user="user"\n                on-user-changed="onAdminUserEdited($event)">\n              </admin-user-edit-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onAdminUserEdited',
	      value: function onAdminUserEdited(_ref14) {
	        var _this18 = this;
	
	        var user = _ref14.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this18.ToastService.showSuccess(_messages.USER_EDITED);
	            _this18.$mdDialog.hide();
	            _this18.refreshAdminUsers();
	          }).catch(function (error) {
	            return _this18.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'adminUserDelete',
	      value: function adminUserDelete(users) {
	        var _this19 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Delete selected users?').textContent('Once deleted, the selected user(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = users.length - 1; i >= 0; i -= 1) {
	            promises.push(_this19.AccountService.deleteAccount(users[i].UserId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this19.ToastService.showSuccess(_messages.USER_DELETED);
	            _this19.refreshAdminUsers();
	          }).catch(function (error) {
	            return _this19.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'showChangeAdminPassword',
	      value: function showChangeAdminPassword(user) {
	        var _this20 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          passwordChanged: function passwordChanged($event) {
	            return _this20.onAdminPasswordChanged($event);
	          },
	          credentials: {
	            UserId: user.UserId
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="passwordChanged($event)"\n                require-current-password="false"\n                credentials="credentials">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onAdminPasswordChanged',
	      value: function onAdminPasswordChanged(_ref15) {
	        var _this21 = this;
	
	        var credentials = _ref15.credentials;
	
	        if (credentials) {
	          this.AccountService.forcePasswordChange(_extends({}, credentials)).then(function () {
	            _this21.$mdDialog.hide();
	            _this21.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	            _this21.selectedAdminUsers = [];
	          }).catch(function (error) {
	            return _this21.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'setUserLockout',
	      value: function setUserLockout(_ref16) {
	        var _this22 = this;
	
	        var userId = _ref16.userId,
	            isLocked = _ref16.isLocked;
	
	        this.AccountService.setLockoutStatus(userId, isLocked).then(function () {
	          _this22.ToastService.showSuccess(_messages.ACCOUNT_LOCKOUT_EDITED);
	        }).catch(function (error) {
	          return _this22.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return CompaniesComponent;
	  }()
	};

/***/ },
/* 464 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/companies/companies.html';
	var html = "<div layout=column flex layout-padding> <div layout=row layout-wrap> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Company\" ng-click=$ctrl.showCompanyAdd() flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Company </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add User\" ng-click=$ctrl.showUserAdd() permission permission-only=\"'SYS_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add User </md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Regulator\" ng-click=$ctrl.showRegulatorAdd() flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Regulator </md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Change Password\" ng-click=$ctrl.showChangeOwnPassword() flex-xs=100> <md-icon md-font-set=material-icons>vpn_key</md-icon> Change Password </md-button> </div> <user-edit-form user=::$ctrl.user on-user-changed=$ctrl.updateAccount($event) show-access-level=false> </user-edit-form> <div> <md-card> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Companies</span> </div> </md-toolbar> <company-list companies=$ctrl.companies query=$ctrl.companyQuery query-changed=$ctrl.onCompanyQueryChanged($event) search-text-changed=$ctrl.onCompanySearchTextChanged($event) compliance-changed=$ctrl.updateCompliance($event) layout=column flex> </company-list> </md-card> <md-card> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Manage Regulators</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedRegulators && $ctrl.selectedRegulators.length\" ng-click=$ctrl.regulatorDelete($ctrl.selectedRegulators)> <md-tooltip md-direction=top>Delete Regulator</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <regulator-list regulators=$ctrl.regulators query=$ctrl.regulatorQuery query-changed=$ctrl.onRegulatorQueryChanged($event) search-text-changed=$ctrl.onRegulatorSearchTextChanged($event) selected-regulators=$ctrl.selectedRegulators layout=column flex> </regulator-list> </md-card> </div> <div flex layout=column> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage System Admin Users</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.showChangeAdminPassword($ctrl.selectedAdminUsers[0]) ng-if=\"$ctrl.selectedAdminUsers && $ctrl.selectedAdminUsers.length === 1 && $ctrl.user.IsSysAdminOwner === true\" permission permission-only=\"'SYS_ADMIN'\"> <md-tooltip md-direction=top>Change Password</md-tooltip> <md-icon md-font-set=material-icons>vpn_key</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.adminUserAdd() ng-if=::!$ctrl.locked> <md-tooltip md-direction=top>Add User</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedAdminUsers && $ctrl.selectedAdminUsers.length === 1\" ng-click=$ctrl.adminUserEdit($ctrl.selectedAdminUsers[0]) ng-if=\"$ctrl.selectedAdminUsers && $ctrl.selectedAdminUsers.length === 1\"> <md-tooltip md-direction=top>Edit User</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedAdminUsers && $ctrl.selectedAdminUsers.length && $ctrl.user.IsSysAdminOwner === true\" ng-click=$ctrl.adminUserDelete($ctrl.selectedAdminUsers)> <md-tooltip md-direction=top>Delete User</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <admin-user-list users=$ctrl.adminUsers query=$ctrl.adminUsersQuery query-changed=$ctrl.onAdminQueryChanged($event) selected-users=$ctrl.selectedAdminUsers search-text-changed=$ctrl.onAdminSearchTextChanged($event) locked=::$ctrl.locked user-lockout-changed=$ctrl.setUserLockout($event) layout=column flex> </admin-user-list> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _company = __webpack_require__(466);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _companyAddForm = __webpack_require__(468);
	
	var _companyAddForm2 = _interopRequireDefault(_companyAddForm);
	
	var _companyEditForm = __webpack_require__(471);
	
	var _companyEditForm2 = _interopRequireDefault(_companyEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.company', [_angularUiRouter2.default, _companyAddForm2.default, _companyEditForm2.default]).component('company', _company2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('company', {
	    parent: 'app',
	    url: '/companies/{id:int}',
	    component: 'company',
	    data: {
	      permissions: {
	        only: [_roles.COMPANY_ADMIN, _roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    },
	    resolve: {
	      accessLevels: ["AuthService", function accessLevels(AuthService) {
	        return AuthService.getAccessLevels();
	      }],
	      company: ["CompanyService", "$stateParams", function company(CompanyService, $stateParams) {
	        return CompanyService.getCompany($stateParams.id).then(function (r) {
	          return r.data;
	        });
	      }],
	      user: ["AccountService", "AuthService", "currentUser", function user(AccountService, AuthService, currentUser) {
	        return AccountService.getAccount(currentUser.UserId).then(function (r) {
	          return r.data;
	        });
	      }],
	      locked: function locked() {
	        return true;
	      }
	    }
	  });
	}]).name;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _messages = __webpack_require__(442);
	
	var _company = __webpack_require__(467);
	
	var _company2 = _interopRequireDefault(_company);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _company2.default,
	  bindings: {
	    accessLevels: '<',
	    company: '<',
	    user: '<'
	  },
	  controller: function () {
	    CompanyComponent.$inject = ["$mdDialog", "$scope", "$state", "AccountService", "ArrayService", "CompanyService", "AuthService", "PeopleService", "ToastService"];
	    function CompanyComponent($mdDialog, $scope, $state, AccountService, ArrayService, CompanyService, AuthService, PeopleService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, CompanyComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        ArrayService: ArrayService,
	        CompanyService: CompanyService,
	        AuthService: AuthService,
	        PeopleService: PeopleService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(CompanyComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.selectedUsers = [];
	
	        this.query = _extends({}, this.PeopleService.getDefaultQuery());
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'userAdd',
	      value: function userAdd() {
	        var _this = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.accessLevels,
	          onUserChanged: function onUserChanged($event) {
	            return _this.onUserAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-add-form\n                require-user-type-selection="false"\n                access-levels="accessLevels"\n                on-user-changed="onUserChanged($event)">\n              </user-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onUserAdded',
	      value: function onUserAdded(_ref) {
	        var _this2 = this;
	
	        var user = _ref.user;
	
	        if (user) {
	          this.AccountService.addAccount(_extends({}, user, {
	            TypeReferenceId: this.company.MemberId,
	            UserTypeId: 1
	          })).then(function () {
	            _this2.ToastService.showSuccess(_messages.USER_ADDED);
	            _this2.$mdDialog.hide();
	            _this2.refreshResults();
	          }).catch(function (error) {
	            return _this2.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'userEdit',
	      value: function userEdit(user) {
	        var _this3 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.accessLevels,
	          user: _angular2.default.copy(user),
	          onUserChanged: function onUserChanged($event) {
	            return _this3.onUserEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-edit-form\n                user="user"\n                access-levels="accessLevels"\n                show-access-level="true"\n                on-user-changed="onUserChanged($event)">\n              </user-edit-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onUserEdited',
	      value: function onUserEdited(_ref2) {
	        var _this4 = this;
	
	        var user = _ref2.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this4.ToastService.showSuccess(_messages.USER_EDITED);
	            _this4.$mdDialog.hide();
	            _this4.refreshResults();
	          }).catch(function (error) {
	            return _this4.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'userDelete',
	      value: function userDelete(users) {
	        var _this5 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected user(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = users.length - 1; i >= 0; i -= 1) {
	            promises.push(_this5.AccountService.deleteAccount(users[i].UserId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this5.ToastService.showSuccess(_messages.USER_DELETED);
	            _this5.refreshResults();
	          }).catch(function (error) {
	            return _this5.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'updateCompany',
	      value: function updateCompany(_ref3) {
	        var _this6 = this;
	
	        var company = _ref3.company;
	
	        if (company) {
	          this.CompanyService.update(company).then(function () {
	            _this6.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	            _this6.$state.reload();
	          }).catch(function (error) {
	            return _this6.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'updateAccount',
	      value: function updateAccount(_ref4) {
	        var _this7 = this;
	
	        var user = _ref4.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this7.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	            _this7.$state.reload();
	          }).catch(function (error) {
	            return _this7.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showChangePassword',
	      value: function showChangePassword(user) {
	        var _this8 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          passwordChanged: function passwordChanged($event) {
	            return _this8.onPasswordChanged($event);
	          },
	          credentials: {
	            UserId: user.UserId
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password\n                password-changed="passwordChanged($event)"\n                require-current-password="false"\n                credentials="credentials">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onPasswordChanged',
	      value: function onPasswordChanged(_ref5) {
	        var _this9 = this;
	
	        var credentials = _ref5.credentials;
	
	        if (credentials) {
	          this.AccountService.forcePasswordChange(_extends({}, credentials)).then(function () {
	            _this9.$mdDialog.hide();
	            _this9.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	            _this9.selectedUsers = [];
	          }).catch(function (error) {
	            return _this9.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'setUserLockout',
	      value: function setUserLockout(_ref6) {
	        var _this10 = this;
	
	        var userId = _ref6.userId,
	            isLocked = _ref6.isLocked;
	
	        this.AccountService.setLockoutStatus(userId, isLocked).then(function () {
	          _this10.ToastService.showSuccess(_messages.ACCOUNT_LOCKOUT_EDITED);
	        }).catch(function (error) {
	          return _this10.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(_ref7) {
	        var searchText = _ref7.searchText;
	
	        this.searchText = searchText;
	        this.refreshResults();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref8) {
	        var query = _ref8.query;
	
	        this.query = query;
	        this.refreshResults();
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this11 = this;
	
	        this.selectedUsers = [];
	        var filter = (0, _odataFilterBuilder2.default)();
	
	        if (this.searchText && this.searchText.length) {
	          filter = filter.contains('LastName', this.searchText).or(function (x) {
	            return x.contains('FirstName', _this11.searchText);
	          });
	        }
	
	        filter = filter.and(function (x) {
	          return x.eq('UserTypeName', 'Member');
	        }).and(function (x) {
	          return x.ne('UserId', _this11.user.UserId);
	        }).and(function (x) {
	          return x.eq('TypeReferenceId', _this11.$state.params.id);
	        });
	
	        this.promise = this.PeopleService.search(_extends({}, this.query, {
	          filter: filter
	        }));
	
	        this.promise.then(function (r) {
	          _this11.users = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this11.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return CompanyComponent;
	  }()
	};

/***/ },
/* 467 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/company/company.html';
	var html = "<div layout=column> <div layout-padding> <div layout=column layout-gt-xs=row layout-wrap flex=none permission permission-only=\"'COMPANY_ADMIN'\"> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Change Password\" ng-click=$ctrl.showChangePassword($ctrl.user)> <md-icon md-font-set=material-icons>vpn_key</md-icon> Change Password </md-button> </div> <user-edit-form access-levels=$ctrl.accessLevels user=::$ctrl.user on-user-changed=$ctrl.updateAccount($event) show-access-level=false layout=column flex permission permission-only=\"'COMPANY_ADMIN'\"> </user-edit-form> <company-edit-form company=$ctrl.company on-company-changed=$ctrl.updateCompany($event) layout=column flex> </company-edit-form> <div flex layout=column> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Users</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.showChangePassword($ctrl.selectedUsers[0]) ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\" permission permission-only=\"'SYS_ADMIN'\"> <md-tooltip md-direction=top>Change Password</md-tooltip> <md-icon md-font-set=material-icons>vpn_key</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.userAdd() ng-if=::!$ctrl.locked> <md-tooltip md-direction=top>Add User</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\" ng-click=$ctrl.userEdit($ctrl.selectedUsers[0]) ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\"> <md-tooltip md-direction=top>Edit User</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length\" ng-click=$ctrl.userDelete($ctrl.selectedUsers)> <md-tooltip md-direction=top>Delete User</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <user-list users=$ctrl.users query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) selected-users=$ctrl.selectedUsers search-text-changed=$ctrl.onSearchTextChanged($event) locked=::$ctrl.locked user-lockout-changed=$ctrl.setUserLockout($event) layout=column flex> </user-list> </md-card> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _companyAddForm = __webpack_require__(469);
	
	var _companyAddForm2 = _interopRequireDefault(_companyAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.company.company-add-form', []).component('companyAddForm', _companyAddForm2.default).name;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _companyAddForm = __webpack_require__(470);
	
	var _companyAddForm2 = _interopRequireDefault(_companyAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _companyAddForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    company: '<',
	    onCompanyChanged: '&'
	  },
	  controller: function () {
	    CompanyAddFormComponent.$inject = ["EventEmitter"];
	    function CompanyAddFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, CompanyAddFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(CompanyAddFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onCompanyChanged(this.EventEmitter({
	          company: this.company
	        }));
	      }
	    }]);
	
	    return CompanyAddFormComponent;
	  }()
	};

/***/ },
/* 470 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/company/company-add-form/company-add-form.html';
	var html = "<form name=$ctrl.companyForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Add New Company</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100> <label>Company Name</label> <input ng-model=$ctrl.company.MemberName name=memberName required> <div ng-messages=$ctrl.companyForm.memberName.$error md-auto-hide=false> <div ng-message=required> Company name is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.companyForm.$valid> Add Company </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _companyEditForm = __webpack_require__(472);
	
	var _companyEditForm2 = _interopRequireDefault(_companyEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.company.company-edit-form', []).component('companyEditForm', _companyEditForm2.default).name;

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _companyEditForm = __webpack_require__(473);
	
	var _companyEditForm2 = _interopRequireDefault(_companyEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _companyEditForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    company: '<',
	    onCompanyChanged: '&'
	  },
	  controller: function () {
	    CompanyEditFormComponent.$inject = ["EventEmitter"];
	    function CompanyEditFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, CompanyEditFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(CompanyEditFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onCompanyChanged(this.EventEmitter({
	          company: this.company
	        }));
	      }
	    }]);
	
	    return CompanyEditFormComponent;
	  }()
	};

/***/ },
/* 473 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/company/company-edit-form/company-edit-form.html';
	var html = "<form name=$ctrl.companyForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Company</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-wrap> <md-input-container class=md-block flex=100> <label>Company Name</label> <input ng-model=$ctrl.company.MemberName name=memberName ng-disabled=\"::!($ctrl.AuthService.isSysAdmin || $ctrl.AuthService.isCompanyAdmin)\" required> <div ng-messages=$ctrl.companyForm.memberName.$error md-auto-hide=false> <div ng-message=required> Company name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 1</label> <input ng-model=$ctrl.company.tblAddress.Address1 name=address1 required> <div ng-messages=$ctrl.companyForm.address1.$error md-auto-hide=false> <div ng-message=required> Address is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 2</label> <input ng-model=$ctrl.company.tblAddress.Address2 name=address2> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>City</label> <input ng-model=$ctrl.company.tblAddress.City name=city required> <div ng-messages=$ctrl.companyForm.city.$error md-auto-hide=false> <div ng-message=required> City is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>State</label> <input ng-model=$ctrl.company.tblAddress.State name=state required> <div ng-messages=$ctrl.companyForm.state.$error md-auto-hide=false> <div ng-message=required> State is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Zip Code</label> <input ng-model=$ctrl.company.tblAddress.Postal name=postal required> <div ng-messages=$ctrl.companyForm.postal.$error md-auto-hide=false> <div ng-message=required> Zip code is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Phone</label> <input ng-model=$ctrl.company.Phone name=phone required> <div ng-messages=$ctrl.companyForm.phone.$error md-auto-hide=false> <div ng-message=required> Phone number is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Website</label> <input ng-model=$ctrl.company.WebSite name=webSite required> <div ng-messages=$ctrl.companyForm.webSite.$error md-auto-hide=false> <div ng-message=required> Website is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.companyForm.$valid> Update Company Information </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mapCategories = __webpack_require__(475);
	
	var _mapCategories2 = _interopRequireDefault(_mapCategories);
	
	var _mapCategories3 = __webpack_require__(477);
	
	var _mapCategories4 = _interopRequireDefault(_mapCategories3);
	
	__webpack_require__(478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.map-categories', [_angularUiRouter2.default]).component('mapCategories', _mapCategories2.default).service('MapCategoriesService', _mapCategories4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mapCategories', {
	    parent: 'admin',
	    url: '/map-categories',
	    component: 'mapCategories',
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      }
	    }
	  });
	}]).name;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _mapCategories = __webpack_require__(476);
	
	var _mapCategories2 = _interopRequireDefault(_mapCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _mapCategories2.default,
	  bindings: {
	    flex: '@',
	    layout: '@'
	  },
	  controller: function () {
	    MapCategoriesComponent.$inject = ["$mdDialog", "$scope", "MapCategoriesService", "LoadingService", "ToastService"];
	    function MapCategoriesComponent($mdDialog, $scope, MapCategoriesService, LoadingService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, MapCategoriesComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        MapCategoriesService: MapCategoriesService,
	        LoadingService: LoadingService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(MapCategoriesComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.columns = [{
	          FieldName: 'ProductName',
	          DisplayName: 'Product Name'
	        }, {
	          FieldName: 'MapCount',
	          DisplayName: 'Map Count'
	        }];
	
	        this.query = _extends({}, this.MapCategoriesService.getProductQuery());
	
	        this.queryMapped = _extends({}, this.MapCategoriesService.getProductQuery());
	
	        this.selectedProducts = [];
	        this.selectedMappedProducts = [];
	        this.mappedProducts = [];
	        this.categories = [];
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var promises = [this.refreshProducts(), this.refreshMappedProducts()];
	
	        Promise.all(promises);
	      }
	    }, {
	      key: 'refreshProducts',
	      value: function refreshProducts() {
	        var _this = this;
	
	        this.selectedProducts = [];
	        this.selectedMappedProducts = [];
	
	        var filter = (0, _odataFilterBuilder2.default)().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId).and(function (x) {
	          return x.eq('IsMapped', 0);
	        });
	
	        if (this.productSearchText && this.productSearchText.length) {
	          filter = filter.and(function (x) {
	            return x.contains('ProductName', _this.productSearchText);
	          });
	        }
	
	        this.promise = this.MapCategoriesService.searchProducts(_extends({}, this.query, {
	          filter: filter
	        }));
	
	        return this.promise.then(function (r) {
	          _this.products = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'refreshMappedProducts',
	      value: function refreshMappedProducts() {
	        var _this2 = this;
	
	        this.selectedMappedProducts = [];
	
	        var filter = (0, _odataFilterBuilder2.default)().eq('ProductCategoryId', this.selectedCategory.ProductCategoryId).and(function (x) {
	          return x.eq('IsMapped', 1);
	        });
	
	        if (this.mappedProductSearchText && this.mappedProductSearchText.length) {
	          filter = filter.and(function (x) {
	            return x.contains('ProductName', _this2.mappedProductSearchText);
	          });
	        }
	
	        this.promiseMapped = this.MapCategoriesService.searchProducts(_extends({}, this.queryMapped, {
	          filter: filter
	        }));
	
	        return this.promiseMapped.then(function (r) {
	          _this2.mappedProducts = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'selectedCategoryChanged',
	      value: function selectedCategoryChanged(_ref) {
	        var selectedItem = _ref.selectedItem;
	
	        this.selectedCategory = selectedItem;
	
	        if (selectedItem) {
	          this.refreshResults();
	        } else {
	          this.products = [];
	          this.mappedProducts = [];
	          this.productSearchText = null;
	          this.mappedProductSearchText = null;
	        }
	      }
	    }, {
	      key: 'addMapping',
	      value: function addMapping(selectedCategory, selectedProducts) {
	        var _this3 = this;
	
	        this.LoadingService.start();
	        var productIds = selectedProducts.map(function (p) {
	          return p.ProductId;
	        });
	
	        this.MapCategoriesService.addProductCategoryMapping(selectedCategory.ProductCategoryId, productIds).then(function () {
	          _this3.selectedProducts = [];
	
	          var promises = [_this3.refreshProducts(), _this3.refreshMappedProducts()];
	
	          Promise.all(promises).then(function () {
	            return _this3.ToastService.showSuccess('Product categories mapped successfully!');
	          });
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        }).finally(function () {
	          return _this3.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'removeMapping',
	      value: function removeMapping(selectedCategory, selectedProducts) {
	        var _this4 = this;
	
	        this.LoadingService.start();
	        var productIds = selectedProducts.map(function (p) {
	          return p.ProductId;
	        });
	
	        this.MapCategoriesService.removeProductCategoryMapping(selectedCategory.ProductCategoryId, productIds).then(function () {
	          _this4.selectedMappedProducts = [];
	
	          var promises = [_this4.refreshProducts(), _this4.refreshMappedProducts()];
	
	          Promise.all(promises).then(function () {
	            return _this4.ToastService.showSuccess('Product categories unmapped successfully!');
	          });
	        }).catch(function (error) {
	          return _this4.ToastService.showError(error);
	        }).finally(function () {
	          return _this4.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'onProductSearchTextChanged',
	      value: function onProductSearchTextChanged(_ref2) {
	        var searchText = _ref2.searchText;
	
	        this.selectedProducts = [];
	        this.productSearchText = searchText;
	        this.refreshProducts();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref3) {
	        var query = _ref3.query;
	
	        this.selectedProducts = [];
	        this.query = query;
	        this.refreshProducts();
	      }
	    }, {
	      key: 'onMappedProductSearchTextChanged',
	      value: function onMappedProductSearchTextChanged(_ref4) {
	        var searchText = _ref4.searchText;
	
	        this.selectedMappedProducts = [];
	        this.mappedProductSearchText = searchText;
	        this.refreshMappedProducts();
	      }
	    }, {
	      key: 'onMappedQueryChanged',
	      value: function onMappedQueryChanged(_ref5) {
	        var query = _ref5.query;
	
	        this.selectedMappedProducts = [];
	        this.queryMapped = query;
	        this.refreshMappedProducts();
	      }
	    }]);
	
	    return MapCategoriesComponent;
	  }()
	};

/***/ },
/* 476 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/map-categories/map-categories.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Map Categories</span> </div> </md-toolbar> <md-card-content layout=column flex> <category-autocomplete label-text=\"Search by Category Name\" search-display-property=ProductCategoryName on-item-selected=$ctrl.selectedCategoryChanged($event)> </category-autocomplete> <div layout=row layout-xs=column flex ng-if=$ctrl.selectedCategory> <div layout=column flex> <item-list items=$ctrl.products selected-items=$ctrl.selectedProducts columns=$ctrl.columns query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) search-text-changed=$ctrl.onProductSearchTextChanged($event) display-name-plural=Products layout=column flex> </item-list> </div> <div layout=column layout-align=\"start center\"> <md-button class=\"md-accent md-fab md-mini\" ng-click=\"$ctrl.addMapping($ctrl.selectedCategory, $ctrl.selectedProducts)\" ng-disabled=\"!($ctrl.selectedProducts && $ctrl.selectedProducts.length)\" id=mapping-add> <md-tooltip md-direction=top>Add Mapping</md-tooltip> <md-icon md-font-icon=fa-arrow-right class=\"fa md-accent\"></md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-click=\"$ctrl.removeMapping($ctrl.selectedCategory, $ctrl.selectedMappedProducts)\" ng-disabled=\"!($ctrl.selectedMappedProducts && $ctrl.selectedMappedProducts.length)\" id=mapping-remove> <md-tooltip md-direction=bottom>Remove Mapping</md-tooltip> <md-icon md-font-icon=fa-arrow-left class=\"fa md-accent\"></md-icon> </md-button> </div> <div layout=column flex> <item-list items=$ctrl.mappedProducts selected-items=$ctrl.selectedMappedProducts columns=$ctrl.columns query=$ctrl.queryMapped query-changed=$ctrl.onMappedQueryChanged($event) search-text-changed=$ctrl.onMappedProductSearchTextChanged($event) display-name-plural=Products layout=column flex> </item-list> </div> </div> </md-card-content> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MapCategoriesService = function () {
	  MapCategoriesService.$inject = ["$http"];
	  function MapCategoriesService($http) {
	    'ngInject';
	
	    _classCallCheck(this, MapCategoriesService);
	
	    this.$http = $http;
	  }
	
	  _createClass(MapCategoriesService, [{
	    key: 'getProductQuery',
	    value: function getProductQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'ProductName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'searchProducts',
	    value: function searchProducts(query) {
	      return this.$http.get('/odata/ProductCategoryMappingOData', {
	        params: _extends({
	          $select: 'ProductId, ProductCategoryId, ProductName, MapCount',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'addProductCategoryMapping',
	    value: function addProductCategoryMapping(productCategoryId, productIds) {
	      return this.$http.post('/api/product_category/' + productCategoryId + '/products', {
	        productCategoryId: productCategoryId,
	        productIds: productIds
	      });
	    }
	  }, {
	    key: 'removeProductCategoryMapping',
	    value: function removeProductCategoryMapping(productCategoryId, productIds) {
	      return this.$http.delete('/api/product_category/' + productCategoryId + '/products', {
	        data: {
	          productCategoryId: productCategoryId,
	          productIds: productIds
	        }
	      });
	    }
	  }]);
	
	  return MapCategoriesService;
	}();
	
	exports.default = MapCategoriesService;

/***/ },
/* 478 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mapIngredients = __webpack_require__(480);
	
	var _mapIngredients2 = _interopRequireDefault(_mapIngredients);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.map-ingredients', [_angularUiRouter2.default]).component('mapIngredients', _mapIngredients2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('mapIngredients', {
	    parent: 'admin',
	    url: '/map-ingredients',
	    component: 'mapIngredients',
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      query: ["IngredientService", function query(IngredientService) {
	        return IngredientService.getDefaultUserIngredientQuery();
	      }],
	      queryMapped: ["IngredientService", function queryMapped(IngredientService) {
	        return IngredientService.getDefaultUserIngredientQuery();
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _mapIngredients = __webpack_require__(481);
	
	var _mapIngredients2 = _interopRequireDefault(_mapIngredients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _mapIngredients2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    query: '<',
	    queryMapped: '<'
	  },
	  controller: function () {
	    MapIngredientsComponent.$inject = ["$mdDialog", "$scope", "IngredientService", "LoadingService", "ToastService"];
	    function MapIngredientsComponent($mdDialog, $scope, IngredientService, LoadingService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, MapIngredientsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        IngredientService: IngredientService,
	        LoadingService: LoadingService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(MapIngredientsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.columns = [{
	          FieldName: 'UserIngredientName',
	          DisplayName: 'User Ingredient Name'
	        }];
	
	        this.selectedUserIngredients = [];
	        this.selectedMappedIngredients = [];
	        this.mappedUserIngredients = [];
	      }
	    }, {
	      key: 'refreshUserIngredients',
	      value: function refreshUserIngredients() {
	        var _this = this;
	
	        this.selectedUserIngredients = [];
	        this.selectedMappedIngredients = [];
	
	        var filter = (0, _odataFilterBuilder2.default)().ne('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
	        if (this.userIngredientSearchText) {
	          filter = filter.and(function (x) {
	            return x.contains('UserIngredientName', _this.userIngredientSearchText);
	          });
	        }
	
	        this.promise = this.IngredientService.searchUserIngredients(_extends({}, this.query, {
	          filter: filter.toString()
	        }));
	
	        return this.promise.then(function (r) {
	          _this.userIngredients = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'refreshMappedUserIngredients',
	      value: function refreshMappedUserIngredients() {
	        var _this2 = this;
	
	        var filter = (0, _odataFilterBuilder2.default)().eq('SystemIngredientId', this.selectedSystemIngredient.SystemIngredientId);
	        if (this.mappedUserIngredientSearchText) {
	          filter = filter.and(function (x) {
	            return x.contains('UserIngredientName', _this2.mappedUserIngredientSearchText);
	          });
	        }
	
	        this.promiseMapped = this.IngredientService.searchUserIngredients(_extends({}, this.queryMapped, {
	          filter: filter.toString()
	        }));
	
	        return this.promiseMapped.then(function (r) {
	          _this2.mappedUserIngredients = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'selectedSystemIngredientChanged',
	      value: function selectedSystemIngredientChanged(_ref) {
	        var selectedIngredient = _ref.selectedIngredient;
	
	        this.selectedSystemIngredient = selectedIngredient;
	
	        if (selectedIngredient) {
	          var promises = [this.refreshUserIngredients(), this.refreshMappedUserIngredients()];
	
	          Promise.all(promises);
	        } else {
	          this.userIngredients = [];
	          this.mappedUserIngredients = [];
	          this.userIngredientSearchText = null;
	          this.mappedUserIngredientSearchText = null;
	        }
	      }
	    }, {
	      key: 'addMapping',
	      value: function addMapping(selectedSystemIngredient, selectedUserIngredients) {
	        var _this3 = this;
	
	        this.LoadingService.start();
	        var userIngredientIds = selectedUserIngredients.map(function (u) {
	          return u.UserIngredientId;
	        });
	
	        this.IngredientService.addSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds).then(function () {
	          _this3.selectedUserIngredients = [];
	
	          var promises = [_this3.refreshUserIngredients(), _this3.refreshMappedUserIngredients()];
	
	          Promise.all(promises).then(function () {
	            return _this3.ToastService.showSuccess('User ingredients mapped successfully!');
	          });
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        }).finally(function () {
	          return _this3.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'removeMapping',
	      value: function removeMapping(selectedSystemIngredient, selectedUserIngredients) {
	        var _this4 = this;
	
	        this.LoadingService.start();
	        var userIngredientIds = selectedUserIngredients.map(function (u) {
	          return u.UserIngredientId;
	        });
	
	        this.IngredientService.removeSystemIngredientMapping(selectedSystemIngredient.SystemIngredientId, userIngredientIds).then(function () {
	          _this4.selectedMappedIngredients = [];
	
	          var promises = [_this4.refreshUserIngredients(), _this4.refreshMappedUserIngredients()];
	
	          Promise.all(promises).then(function () {
	            return _this4.ToastService.showSuccess('User ingredients unmapped successfully!');
	          });
	        }).catch(function (error) {
	          return _this4.ToastService.showError(error);
	        }).finally(function () {
	          return _this4.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'onIngredientSearchTextChanged',
	      value: function onIngredientSearchTextChanged(_ref2) {
	        var searchText = _ref2.searchText;
	
	        this.selectedUserIngredients = [];
	        this.userIngredientSearchText = searchText;
	        this.refreshUserIngredients();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref3) {
	        var query = _ref3.query;
	
	        this.selectedUserIngredients = [];
	        this.query = query;
	        this.refreshUserIngredients();
	      }
	    }, {
	      key: 'onMappedIngredientSearchTextChanged',
	      value: function onMappedIngredientSearchTextChanged(_ref4) {
	        var searchText = _ref4.searchText;
	
	        this.selectedMappedIngredients = [];
	        this.mappedUserIngredientSearchText = searchText;
	        this.refreshMappedUserIngredients();
	      }
	    }, {
	      key: 'onMappedQueryChanged',
	      value: function onMappedQueryChanged(_ref5) {
	        var query = _ref5.query;
	
	        this.selectedMappedIngredients = [];
	        this.queryMapped = query;
	        this.refreshMappedUserIngredients();
	      }
	    }]);
	
	    return MapIngredientsComponent;
	  }()
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/map-ingredients/map-ingredients.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Map Ingredients</span> </div> </md-toolbar> <md-card-content layout=column flex> <ingredient-autocomplete ingredient-type=system label-text=\"Search by System Ingredient Name\" search-text=$ctrl.ingredientSearchText selected-ingredient=$ctrl.selectedIngredient search-display-property=SystemIngredientName on-ingredient-selected=$ctrl.selectedSystemIngredientChanged($event)> </ingredient-autocomplete> <div layout=row layout-xs=column flex ng-if=$ctrl.selectedSystemIngredient> <div layout=column flex> <item-list items=$ctrl.userIngredients selected-items=$ctrl.selectedUserIngredients columns=$ctrl.columns query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) search-text-changed=$ctrl.onIngredientSearchTextChanged($event) display-name-plural=Ingredients layout=column flex> </item-list> </div> <div layout=column layout-align=\"start center\"> <md-button class=\"md-accent md-fab md-mini\" ng-click=\"$ctrl.addMapping($ctrl.selectedSystemIngredient, $ctrl.selectedUserIngredients)\" ng-disabled=\"!($ctrl.selectedUserIngredients && $ctrl.selectedUserIngredients.length)\" id=mapping-add> <md-tooltip md-direction=top>Add Mapping</md-tooltip> <md-icon md-font-icon=fa-arrow-right class=\"fa md-accent\"></md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-click=\"$ctrl.removeMapping($ctrl.selectedSystemIngredient, $ctrl.selectedMappedIngredients)\" ng-disabled=\"!($ctrl.selectedMappedIngredients && $ctrl.selectedMappedIngredients.length)\" id=mapping-remove> <md-tooltip md-direction=bottom>Remove Mapping</md-tooltip> <md-icon md-font-icon=fa-arrow-left class=\"fa md-accent\"></md-icon> </md-button> </div> <div layout=column flex> <item-list items=$ctrl.mappedUserIngredients selected-items=$ctrl.selectedMappedIngredients columns=$ctrl.columns query=$ctrl.queryMapped query-changed=$ctrl.onMappedQueryChanged($event) search-text-changed=$ctrl.onMappedIngredientSearchTextChanged($event) display-name-plural=Ingredients layout=column flex> </item-list> </div> </div> </md-card-content> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 482 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _memberCompliance = __webpack_require__(484);
	
	var _memberCompliance2 = _interopRequireDefault(_memberCompliance);
	
	var _memberCompliance3 = __webpack_require__(486);
	
	var _memberCompliance4 = _interopRequireDefault(_memberCompliance3);
	
	var _compliantMembers = __webpack_require__(487);
	
	var _compliantMembers2 = _interopRequireDefault(_compliantMembers);
	
	var _noncompliantMembers = __webpack_require__(490);
	
	var _noncompliantMembers2 = _interopRequireDefault(_noncompliantMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.admin.member-compliance', [_angularUiRouter2.default, _compliantMembers2.default, _noncompliantMembers2.default]).component('memberCompliance', _memberCompliance2.default).service('MemberComplianceService', _memberCompliance4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('memberCompliance', {
	    parent: 'memberComplianceProcess',
	    url: '/member-compliance',
	    component: 'memberCompliance',
	    resolve: {
	      compliantCompanies: ["MemberComplianceService", function compliantCompanies(MemberComplianceService) {
	        return MemberComplianceService.getCompliantCompanies().then(function (r) {
	          return r.data;
	        });
	      }],
	      nonCompliantCompanies: ["MemberComplianceService", function nonCompliantCompanies(MemberComplianceService) {
	        return MemberComplianceService.getNonCompliantCompanies().then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memberCompliance = __webpack_require__(485);
	
	var _memberCompliance2 = _interopRequireDefault(_memberCompliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _memberCompliance2.default,
	  bindings: {
	    compliantCompanies: '<',
	    nonCompliantCompanies: '<'
	  },
	  controller: function MemberComplianceComponent() {
	    'ngInject';
	
	    _classCallCheck(this, MemberComplianceComponent);
	  }
	};

/***/ },
/* 485 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/member-compliance/member-compliance.html';
	var html = "<div layout=column layout-padding> <div> <noncompliant-members companies=$ctrl.nonCompliantCompanies></noncompliant-members> <compliant-members companies=$ctrl.compliantCompanies></compliant-members> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MemberComplianceService = function () {
	  MemberComplianceService.$inject = ["$http"];
	  function MemberComplianceService($http) {
	    'ngInject';
	
	    _classCallCheck(this, MemberComplianceService);
	
	    this.$http = $http;
	  }
	
	  _createClass(MemberComplianceService, [{
	    key: 'process',
	    value: function process() {
	      return this.$http.post('/api/compliance/process');
	    }
	  }, {
	    key: 'getNonCompliantCompanies',
	    value: function getNonCompliantCompanies() {
	      return this.$http.get('/api/compliance/get_fail_list');
	    }
	  }, {
	    key: 'getCompliantCompanies',
	    value: function getCompliantCompanies() {
	      return this.$http.get('/api/compliance/get_pass_list');
	    }
	  }]);
	
	  return MemberComplianceService;
	}();
	
	exports.default = MemberComplianceService;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _compliantMembers = __webpack_require__(488);
	
	var _compliantMembers2 = _interopRequireDefault(_compliantMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.member-compliance.compliant-members', []).component('compliantMembers', _compliantMembers2.default).name;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _compliantMembers = __webpack_require__(489);
	
	var _compliantMembers2 = _interopRequireDefault(_compliantMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _compliantMembers2.default,
	  bindings: {
	    companies: '<'
	  },
	  controller: function () {
	    CompliantMembersComponent.$inject = ["$mdDialog", "EventEmitter"];
	    function CompliantMembersComponent($mdDialog, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, CompliantMembersComponent);
	
	      Object.assign(this, { $mdDialog: $mdDialog, EventEmitter: EventEmitter });
	    }
	
	    _createClass(CompliantMembersComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }]);
	
	    return CompliantMembersComponent;
	  }()
	};

/***/ },
/* 489 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/member-compliance/compliant-members/compliant-members.html';
	var html = "<md-card flex=100> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Members in Compliance</span> </div> </md-toolbar> <md-card-content> <div flex ng-show=\"$ctrl.companies && $ctrl.companies.length\"> <md-table-container> <table md-table> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=MemberName><span>Company Name</span></th> <th md-column md-order-by=AttestSignature><span>Last Attested By</span></th> <th md-column md-order-by=LastAttestedDate><span>Last Attested Date</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"company in $ctrl.companies | orderBy: $ctrl.query.order | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\"> <td md-cell>{{company.MemberName}}</td> <td md-cell>{{company.AttestSignature}}</td> <td md-cell>{{company.LastAttestedDate | date:'MMM-yy'}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.companies.length}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Companies per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.companies && $ctrl.companies.length\"> <p class=md-body-1> There are no companies matching the specified criteria. </p> </div> </md-card-content> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _noncompliantMembers = __webpack_require__(491);
	
	var _noncompliantMembers2 = _interopRequireDefault(_noncompliantMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.member-compliance.noncompliant-members', []).component('noncompliantMembers', _noncompliantMembers2.default).name;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _noncompliantMembers = __webpack_require__(492);
	
	var _noncompliantMembers2 = _interopRequireDefault(_noncompliantMembers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _noncompliantMembers2.default,
	  bindings: {
	    companies: '<'
	  },
	  controller: function () {
	    NoncompliantMembersComponent.$inject = ["$mdDialog", "EventEmitter"];
	    function NoncompliantMembersComponent($mdDialog, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, NoncompliantMembersComponent);
	
	      Object.assign(this, { $mdDialog: $mdDialog, EventEmitter: EventEmitter });
	    }
	
	    _createClass(NoncompliantMembersComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'getIcon',
	      value: function getIcon(bool) {
	        if (bool) {
	          return 'check';
	        }
	
	        return 'close';
	      }
	    }]);
	
	    return NoncompliantMembersComponent;
	  }()
	};

/***/ },
/* 492 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/member-compliance/noncompliant-members/noncompliant-members.html';
	var html = "<md-card flex=100> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Members Not in Compliance</span> </div> </md-toolbar> <md-card-content> <div flex ng-show=\"$ctrl.companies && $ctrl.companies.length\"> <md-table-container> <table md-table> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=MemberName><span>Company Name</span></th> <th md-column md-order-by=AttestSignature><span>Last Attested By</span></th> <th md-column md-order-by=LastAttestedDate><span>Last Attested Date</span></th> <th md-column md-order-by=IsPassAttest><span>Monthly Attest</span></th> <th md-column md-order-by=IsPassAEFiling><span>AE(s) Closed</span></th> <th md-column md-order-by=IsPassSalesData><span>Shipping Data</span></th> <th md-column md-order-by=IsPassProductInformation><span>Product Information</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"company in $ctrl.companies | orderBy: $ctrl.query.order | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\"> <td md-cell>{{company.MemberName}}</td> <td md-cell>{{company.AttestSignature}}</td> <td md-cell>{{company.LastAttestedDate | date:'MMM-yy'}}</td> <td md-cell> <md-icon md-font-set=material-icons ng-class=\"{'success' : company.IsPassAttest, 'warning' : !company.IsPassAttest}\">{{$ctrl.getIcon(company.IsPassAttest)}}</md-icon> </td> <td md-cell> <md-icon md-font-set=material-icons ng-class=\"{'success' : company.IsPassAEFiling, 'warning' : !company.IsPassAEFiling}\">{{$ctrl.getIcon(company.IsPassAEFiling)}}</md-icon> </td> <td md-cell> <md-icon md-font-set=material-icons ng-class=\"{'success' : company.IsPassSalesData, 'warning' : !company.IsPassSalesData}\">{{$ctrl.getIcon(company.IsPassSalesData)}}</md-icon> </td> <td md-cell> <md-icon md-font-set=material-icons ng-class=\"{'success' : company.IsPassProductInformation, 'warning' : !company.IsPassProductInformation}\"> {{$ctrl.getIcon(company.IsPassProductInformation)}} </md-icon> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.companies.length}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Companies per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.companies && $ctrl.companies.length\"> <p class=md-body-1> There are no companies matching the specified criteria. </p> </div> </md-card-content> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _memberCompliance = __webpack_require__(486);
	
	var _memberCompliance2 = _interopRequireDefault(_memberCompliance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.admin.member-compliance-process', [_angularUiRouter2.default]).service('MemberComplianceService', _memberCompliance2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('memberComplianceProcess', {
	    parent: 'admin',
	    abstract: true,
	    resolve: {
	      processed: ["MemberComplianceService", function processed(MemberComplianceService) {
	        return MemberComplianceService.process().then(function () {
	          return true;
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _regulatorAddForm = __webpack_require__(495);
	
	var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);
	
	var _regulatorEditForm = __webpack_require__(498);
	
	var _regulatorEditForm2 = _interopRequireDefault(_regulatorEditForm);
	
	var _regulator = __webpack_require__(501);
	
	var _regulator2 = _interopRequireDefault(_regulator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.regulator', [_angularUiRouter2.default, _regulatorAddForm2.default, _regulatorEditForm2.default]).component('regulator', _regulator2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('regulator', {
	    parent: 'app',
	    url: '/regulators/{id:int}',
	    component: 'regulator',
	    data: {
	      permissions: {
	        only: [_roles.COMPANY_ADMIN, _roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    },
	    resolve: {
	      accessLevels: ["AuthService", function accessLevels(AuthService) {
	        return AuthService.getAccessLevels();
	      }],
	      regulator: ["RegulatorService", "$stateParams", function regulator(RegulatorService, $stateParams) {
	        return RegulatorService.get($stateParams.id).then(function (r) {
	          return r.data;
	        });
	      }],
	      user: ["AccountService", "AuthService", "currentUser", function user(AccountService, AuthService, currentUser) {
	        return AccountService.getAccount(currentUser.UserId).then(function (r) {
	          return r.data;
	        });
	      }],
	      locked: function locked() {
	        return true;
	      }
	    }
	  });
	}]).name;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _regulatorAddForm = __webpack_require__(496);
	
	var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.dashboard.regulator-add-form', []).component('regulatorAddForm', _regulatorAddForm2.default).name;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _regulatorAddForm = __webpack_require__(497);
	
	var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _regulatorAddForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    regulator: '<',
	    dialogTitle: '@',
	    submitTitle: '@',
	    onRegulatorChanged: '&'
	  },
	  controller: function () {
	    RegulatorAddFormComponent.$inject = ["EventEmitter"];
	    function RegulatorAddFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, RegulatorAddFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(RegulatorAddFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onRegulatorChanged(this.EventEmitter({
	          regulator: this.regulator
	        }));
	      }
	    }]);
	
	    return RegulatorAddFormComponent;
	  }()
	};

/***/ },
/* 497 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/regulator/regulator-add-form/regulator-add-form.html';
	var html = "<form name=$ctrl.regulatorForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100> <label>Organization Name</label> <input ng-model=$ctrl.regulator.AgentName name=agentName required> <div ng-messages=$ctrl.regulatorForm.agentName.$error md-auto-hide=false> <div ng-message=required> Organization name is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=$ctrl.regulatorForm.$invalid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _regulatorEditForm = __webpack_require__(499);
	
	var _regulatorEditForm2 = _interopRequireDefault(_regulatorEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.dashboard.regulator-edit-form', []).component('regulatorEditForm', _regulatorEditForm2.default).name;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _regulatorEditForm = __webpack_require__(500);
	
	var _regulatorEditForm2 = _interopRequireDefault(_regulatorEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _regulatorEditForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    regulator: '<',
	    dialogTitle: '@',
	    submitTitle: '@',
	    onRegulatorChanged: '&'
	  },
	  controller: function () {
	    RegulatorEditFormComponent.$inject = ["EventEmitter"];
	    function RegulatorEditFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, RegulatorEditFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(RegulatorEditFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onRegulatorChanged(this.EventEmitter({
	          regulator: this.regulator
	        }));
	      }
	    }]);
	
	    return RegulatorEditFormComponent;
	  }()
	};

/***/ },
/* 500 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/regulator/regulator-edit-form/regulator-edit-form.html';
	var html = "<form name=$ctrl.regulatorForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100> <label>Organization Name</label> <input ng-model=$ctrl.regulator.AgentName name=agentName required> <div ng-messages=$ctrl.regulatorForm.agentName.$error md-auto-hide=false> <div ng-message=required> Organization name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 1</label> <input ng-model=$ctrl.regulator.tblAddress.Address1 name=address1 required> <div ng-messages=$ctrl.regulatorForm.address1.$error md-auto-hide=false> <div ng-message=required> Address is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 2</label> <input ng-model=$ctrl.regulator.tblAddress.Address2 name=address2> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>City</label> <input ng-model=$ctrl.regulator.tblAddress.City name=city required> <div ng-messages=$ctrl.regulatorForm.city.$error md-auto-hide=false> <div ng-message=required> City is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>State</label> <input ng-model=$ctrl.regulator.tblAddress.State name=state required> <div ng-messages=$ctrl.regulatorForm.state.$error md-auto-hide=false> <div ng-message=required> State is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Zip Code</label> <input ng-model=$ctrl.regulator.tblAddress.Postal name=postal required> <div ng-messages=$ctrl.regulatorForm.postal.$error md-auto-hide=false> <div ng-message=required> Zip code is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Phone</label> <input ng-model=$ctrl.regulator.Phone name=phone required> <div ng-messages=$ctrl.regulatorForm.phone.$error md-auto-hide=false> <div ng-message=required> Phone number is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Website</label> <input ng-model=$ctrl.regulator.WebSite name=webSite required> <div ng-messages=$ctrl.regulatorForm.webSite.$error md-auto-hide=false> <div ng-message=required> Website is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=$ctrl.regulatorForm.$invalid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _messages = __webpack_require__(442);
	
	var _regulator = __webpack_require__(502);
	
	var _regulator2 = _interopRequireDefault(_regulator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _regulator2.default,
	  bindings: {
	    accessLevels: '<',
	    regulator: '<',
	    user: '<'
	  },
	  controller: function () {
	    RegulatorComponent.$inject = ["$mdDialog", "$scope", "$state", "AccountService", "ArrayService", "CompanyService", "AuthService", "PeopleService", "RegulatorService", "ToastService"];
	    function RegulatorComponent($mdDialog, $scope, $state, AccountService, ArrayService, CompanyService, AuthService, PeopleService, RegulatorService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, RegulatorComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        ArrayService: ArrayService,
	        CompanyService: CompanyService,
	        AuthService: AuthService,
	        PeopleService: PeopleService,
	        RegulatorService: RegulatorService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(RegulatorComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.selectedUsers = [];
	
	        this.query = _extends({}, this.PeopleService.getDefaultQuery());
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'userAdd',
	      value: function userAdd() {
	        var _this = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.accessLevels,
	          onUserChanged: function onUserChanged($event) {
	            return _this.onUserAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-add-form\n                require-user-type-selection="false"\n                access-levels="accessLevels"\n                on-user-changed="onUserChanged($event)">\n              </user-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onUserAdded',
	      value: function onUserAdded(_ref) {
	        var _this2 = this;
	
	        var user = _ref.user;
	
	        if (user) {
	          this.AccountService.addAccount(_extends({}, user, {
	            TypeReferenceId: this.regulator.RegulatorId,
	            UserTypeId: 2
	          })).then(function () {
	            _this2.ToastService.showSuccess(_messages.USER_ADDED);
	            _this2.$mdDialog.hide();
	            _this2.refreshResults();
	          }).catch(function (error) {
	            return _this2.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'userEdit',
	      value: function userEdit(user) {
	        var _this3 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.accessLevels,
	          user: _angular2.default.copy(user),
	          onUserChanged: function onUserChanged($event) {
	            return _this3.onUserEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-edit-form\n                user="user"\n                access-levels="accessLevels"\n                show-access-level="true"\n                on-user-changed="onUserChanged($event)">\n              </user-edit-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onUserEdited',
	      value: function onUserEdited(_ref2) {
	        var _this4 = this;
	
	        var user = _ref2.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this4.ToastService.showSuccess(_messages.USER_EDITED);
	            _this4.$mdDialog.hide();
	            _this4.refreshResults();
	          }).catch(function (error) {
	            return _this4.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'userDelete',
	      value: function userDelete(users) {
	        var _this5 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected user(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = users.length - 1; i >= 0; i -= 1) {
	            promises.push(_this5.AccountService.deleteAccount(users[i].UserId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this5.ToastService.showSuccess(_messages.USER_DELETED);
	            _this5.refreshResults();
	          }).catch(function (error) {
	            return _this5.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'updateRegulator',
	      value: function updateRegulator(_ref3) {
	        var _this6 = this;
	
	        var regulator = _ref3.regulator;
	
	        if (regulator) {
	          this.RegulatorService.update(regulator).then(function () {
	            _this6.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	          }).catch(function (error) {
	            return _this6.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'updateAccount',
	      value: function updateAccount(_ref4) {
	        var _this7 = this;
	
	        var user = _ref4.user;
	
	        if (user) {
	          this.AccountService.updateAccount(user).then(function () {
	            _this7.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	            _this7.$state.reload();
	          }).catch(function (error) {
	            return _this7.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showChangePassword',
	      value: function showChangePassword(user) {
	        var _this8 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          passwordChanged: function passwordChanged($event) {
	            return _this8.onPasswordChanged($event);
	          },
	          credentials: {
	            UserId: user.UserId
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password\n                password-changed="passwordChanged($event)"\n                require-current-password="false"\n                credentials="credentials">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onPasswordChanged',
	      value: function onPasswordChanged(_ref5) {
	        var _this9 = this;
	
	        var credentials = _ref5.credentials;
	
	        if (credentials) {
	          this.AccountService.forcePasswordChange(_extends({}, credentials)).then(function () {
	            _this9.$mdDialog.hide();
	            _this9.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	            _this9.selectedUsers = [];
	          }).catch(function (error) {
	            return _this9.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'setUserLockout',
	      value: function setUserLockout(_ref6) {
	        var _this10 = this;
	
	        var userId = _ref6.userId,
	            isLocked = _ref6.isLocked;
	
	        this.AccountService.setLockoutStatus(userId, isLocked).then(function () {
	          _this10.ToastService.showSuccess(_messages.ACCOUNT_LOCKOUT_EDITED);
	        }).catch(function (error) {
	          return _this10.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(_ref7) {
	        var searchText = _ref7.searchText;
	
	        this.searchText = searchText;
	        this.refreshResults();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref8) {
	        var query = _ref8.query;
	
	        this.query = query;
	        this.refreshResults();
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this11 = this;
	
	        this.selectedUsers = [];
	        var filter = (0, _odataFilterBuilder2.default)();
	
	        if (this.searchText && this.searchText.length) {
	          filter = filter.contains('LastName', this.searchText).or(function (x) {
	            return x.contains('FirstName', _this11.searchText);
	          });
	        }
	
	        filter = filter.and(function (x) {
	          return x.eq('UserTypeName', 'Regulator');
	        }).and(function (x) {
	          return x.ne('UserId', _this11.user.UserId);
	        }).and(function (x) {
	          return x.eq('TypeReferenceId', _this11.$state.params.id);
	        });
	
	        this.promise = this.PeopleService.search(_extends({}, this.query, {
	          filter: filter
	        }));
	
	        this.promise.then(function (r) {
	          _this11.users = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this11.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return RegulatorComponent;
	  }()
	};

/***/ },
/* 502 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/regulator/regulator.html';
	var html = "<div layout=column> <div layout-padding> <div layout=column layout-gt-xs=row layout-wrap flex=none permission permission-only=\"'REGULATOR_ADMIN'\"> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Change Password\" ng-click=$ctrl.showChangePassword($ctrl.user)> <md-icon md-font-set=material-icons>vpn_key</md-icon> Change Password </md-button> </div> <user-edit-form access-levels=$ctrl.accessLevels user=::$ctrl.user on-user-changed=$ctrl.updateAccount($event) show-access-level=false layout=column flex permission permission-only=\"'REGULATOR_ADMIN'\"> </user-edit-form> <regulator-edit-form regulator=$ctrl.regulator on-regulator-changed=$ctrl.updateRegulator($event) dialog-title=\"Manage Regulator\" submit-title=\"Update Account Information\" layout=column flex> </regulator-edit-form> <div flex layout=column> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Users</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.showChangePassword($ctrl.selectedUsers[0]) ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\" permission permission-only=\"'SYS_ADMIN'\"> <md-tooltip md-direction=top>Change Password</md-tooltip> <md-icon md-font-set=material-icons>vpn_key</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.userAdd() ng-if=::!$ctrl.locked> <md-tooltip md-direction=top>Add User</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\" ng-click=$ctrl.userEdit($ctrl.selectedUsers[0]) ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length === 1\"> <md-tooltip md-direction=top>Edit User</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedUsers && $ctrl.selectedUsers.length\" ng-click=$ctrl.userDelete($ctrl.selectedUsers)> <md-tooltip md-direction=top>Delete User</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <user-list users=$ctrl.users query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) selected-users=$ctrl.selectedUsers search-text-changed=$ctrl.onSearchTextChanged($event) locked=::$ctrl.locked user-lockout-changed=$ctrl.setUserLockout($event) show-columns=\"['FirstName', 'LastName', 'Username']\" layout=column flex> </user-list> </md-card> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _query = __webpack_require__(408);
	
	var _userIngredients = __webpack_require__(504);
	
	var _userIngredients2 = _interopRequireDefault(_userIngredients);
	
	var _userIngredients3 = __webpack_require__(506);
	
	var _userIngredients4 = _interopRequireDefault(_userIngredients3);
	
	var _userIngredientForm = __webpack_require__(507);
	
	var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.user-ingredients', [_angularUiRouter2.default, _userIngredientForm2.default]).component('userIngredients', _userIngredients2.default).service('UserIngredientsService', _userIngredients4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('userIngredients', {
	    parent: 'admin',
	    url: '/user-ingredients',
	    component: 'userIngredients',
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      query: ["UserIngredientsService", function query(UserIngredientsService) {
	        return UserIngredientsService.getDefaultQuery();
	      }],
	      ingredients: ["query", "UserIngredientsService", function ingredients(query, UserIngredientsService) {
	        return UserIngredientsService.search(query).then(function (r) {
	          return (0, _query.transformODataResponse)(r);
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _messages = __webpack_require__(442);
	
	var _query = __webpack_require__(408);
	
	var _userIngredients = __webpack_require__(505);
	
	var _userIngredients2 = _interopRequireDefault(_userIngredients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _userIngredients2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    ingredients: '<',
	    query: '<'
	  },
	  controller: function () {
	    UserIngredientsComponent.$inject = ["$mdDialog", "$scope", "$state", "ToastService", "UserIngredientsService"];
	    function UserIngredientsComponent($mdDialog, $scope, $state, ToastService, UserIngredientsService) {
	      'ngInject';
	
	      _classCallCheck(this, UserIngredientsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        ToastService: ToastService,
	        UserIngredientsService: UserIngredientsService
	      });
	    }
	
	    _createClass(UserIngredientsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.columns = [{
	          FieldName: 'UserIngredientName',
	          DisplayName: 'Ingredient Name'
	        }, {
	          FieldName: 'ProductCount',
	          DisplayName: 'Product Count'
	        }];
	
	        this.selectedIngredients = [];
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(_ref) {
	        var searchText = _ref.searchText;
	
	        this.selectedIngredients = [];
	        this.searchText = searchText;
	        this.query = _extends({}, this.query, {
	          filter: (0, _odataFilterBuilder2.default)().contains('UserIngredientName', searchText)
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref2) {
	        var query = _ref2.query;
	
	        this.selectedIngredients = [];
	        this.query = query;
	        this.refreshResults();
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this = this;
	
	        this.promise = this.UserIngredientsService.search(this.query);
	        this.promise.then(function (r) {
	          _this.ingredients = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'canDeleteIngredients',
	      value: function canDeleteIngredients(ingredients) {
	        if (!(ingredients && ingredients.length)) {
	          return false;
	        }
	
	        return true; // !ingredients.some(x => x.ProductCount > 0);
	      }
	    }, {
	      key: 'ingredientAdd',
	      value: function ingredientAdd() {
	        var _this2 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredientChanged: function ingredientChanged($event) {
	            return _this2.onIngredientAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-ingredient-form\n                dialog-title="Add New User Ingredient"\n                submit-title="Add User Ingredient"\n                ingredient-changed="ingredientChanged($event)">\n              </user-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onIngredientAdded',
	      value: function onIngredientAdded(_ref3) {
	        var _this3 = this;
	
	        var ingredient = _ref3.ingredient;
	
	        this.UserIngredientsService.add(ingredient).then(function () {
	          _this3.$mdDialog.hide();
	          _this3.refreshResults();
	          _this3.ToastService.showSuccess(_messages.USER_INGREDIENT_ADDED);
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'ingredientEdit',
	      value: function ingredientEdit(ingredient) {
	        var _this4 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredientChanged: function ingredientChanged($event) {
	            return _this4.onIngredientEdited($event);
	          },
	          ingredient: _angular2.default.copy(ingredient)
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <user-ingredient-form\n                ingredient="ingredient"\n                dialog-title="Edit User Ingredient"\n                submit-title="Save Changes"\n                ingredient-changed="ingredientChanged($event)">\n              </user-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientDelete',
	      value: function ingredientDelete(ingredients) {
	        var _this5 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent(_messages.USER_INGREDIENT_DELETE_CONFIRMATION).ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = ingredients.length - 1; i >= 0; i -= 1) {
	            promises.push(_this5.UserIngredientsService.delete(ingredients[i].UserIngredientId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this5.ToastService.showSuccess(_messages.USER_INGREDIENT_DELETED);
	            _this5.selectedIngredients = [];
	            _this5.refreshResults();
	          }).catch(function (error) {
	            if (error.statusText === 'Bad Request' && error.data && error.data.Message) {
	              _this5.ToastService.showError(error, error.data.Message);
	            } else {
	              _this5.ToastService.showError(error);
	            }
	          });
	        });
	      }
	    }, {
	      key: 'onIngredientEdited',
	      value: function onIngredientEdited(_ref4) {
	        var _this6 = this;
	
	        var ingredient = _ref4.ingredient;
	
	        this.UserIngredientsService.update(ingredient).then(function () {
	          _this6.$mdDialog.hide();
	          _this6.selectedIngredients = [];
	          _this6.refreshResults();
	          _this6.ToastService.showSuccess(_messages.USER_INGREDIENT_EDITED);
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return UserIngredientsComponent;
	  }()
	};

/***/ },
/* 505 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/user-ingredients/user-ingredients.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage User Ingredients</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.ingredientAdd()> <md-tooltip md-direction=top>Add User Ingredient</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length === 1\" ng-click=$ctrl.ingredientEdit($ctrl.selectedIngredients[0]) ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length === 1\"> <md-tooltip md-direction=top>Edit User Ingredient</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=$ctrl.canDeleteIngredients($ctrl.selectedIngredients) ng-click=$ctrl.ingredientDelete($ctrl.selectedIngredients)> <md-tooltip md-direction=top>Delete User Ingredient</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <item-list items=$ctrl.ingredients selected-items=$ctrl.selectedIngredients columns=$ctrl.columns query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) search-text-changed=$ctrl.onSearchTextChanged($event) display-name-plural=Ingredients layout=column flex> </item-list> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserIngredientsService = function () {
	  UserIngredientsService.$inject = ["$http"];
	  function UserIngredientsService($http) {
	    'ngInject';
	
	    _classCallCheck(this, UserIngredientsService);
	
	    this.$http = $http;
	  }
	
	  _createClass(UserIngredientsService, [{
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'UserIngredientName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'add',
	    value: function add(ingredient) {
	      return this.$http.post('/api/user_ingredient', ingredient);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/user_ingredient/' + id);
	    }
	  }, {
	    key: 'update',
	    value: function update(ingredient) {
	      return this.$http.put('/api/user_ingredient/' + ingredient.UserIngredientId, ingredient);
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/UserIngredientOData', {
	        params: _extends({
	          $select: 'UserIngredientId, UserIngredientName, ProductCount',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'isUniqueIngredientName',
	    value: function isUniqueIngredientName(ingredientName, id) {
	      return this.$http.get('/api/user_ingredient/unique_ingredient_name', {
	        params: {
	          UserIngredientName: ingredientName,
	          id: id
	        }
	      });
	    }
	  }]);
	
	  return UserIngredientsService;
	}();
	
	exports.default = UserIngredientsService;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userIngredientForm = __webpack_require__(508);
	
	var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.admin.userIngredients.userIngredientForm', []).component('userIngredientForm', _userIngredientForm2.default).name;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _userIngredientForm = __webpack_require__(509);
	
	var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _userIngredientForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    ingredient: '<',
	    dialogTitle: '@',
	    submitTitle: '@',
	    ingredientChanged: '&'
	  },
	  controller: function () {
	    UserIngredientFormComponent.$inject = ["EventEmitter"];
	    function UserIngredientFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, UserIngredientFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(UserIngredientFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.ingredientChanged(this.EventEmitter({
	          ingredient: this.ingredient
	        }));
	      }
	    }]);
	
	    return UserIngredientFormComponent;
	  }()
	};

/***/ },
/* 509 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/user-ingredients/user-ingredient-form/user-ingredient-form.html';
	var html = "<form name=$ctrl.ingredientForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex> <label>Ingredient Name</label> <input ng-model=$ctrl.ingredient.UserIngredientName name=ingredientName data-ingredient-id={{$ctrl.ingredient.UserIngredientId}} required unique-user-ingredient-name> <div ng-messages=$ctrl.ingredientForm.ingredientName.$error md-auto-hide=false> <div ng-message=required> Ingredient name is required. </div> <div ng-message=uniqueUserIngredientName> User ingredient name is already taken! Please choose a unique name. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.ingredientForm.$valid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _query = __webpack_require__(408);
	
	var _systemIngredients = __webpack_require__(511);
	
	var _systemIngredients2 = _interopRequireDefault(_systemIngredients);
	
	var _systemIngredients3 = __webpack_require__(513);
	
	var _systemIngredients4 = _interopRequireDefault(_systemIngredients3);
	
	var _systemIngredientForm = __webpack_require__(514);
	
	var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.admin.system-ingredients', [_angularUiRouter2.default, _systemIngredientForm2.default]).component('systemIngredients', _systemIngredients2.default).service('SystemIngredientsService', _systemIngredients4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('systemIngredients', {
	    parent: 'admin',
	    url: '/system-ingredients',
	    component: 'systemIngredients',
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      query: ["SystemIngredientsService", function query(SystemIngredientsService) {
	        return SystemIngredientsService.getDefaultQuery();
	      }],
	      ingredients: ["query", "SystemIngredientsService", function ingredients(query, SystemIngredientsService) {
	        return SystemIngredientsService.search(query).then(function (r) {
	          return (0, _query.transformODataResponse)(r);
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _messages = __webpack_require__(442);
	
	var _query = __webpack_require__(408);
	
	var _systemIngredients = __webpack_require__(512);
	
	var _systemIngredients2 = _interopRequireDefault(_systemIngredients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _systemIngredients2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    ingredients: '<',
	    query: '<'
	  },
	  controller: function () {
	    SystemIngredientsComponent.$inject = ["$mdDialog", "$scope", "ToastService", "SystemIngredientsService"];
	    function SystemIngredientsComponent($mdDialog, $scope, ToastService, SystemIngredientsService) {
	      'ngInject';
	
	      _classCallCheck(this, SystemIngredientsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        ToastService: ToastService,
	        SystemIngredientsService: SystemIngredientsService
	      });
	    }
	
	    _createClass(SystemIngredientsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.columns = [{
	          FieldName: 'SystemIngredientName',
	          DisplayName: 'Ingredient Name'
	        }, {
	          FieldName: 'IUtoMgConversiontRate',
	          DisplayName: '1 IU to MG Conversion Rate'
	        }];
	
	        this.selectedIngredients = [];
	      }
	    }, {
	      key: 'onQueryChanged',
	      value: function onQueryChanged(_ref) {
	        var query = _ref.query;
	
	        this.selectedIngredients = [];
	        this.query = query;
	        this.refreshResults();
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(_ref2) {
	        var searchText = _ref2.searchText;
	
	        this.selectedIngredients = [];
	        this.query = _extends({}, this.query, {
	          filter: (0, _odataFilterBuilder2.default)().contains('SystemIngredientName', searchText)
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this = this;
	
	        this.promise = this.SystemIngredientsService.search(this.query);
	        this.promise.then(function (r) {
	          _this.ingredients = (0, _query.transformODataResponse)(r);
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'ingredientAdd',
	      value: function ingredientAdd() {
	        var _this2 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredientChanged: function ingredientChanged($event) {
	            return _this2.onIngredientAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <system-ingredient-form\n                dialog-title="Add New System Ingredient"\n                submit-title="Add System Ingredient"\n                ingredient-changed="ingredientChanged($event)">\n              </system-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onIngredientAdded',
	      value: function onIngredientAdded(_ref3) {
	        var _this3 = this;
	
	        var ingredient = _ref3.ingredient;
	
	        this.SystemIngredientsService.add(ingredient).then(function () {
	          _this3.$mdDialog.hide();
	          _this3.refreshResults();
	          _this3.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_ADDED);
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'ingredientEdit',
	      value: function ingredientEdit(ingredient) {
	        var _this4 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredient: _angular2.default.copy(ingredient),
	          ingredientChanged: function ingredientChanged($event) {
	            return _this4.onIngredientEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <system-ingredient-form\n                ingredient="ingredient"\n                dialog-title="Edit System Ingredient"\n                submit-title="Save Changes"\n                ingredient-changed="ingredientChanged($event)">\n              </system-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientDelete',
	      value: function ingredientDelete(ingredients) {
	        var _this5 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected ingredient(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = ingredients.length - 1; i >= 0; i -= 1) {
	            promises.push(_this5.SystemIngredientsService.delete(ingredients[i].SystemIngredientId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this5.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_DELETED);
	            _this5.refreshResults();
	            _this5.selectedIngredients = [];
	          }).catch(function (error) {
	            return _this5.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'onIngredientEdited',
	      value: function onIngredientEdited(_ref4) {
	        var _this6 = this;
	
	        var ingredient = _ref4.ingredient;
	
	        this.SystemIngredientsService.update(ingredient).then(function () {
	          _this6.$mdDialog.hide();
	          _this6.selectedIngredients = [];
	          _this6.refreshResults();
	          _this6.ToastService.showSuccess(_messages.SYSTEM_INGREDIENT_EDITED);
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return SystemIngredientsComponent;
	  }()
	};

/***/ },
/* 512 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/system-ingredients/system-ingredients.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex layout=column> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage System Ingredients</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.ingredientAdd()> <md-tooltip md-direction=top>Add System Ingredient</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length === 1\" ng-click=$ctrl.ingredientEdit($ctrl.selectedIngredients[0]) ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length === 1\"> <md-tooltip md-direction=top>Edit System Ingredient</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length\" ng-click=$ctrl.ingredientDelete($ctrl.selectedIngredients)> <md-tooltip md-direction=top>Delete System Ingredient</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <item-list items=$ctrl.ingredients selected-items=$ctrl.selectedIngredients columns=$ctrl.columns query=$ctrl.query query-changed=$ctrl.onQueryChanged($event) search-text-changed=$ctrl.onSearchTextChanged($event) display-name-plural=Ingredients layout=column flex> </item-list> </md-card> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SystemIngredientsService = function () {
	  SystemIngredientsService.$inject = ["$http"];
	  function SystemIngredientsService($http) {
	    'ngInject';
	
	    _classCallCheck(this, SystemIngredientsService);
	
	    this.$http = $http;
	  }
	
	  _createClass(SystemIngredientsService, [{
	    key: 'getDefaultQuery',
	    value: function getDefaultQuery() {
	      return _extends({}, (0, _query.getQuery)(), {
	        orderBy: 'SystemIngredientName',
	        direction: 'asc'
	      });
	    }
	  }, {
	    key: 'search',
	    value: function search(query) {
	      return this.$http.get('/odata/SystemIngredientOData', {
	        params: _extends({
	          $select: 'SystemIngredientId, SystemIngredientName, IUtoMgConversiontRate',
	          $top: query.take,
	          $skip: query.calculateSkip(),
	          $orderby: query.orderBy + ' ' + query.direction
	        }, query.filter && { $filter: query.filter.toString() }, {
	          $count: true
	        })
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/system_ingredient/' + id);
	    }
	  }, {
	    key: 'add',
	    value: function add(ingredient) {
	      return this.$http.post('/api/system_ingredient', ingredient);
	    }
	  }, {
	    key: 'update',
	    value: function update(ingredient) {
	      return this.$http.put('/api/system_ingredient/' + ingredient.SystemIngredientId, ingredient);
	    }
	  }, {
	    key: 'isUniqueIngredientName',
	    value: function isUniqueIngredientName(ingredientName, id) {
	      return this.$http.get('/api/system_ingredient/unique_ingredient_name', {
	        params: {
	          SystemIngredientName: ingredientName,
	          id: id
	        }
	      });
	    }
	  }]);
	
	  return SystemIngredientsService;
	}();
	
	exports.default = SystemIngredientsService;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _systemIngredientForm = __webpack_require__(515);
	
	var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.admin.system-ingredients.system-ingredient-form', []).component('systemIngredientForm', _systemIngredientForm2.default).name;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _systemIngredientForm = __webpack_require__(516);
	
	var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _systemIngredientForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    ingredient: '<',
	    dialogTitle: '@',
	    submitTitle: '@',
	    ingredientChanged: '&'
	  },
	  controller: function () {
	    SystemIngredientFormComponent.$inject = ["EventEmitter"];
	    function SystemIngredientFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, SystemIngredientFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(SystemIngredientFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.ingredientChanged(this.EventEmitter({
	          ingredient: this.ingredient
	        }));
	      }
	    }]);
	
	    return SystemIngredientFormComponent;
	  }()
	};

/***/ },
/* 516 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/admin/system-ingredients/system-ingredient-form/system-ingredient-form.html';
	var html = "<form name=$ctrl.ingredientForm flex ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100> <label>Ingredient Name</label> <input ng-model=$ctrl.ingredient.SystemIngredientName name=ingredientName data-ingredient-id={{$ctrl.ingredient.SystemIngredientId}} required unique-system-ingredient-name> <div ng-messages=$ctrl.ingredientForm.ingredientName.$error md-auto-hide=false> <div ng-message=required> Ingredient name is required. </div> <div ng-message=uniqueSystemIngredientName> System ingredient name is already taken! Please choose a unique name. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>1 IU to MG Conversion Rate</label> <input ng-model=$ctrl.ingredient.IUtoMgConversiontRate name=conversionRate type=number required> <div ng-messages=$ctrl.ingredientForm.conversionRate.$error md-auto-hide=false> <div ng-message=required> Conversion rate is required. </div> <div ng-message=number> Conversion rate must be numeric. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.ingredientForm.$valid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _account = __webpack_require__(518);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _account3 = __webpack_require__(519);
	
	var _account4 = _interopRequireDefault(_account3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.account', [_angularUiRouter2.default]).component('account', _account4.default).service('AccountService', _account2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('account', {
	    parent: 'app',
	    url: '/account',
	    component: 'account',
	    data: {
	      permissions: {
	        only: [_roles.REGULATOR, _roles.USER],
	        redirectTo: 'dashboard'
	      }
	    },
	    resolve: {
	      accessLevels: ["AuthService", function accessLevels(AuthService) {
	        return AuthService.getAccessLevels();
	      }],
	      user: ["AccountService", "currentUser", function user(AccountService, currentUser) {
	        return AccountService.getAccount(currentUser.UserId).then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 518 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AccountService = function () {
	  AccountService.$inject = ["$http"];
	  function AccountService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AccountService);
	
	    this.$http = $http;
	  }
	
	  _createClass(AccountService, [{
	    key: 'getAccount',
	    value: function getAccount(id) {
	      return this.$http.get('/api/account/' + id);
	    }
	  }, {
	    key: 'deleteAccount',
	    value: function deleteAccount(id) {
	      return this.$http.delete('/api/account/' + id);
	    }
	  }, {
	    key: 'addAccount',
	    value: function addAccount(account) {
	      return this.$http.post('/api/account', account);
	    }
	  }, {
	    key: 'updateAccount',
	    value: function updateAccount(account) {
	      return this.$http.put('/api/account/' + account.UserId, account);
	    }
	  }, {
	    key: 'isUniqueUsername',
	    value: function isUniqueUsername(username, id) {
	      return this.$http.get('/api/account/unique_username', {
	        params: {
	          username: username,
	          id: id
	        }
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(credentials) {
	      return this.$http.post('/api/account/password_reset', credentials);
	    }
	  }, {
	    key: 'forcePasswordChange',
	    value: function forcePasswordChange(credentials) {
	      return this.$http.post('/api/account/password_override', credentials);
	    }
	  }, {
	    key: 'setLockoutStatus',
	    value: function setLockoutStatus(userId, isLocked) {
	      return this.$http.put('/api/account/' + userId + '/lockout', {
	        userId: userId,
	        isLocked: isLocked
	      });
	    }
	  }, {
	    key: 'updateDiscontinuedPreference',
	    value: function updateDiscontinuedPreference(userId, showDiscontinuedProducts) {
	      return this.$http.put('/api/account/' + userId + '/set_search_perference', {}, {
	        params: {
	          Is_Show_Discontiuned: showDiscontinuedProducts
	        }
	      });
	    }
	  }]);
	
	  return AccountService;
	}();
	
	exports.default = AccountService;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _account = __webpack_require__(520);
	
	var _account2 = _interopRequireDefault(_account);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _account2.default,
	  bindings: {
	    accessLevels: '<',
	    user: '<'
	  },
	  controller: function () {
	    AccountComponent.$inject = ["$mdDialog", "$scope", "$state", "AccountService", "ToastService"];
	    function AccountComponent($mdDialog, $scope, $state, AccountService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AccountComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AccountComponent, [{
	      key: 'updateAccount',
	      value: function updateAccount($event) {
	        var _this = this;
	
	        if ($event && $event.user) {
	          this.AccountService.updateAccount($event.user).then(function () {
	            _this.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
	            _this.$state.reload();
	          }).catch(function (error) {
	            return _this.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showChangePassword',
	      value: function showChangePassword() {
	        var _this2 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          passwordChanged: function passwordChanged($event) {
	            return _this2.onPasswordChanged($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="passwordChanged($event)">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onPasswordChanged',
	      value: function onPasswordChanged($event) {
	        var _this3 = this;
	
	        if ($event && $event.credentials && this.user.UserId) {
	          this.AccountService.forcePasswordChange(_extends({
	            UserId: this.user.UserId
	          }, $event.credentials)).then(function () {
	            _this3.$mdDialog.hide();
	            _this3.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	          }).catch(function (error) {
	            return _this3.ToastService.showError(error);
	          });
	        }
	      }
	    }]);
	
	    return AccountComponent;
	  }()
	};

/***/ },
/* 520 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/account/account.html';
	var html = "<div layout=column layout-padding flex> <div layout=row layout-wrap> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Change Password\" ng-click=$ctrl.showChangePassword() flex-xs=100> <md-icon md-font-set=material-icons>vpn_key</md-icon> Change Password </md-button> </div> <div layout=column flex> <user-edit-form access-levels=$ctrl.accessLevels show-access-level=false user=::$ctrl.user on-user-changed=$ctrl.updateAccount($event) layout=column flex> </user-edit-form> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _adverseEvent = __webpack_require__(522);
	
	var _adverseEvent2 = _interopRequireDefault(_adverseEvent);
	
	var _adverseEvent3 = __webpack_require__(523);
	
	var _adverseEvent4 = _interopRequireDefault(_adverseEvent3);
	
	var _information = __webpack_require__(525);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _animalHistory = __webpack_require__(528);
	
	var _animalHistory2 = _interopRequireDefault(_animalHistory);
	
	var _animalInformation = __webpack_require__(531);
	
	var _animalInformation2 = _interopRequireDefault(_animalInformation);
	
	var _caseReference = __webpack_require__(534);
	
	var _caseReference2 = _interopRequireDefault(_caseReference);
	
	var _closure = __webpack_require__(537);
	
	var _closure2 = _interopRequireDefault(_closure);
	
	var _ownerForm = __webpack_require__(540);
	
	var _ownerForm2 = _interopRequireDefault(_ownerForm);
	
	var _vetForm = __webpack_require__(543);
	
	var _vetForm2 = _interopRequireDefault(_vetForm);
	
	var _otherForm = __webpack_require__(546);
	
	var _otherForm2 = _interopRequireDefault(_otherForm);
	
	var _contactList = __webpack_require__(549);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	var _riskAnalysis = __webpack_require__(552);
	
	var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent', [_angularUiRouter2.default, _information2.default, _animalHistory2.default, _animalInformation2.default, _caseReference2.default, _closure2.default, _ownerForm2.default, _vetForm2.default, _otherForm2.default, _contactList2.default, _riskAnalysis2.default]).component('adverseEvent', _adverseEvent4.default).service('AdverseEventService', _adverseEvent2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('adverseEventEdit', {
	    parent: 'app',
	    url: '/adverse-events/{id:int}',
	    component: 'adverseEvent',
	    resolve: {
	      adverseEvent: ["AdverseEventService", "$stateParams", function adverseEvent(AdverseEventService, $stateParams) {
	        return AdverseEventService.getAdverseEvent($stateParams.id).then(function (r) {
	          return r.data;
	        });
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      company: ["CompanyService", "adverseEvent", function company(CompanyService, adverseEvent) {
	        return CompanyService.getCompany(adverseEvent.MemberId).then(function (r) {
	          return r.data;
	        });
	      }],
	      contactTypes: ["AdverseEventService", function contactTypes(AdverseEventService) {
	        return AdverseEventService.getContactTypes();
	      }],
	      statuses: ["AdverseEventService", function statuses(AdverseEventService) {
	        return AdverseEventService.getStatuses();
	      }],
	      sexes: ["AdverseEventService", function sexes(AdverseEventService) {
	        return AdverseEventService.getAnimalSexes();
	      }],
	      symptoms: ["AdverseEventService", function symptoms(AdverseEventService) {
	        return AdverseEventService.getSymptoms();
	      }],
	      occurrenceLikelihoods: ["AdverseEventService", function occurrenceLikelihoods(AdverseEventService) {
	        return AdverseEventService.getOccurrenceLikelihoods();
	      }],
	      injuryProbabilities: ["AdverseEventService", function injuryProbabilities(AdverseEventService) {
	        return AdverseEventService.getInjurityProbabilities();
	      }],
	      injurySeverities: ["AdverseEventService", function injurySeverities(AdverseEventService) {
	        return AdverseEventService.getInjuritySeverities();
	      }]
	    }
	  }).state('adverseEventCreate', {
	    parent: 'app',
	    url: '/adverse-events/create',
	    component: 'adverseEvent',
	    data: {
	      permissions: {
	        only: [_roles.USER, _roles.COMPANY_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    },
	    resolve: {
	      adverseEvent: ["currentUser", function adverseEvent(currentUser) {
	        return {
	          AEId: 0,
	          MemberId: currentUser.MemberId,
	          Status: 'OPEN'
	        };
	      }],
	      statuses: ["AdverseEventService", function statuses(AdverseEventService) {
	        return AdverseEventService.getStatuses();
	      }],
	      company: ["CompanyService", "currentUser", function company(CompanyService, currentUser) {
	        return CompanyService.getCompany(currentUser.MemberId).then(function (r) {
	          return r.data;
	        });
	      }],
	      contactTypes: ["AdverseEventService", function contactTypes(AdverseEventService) {
	        return AdverseEventService.getContactTypes();
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      sexes: ["AdverseEventService", function sexes(AdverseEventService) {
	        return AdverseEventService.getAnimalSexes();
	      }],
	      symptoms: ["AdverseEventService", function symptoms(AdverseEventService) {
	        return AdverseEventService.getSymptoms();
	      }],
	      occurrenceLikelihoods: ["AdverseEventService", function occurrenceLikelihoods(AdverseEventService) {
	        return AdverseEventService.getOccurrenceLikelihoods();
	      }],
	      injuryProbabilities: ["AdverseEventService", function injuryProbabilities(AdverseEventService) {
	        return AdverseEventService.getInjurityProbabilities();
	      }],
	      injurySeverities: ["AdverseEventService", function injurySeverities(AdverseEventService) {
	        return AdverseEventService.getInjuritySeverities();
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 522 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdverseEventService = function () {
	  AdverseEventService.$inject = ["$http"];
	  function AdverseEventService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdverseEventService);
	
	    this.$http = $http;
	  }
	
	  _createClass(AdverseEventService, [{
	    key: 'getAdverseEvent',
	    value: function getAdverseEvent(id) {
	      return this.$http.get('/api/ae/' + id);
	    }
	  }, {
	    key: 'getInjurityProbabilities',
	    value: function getInjurityProbabilities() {
	      return [{
	        name: '(+1) Extremely unlikely',
	        value: 1
	      }, {
	        name: '(+2) Unlikely but possible',
	        value: 2
	      }, {
	        name: '(+3) Likely',
	        value: 3
	      }, {
	        name: '(+4) Very Likely',
	        value: 4
	      }, {
	        name: '(+5) Extremely Likely',
	        value: 5
	      }];
	    }
	  }, {
	    key: 'getInjuritySeverities',
	    value: function getInjuritySeverities() {
	      return [{
	        name: '(+1) None – No symptoms reported.',
	        value: 1
	      }, {
	        name: '(+2) Limited – Symptoms resolve quickly. Does not interfere with normal activities.',
	        value: 2
	      }, {
	        name: '(+3) Moderate – Prolonged symptoms and/or interferes with the ability to perform normal activities.',
	        value: 3
	      }, {
	        name: '(+4) Severe – Permanent injury or unable to perform normal activities.',
	        value: 4
	      }, {
	        name: '(+5) Life threatening.',
	        value: 5
	      }];
	    }
	  }, {
	    key: 'getOccurrenceLikelihoods',
	    value: function getOccurrenceLikelihoods() {
	      return [{
	        name: '(+1) Remote - Only instance recorded',
	        value: 1
	      }, {
	        name: '(+2) Rare - More than one instance (estimated 1 in 1000)',
	        value: 2
	      }, {
	        name: '(+3) Occasional - Multiple instances (estimated 1 in 100)',
	        value: 3
	      }, {
	        name: '(+4) Frequent - Estimated 1 in 10',
	        value: 4
	      }, {
	        name: '(+5) Continuously occurring - More than 10% of the patients',
	        value: 5
	      }];
	    }
	  }, {
	    key: 'getAnimalSexes',
	    value: function getAnimalSexes() {
	      var sexes = [{
	        name: 'Male - Neutered / Gelding',
	        value: 1
	      }, {
	        name: 'Male - Intact / Stallion',
	        value: 2
	      }, {
	        name: 'Female - Spayed',
	        value: 3
	      }, {
	        name: 'Female - Intact - Pregnant',
	        value: 4
	      }, {
	        name: 'Female - Intact - Not Pregnant',
	        value: 5
	      }, {
	        name: 'Male - Unknown',
	        value: 6
	      }, {
	        name: 'Female - Unknown',
	        value: 7
	      }];
	
	      return sexes.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      });
	    }
	  }, {
	    key: 'getSymptoms',
	    value: function getSymptoms() {
	      return ['Diarrhea', 'Stomach Upset/Vomiting', 'Colic (Horse)', 'Skin/Allergic Reaction', 'Seizures', 'Death', 'Lameness', 'Accidental Ingestion', 'Other'];
	    }
	  }, {
	    key: 'getContactTypes',
	    value: function getContactTypes() {
	      return ['Owner', 'Vet', 'Other'];
	    }
	  }, {
	    key: 'getStatuses',
	    value: function getStatuses() {
	      return ['OPEN', 'CLOSED'];
	    }
	  }, {
	    key: 'getProductsByCompany',
	    value: function getProductsByCompany(companyId) {
	      return this.$http.get('/api/product/signed_by_member/' + companyId);
	    }
	  }, {
	    key: 'update',
	    value: function update(adverseEvent) {
	      return this.$http.put('/api/ae/' + adverseEvent.AEId, _extends({}, adverseEvent, {
	        Contacts: this.orderContacts(adverseEvent.Contacts)
	      }));
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(id) {
	      return this.$http.delete('/api/ae/' + id);
	    }
	  }, {
	    key: 'create',
	    value: function create(adverseEvent) {
	      return this.$http.post('/api/ae', _extends({}, adverseEvent, {
	        Contacts: this.orderContacts(adverseEvent.Contacts)
	      }));
	    }
	  }, {
	    key: 'orderContacts',
	    value: function orderContacts(contacts) {
	      var tempContacts = [];
	      if (!(contacts && contacts.length)) {
	        return [];
	      }
	
	      var vetIndex = contacts.findIndex(function (c) {
	        return c.Relationship === 'Vet';
	      });
	      var ownerIndex = contacts.findIndex(function (c) {
	        return c.Relationship === 'Owner';
	      });
	      var otherIndex = contacts.findIndex(function (c) {
	        return c.Relationship === 'Other';
	      });
	
	      if (vetIndex !== -1) {
	        tempContacts.push(contacts[vetIndex]);
	      }
	
	      if (ownerIndex !== -1) {
	        tempContacts.push(contacts[ownerIndex]);
	      }
	
	      if (otherIndex !== -1) {
	        tempContacts.push(contacts[otherIndex]);
	      }
	
	      return tempContacts;
	    }
	  }, {
	    key: 'attest',
	    value: function attest(signature) {
	      return this.$http.post('/api/ae/attest', {
	        signature: signature
	      });
	    }
	  }]);
	
	  return AdverseEventService;
	}();
	
	exports.default = AdverseEventService;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messages = __webpack_require__(442);
	
	var _adverseEvent = __webpack_require__(524);
	
	var _adverseEvent2 = _interopRequireDefault(_adverseEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adverseEvent2.default,
	  bindings: {
	    adverseEvent: '<',
	    company: '<',
	    animalTypes: '<',
	    sexes: '<',
	    states: '<',
	    statuses: '<',
	    symptoms: '<',
	    occurrenceLikelihoods: '<',
	    injuryProbabilities: '<',
	    injurySeverities: '<'
	  },
	  controller: function () {
	    AdverseEventComponent.$inject = ["$mdDialog", "$scope", "$state", "AdverseEventService", "LoadingService", "ToastService"];
	    function AdverseEventComponent($mdDialog, $scope, $state, AdverseEventService, LoadingService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdverseEventComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AdverseEventService: AdverseEventService,
	        LoadingService: LoadingService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AdverseEventComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.adverseEvent.Products = this.adverseEvent.Products || [];
	      }
	    }, {
	      key: 'saveChanges',
	      value: function saveChanges() {
	        var _this = this;
	
	        var saveMessage = this.adverseEvent.AEId ? _messages.ADVERSE_EVENT_EDITED : _messages.ADVERSE_EVENT_ADDED;
	        var promise = void 0;
	
	        if (this.adverseEvent.AEId) {
	          promise = this.AdverseEventService.update(this.adverseEvent);
	        } else {
	          promise = this.AdverseEventService.create(this.adverseEvent);
	        }
	
	        this.LoadingService.start();
	        promise.then(function (r) {
	          _this.ToastService.showSuccess(saveMessage);
	          _this.adverseEvent.AEId = _this.adverseEvent.AEId || r.data.Id;
	
	          return Promise.resolve(true);
	        }).then(function () {
	          return _this.$state.go('adverseEventEdit', { id: _this.adverseEvent.AEId }, { reload: true });
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          return _this.LoadingService.stop();
	        });
	      }
	    }]);
	
	    return AdverseEventComponent;
	  }()
	};

/***/ },
/* 524 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/adverse-event.html';
	var html = "<ng-form name=$ctrl.adverseEventForm flex layout=column novalidate> <div layout=column> <div layout-padding layout=column> <case-reference adverse-event=$ctrl.adverseEvent layout=row> </case-reference> <contact-list adverse-event=$ctrl.adverseEvent layout=row show-header=true> </contact-list> <animal-information adverse-event=$ctrl.adverseEvent animal-types=::$ctrl.animalTypes sexes=::$ctrl.sexes layout=row> </animal-information> <adverse-event-information adverse-event=$ctrl.adverseEvent symptoms=::$ctrl.symptoms allow-multiple-products=::$ctrl.company.IsAllowMultiProductPerAE member-id=::$ctrl.adverseEvent.MemberId layout=row> </adverse-event-information> <animal-history adverse-event=$ctrl.adverseEvent layout=row></animal-history> <risk-analysis adverse-event=$ctrl.adverseEvent injury-severities=::$ctrl.injurySeverities injury-probabilities=::$ctrl.injuryProbabilities occurrence-likelihoods=::$ctrl.occurrenceLikelihoods layout=row> </risk-analysis> <closure adverse-event=$ctrl.adverseEvent statuses=::$ctrl.statuses layout=row></closure> </div> </div> </ng-form> <footer class=no-print> <div layout=column layout-align=\"center center\"> <div ng-messages=$ctrl.adverseEventForm.$error style=color:#b53b0a> <div ng-message-exp=\"['minlength', 'maxlength', 'required']\"> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please ensure that all required fields are answered before saving. </div> </div> <div layout=row flex> <md-button class=\"md-raised md-accent md-button-md\" aria-label=\"Save Adverse Event\" ng-click=$ctrl.saveChanges() ng-disabled=$ctrl.adverseEventForm.$invalid> <md-icon md-font-set=material-icons>save</md-icon> Save Adverse Event </md-button> </div> </div></footer> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _information = __webpack_require__(526);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.information', []).component('adverseEventInformation', _information2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _query = __webpack_require__(408);
	
	var _information = __webpack_require__(527);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _information2.default,
	  bindings: {
	    adverseEvent: '<',
	    allowMultipleProducts: '<',
	    symptoms: '<',
	    locked: '<',
	    memberId: '<'
	  },
	  controller: function () {
	    AdverseEventInformationComponent.$inject = ["$http", "ToastService"];
	    function AdverseEventInformationComponent($http, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdverseEventInformationComponent);
	
	      Object.assign(this, {
	        $http: $http,
	        ToastService: ToastService
	      });
	
	      this.today = new Date();
	    }
	
	    _createClass(AdverseEventInformationComponent, [{
	      key: 'transformChip',
	      value: function transformChip(chip) {
	        if (_angular2.default.isObject(chip)) {
	          return chip;
	        }
	
	        return { name: chip, type: 'new' };
	      }
	    }, {
	      key: 'searchSignedProductsByMember',
	      value: function searchSignedProductsByMember(searchText) {
	        var _this = this;
	
	        return this.$http.get('/odata/ProductOData', {
	          params: {
	            $select: 'ProductId, ProductName, DateIntroduced, Discontinued',
	            $orderby: 'ProductName asc, DateIntroduced desc',
	            $filter: 'MemberId eq ' + this.memberId + ' and SignDate ne null and contains(ProductName, \'' + searchText + '\')'
	          }
	        }).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'maxProducts',
	      get: function get() {
	        if (this.allowMultipleProducts) {
	          return 100;
	        }
	
	        return 2;
	      }
	    }]);
	
	    return AdverseEventInformationComponent;
	  }()
	};

/***/ },
/* 527 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/information/information.html';
	var html = "<form name=$ctrl.adverseEventInformationForm flex=100> <md-card> <md-toolbar class=md-table-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Adverse Event Information</span> <md-icon md-font-set=material-icons class=warning ng-show=$ctrl.adverseEventInformationForm.$invalid>error</md-icon> <span flex></span> </div> </md-toolbar> <div layout=row layout-padding layout-wrap> <div layout=row layout-wrap> <md-chips ng-model=$ctrl.adverseEvent.Products md-autocomplete-snap md-require-match=true md-transform-chip=$ctrl.transformChip($chip) name=productIds flex=100 md-max-chips={{::$ctrl.maxProducts}} readonly=::$ctrl.locked required> <md-autocomplete md-search-text=$ctrl.productSearchText md-items=\"item in $ctrl.searchSignedProductsByMember($ctrl.productSearchText)\" md-item-text=item.ProductName placeholder=\"Product Involved (start typing name to select match) *\" secondary-placeholder=\"Product Involved *\"> <span md-highlight-text=$ctrl.productSearchText>{{item.ProductName}} &ensp; ({{(item.Discontinued ? 'Discontinued &dash; ' : '')}}first sold {{item.DateIntroduced | date:'MMM-yy'}})</span> </md-autocomplete> <md-chip-template> <span>{{$chip.ProductName}}</span> </md-chip-template> </md-chips> <md-input-container class=md-block flex=100 flex-gt-sm=33> <div ng-messages=$ctrl.adverseEventInformationForm.productIds.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-max-chips>Please select only 1 product.</div> <div ng-message=required> Product Involved is required. </div> </div> </md-input-container> </div> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Product Lot Number</label> <input ng-model=$ctrl.adverseEvent.ProductLotNumber ng-disabled=::$ctrl.locked md-maxlength=50 name=lotNumber> <div ng-messages=$ctrl.adverseEventInformationForm.lotNumber.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Product Lot Number must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Order Number</label> <input ng-model=$ctrl.adverseEvent.ProductOrderNumber ng-disabled=::$ctrl.locked md-maxlength=50 name=orderNumber> <div ng-messages=$ctrl.adverseEventInformationForm.orderNumber.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Order Number must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Product Invoice Date</label> <md-datepicker ng-model=$ctrl.adverseEvent.ProductInvoiceDate ng-disabled=::$ctrl.locked name=invoiceDate md-max-date=$ctrl.today md-current-view=year></md-datepicker> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=60> <label>Event Description</label> <md-select ng-model=$ctrl.adverseEvent.SymptomIds multiple=multiple ng-disabled=::$ctrl.locked name=eventDescription required> <md-option ng-repeat=\"symptom in ::$ctrl.symptoms\" value={{$index}}> {{symptom}} </md-option> </md-select> <div ng-messages=$ctrl.adverseEventInformationForm.eventDescription.$error md-auto-hide=false> <div ng-message=required> Event description selection is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=40> <label>Event Date</label> <md-datepicker ng-model=$ctrl.adverseEvent.EventDate ng-disabled=::$ctrl.locked name=eventDate required md-max-date=$ctrl.today md-current-view=year></md-datepicker> <div ng-messages=$ctrl.adverseEventInformationForm.eventDate.$error md-auto-hide=false> <div ng-message=valid> Event date must be a valid date. </div> <div ng-message=required> Event date is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Please list other symptoms if any</label> <textarea ng-model=$ctrl.adverseEvent.Question1 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=otherSymptoms md-no-autogrow class=no-print>\r\n        </textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question1}}</p> </md-input-container> <md-input-container class=md-block flex=100> <label>Please provide a brief factual account of the complaint including suspected role of product</label> <textarea ng-model=$ctrl.adverseEvent.Question2 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=productRole md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question2}}</p> </md-input-container> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _animalHistory = __webpack_require__(529);
	
	var _animalHistory2 = _interopRequireDefault(_animalHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.animal-history', []).component('animalHistory', _animalHistory2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _animalHistory = __webpack_require__(530);
	
	var _animalHistory2 = _interopRequireDefault(_animalHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _animalHistory2.default,
	  bindings: {
	    adverseEvent: '<',
	    symptoms: '<',
	    locked: '<'
	  },
	  controller: function () {
	    AnimalHistoryComponent.$inject = ["EventEmitter"];
	    function AnimalHistoryComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, AnimalHistoryComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(AnimalHistoryComponent, [{
	      key: 'showConclusionQuestion',
	      get: function get() {
	        return this.adverseEvent.Question9a === true;
	      }
	    }]);
	
	    return AnimalHistoryComponent;
	  }()
	};

/***/ },
/* 530 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/animal-history/animal-history.html';
	var html = "<form name=$ctrl.animalHistoryForm flex=100 novalidate ng-model-options=\"{ updateOn: 'blur', debounce: 250 }\"> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Relevant Animal History</span> </div> </md-toolbar> <div layout-padding> <md-input-container class=md-block> <label>List any medications the patient has been on in the last 30 days</label> <textarea ng-model=$ctrl.adverseEvent.Question3 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=medications ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question3}}</p> </md-input-container> <md-input-container class=md-block> <label>Has the patient had any type of diet, supplement, or medication change other than the supplement in question?</label> <textarea ng-model=$ctrl.adverseEvent.Question4 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=otherSupplements ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question4}}</p> </md-input-container> <md-input-container class=md-block> <label>Has the patient been vaccinated recently? (If yes, please provide the date and vaccination)</label> <textarea ng-model=$ctrl.adverseEvent.Question5 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=vaccination ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question5}}</p> </md-input-container> <md-input-container class=md-block> <label>Has the patient undergone any stress conditions lately (e.g. moving)?</label> <textarea ng-model=$ctrl.adverseEvent.Question6 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=stress ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question6}}</p> </md-input-container> <md-input-container class=md-block> <label>Have any new things (e.g. oleander leaves, clippings) been introduced to the patient's environment recently?</label> <textarea ng-model=$ctrl.adverseEvent.Question7 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=environment ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question7}}</p> </md-input-container> <md-input-container class=md-block> <label>Have any new animals been added to the environment?</label> <textarea ng-model=$ctrl.adverseEvent.Question8 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=newAnimals ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question8}}</p> </md-input-container> <md-input-container class=md-block> <label>Have you used any poisons or yard sprays that the patient could have gotten into (e.g. snail or gopher bait)?</label> <textarea ng-model=$ctrl.adverseEvent.Question9 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=poison ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question9}}</p> </md-input-container> <md-input-container class=\"md-block md-input-has-value\"> <label>Was the animal's veterinarian consulted as part of the investigation?</label> <md-radio-group ng-model=$ctrl.adverseEvent.Question9a ng-disabled=::$ctrl.locked name=vetConsulted ng-model-options=\"{ updateOn: 'blur click keyup', debounce: '$inherit' }\"> <md-radio-button ng-value=false class=md-primary>No</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <md-input-container class=md-block ng-if=$ctrl.showConclusionQuestion class=no-print> <label>Please indicate the vets' hypothesis or conclusion.</label> <textarea ng-model=$ctrl.adverseEvent.Question10 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=vetConclusion ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question10}}</p> </md-input-container> <md-input-container class=md-block> <label>Additional Information</label> <textarea ng-model=$ctrl.adverseEvent.Question11 rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=additionalInformation ng-model-options=\"{ updateOn: '$inherit', debounce: '$inherit' }\" md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Question11}}</p> </md-input-container> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _animalInformation = __webpack_require__(532);
	
	var _animalInformation2 = _interopRequireDefault(_animalInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.animal-information', []).component('animalInformation', _animalInformation2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _animalInformation = __webpack_require__(533);
	
	var _animalInformation2 = _interopRequireDefault(_animalInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _animalInformation2.default,
	  bindings: {
	    adverseEvent: '<',
	    animalTypes: '<',
	    sexes: '<',
	    locked: '<'
	  },
	  controller: ["EventEmitter", function AnimalInformationComponent(EventEmitter) {
	    'ngInject';
	
	    _classCallCheck(this, AnimalInformationComponent);
	
	    Object.assign(this, { EventEmitter: EventEmitter });
	  }]
	};

/***/ },
/* 533 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/animal-information/animal-information.html';
	var html = "<form name=$ctrl.animalInformationForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Animal Information</span> <md-icon md-font-set=material-icons class=warning ng-if=$ctrl.animalInformationForm.$invalid>error</md-icon> <span flex></span> </div> </md-toolbar> <div layout=row layout-padding layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Name</label> <input ng-model=$ctrl.adverseEvent.tblAnimal.AnimalName name=name ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.animalInformationForm.name.$error md-auto-hide=true> <div ng-message=md-maxlength> Name must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Weight</label> <input ng-model=$ctrl.adverseEvent.tblAnimal.Weight name=weight ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.animalInformationForm.weight.$error md-auto-hide=true> <div ng-message=md-maxlength> Weight must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Species</label> <md-select ng-model=$ctrl.adverseEvent.tblAnimal.Specie name=species required ng-disabled=::$ctrl.locked> <md-option ng-repeat=\"species in ::$ctrl.animalTypes\" value={{species.AnimalTypeName}}> {{species.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.animalInformationForm.species.$error md-auto-hide=false> <div ng-message=required> Species selection is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Age</label> <input ng-model=$ctrl.adverseEvent.tblAnimal.Age name=age ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.animalInformationForm.age.$error md-auto-hide=true> <div ng-message=md-maxlength> Age must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Breed</label> <input ng-model=$ctrl.adverseEvent.tblAnimal.Breed name=breed ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.animalInformationForm.breed.$error md-auto-hide=true> <div ng-message=md-maxlength> Breed must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Sex</label> <md-select ng-model=$ctrl.adverseEvent.tblAnimal.Sex name=sex ng-disabled=::$ctrl.locked> <md-option ng-repeat=\"sex in ::$ctrl.sexes\" ng-value={{sex.value}}> {{sex.name}} </md-option> </md-select> </md-input-container> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _caseReference = __webpack_require__(535);
	
	var _caseReference2 = _interopRequireDefault(_caseReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.case-reference', []).component('caseReference', _caseReference2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _caseReference = __webpack_require__(536);
	
	var _caseReference2 = _interopRequireDefault(_caseReference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _caseReference2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    adverseEvent: '<',
	    locked: '<'
	  },
	  controller: ["EventEmitter", function CaseReferenceComponent(EventEmitter) {
	    'ngInject';
	
	    _classCallCheck(this, CaseReferenceComponent);
	
	    Object.assign(this, { EventEmitter: EventEmitter });
	    this.today = new Date();
	  }]
	};

/***/ },
/* 536 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/case-reference/case-reference.html';
	var html = "<form name=$ctrl.caseReferenceForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Case Reference</span> <md-icon md-font-set=material-icons class=warning ng-show=$ctrl.caseReferenceForm.$invalid>error</md-icon> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout=row layout-padding layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Internal Company Reference Number</label> <input ng-model=$ctrl.adverseEvent.CompanyReference ng-disabled=::$ctrl.locked name=companyReference md-maxlength=50> <div ng-messages=$ctrl.caseReferenceForm.companyReference.$error md-auto-hide=true> <div ng-message=md-maxlength> Company reference number must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container> <label>Complaint Report Date</label> <md-datepicker ng-model=$ctrl.adverseEvent.ReportDate name=reportDate required ng-disabled=::$ctrl.locked md-max-date=$ctrl.today md-current-view=year> </md-datepicker> <div ng-messages=$ctrl.caseReferenceForm.reportDate.$error md-auto-hide=true> <div ng-message=valid> Report date must be a valid date. </div> <div ng-message=required> Report date is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Person Taking Complaint</label> <input ng-model=$ctrl.adverseEvent.CallTaker ng-disabled=::$ctrl.locked name=callTaker md-maxlength=50> <div ng-messages=$ctrl.caseReferenceForm.callTaker.$error md-auto-hide=true> <div ng-message=md-maxlength> Person taking complaint must not exceed 50 characters. </div> </div> </md-input-container> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _closure = __webpack_require__(538);
	
	var _closure2 = _interopRequireDefault(_closure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.closure', []).component('closure', _closure2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _closure = __webpack_require__(539);
	
	var _closure2 = _interopRequireDefault(_closure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _closure2.default,
	  bindings: {
	    adverseEvent: '<',
	    statuses: '<',
	    locked: '<',
	    onClosed: '&'
	  },
	  controller: function () {
	    ClosureComponent.$inject = ["EventEmitter"];
	    function ClosureComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, ClosureComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(ClosureComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onClosed(this.EventEmitter({
	          adverseEvent: this.adverseEvent
	        }));
	      }
	    }]);
	
	    return ClosureComponent;
	  }()
	};

/***/ },
/* 539 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/closure/closure.html';
	var html = "<ng-form name=$ctrl.closureForm flex=100 ng-submit=$ctrl.onSubmit() novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Closing out the Adverse Event (within 30 days where possible)</span> </div> </md-toolbar> <div layout=column layout-padding layout-wrap> <md-input-container class=\"md-block md-input-has-value\"> <label>Did your product contribute to the Adverse Event?</label> <md-radio-group ng-model=$ctrl.adverseEvent.IsAE ng-disabled=::$ctrl.locked name=directlyAttributable> <md-radio-button ng-value=false class=md-primary>No / Unknown</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <md-input-container class=md-block> <label>Describe how your product did or did not contribute to the Adverse Event</label> <textarea ng-model=$ctrl.adverseEvent.ProductRoleNote ng-disabled=::$ctrl.locked name=productRole rows=5 md-select-on-focus md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.ProductRoleNote}}</p> </md-input-container> <md-input-container class=md-block> <label>Provide a conclusive summary detailing your company&apos;s response to this AE, including any internal corrective actions taken</label> <textarea ng-model=$ctrl.adverseEvent.Conclusion ng-disabled=::$ctrl.locked name=conclusion rows=5 md-select-on-focus md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.Conclusion}}</p> </md-input-container> <md-input-container class=md-block> <label>Case Status</label> <md-select ng-disabled=::$ctrl.locked ng-model=$ctrl.adverseEvent.Status required> <md-option ng-repeat=\"status in ::$ctrl.statuses\" value={{status}}> {{status}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block> <label>Please give explanation if case not in \"Closed\" Status after 30 days have elapsed</label> <textarea ng-disabled=::$ctrl.locked ng-model=$ctrl.adverseEvent.NonCloseNote name=closureExplanation rows=5 md-select-on-focus md-no-autogrow class=no-print></textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.NonCloseNote}}</p> </md-input-container> </div> </md-card> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ownerForm = __webpack_require__(541);
	
	var _ownerForm2 = _interopRequireDefault(_ownerForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.ownerForm', []).component('ownerForm', _ownerForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ownerForm = __webpack_require__(542);
	
	var _ownerForm2 = _interopRequireDefault(_ownerForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _ownerForm2.default,
	  bindings: {
	    adverseEvent: '<',
	    states: '<',
	    locked: '<'
	  },
	  controller: function () {
	    function OwnerFormComponent() {
	      'ngInject';
	
	      _classCallCheck(this, OwnerFormComponent);
	    }
	
	    _createClass(OwnerFormComponent, [{
	      key: 'hasValidContact',
	      value: function hasValidContact(adverseEvent) {
	        var validVet = adverseEvent.VetPerson && adverseEvent.VetPerson.FirstName && adverseEvent.VetPerson.LastName && adverseEvent.VetPerson.OfficePhone;
	
	        return validVet;
	      }
	    }]);
	
	    return OwnerFormComponent;
	  }()
	};

/***/ },
/* 542 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/owner-form/owner-form.html';
	var html = "<ng-form name=$ctrl.ownerForm novalidate flex=100 layout-padding layout=row layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>First Name</label> <input ng-model=$ctrl.adverseEvent.OwnerPerson.FirstName name=firstName ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.ownerForm.firstName.$error md-auto-hide=false> <div ng-message=required> First Name is required. </div> <div ng-message=md-maxlength> First Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Last Name</label> <input ng-model=$ctrl.adverseEvent.OwnerPerson.LastName name=lastName ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.ownerForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last Name is required. </div> <div ng-message=md-maxlength> Last Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Email</label> <input ng-model=$ctrl.adverseEvent.OwnerPerson.Email name=email type=email ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.ownerForm.email.$error md-auto-hide=false> <div ng-message=email> Email address must be valid. </div> <div ng-message=md-maxlength> Email address must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 1</label> <input ng-model=$ctrl.adverseEvent.OwnerAddress.Address1 name=address ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.ownerForm.address.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 1 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 2</label> <input ng-model=$ctrl.adverseEvent.OwnerAddress.Address2 name=address2 ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.ownerForm.address2.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 2 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>City</label> <input ng-model=$ctrl.adverseEvent.OwnerAddress.City name=city ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.ownerForm.city.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> City must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>State</label> <input ng-model=$ctrl.adverseEvent.OwnerAddress.State name=state ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.ownerForm.state.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> State must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Zip Code</label> <input name=postalCode ng-model=$ctrl.adverseEvent.OwnerAddress.Postal ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.ownerForm.postalCode.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Zip code must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Home Phone</label> <input ng-model=$ctrl.adverseEvent.OwnerPerson.HomePhone name=homePhone ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) ng-disabled=::$ctrl.locked phone-number> <div class=hint ng-show=\"$ctrl.ownerForm.homePhone.$untouched || (!$ctrl.ownerForm.homePhone.$error.phoneNumber && !$ctrl.ownerForm.homePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.ownerForm.homePhone.$error md-auto-hide=false> <div ng-message=required> Phone is required. </div> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div>  </md-input-container> <md-input-container class=md-block flex=100> <label>Note</label> <textarea ng-model=$ctrl.adverseEvent.OwnerNote rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=ownerNote md-no-autogrow class=no-print>\r\n        </textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.OwnerNote}}</p> </md-input-container> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _vetForm = __webpack_require__(544);
	
	var _vetForm2 = _interopRequireDefault(_vetForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.vetForm', []).component('vetForm', _vetForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vetForm = __webpack_require__(545);
	
	var _vetForm2 = _interopRequireDefault(_vetForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _vetForm2.default,
	  bindings: {
	    adverseEvent: '<',
	    states: '<',
	    locked: '<'
	  },
	  controller: function () {
	    function VetFormComponent() {
	      'ngInject';
	
	      _classCallCheck(this, VetFormComponent);
	    }
	
	    _createClass(VetFormComponent, [{
	      key: 'hasValidContact',
	      value: function hasValidContact(adverseEvent) {
	        var validOwner = adverseEvent.OwnerPerson && adverseEvent.OwnerPerson.FirstName && adverseEvent.OwnerPerson.LastName && adverseEvent.OwnerPerson.HomePhone;
	
	        return validOwner;
	      }
	    }]);
	
	    return VetFormComponent;
	  }()
	};

/***/ },
/* 545 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/vet-form/vet-form.html';
	var html = "<ng-form name=$ctrl.vetForm novalidate flex=100 layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>First Name</label> <input ng-model=$ctrl.adverseEvent.VetPerson.FirstName name=firstName ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) md-maxlength=100> <div ng-messages=$ctrl.vetForm.firstName.$error md-auto-hide=false> <div ng-message=required> First Name is required. </div> <div ng-message=md-maxlength> First Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Last Name</label> <input ng-model=$ctrl.adverseEvent.VetPerson.LastName name=lastName ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.vetForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last Name is required. </div> <div ng-message=md-maxlength> Last Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Email</label> <input ng-model=$ctrl.adverseEvent.VetPerson.Email name=email type=email ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.vetForm.email.$error md-auto-hide=false> <div ng-message=email> Email address must be valid. </div> <div ng-message=md-maxlength> Email address must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 1</label> <input ng-model=$ctrl.adverseEvent.VetAddress.Address1 name=address ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.vetForm.address.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 1 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 2</label> <input ng-model=$ctrl.adverseEvent.VetAddress.Address2 name=address2 ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.vetForm.address2.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 2 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>City</label> <input ng-model=$ctrl.adverseEvent.VetAddress.City name=city ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.vetForm.city.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> City must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>State</label> <input ng-model=$ctrl.adverseEvent.VetAddress.State name=state ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.vetForm.state.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> State must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Zip Code</label> <input name=postalCode ng-model=$ctrl.adverseEvent.VetAddress.Postal ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.vetForm.postalCode.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Zip code must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Office Phone</label> <input ng-model=$ctrl.adverseEvent.VetPerson.OfficePhone name=officePhone ng-required=!$ctrl.hasValidContact($ctrl.adverseEvent) ng-disabled=::$ctrl.locked phone-number> <div class=hint ng-show=\"$ctrl.vetForm.officePhone.$untouched || (!$ctrl.vetForm.officePhone.$error.phoneNumber && !$ctrl.vetForm.officePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.vetForm.officePhone.$error md-auto-hide=false> <div ng-message=required> Office phone is required. </div> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Home Phone</label> <input ng-model=$ctrl.adverseEvent.VetPerson.HomePhone name=homePhone ng-disabled=::$ctrl.locked phone-number> <div class=hint ng-show=\"$ctrl.vetForm.homePhone.$untouched || (!$ctrl.vetForm.homePhone.$error.phoneNumber && !$ctrl.vetForm.homePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.vetForm.homePhone.$error md-auto-hide=false> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50 ng-disabled=::$ctrl.locked> <label>Toll-Free #</label> <input ng-model=$ctrl.adverseEvent.VetPerson.TollFreePhone phone-number name=tollFreePhone> <div class=hint ng-show=\"$ctrl.vetForm.tollFreePhone.$untouched || (!$ctrl.vetForm.tollFreePhone.$error.phoneNumber && !$ctrl.vetForm.tollFreePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.vetForm.tollFreePhone.$error md-auto-hide=false> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50 ng-disabled=::$ctrl.locked> <label>Clinic Name</label> <input ng-model=$ctrl.adverseEvent.VetPerson.ClinicName md-maxlength=50 name=clinic> <div ng-messages=$ctrl.vetForm.clinic.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Clinic name must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Note</label> <textarea ng-model=$ctrl.adverseEvent.VetNote rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=vetNote md-no-autogrow class=no-print>\r\n    </textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.VetNote}}</p> </md-input-container> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _otherForm = __webpack_require__(547);
	
	var _otherForm2 = _interopRequireDefault(_otherForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.otherForm', []).component('otherForm', _otherForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _otherForm = __webpack_require__(548);
	
	var _otherForm2 = _interopRequireDefault(_otherForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _otherForm2.default,
	  bindings: {
	    adverseEvent: '<',
	    locked: '<'
	  },
	  controller: function OtherFormComponent() {
	    'ngInject';
	
	    _classCallCheck(this, OtherFormComponent);
	  }
	};

/***/ },
/* 548 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/other-form/other-form.html';
	var html = "<ng-form name=$ctrl.otherForm novalidate flex=100 layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>First Name</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.FirstName name=firstName md-maxlength=100> <div ng-messages=$ctrl.otherForm.firstName.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> First Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Last Name</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.LastName name=lastName ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.otherForm.lastName.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Last Name must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Email</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.Email name=email type=email ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.otherForm.email.$error md-auto-hide=false> <div ng-message=email> Email address must be valid. </div> <div ng-message=md-maxlength> Email address must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 1</label> <input ng-model=$ctrl.adverseEvent.OtherAddress.Address1 name=address ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.otherForm.address.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 1 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Address 2</label> <input ng-model=$ctrl.adverseEvent.OtherAddress.Address2 name=address2 ng-disabled=::$ctrl.locked md-maxlength=100> <div ng-messages=$ctrl.otherForm.address2.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Address 2 must not exceed 100 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>City</label> <input ng-model=$ctrl.adverseEvent.OtherAddress.City name=city ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.otherForm.city.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> City must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>State</label> <input ng-model=$ctrl.adverseEvent.OtherAddress.State name=state ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.otherForm.state.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> State must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=33> <label>Zip Code</label> <input name=postalCode ng-model=$ctrl.adverseEvent.OtherAddress.Postal ng-disabled=::$ctrl.locked md-maxlength=50> <div ng-messages=$ctrl.otherForm.postalCode.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Zip Code must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Office Phone</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.OfficePhone name=officePhone ng-disabled=::$ctrl.locked phone-number> <div class=hint ng-show=\"$ctrl.otherForm.officePhone.$untouched || (!$ctrl.otherForm.officePhone.$error.phoneNumber && !$ctrl.otherForm.officePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.otherForm.officePhone.$error md-auto-hide=false> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Home Phone</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.HomePhone name=homePhone ng-disabled=::$ctrl.locked phone-number> <div class=hint ng-show=\"$ctrl.otherForm.homePhone.$untouched || (!$ctrl.otherForm.homePhone.$error.phoneNumber && !$ctrl.otherForm.homePhone.$error.required)\">###-###-####</div> <div ng-messages=$ctrl.otherForm.homePhone.$error md-auto-hide=false> <div ng-message=phoneNumber> Phone number must be in the following format: ###-###-#### </div> </div> </md-input-container> <md-input-container class=md-block flex=100 ng-disabled=::$ctrl.locked> <label>Company Name</label> <input ng-model=$ctrl.adverseEvent.OtherPerson.CompanyName md-maxlength=50 name=company> <div ng-messages=$ctrl.otherForm.company.$error class=md-chips-messages md-auto-hide=false> <div ng-message=md-maxlength> Company Name must not exceed 50 characters. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Note</label> <textarea ng-model=$ctrl.adverseEvent.OtherNote rows=5 md-select-on-focus ng-disabled=::$ctrl.locked name=otherNote md-no-autogrow class=no-print>\r\n    </textarea> <p class=\"print-only md-body-1\">{{$ctrl.adverseEvent.OtherNote}}</p> </md-input-container> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _contactList = __webpack_require__(550);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.contactList', []).component('contactList', _contactList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contactList = __webpack_require__(551);
	
	var _contactList2 = _interopRequireDefault(_contactList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _contactList2.default,
	  bindings: {
	    adverseEvent: '<',
	    locked: '<'
	  },
	  controller: function ContactListComponent() {
	    'ngInject';
	
	    _classCallCheck(this, ContactListComponent);
	  }
	};

/***/ },
/* 551 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/contact-list/contact-list.html';
	var html = "<ng-form name=$ctrl.contactListForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar alternate\"> <div class=md-toolbar-tools> <span class=md-truncate>Contact Information</span> <md-icon md-font-set=material-icons class=warning ng-if=$ctrl.contactListForm.$invalid>error</md-icon> <span flex></span> </div> </md-toolbar> <md-tabs md-dynamic-height md-border-bottom> <md-tab label=Owner> <owner-form adverse-event=$ctrl.adverseEvent locked=::$ctrl.locked> </owner-form> </md-tab> <md-tab label=Vet> <vet-form adverse-event=$ctrl.adverseEvent locked=::$ctrl.locked> </vet-form> </md-tab> <md-tab label=Other> <other-form adverse-event=$ctrl.adverseEvent locked=::$ctrl.locked> </other-form> </md-tab> </md-tabs> </md-card> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _riskAnalysis = __webpack_require__(553);
	
	var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvent.risk-analysis', []).component('riskAnalysis', _riskAnalysis2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _riskAnalysis = __webpack_require__(554);
	
	var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _riskAnalysis2.default,
	  bindings: {
	    adverseEvent: '<',
	    injurySeverities: '<',
	    injuryProbabilities: '<',
	    occurrenceLikelihoods: '<',
	    locked: '<'
	  },
	  controller: function () {
	    RiskAnalysisComponent.$inject = ["EventEmitter"];
	    function RiskAnalysisComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, RiskAnalysisComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(RiskAnalysisComponent, [{
	      key: 'getRiskScore',
	      value: function getRiskScore() {
	        var risks = [this.adverseEvent.AnalysisQ1 || 0, this.adverseEvent.AnalysisQ2 || 0, this.adverseEvent.AnalysisQ3 || 0];
	
	        var sum = risks.reduce(function (a, b) {
	          return a + b;
	        }, 0);
	        return sum;
	      }
	    }]);
	
	    return RiskAnalysisComponent;
	  }()
	};

/***/ },
/* 554 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-event/risk-analysis/risk-analysis.html';
	var html = "<form name=$ctrl.riskAnalysisForm flex=100 novalidate> <md-card> <md-toolbar class=md-table-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Risk Analysis</span> <md-icon md-font-set=material-icons class=warning ng-if=$ctrl.riskAnalysisForm.$invalid>error</md-icon> <span flex></span> </div> </md-toolbar> <div layout-padding> <p class=md-body-1 style=background-color:#f9eaa4> The risk analysis section has been updated to provide clearer language to help you better answer the questions and assess the risk of this event. </p> </div> <div layout=column layout-padding> <md-input-container class=\"md-block md-input-has-value\"> <label>How frequently is this symptom reported for this product?*</label> <md-radio-group ng-model=$ctrl.adverseEvent.AnalysisQ1 ng-disabled=::$ctrl.locked name=hazardousEvent required> <md-radio-button class=md-primary ng-repeat=\"likelihood in $ctrl.occurrenceLikelihoods\" ng-value={{likelihood.value}}> {{likelihood.name}} </md-radio-button> </md-radio-group> <div ng-messages=$ctrl.riskAnalysisForm.hazardousEvent.$error md-auto-hide=false> <div ng-message=required> Frequency selection is required. </div> </div> </md-input-container> <md-input-container class=\"md-block md-input-has-value\"> <label>Considering all reported information, what is the likelihood that this product formula would cause an adverse event?*</label> <md-radio-group ng-model=$ctrl.adverseEvent.AnalysisQ2 ng-disabled=::$ctrl.locked name=probability required> <md-radio-button class=md-primary ng-repeat=\"probability in $ctrl.injuryProbabilities\" ng-value={{probability.value}}> {{probability.name}} </md-radio-button> </md-radio-group> <div ng-messages=$ctrl.riskAnalysisForm.probability.$error md-auto-hide=false> <div ng-message=required> Likelihood selection is required. </div> </div> </md-input-container> <md-input-container class=\"md-block md-input-has-value\"> <label>What are the severity and duration of the reported symptoms or health outcome?*</label> <md-radio-group ng-model=$ctrl.adverseEvent.AnalysisQ3 ng-disabled=::$ctrl.locked name=severity required> <md-radio-button class=md-primary ng-repeat=\"severity in $ctrl.injurySeverities\" ng-value={{severity.value}}> {{severity.name}} </md-radio-button> </md-radio-group> <div ng-messages=$ctrl.riskAnalysisForm.severity.$error md-auto-hide=false> <div ng-message=required> Severity selection is required. </div> </div> </md-input-container> <label>Adverse Event Risk Score: {{$ctrl.getRiskScore()}}</label> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _query = __webpack_require__(408);
	
	var _adverseEvent = __webpack_require__(522);
	
	var _adverseEvent2 = _interopRequireDefault(_adverseEvent);
	
	var _adverseEvents = __webpack_require__(556);
	
	var _adverseEvents2 = _interopRequireDefault(_adverseEvents);
	
	var _adverseEventSearch = __webpack_require__(558);
	
	var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);
	
	__webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvents', [_angularUiRouter2.default, _adverseEventSearch2.default]).component('adverseEvents', _adverseEvents2.default).service('AdverseEventService', _adverseEvent2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('adverseEvents', {
	    parent: 'app',
	    url: '/adverse-events',
	    component: 'adverseEvents',
	    params: {
	      search: {
	        value: 'default'
	      }
	    },
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      query: function query() {
	        return (0, _query.getQuery)();
	      },
	      limitOptions: function limitOptions() {
	        return (0, _query.getLimitOptions)();
	      },
	      adverseEvents: ["$stateParams", "query", "AdverseEventsService", function adverseEvents($stateParams, query, AdverseEventsService) {
	        AdverseEventsService.setQuery(query);
	
	        if (!$stateParams.search) {
	          return AdverseEventsService.getAdverseEvents().then(function (r) {
	            return r.data;
	          });
	        }
	
	        if ($stateParams.search === 'status_open') {
	          return AdverseEventsService.getAdverseEventsByStatus('OPEN').then(function (r) {
	            return r.data;
	          });
	        }
	
	        return AdverseEventsService.getAdverseEvents().then(function (r) {
	          return r.data;
	        });
	      }],
	      alerts: ["AdverseEventsService", function alerts(AdverseEventsService) {
	        return AdverseEventsService.getAlerts().then(function (r) {
	          return r.data;
	        });
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      eventTypes: ["AdverseEventsService", function eventTypes(AdverseEventsService) {
	        return AdverseEventsService.getEventTypes();
	      }],
	      searchCriteria: ["$stateParams", function searchCriteria($stateParams) {
	        var selectedSearchType = 'All Adverse Events';
	        if ($stateParams.search === 'status_open') {
	          selectedSearchType = 'Open Adverse Events';
	        }
	
	        return {
	          selectedSearchType: selectedSearchType
	        };
	      }],
	      searchTypes: ["AdverseEventsService", function searchTypes(AdverseEventsService) {
	        return AdverseEventsService.getSearchTypes();
	      }],
	      sexes: ["AdverseEventService", function sexes(AdverseEventService) {
	        return AdverseEventService.getAnimalSexes();
	      }],
	      statuses: ["AdverseEventService", function statuses(AdverseEventService) {
	        return AdverseEventService.getStatuses();
	      }],
	      symptoms: ["AdverseEventService", function symptoms(AdverseEventService) {
	        return AdverseEventService.getSymptoms();
	      }],
	      occurrenceLikelihoods: ["AdverseEventService", function occurrenceLikelihoods(AdverseEventService) {
	        return AdverseEventService.getOccurrenceLikelihoods();
	      }],
	      injuryProbabilities: ["AdverseEventService", function injuryProbabilities(AdverseEventService) {
	        return AdverseEventService.getInjurityProbabilities();
	      }],
	      injurySeverities: ["AdverseEventService", function injurySeverities(AdverseEventService) {
	        return AdverseEventService.getInjuritySeverities();
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _adverseEvents = __webpack_require__(557);
	
	var _adverseEvents2 = _interopRequireDefault(_adverseEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adverseEvents2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    adverseEvents: '<',
	    alerts: '<',
	    animalTypes: '<',
	    eventTypes: '<',
	    searchCriteria: '<',
	    searchTypes: '<',
	    sexes: '<',
	    statuses: '<',
	    symptoms: '<',
	    injuryProbabilities: '<',
	    injurySeverities: '<',
	    occurrenceLikelihoods: '<',
	    query: '<',
	    limitOptions: '<'
	  },
	  controller: function () {
	    AdverseEventsComponent.$inject = ["$mdDialog", "$scope", "$state", "AdverseEventService", "AdverseEventsService", "CompanyService", "AuthService", "ToastService"];
	    function AdverseEventsComponent($mdDialog, $scope, $state, AdverseEventService, AdverseEventsService, CompanyService, AuthService, ToastService) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, AdverseEventsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AdverseEventService: AdverseEventService,
	        AdverseEventsService: AdverseEventsService,
	        AuthService: AuthService,
	        CompanyService: CompanyService,
	        ToastService: ToastService
	      });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.query = _extends({}, _this.query, {
	          page: page,
	          take: take
	        });
	
	        _this.refreshResults();
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.query = _extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        });
	
	        _this.refreshResults();
	      };
	    }
	
	    _createClass(AdverseEventsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.searchCriteria = this.searchCriteria || {};
	        this.selectedAdverseEvents = [];
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this2 = this;
	
	        this.AdverseEventsService.setQuery(this.query);
	
	        if (!this.searchCriteria.selectedSearchType) {
	          return;
	        }
	
	        switch (this.searchCriteria.selectedSearchType) {
	          case 'Open Adverse Events':
	            this.promise = this.AdverseEventsService.getAdverseEventsByStatus('OPEN');
	            break;
	          case 'Search by Report Date':
	            if (this.searchCriteria.selectedReportDate) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByReportDate(this.searchCriteria.selectedReportDate);
	            }
	            break;
	          case 'Search by Product Name':
	            if (this.searchCriteria.selectedProduct) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByProduct(this.searchCriteria.selectedProduct.ProductId);
	            }
	            break;
	          case 'Search by Ingredient Name':
	            if (this.searchCriteria.selectedIngredient) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByIngredient(this.searchCriteria.selectedIngredient.UserIngredientId);
	            }
	            break;
	          case 'Search by System Ingredient':
	            if (this.searchCriteria.selectedIngredient) {
	              this.promise = this.AdverseEventsService.getAdverseEventsBySystemIngredient(this.searchCriteria.selectedIngredient.SystemIngredientId);
	            }
	            break;
	          case 'Search by Member':
	            if (this.searchCriteria.selectedCompany) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByMember(this.searchCriteria.selectedCompany.MemberId);
	            }
	            break;
	          case 'Search by Event (any events)':
	            if (this.searchCriteria.selectedEventTypes) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByType(this.searchCriteria.selectedEventTypes, false);
	            }
	            break;
	          case 'Search by Event (all matched events)':
	            if (this.searchCriteria.selectedEventTypes) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByType(this.searchCriteria.selectedEventTypes, true);
	            }
	            break;
	          case 'Search by Species':
	            if (this.searchCriteria.selectedSpecies) {
	              this.promise = this.AdverseEventsService.getAdverseEventsBySpecies(this.searchCriteria.selectedSpecies);
	            }
	            break;
	          case 'Search by Text':
	            if (this.searchCriteria.searchByText) {
	              this.promise = this.AdverseEventsService.getAdverseEventsByText(this.searchCriteria.searchByText);
	            }
	            break;
	          case 'Missing Event Information':
	            this.promise = this.AdverseEventsService.getAdverseEventsMissingInfo();
	            break;
	          default:
	            this.promise = this.AdverseEventsService.getAdverseEvents();
	        }
	
	        if (!this.promise) {
	          this.promise = this.AdverseEventsService.getAdverseEvents();
	        }
	
	        this.promise.then(function (r) {
	          _this2.adverseEvents = {
	            Count: r.data.Count,
	            Data: r.data.Data
	          };
	
	          _this2.promise = undefined;
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onSearchChanged',
	      value: function onSearchChanged(_ref) {
	        var searchCriteria = _ref.searchCriteria;
	
	        this.searchCriteria = searchCriteria;
	        this.query = _extends({}, this.query, {
	          searchText: this.searchCriteria.searchText,
	          seriousAEsOnly: this.searchCriteria.seriousAEsOnly
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'searchTextChanged',
	      value: function searchTextChanged($event) {
	        this.query = _extends({}, this.query, {
	          searchText: $event.searchText
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'searchByTextChanged',
	      value: function searchByTextChanged(_ref2) {
	        var searchByText = _ref2.searchByText;
	
	        this.searchCriteria.searchByText = searchByText;
	        this.refreshResults();
	      }
	    }, {
	      key: 'onEditClicked',
	      value: function onEditClicked(adverseEventId) {
	        this.$state.go('adverseEventEdit', { id: adverseEventId });
	      }
	    }, {
	      key: 'onViewClicked',
	      value: function onViewClicked(adverseEventId) {
	        var _this3 = this;
	
	        this.AdverseEventService.getAdverseEvent(adverseEventId).then(function (r) {
	          var adverseEvent = r.data;
	
	          _this3.AdverseEventService.getProductsByCompany(adverseEvent.MemberId).then(function (rp) {
	            var products = rp.data;
	
	            _this3.CompanyService.getCompany(adverseEvent.MemberId).then(function (rc) {
	              var company = rc.data;
	
	              if (!company.IsAllowMultiProductPerAE && adverseEvent.ProductIds && adverseEvent.ProductIds.length) {
	                adverseEvent.ProductIds = adverseEvent.ProductIds[0];
	              }
	
	              var scope = _angular2.default.extend(_this3.$scope.$new(true), {
	                adverseEvent: adverseEvent,
	                symptoms: _this3.symptoms,
	                animalTypes: _this3.animalTypes,
	                sexes: _this3.sexes,
	                injurySeverities: _this3.injurySeverities,
	                injuryProbabilities: _this3.injuryProbabilities,
	                occurrenceLikelihoods: _this3.occurrenceLikelihoods,
	                statuses: _this3.statuses,
	                products: products
	              });
	
	              _this3.$mdDialog.show({
	                clickOutsideToClose: true,
	                fullscreen: true,
	                scope: scope,
	                template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <case-reference adverse-event="adverseEvent" \n                  locked="true" layout="column" flex>\n                </case-reference>\n                <contact-list adverse-event="adverseEvent"\n                  show-header="true" locked="true" layout="column" flex>\n                </contact-list>\n                <adverse-event-information adverse-event="adverseEvent" symptoms="symptoms"\n                  products="products"\n                  locked="true" layout="column" flex>\n                </adverse-event-information>\n                <animal-information adverse-event="adverseEvent" animal-types="animalTypes"\n                  sexes="sexes" locked="true" layout="column" flex>\n                </animal-information>\n\n                <animal-history adverse-event="adverseEvent" locked="true"\n                  layout="column" flex>\n                </animal-history>\n\n                <risk-analysis adverse-event="adverseEvent" injury-severities="injurySeverities"\n                  injury-probabilities="injuryProbabilities" occurrence-likelihoods="occurrenceLikelihoods"\n                  locked="true" layout="column" flex>\n                </risk-analysis>\n                <closure adverse-event="adverseEvent"\n                  statuses="::statuses"\n                  locked="true" layout="column" flex>\n                </closure>\n              </md-dialog-content>\n            </md-dialog>\n          '
	              });
	            });
	          });
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'alertClicked',
	      value: function alertClicked(_ref3) {
	        var alert = _ref3.alert;
	
	        if (alert) {
	          if (alert.AlertTypeID === 2) {
	            this.searchCriteria = _extends({}, this.searchCriteria, {
	              selectedSearchType: 'Open Adverse Events'
	            });
	            this.refreshResults();
	          } else if (alert.AlertTypeID === 4) {
	            if (this.AuthService.isSysAdmin) {
	              this.$state.go('memberCompliance');
	            } else {
	              this.showAttestment();
	            }
	          }
	        }
	      }
	    }, {
	      key: 'showAttestment',
	      value: function showAttestment() {
	        var _this4 = this;
	
	        this.AdverseEventsService.getOpenAdverseEventsPreviousMonth().then(function (r) {
	          var adverseEvents = r.data;
	          var scope = _angular2.default.extend(_this4.$scope.$new(true), {
	            adverseEvents: adverseEvents,
	            onAttested: function onAttested($event) {
	              return _this4.onAttested($event);
	            }
	          });
	
	          _this4.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content>\n                <dialog-close/>\n                <attest\n                  adverse-events="adverseEvents"\n                  on-attested="onAttested($event)">\n                </attest>\n              </md-dialog-content>\n            </md-dialog>\n          '
	          });
	        }).catch(function (error) {
	          return _this4.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onAttested',
	      value: function onAttested(_ref4) {
	        var _this5 = this;
	
	        var signature = _ref4.signature;
	
	        if (signature) {
	          this.AdverseEventService.attest(signature).then(function () {
	            _this5.ToastService.showSuccess(_messages.ADVERSE_EVENT_ATTESTED);
	            _this5.$mdDialog.hide();
	            _this5.$state.reload();
	          }).catch(function (error) {
	            return _this5.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'onDeleteClicked',
	      value: function onDeleteClicked(adverseEvents) {
	        var _this6 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected adverse event(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = adverseEvents.length - 1; i >= 0; i -= 1) {
	            promises.push(_this6.AdverseEventService.delete(adverseEvents[i].AEId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this6.ToastService.showSuccess(_messages.ADVERSE_EVENT_DELETED);
	            _this6.refreshResults();
	            _this6.selectedAdverseEvents = [];
	          }).catch(function (error) {
	            return _this6.ToastService.showError(error);
	          });
	        });
	      }
	    }]);
	
	    return AdverseEventsComponent;
	  }()
	};

/***/ },
/* 557 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-events/adverse-events.html';
	var html = "<div layout=column layout-padding flex> <section layout=column flex> <div layout=row layout-xs=column> <alert alerts=$ctrl.alerts on-alert-clicked=$ctrl.alertClicked($event) flex=100 flex-gt-sm=60 layout=column permission permission-except=\"'REGULATOR'\"> </alert> <div flex=100 flex-md=40 flex-offset-md=0 flex-lg=25 flex-offset-lg=15 flex-offset-gt-lg=20 flex-gt-lg=20 layout=column> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Adverse Event\" ui-sref=adverseEventCreate permission permission-only=\"['USER','COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon>Add Adverse Event</md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"AE Attest\" ng-click=$ctrl.showAttestment() permission permission-only=\"'COMPANY_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>assignment</md-icon>AE Attest</md-button> </div> </div> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Adverse Event Management</span> <span flex></span> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedAdverseEvents && $ctrl.selectedAdverseEvents.length\" ng-click=$ctrl.onDeleteClicked($ctrl.selectedAdverseEvents)> <md-tooltip md-direction=top>Delete Adverse Event</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <adverse-event-search animal-types=$ctrl.animalTypes event-types=$ctrl.eventTypes search-types=$ctrl.searchTypes on-search-criteria-changed=$ctrl.onSearchChanged($event) search-criteria=$ctrl.searchCriteria on-search-text-changed=$ctrl.searchTextChanged($event) on-search-by-text-changed=$ctrl.searchByTextChanged($event) search-criteria=$ctrl.searchCriteria> </adverse-event-search> <md-table-container> <table md-table md-progress=$ctrl.promise multiple=true md-row-select=::$ctrl.AuthService.isSysAdmin ng-model=$ctrl.selectedAdverseEvents> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=CompanyReference><span>Company Ref</span></th> <th md-column md-order-by=EventDate><span>Event Date</span></th> <th md-column md-order-by=ReportDate><span>Report Date</span></th> <th md-column md-order-by=Status><span>Case Status</span></th> <th md-column md-order-by=RiskIndex><span>Risk Index</span></th> <th md-column>&nbsp;</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"ae in $ctrl.adverseEvents.Data\" class=adverse-event-row ng-click=$ctrl.onViewClicked(ae.AEId) md-select=ae> <td md-cell>{{ae.CompanyReference}}</td> <td md-cell>{{ae.EventDate | date:'MMMM dd yyyy'}}</td> <td md-cell>{{ae.ReportDate | date:'MMMM dd yyyy'}}</td> <td md-cell>{{ae.Status}}</td> <td md-cell>{{ae.RiskIndex}}</td> <td md-cell stop-event=click> <a href ng-click=$ctrl.onEditClicked(ae.AEId) class=md-primary permission permission-except=\"'REGULATOR'\">Edit</a> </td> </tr> </tbody> </table> </md-table-container> <div layout=row layout-align=\"center center\" flex> <p class=md-body-1 ng-hide=\"$ctrl.adverseEvents.Data && $ctrl.adverseEvents.Data.length\"> There are no adverse events matching the specified criteria. </p> </div> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.adverseEvents.Count}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'AEs per page:' }\"> </md-table-pagination> </md-card> </section> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _adverseEventSearch = __webpack_require__(559);
	
	var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);
	
	__webpack_require__(561);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.adverseEvents.adverseEventSearch', []).component('adverseEventSearch', _adverseEventSearch2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adverseEventSearch = __webpack_require__(560);
	
	var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adverseEventSearch2.default,
	  bindings: {
	    animalTypes: '<',
	    eventTypes: '<',
	    searchTypes: '<',
	    searchCriteria: '<',
	    onSearchCriteriaChanged: '&',
	    onSearchTextChanged: '&',
	    onSearchByTextChanged: '&'
	  },
	  controller: function () {
	    AdverseEventSearchComponent.$inject = ["EventEmitter", "ProductService"];
	    function AdverseEventSearchComponent(EventEmitter, ProductService) {
	      'ngInject';
	
	      _classCallCheck(this, AdverseEventSearchComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter, ProductService: ProductService });
	    }
	
	    _createClass(AdverseEventSearchComponent, [{
	      key: '$onChanges',
	      value: function $onChanges(changes) {
	        if (changes.searchCriteria) {
	          this.searchCriteria = Object.assign({}, this.searchCriteria);
	        }
	      }
	    }, {
	      key: 'onChange',
	      value: function onChange() {
	        this.onSearchCriteriaChanged(this.EventEmitter({
	          searchCriteria: this.searchCriteria
	        }));
	      }
	    }, {
	      key: 'onSearchTextChange',
	      value: function onSearchTextChange(text) {
	        this.onSearchTextChanged(this.EventEmitter({
	          searchText: text
	        }));
	      }
	    }, {
	      key: 'onSearchByTextChange',
	      value: function onSearchByTextChange(text) {
	        this.onSearchByTextChanged(this.EventEmitter({
	          searchByText: text
	        }));
	      }
	    }, {
	      key: 'selectedIngredientChanged',
	      value: function selectedIngredientChanged($event) {
	        this.searchCriteria.selectedIngredient = $event.selectedIngredient;
	        this.onChange();
	      }
	    }, {
	      key: 'searchProducts',
	      value: function searchProducts(name) {
	        return this.ProductService.searchProductsByName(name).then(function (r) {
	          return r.data;
	        });
	      }
	    }, {
	      key: 'selectedMemberChanged',
	      value: function selectedMemberChanged($event) {
	        this.searchCriteria.selectedCompany = $event.company;
	        this.onChange();
	      }
	    }]);
	
	    return AdverseEventSearchComponent;
	  }()
	};

/***/ },
/* 560 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/adverse-events/adverse-event-search/adverse-event-search.html';
	var html = "<form name=$ctrl.adverseEventSearchForm flex=100 novalidate> <div layout-padding layout-wrap layout=column layout-gt-xs=row flex> <md-input-container class=md-block flex=100 flex-gt-xs=50> <label>Choose a Search</label> <md-select ng-model=$ctrl.searchCriteria.selectedSearchType ng-change=$ctrl.onChange()> <md-option ng-repeat=\"searchType in $ctrl.searchTypes\" value={{searchType.name}} permission permission-only=searchType.permission> {{searchType.name}} </md-option> </md-select> </md-input-container> <ng-switch on=$ctrl.searchCriteria.selectedSearchType flex=100 flex-gt-xs=50> <div flex ng-switch-when=\"Search by Report Date\"> <md-input-container class=md-block flex> <label>Report Date</label> <md-datepicker ng-model=$ctrl.searchCriteria.selectedReportDate ng-change=$ctrl.onChange() required name=reportDate md-current-view=year> </md-datepicker> <div ng-messages=$ctrl.adverseEventSearchForm.reportDate.$error md-auto-hide=false> <div ng-message=required> Report Date is required. </div> </div> </md-input-container> </div> <div flex ng-switch-when=\"Search by Ingredient Name\"> <ingredient-autocomplete ingredient-type=user label-text=\"Search for Ingredient By Name\" search-display-property=UserIngredientName on-ingredient-selected=$ctrl.selectedIngredientChanged($event)> </ingredient-autocomplete> </div> <div flex ng-switch-when=\"Search by System Ingredient\"> <ingredient-autocomplete ingredient-type=system label-text=\"Search for System Ingredient\" search-display-property=SystemIngredientName on-ingredient-selected=$ctrl.selectedIngredientChanged($event)> </ingredient-autocomplete> </div> <div flex ng-switch-when=\"Search by Member\"> <company-autocomplete on-company-selected=$ctrl.selectedMemberChanged($event)> </company-autocomplete> </div> <div flex ng-switch-when=\"Search by Product Name\"> <md-autocomplete flex=100 md-selected-item=$ctrl.searchCriteria.selectedProduct md-search-text=$ctrl.productSearchText md-items=\"item in $ctrl.searchProducts($ctrl.productSearchText)\" md-item-text=item.ProductName md-min-length=2 md-floating-label=\"Search for Product by Name\" md-selected-item-change=$ctrl.onChange() name=productSearch required> <md-item-template> <span md-highlight-text=$ctrl.productSearchText md-highlight-flags=^i>{{item.ProductName}}</span> </md-item-template> <md-not-found> No products matching \"{{$ctrl.productSearchText}}\" were found. </md-not-found> </md-autocomplete> </div> <div flex ng-switch-when=\"Search by Event (any events)\"> <md-input-container class=md-block flex=100> <label>Events</label> <md-select ng-model=$ctrl.searchCriteria.selectedEventTypes ng-change=$ctrl.onChange() multiple=multiple name=eventTypes required> <md-option ng-repeat=\"eventType in $ctrl.eventTypes\" ng-value={{eventType.id}}> {{eventType.name}} </md-option> </md-select> <div ng-messages=$ctrl.adverseEventSearchForm.eventTypes.$error md-auto-hide=false> <div ng-message=required> Event selection is required. </div> </div> </md-input-container> </div> <div flex ng-switch-when=\"Search by Event (all matched events)\"> <md-input-container class=md-block flex=100> <label>Events</label> <md-select ng-model=$ctrl.searchCriteria.selectedEventTypes ng-change=$ctrl.onChange() multiple=multiple name=eventTypes required> <md-option ng-repeat=\"eventType in $ctrl.eventTypes\" ng-value={{eventType.id}}> {{eventType.name}} </md-option> </md-select> <div ng-messages=$ctrl.adverseEventSearchForm.eventTypes.$error md-auto-hide=false> <div ng-message=required> Event selection is required. </div> </div> </md-input-container> </div> <div flex ng-switch-when=\"Search by Species\"> <md-input-container class=md-block flex=100> <label>Species</label> <md-select ng-model=$ctrl.searchCriteria.selectedSpecies ng-change=$ctrl.onChange() name=animalType required> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" value={{animalType.AnimalTypeName}}> {{animalType.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.adverseEventSearchForm.animalType.$error md-auto-hide=false> <div ng-message=required> Species is required. </div> </div> </md-input-container> </div> <div flex ng-switch-when=\"Search by Text\"> <md-input-container class=md-block flex=100> <label>Search by Text</label> <input name=searchByText ng-model=$ctrl.searchCriteria.searchByText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchByTextChange($ctrl.searchCriteria.searchByText)> </md-input-container> </div> </ng-switch> <md-input-container class=md-block flex=100 flex-gt-xs=75 ng-hide=\"$ctrl.searchCriteria.selectedSearchType == 'Search by Text'\"> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchCriteria.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChange($ctrl.searchCriteria.searchText)> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-xs=25 style=text-align:right> <md-checkbox ng-model=$ctrl.searchCriteria.seriousAEsOnly ng-change=$ctrl.onChange() aria-label=\"Serious AEs Only\">Serious AEs Only</md-checkbox> </md-input-container> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 561 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 562 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _alert = __webpack_require__(564);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _appMenu = __webpack_require__(568);
	
	var _appMenu2 = _interopRequireDefault(_appMenu);
	
	var _appToolbar = __webpack_require__(573);
	
	var _appToolbar2 = _interopRequireDefault(_appToolbar);
	
	var _attest = __webpack_require__(577);
	
	var _attest2 = _interopRequireDefault(_attest);
	
	var _categoryAutocomplete = __webpack_require__(580);
	
	var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);
	
	var _changePassword = __webpack_require__(583);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	var _companyAutocomplete = __webpack_require__(586);
	
	var _companyAutocomplete2 = _interopRequireDefault(_companyAutocomplete);
	
	var _dialogClose = __webpack_require__(589);
	
	var _dialogClose2 = _interopRequireDefault(_dialogClose);
	
	var _ingredientAutocomplete = __webpack_require__(592);
	
	var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);
	
	var _itemList = __webpack_require__(595);
	
	var _itemList2 = _interopRequireDefault(_itemList);
	
	var _feedback = __webpack_require__(598);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _productLabelUpload = __webpack_require__(601);
	
	var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);
	
	var _regulatorAutocomplete = __webpack_require__(604);
	
	var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);
	
	var _userAddForm = __webpack_require__(607);
	
	var _userAddForm2 = _interopRequireDefault(_userAddForm);
	
	var _userEditForm = __webpack_require__(611);
	
	var _userEditForm2 = _interopRequireDefault(_userEditForm);
	
	var _userList = __webpack_require__(614);
	
	var _userList2 = _interopRequireDefault(_userList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.common', [_alert2.default, _appMenu2.default, _appToolbar2.default, _attest2.default, _categoryAutocomplete2.default, _changePassword2.default, _companyAutocomplete2.default, _dialogClose2.default, _feedback2.default, _ingredientAutocomplete2.default, _itemList2.default, _productLabelUpload2.default, _regulatorAutocomplete2.default, _userAddForm2.default, _userEditForm2.default, _userList2.default]).name;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _alert = __webpack_require__(565);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	__webpack_require__(567);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.alert', []).component('alert', _alert2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _alert = __webpack_require__(566);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _alert2.default,
	  bindings: {
	    alerts: '<',
	    onAlertClicked: '&'
	  },
	  controller: function () {
	    AlertComponent.$inject = ["$state", "AuthService", "EventEmitter"];
	    function AlertComponent($state, AuthService, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, AlertComponent);
	
	      Object.assign(this, { $state: $state, AuthService: AuthService, EventEmitter: EventEmitter });
	    }
	
	    _createClass(AlertComponent, [{
	      key: 'alertClicked',
	      value: function alertClicked(alert) {
	        this.onAlertClicked(this.EventEmitter({
	          alert: alert
	        }));
	      }
	    }]);
	
	    return AlertComponent;
	  }()
	};

/***/ },
/* 566 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/alert/alert.html';
	var html = "<md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Alerts</span> </div> </md-toolbar> <div layout=column flex> <div ng-repeat=\"alert in $ctrl.alerts\" ng-if=\"$ctrl.alerts && $ctrl.alerts.length\"> <div class=alert-action flex=100 layout=row layout-wrap ng-click=$ctrl.alertClicked(alert)> <div class=alert layout-margin flex=100 layout=row layout-wrap> <span class=alert-title> <md-icon md-font-set=material-icons class=\"warning alert-icon\">error</md-icon> </span> <span class=alert-title flex=100 flex-gt-md=30> {{alert.AlertTypeName}} </span> <span class=\"alert-message md-body-1\" flex=100 flex-gt-md=60> {{alert.AlertMessage}} </span> </div> </div> <md-divider ng-if=!$last></md-divider> </div> <div ng-if=\"!($ctrl.alerts && $ctrl.alerts.length)\"> <div class=alert layout=row layout-md=column layout-xs=column layout-sm=column layout-margin layout-fill layout-align=\"start center\"> <header class=alert-title> <md-icon md-font-set=material-icons class=\"success alert-icon\">check</md-icon> Congratulations! You're in compliance! </header> <p class=\"alert-message md-body-1 flex\">No further action is required at this time. </p> </div> </div> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 567 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _appMenu = __webpack_require__(569);
	
	var _appMenu2 = _interopRequireDefault(_appMenu);
	
	__webpack_require__(572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.app-menu', []).component('appMenu', _appMenu2.default).name;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _appMenu = __webpack_require__(570);
	
	var _appMenu2 = _interopRequireDefault(_appMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _appMenu2.default,
	  bindings: {
	    currentUser: '<'
	  },
	  controller: function () {
	    MenuComponent.$inject = ["$location", "$mdMedia", "$mdSidenav", "AuthService"];
	    function MenuComponent($location, $mdMedia, $mdSidenav, AuthService) {
	      'ngInject';
	
	      _classCallCheck(this, MenuComponent);
	
	      Object.assign(this, {
	        $location: $location,
	        $mdMedia: $mdMedia,
	        $mdSidenav: $mdSidenav,
	        AuthService: AuthService
	      });
	    }
	
	    _createClass(MenuComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.navLinks = [{
	          state: 'dashboard',
	          sref: 'dashboard',
	          description: 'Dashboard',
	          keywords: ['dashboard'],
	          icon: 'fa-home'
	        }, {
	          state: 'account',
	          sref: 'account',
	          description: 'Manage Account',
	          keywords: ['account'],
	          icon: 'fa-gear'
	        }, {
	          state: 'company',
	          sref: 'company({id: ' + this.currentUser.MemberId + '})',
	          description: 'Manage Account',
	          keywords: ['companies'],
	          icon: 'fa-gear'
	        }, {
	          state: 'companies',
	          sref: 'companies',
	          description: 'Manage Accounts',
	          keywords: ['companies', 'regulators'],
	          icon: 'fa-gear'
	        }, {
	          state: 'products',
	          sref: 'products',
	          description: 'Manage Products',
	          keywords: ['products'],
	          icon: 'fa-leaf'
	        }, {
	          state: 'adverseEvents',
	          sref: 'adverseEvents',
	          description: 'Manage Adverse Events',
	          keywords: ['adverse-events'],
	          icon: 'fa-pencil-square-o'
	        }, {
	          state: 'userIngredients',
	          sref: 'userIngredients',
	          description: 'User Ingredients',
	          keywords: ['user-ingredients'],
	          icon: 'fa-user'
	        }, {
	          state: 'systemIngredients',
	          sref: 'systemIngredients',
	          description: 'System Ingredients',
	          keywords: ['system-ingredients'],
	          icon: 'fa-hdd-o'
	        }, {
	          state: 'mapIngredients',
	          sref: 'mapIngredients',
	          description: 'Map Ingredients',
	          keywords: ['map-ingredients'],
	          icon: 'fa-sitemap fa-rotate-90'
	        }, {
	          state: 'categories',
	          sref: 'categories',
	          description: 'Categories',
	          keywords: ['/categories'],
	          icon: 'fa-tags'
	        }, {
	          state: 'mapCategories',
	          sref: 'mapCategories',
	          description: 'Map Categories',
	          keywords: ['map-categories'],
	          icon: 'fa-sitemap fa-rotate-90'
	        }, {
	          state: 'memberCompliance',
	          sref: 'memberCompliance',
	          description: 'Member Compliance',
	          keywords: ['member-compliance'],
	          icon: 'fa-id-card-o'
	        }, {
	          state: 'reports',
	          sref: 'reports',
	          description: 'Reports',
	          keywords: ['reports'],
	          icon: 'fa-bar-chart-o'
	        }];
	
	        if (this.AuthService.isSysAdmin) {
	          this.navLinks = this.navLinks.filter(function (l) {
	            return l.state !== 'company';
	          });
	        }
	      }
	    }, {
	      key: 'toggleIfOpenUnlocked',
	      value: function toggleIfOpenUnlocked() {
	        var isLockedOpen = this.$mdSidenav('left').isLockedOpen();
	
	        if (isLockedOpen === false) {
	          this.$mdSidenav('left').toggle();
	        }
	      }
	    }, {
	      key: 'isActive',
	      value: function isActive(navLink) {
	        var _this = this;
	
	        return navLink.keywords.some(function (k) {
	          return _this.$location.path().toLowerCase().indexOf(k) > -1;
	        });
	      }
	    }, {
	      key: 'logout',
	      value: function logout() {
	        this.AuthService.logout();
	      }
	    }, {
	      key: 'welcomeMessage',
	      get: function get() {
	        if (this.currentUser.FirstName) {
	          return 'Welcome, ' + this.currentUser.FirstName + '!';
	        }
	
	        return 'Welcome!';
	      }
	    }]);
	
	    return MenuComponent;
	  }()
	};

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/app-menu/app-menu.html';
	var html = "<md-sidenav class=\"site-sidenav md-sidenav-left\" md-component-id=left md-is-locked-open=\"$ctrl.$mdMedia('gt-sm')\" flex> <header layout-padding> <div layout=row layout-align=\"center center\"> <a href=./ > <img src=" + __webpack_require__(571) + " alt=NAERS> </a> </div> </header> <md-content flex role=navigation> <h2 class=\"welcome-text md-title\">{{$ctrl.welcomeMessage}}</h2> <ul class=docs-menu> <li class=parent-list-item ng-repeat=\"link in $ctrl.navLinks\" permission permission-sref=link.state> <menu-link section=section> <a class=\"md-button md-ink-ripple\" ng-class=\"{ active: $ctrl.isActive(link)}\" ui-sref={{link.sref}} ng-click=$ctrl.toggleIfOpenUnlocked()> <md-icon md-font-icon={{link.icon}} class=fa></md-icon> <span id=menu-text>{{link.description}}</span> <div class=md-ripple-container></div> </a> </menu-link> </li> <li class=parent-list-item permission permission-except=ANONYMOUS> <menu-link section=section> <a class=\"md-button md-ink-ripple\" ng-click=$ctrl.logout()> <md-icon md-font-icon=fa-power-off class=fa></md-icon> <span id=menu-text>Logout</span> <div class=md-ripple-container></div> </a> </menu-link> </li> </ul> </md-content> </md-sidenav>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c94bb91d6d23f5fceee5d9ef0328e63.png";

/***/ },
/* 572 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _appToolbar = __webpack_require__(574);
	
	var _appToolbar2 = _interopRequireDefault(_appToolbar);
	
	__webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.app-toolbar', []).component('appToolbar', _appToolbar2.default).name;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appToolbar = __webpack_require__(575);
	
	var _appToolbar2 = _interopRequireDefault(_appToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _appToolbar2.default,
	  transclude: {
	    toolbarButtonsLeft: 'toolbarButtonsLeft',
	    toolbarButtonsRight: 'toolbarButtonsRight'
	  },
	  controller: function ToolbarComponent() {
	    'ngInject';
	
	    _classCallCheck(this, ToolbarComponent);
	  }
	};

/***/ },
/* 575 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/app-toolbar/app-toolbar.html';
	var html = "<md-toolbar id=page-header class=md-hue-2> <div class=md-toolbar-tools> <div ng-transclude=toolbarButtonsLeft></div> <span class=md-truncate>NAERS<sup>&trade;</sup> NASC Adverse Event Reporting System</span> <span flex></span> <div ng-transclude=toolbarButtonsRight></div> </div> </md-toolbar>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 576 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _attest = __webpack_require__(578);
	
	var _attest2 = _interopRequireDefault(_attest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.common.attest', []).component('attest', _attest2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _attest = __webpack_require__(579);
	
	var _attest2 = _interopRequireDefault(_attest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _attest2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    adverseEvents: '<',
	    onAttested: '&'
	  },
	  controller: function () {
	    AttestComponent.$inject = ["EventEmitter"];
	    function AttestComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, AttestComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(AttestComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = _extends({}, (0, _query.getQuery)(), {
	          take: 5
	        });
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onAttested(this.EventEmitter({
	          signature: this.signature
	        }));
	      }
	    }]);
	
	    return AttestComponent;
	  }()
	};

/***/ },
/* 579 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/attest/attest.html';
	var html = "<form name=$ctrl.attestForm flex=100 novalidate ng-submit=$ctrl.onSubmit()> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>AE Attest</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> </div> <div layout-padding layout=column layout-wrap> <md-table-container flex=noshrink ng-if=\"$ctrl.adverseEvents && $ctrl.adverseEvents.length\"> <table md-table> <thead md-head> <tr md-row> <th md-column><span>Event Date</span></th> <th md-column><span>Report Date</span></th> <th md-column><span>Case Status</span></th> <th md-column><span>Risk Index</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"ae in $ctrl.adverseEvents | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\"> <td md-cell><label>{{ ae.EventDate | date:'MMMM dd yyyy' }}</label></td> <td md-cell><label>{{ ae.ReportDate | date:'MMMM dd yyyy' }}</label></td> <td md-cell><label>{{ ae.Status }}</label></td> <td md-cell><label>{{ ae.RiskIndex }}</label></td> </tr> </tbody> </table> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.adverseEvents.length}} md-label=\"{ rowsPerPage: 'AEs per page:' }\"> </md-table-pagination> </md-table-container> <p flex class=md-body-1> I hereby confirm the list of Adverse Events above is a complete and accurate record of all adverse events experienced by NASC in previous month. </p> <md-input-container class=md-block flex=100> <label>Your signature:</label> <input ng-model=$ctrl.signature name=signature required> <div ng-messages=$ctrl.attestForm.signature.$error md-auto-hide=false> <div ng-message=required> Attestment signature is required. </div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" type=submit ng-disabled=!$ctrl.attestForm.$valid>Attest</md-button> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _categoryAutocomplete = __webpack_require__(581);
	
	var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.autocomplete.category', []).component('categoryAutocomplete', _categoryAutocomplete2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _categoryAutocomplete = __webpack_require__(582);
	
	var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _categoryAutocomplete2.default,
	  bindings: {
	    labelText: '@',
	    searchDisplayProperty: '@',
	    onItemSelected: '&'
	  },
	  controller: function () {
	    CategoryAutocomplete.$inject = ["EventEmitter", "CategoryService"];
	    function CategoryAutocomplete(EventEmitter, CategoryService) {
	      'ngInject';
	
	      _classCallCheck(this, CategoryAutocomplete);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        CategoryService: CategoryService
	      });
	    }
	
	    _createClass(CategoryAutocomplete, [{
	      key: 'searchCategories',
	      value: function searchCategories(name) {
	        var query = _extends({}, this.CategoryService.getDefaultQuery(), {
	          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
	            return x.contains('ProductCategoryName', name);
	          })
	        });
	
	        return this.CategoryService.search(query).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        });
	      }
	    }, {
	      key: 'selectedItemChanged',
	      value: function selectedItemChanged(selectedItem) {
	        this.onItemSelected(this.EventEmitter({
	          selectedItem: selectedItem
	        }));
	      }
	    }]);
	
	    return CategoryAutocomplete;
	  }()
	};

/***/ },
/* 582 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/autocomplete/category/category-autocomplete.html';
	var html = "<md-autocomplete flex=100 md-selected-item=$ctrl.selectedItem md-search-text=$ctrl.searchText md-items=\"item in $ctrl.searchCategories($ctrl.searchText)\" md-item-text=item[$ctrl.searchDisplayProperty] md-min-length=2 md-floating-label={{::$ctrl.labelText}} md-selected-item-change=$ctrl.selectedItemChanged(item)> <md-item-template> <span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{item[$ctrl.searchDisplayProperty]}}</span> </md-item-template> <md-not-found> No categories matching \"{{$ctrl.searchText}}\" were found. </md-not-found> </md-autocomplete>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _changePassword = __webpack_require__(584);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.changePassword', []).component('changePassword', _changePassword2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _changePassword = __webpack_require__(585);
	
	var _changePassword2 = _interopRequireDefault(_changePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _changePassword2.default,
	  bindings: {
	    credentials: '<',
	    passwordChanged: '&',
	    requireCurrentPassword: '<'
	  },
	  controller: function () {
	    ChangePasswordComponent.$inject = ["EventEmitter"];
	    function ChangePasswordComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, ChangePasswordComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(ChangePasswordComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.passwordChanged(this.EventEmitter({
	          credentials: this.credentials
	        }));
	      }
	    }]);
	
	    return ChangePasswordComponent;
	  }()
	};

/***/ },
/* 585 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/change-password/change-password.html';
	var html = "<form name=$ctrl.changePasswordForm layout=column flex ng-submit=$ctrl.onSubmit() novalidate> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Change Password</span> <span flex></span> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100 ng-if=::$ctrl.requireCurrentPassword> <label>Current Password</label> <input ng-model=$ctrl.credentials.OldPassword name=currentPassword type=password required> <div ng-messages=$ctrl.changePasswordForm.currentPassword.$error md-auto-hide=false> <div ng-message=required> Current password is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>New Password</label> <input ng-model=$ctrl.credentials.NewPassword name=newPassword type=password required strong-password> <div ng-messages=$ctrl.changePasswordForm.newPassword.$error md-auto-hide=false> <div ng-message=required> New password is required. </div> <div ng-message=strongPassword> Password must be at least eight characters long, containing at least one uppercase character, one lowercase character, and one digit (0-9). </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Confirm Password</label> <input ng-model=$ctrl.credentials.NewPasswordConfirm name=newPasswordConfirm type=password required compare-to=$ctrl.credentials.NewPassword> <div ng-messages=$ctrl.changePasswordForm.newPasswordConfirm.$error md-auto-hide=false> <div ng-message=required> Password confirmation is required. </div> <div ng-message=compareTo> Password confirmation must match new password. </div> </div> </md-input-container> <md-card-actions flex layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=$ctrl.changePasswordForm.$invalid> Change Password </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _companyAutocomplete = __webpack_require__(587);
	
	var _companyAutocomplete2 = _interopRequireDefault(_companyAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.autocomplete.company', []).component('companyAutocomplete', _companyAutocomplete2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _companyAutocomplete = __webpack_require__(588);
	
	var _companyAutocomplete2 = _interopRequireDefault(_companyAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _companyAutocomplete2.default,
	  bindings: {
	    isRequired: '<',
	    onCompanySelected: '&'
	  },
	  controller: function () {
	    CompanyAutocomplete.$inject = ["EventEmitter", "CompanyService"];
	    function CompanyAutocomplete(EventEmitter, CompanyService) {
	      'ngInject';
	
	      _classCallCheck(this, CompanyAutocomplete);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        CompanyService: CompanyService
	      });
	    }
	
	    _createClass(CompanyAutocomplete, [{
	      key: 'searchCompanies',
	      value: function searchCompanies(name) {
	        return this.CompanyService.search(_extends({}, this.CompanyService.getDefaultQuery(), {
	          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
	            return x.contains('MemberName', name);
	          })
	        })).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        });
	      }
	    }, {
	      key: 'selectedCompanyChanged',
	      value: function selectedCompanyChanged(selectedCompany) {
	        this.onCompanySelected(this.EventEmitter({
	          company: selectedCompany
	        }));
	      }
	    }]);
	
	    return CompanyAutocomplete;
	  }()
	};

/***/ },
/* 588 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/autocomplete/company/company-autocomplete.html';
	var html = "<md-autocomplete flex=100 md-selected-item=$ctrl.selectedCompany md-search-text=$ctrl.companySearchText md-items=\"item in $ctrl.searchCompanies($ctrl.companySearchText)\" md-item-text=item.MemberName md-min-length=2 md-floating-label=\"Search by Company Name\" md-selected-item-change=$ctrl.selectedCompanyChanged(item) permission permission-only=\"['SYS_ADMIN', 'REGULATOR']\" ng-required=::$ctrl.isRequired> <md-item-template> <span md-highlight-text=$ctrl.companySearchText md-highlight-flags=^i>{{item.MemberName}}</span> </md-item-template> <md-not-found> No companies matching \"{{$ctrl.companySearchText}}\" were found. </md-not-found> </md-autocomplete>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dialogClose = __webpack_require__(590);
	
	var _dialogClose2 = _interopRequireDefault(_dialogClose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.dialogClose', []).component('dialogClose', _dialogClose2.default).name;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dialogClose = __webpack_require__(591);
	
	var _dialogClose2 = _interopRequireDefault(_dialogClose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _dialogClose2.default,
	  controller: function () {
	    DialogCloseComponent.$inject = ["$mdDialog"];
	    function DialogCloseComponent($mdDialog) {
	      'ngInject';
	
	      _classCallCheck(this, DialogCloseComponent);
	
	      Object.assign(this, { $mdDialog: $mdDialog });
	    }
	
	    _createClass(DialogCloseComponent, [{
	      key: 'close',
	      value: function close() {
	        this.$mdDialog.hide();
	      }
	    }]);
	
	    return DialogCloseComponent;
	  }()
	};

/***/ },
/* 591 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/dialog-close/dialog-close.html';
	var html = "<div class=md-dialog-action-buttons> <md-button class=md-icon-button aria-label=Close ng-click=$ctrl.close()> <md-tooltip md-direction=bottom>Close</md-tooltip> <md-icon md-font-set=material-icons>close</md-icon> </md-button> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ingredientAutocomplete = __webpack_require__(593);
	
	var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.autocomplete.ingredient', []).component('ingredientAutocomplete', _ingredientAutocomplete2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _ingredientAutocomplete = __webpack_require__(594);
	
	var _ingredientAutocomplete2 = _interopRequireDefault(_ingredientAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _ingredientAutocomplete2.default,
	  bindings: {
	    ingredientType: '@',
	    labelText: '@',
	    companyId: '<',
	    searchText: '<',
	    selectedIngredient: '<',
	    searchDisplayProperty: '@',
	    onIngredientSelected: '&'
	  },
	  controller: function () {
	    IngredientAutocomplete.$inject = ["$log", "EventEmitter", "IngredientService"];
	    function IngredientAutocomplete($log, EventEmitter, IngredientService) {
	      'ngInject';
	
	      _classCallCheck(this, IngredientAutocomplete);
	
	      Object.assign(this, {
	        $log: $log,
	        EventEmitter: EventEmitter,
	        IngredientService: IngredientService
	      });
	    }
	
	    _createClass(IngredientAutocomplete, [{
	      key: 'searchIngredients',
	      value: function searchIngredients(name) {
	        if (!this.ingredientType) {
	          this.$log.error('Required ingredientType parameter not supplied for ingredient autocomplete!');
	          return Promise.resolve(false);
	        }
	
	        if (this.ingredientType === 'system') {
	          return this.searchSystemIngredients(name);
	        }
	
	        return this.searchUserIngredients(name);
	      }
	    }, {
	      key: 'searchUserIngredients',
	      value: function searchUserIngredients(name) {
	        return this.IngredientService.searchUserIngredients(_extends({}, this.IngredientService.getDefaultUserIngredientQuery(), {
	          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
	            return x.contains('UserIngredientName', name);
	          })
	        })).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        });
	      }
	    }, {
	      key: 'searchSystemIngredients',
	      value: function searchSystemIngredients(name) {
	        return this.IngredientService.searchSystemIngredients(_extends({}, this.IngredientService.getDefaultSystemIngredientQuery(), {
	          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
	            return x.contains('SystemIngredientName', name);
	          })
	        })).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        });
	      }
	    }, {
	      key: 'selectedIngredientChanged',
	      value: function selectedIngredientChanged(selectedIngredient) {
	        this.onIngredientSelected(this.EventEmitter({
	          selectedIngredient: selectedIngredient
	        }));
	      }
	    }]);
	
	    return IngredientAutocomplete;
	  }()
	};

/***/ },
/* 594 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/autocomplete/ingredient/ingredient-autocomplete.html';
	var html = "<md-autocomplete flex=100 md-selected-item=$ctrl.selectedIngredient md-search-text=$ctrl.searchText md-items=\"item in $ctrl.searchIngredients($ctrl.searchText)\" md-item-text=item[$ctrl.searchDisplayProperty] md-min-length=2 md-floating-label={{::$ctrl.labelText}} md-selected-item-change=$ctrl.selectedIngredientChanged(item)> <md-item-template> <span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{item[$ctrl.searchDisplayProperty]}}</span> </md-item-template> <md-not-found> No ingredients matching \"{{$ctrl.searchText}}\" were found. </md-not-found> </md-autocomplete>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _itemList = __webpack_require__(596);
	
	var _itemList2 = _interopRequireDefault(_itemList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.common.item-list', []).component('itemList', _itemList2.default).name;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _itemList = __webpack_require__(597);
	
	var _itemList2 = _interopRequireDefault(_itemList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _itemList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    columns: '<',
	    displayNamePlural: '@',
	    query: '<',
	    items: '<',
	    selectedItems: '<',
	    queryChanged: '&',
	    searchTextChanged: '&'
	  },
	  controller: function () {
	    ItemListComponent.$inject = ["EventEmitter"];
	    function ItemListComponent(EventEmitter) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, ItemListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.onQueryChange(_extends({}, _this.query, {
	          page: page,
	          take: take
	        }));
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.onQueryChange(_extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        }));
	      };
	    }
	
	    _createClass(ItemListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'onQueryChange',
	      value: function onQueryChange(query) {
	        this.queryChanged(this.EventEmitter({
	          query: query
	        }));
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(searchText) {
	        this.searchTextChanged(this.EventEmitter({
	          searchText: searchText
	        }));
	      }
	    }, {
	      key: 'formattedDisplayName',
	      get: function get() {
	        if (!this.displayName) {
	          return 'Items';
	        }
	
	        return this.displayName;
	      }
	    }]);
	
	    return ItemListComponent;
	  }()
	};

/***/ },
/* 597 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/item-list/item-list.html';
	var html = "<md-card-content layout=column flex> <md-input-container class=md-block> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChanged($ctrl.searchText)> </md-input-container> <div layout=column flex ng-show=\"$ctrl.items.Data && $ctrl.items.Count\"> <md-table-container layout=column flex> <table md-table multiple=true md-row-select=true ng-model=$ctrl.selectedItems md-progress=$ctrl.promise> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th ng-repeat=\"column in $ctrl.columns\" md-column md-order-by={{column.FieldName}}>{{column.DisplayName}}</th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"item in $ctrl.items.Data\" md-select=item> <td md-cell ng-repeat=\"column in $ctrl.columns\">{{item[column.FieldName]}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.items.Count}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: '{{::$ctrl.displayNamePlural}} per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.items.Data && $ctrl.items.Count\" layout=column layout-align=\"center center\"> <p class=md-body-1> There are no {{::$ctrl.displayNamePlural.toLowerCase()}} matching the specified criteria. </p> </div> </md-card-content> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _feedback = __webpack_require__(599);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.feedback', []).component('feedback', _feedback2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _feedback = __webpack_require__(600);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _feedback2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    onFeedbackSubmitted: '&'
	  },
	  controller: function () {
	    FeedbackComponent.$inject = ["EventEmitter"];
	    function FeedbackComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, FeedbackComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(FeedbackComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onFeedbackSubmitted(this.EventEmitter({
	          feedback: this.feedback
	        }));
	      }
	    }]);
	
	    return FeedbackComponent;
	  }()
	};

/***/ },
/* 600 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/feedback/feedback.html';
	var html = "<form name=$ctrl.feedbackForm flex novalidate> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Feedback</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <md-input-container class=md-block flex=100> <label>Please provide your feedback in the box below:</label> <textarea ng-model=$ctrl.feedback required name=feedback md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow></textarea> <div ng-messages=$ctrl.feedbackForm.feedback.$error md-auto-hide=false> <div ng-message=required> Feedback is required. </div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-disabled=!$ctrl.feedbackForm.$valid ng-click=$ctrl.onSubmit()> Submit Feedback </md-button> </div> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productLabelUpload = __webpack_require__(602);
	
	var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.productLabelUpload', []).component('productLabelUpload', _productLabelUpload2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _productLabelUpload = __webpack_require__(603);
	
	var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _productLabelUpload2.default,
	  bindings: {
	    onProductLabelChanged: '&',
	    labelText: '@',
	    labelClass: '@',
	    iconClass: '@',
	    productId: '<',
	    showPreview: '<',
	    isAbbreviated: '<',
	    buttonWidth: '@',
	    locked: '<'
	  },
	  controller: function () {
	    ProductLabelUploadComponent.$inject = ["EventEmitter"];
	    function ProductLabelUploadComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, ProductLabelUploadComponent);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter
	      });
	    }
	
	    _createClass(ProductLabelUploadComponent, [{
	      key: 'onFileChanged',
	      value: function onFileChanged(productLabel) {
	        this.onProductLabelChanged(this.EventEmitter({
	          productLabel: productLabel,
	          productId: this.productId
	        }));
	      }
	    }]);
	
	    return ProductLabelUploadComponent;
	  }()
	};

/***/ },
/* 603 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/product-label-upload/product-label-upload.html';
	var html = "<ng-form layout=column name=$ctrl.productLabelUploadForm flex={{::$ctrl.buttonWidth}}> <p class=md-body-1 ng-if=\"$ctrl.productLabel && $ctrl.productLabel.name\">Pending upload: {{$ctrl.productLabel.name}}</p> <img ngf-thumbnail=$ctrl.productLabel ng-if=\"$ctrl.showPreview && $ctrl.productLabel\"> <div ng-class=::$ctrl.labelClass ngf-select=$ctrl.onFileChanged($file) ng-model=$ctrl.productLabel name=productLabel accept=\"application/pdf, image/*\" ngf-pattern=\"'application/pdf,image/*'\" ngf-accept=\"'application/pdf, image/*'\" ngf-max-size=20MB ng-disabled=::$ctrl.locked> <md-tooltip ng-if=::$ctrl.isAbbreviated>Upload Product Label</md-tooltip> <md-icon md-font-set=material-icons ng-class=::$ctrl.iconClass>file_upload</md-icon> <span ng-if=$ctrl.labelText>{{::$ctrl.labelText}}</span> </div> <div ng-show=$ctrl.productLabelUploadForm.productLabel.$error.maxSize md-auto-hide=true> <div class=max-size> File size needs to be less than 20MB. </div> </div> <p class=md-body-1 ng-if=::!$ctrl.isAbbreviated>Label upload supports .pdf, .jpg, .png, and many other image formats.</p> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _regulatorAutocomplete = __webpack_require__(605);
	
	var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.autocomplete.regulator', []).component('regulatorAutocomplete', _regulatorAutocomplete2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _regulatorAutocomplete = __webpack_require__(606);
	
	var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _regulatorAutocomplete2.default,
	  bindings: {
	    isRequired: '<',
	    onRegulatorSelected: '&'
	  },
	  controller: function () {
	    RegulatorAutocomplete.$inject = ["EventEmitter", "RegulatorService"];
	    function RegulatorAutocomplete(EventEmitter, RegulatorService) {
	      'ngInject';
	
	      _classCallCheck(this, RegulatorAutocomplete);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        RegulatorService: RegulatorService
	      });
	    }
	
	    _createClass(RegulatorAutocomplete, [{
	      key: 'searchRegulators',
	      value: function searchRegulators(name) {
	        return this.RegulatorService.search(_extends({}, this.RegulatorService.getDefaultQuery(), {
	          filter: (0, _odataFilterBuilder2.default)().and(function (x) {
	            return x.contains('AgentName', name);
	          })
	        })).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        });
	      }
	    }, {
	      key: 'selectedRegulatorChanged',
	      value: function selectedRegulatorChanged(selectedRegulator) {
	        this.onRegulatorSelected(this.EventEmitter({
	          regulator: selectedRegulator
	        }));
	      }
	    }]);
	
	    return RegulatorAutocomplete;
	  }()
	};

/***/ },
/* 606 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/autocomplete/regulator/regulator-autocomplete.html';
	var html = "<md-autocomplete flex=100 md-selected-item=$ctrl.selectedRegulator md-search-text=$ctrl.regulatorSearchText md-items=\"item in $ctrl.searchRegulators($ctrl.regulatorSearchText)\" md-item-text=item.AgentName md-min-length=2 md-floating-label=\"Search by Regulator Name\" md-selected-item-change=$ctrl.selectedRegulatorChanged(item) permission permission-only=\"['SYS_ADMIN']\" ng-required=::$ctrl.isRequired> <md-item-template> <span md-highlight-text=$ctrl.regulatorSearchText md-highlight-flags=^i>{{item.AgentName}}</span> </md-item-template> <md-not-found> No regulators matching \"{{$ctrl.regulatorSearchText}}\" were found. </md-not-found> </md-autocomplete>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userAddForm = __webpack_require__(608);
	
	var _userAddForm2 = _interopRequireDefault(_userAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.userAddForm', []).component('userAddForm', _userAddForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _userType = __webpack_require__(609);
	
	var _userType2 = _interopRequireDefault(_userType);
	
	var _userAddForm = __webpack_require__(610);
	
	var _userAddForm2 = _interopRequireDefault(_userAddForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _userAddForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    accessLevels: '<',
	    onUserChanged: '&',
	    requireUserTypeSelection: '<'
	  },
	  controller: function () {
	    UserAddFormComponent.$inject = ["EventEmitter"];
	    function UserAddFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, UserAddFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(UserAddFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.user = this.user || {};
	        this.userTypes = _userType2.default;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onUserChanged(this.EventEmitter({
	          user: this.user
	        }));
	      }
	    }, {
	      key: 'setSelectedCompany',
	      value: function setSelectedCompany(_ref) {
	        var company = _ref.company;
	
	        this.user.TypeReferenceId = company && company.MemberId || null;
	      }
	    }, {
	      key: 'setSelectedRegulator',
	      value: function setSelectedRegulator(_ref2) {
	        var regulator = _ref2.regulator;
	
	        this.user.TypeReferenceId = regulator && regulator.RegulatorId || null;
	      }
	    }]);
	
	    return UserAddFormComponent;
	  }()
	};

/***/ },
/* 609 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  UserTypeId: 1,
	  Name: 'Member'
	}, {
	  UserTypeId: 2,
	  Name: 'Regulator'
	}];

/***/ },
/* 610 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/user-add-form/user-add-form.html';
	var html = "<form name=$ctrl.userForm layout=column flex ng-submit=$ctrl.onSubmit() novalidate> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Add New User</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <md-input-container class=md-block flex=100 ng-if=::$ctrl.requireUserTypeSelection> <label>User Type</label> <md-select ng-model=$ctrl.user.UserTypeId required> <md-option ng-repeat=\"userType in $ctrl.userTypes\" ng-value={{userType.UserTypeId}}> {{userType.Name}} </md-option> </md-select> </md-input-container> <company-autocomplete class=md-block flex=100 required ng-if=\"$ctrl.user.UserTypeId === 1\" on-company-selected=$ctrl.setSelectedCompany($event) permission permission-only=\"'SYS_ADMIN'\" is-required=true> </company-autocomplete> <regulator-autocomplete class=md-block flex=100 required ng-if=\"$ctrl.user.UserTypeId === 2\" on-regulator-selected=$ctrl.setSelectedRegulator($event) permission permission-only=\"'SYS_ADMIN'\" is-required=true> </regulator-autocomplete> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>First Name</label> <input ng-model=$ctrl.user.FirstName name=firstName required> <div ng-messages=$ctrl.userForm.firstName.$error md-auto-hide=false> <div ng-message=required> First name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Last Name</label> <input ng-model=$ctrl.user.LastName name=lastName required> <div ng-messages=$ctrl.userForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Email</label> <input ng-model=$ctrl.user.Email name=email type=email required> <div ng-messages=$ctrl.userForm.email.$error md-auto-hide=false> <div ng-message=required> Email address is required. </div> <div ng-message=email> Email address must be valid. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Username</label> <input ng-model=$ctrl.user.Username name=username data-user-id={{$ctrl.user.UserId}} required min-length=5 unique-username> <div ng-messages=$ctrl.userForm.username.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> <div ng-message=minLength> Username does not meet minimum length requirements. </div> <div ng-message=uniqueUsername> Username is already taken! Please choose a unique username. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Password</label> <input ng-model=$ctrl.user.Password name=password type=password required min-length=5 strong-password> <div ng-messages=$ctrl.userForm.password.$error md-auto-hide=false> <div ng-message=required> Password is required. </div> <div ng-message=strongPassword> Password must be at least eight characters long, containing at least one uppercase character, one lowercase character, and one digit (0-9). </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Level of Access</label> <md-select name=accessLevel ng-model=$ctrl.user.LevelOfAccess required> <md-option ng-repeat=\"accessLevel in $ctrl.accessLevels\" ng-value={{accessLevel.id}}> {{accessLevel.desc}} </md-option> </md-select> <div ng-messages=$ctrl.userForm.accessLevel.$error md-auto-hide=false> <div ng-message=required> Access level is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end end\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.userForm.$valid> Add User </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userEditForm = __webpack_require__(612);
	
	var _userEditForm2 = _interopRequireDefault(_userEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.userEditForm', []).component('userEditForm', _userEditForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _userEditForm = __webpack_require__(613);
	
	var _userEditForm2 = _interopRequireDefault(_userEditForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _userEditForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    accessLevels: '<',
	    user: '<',
	    showAccessLevel: '<',
	    onUserChanged: '&'
	  },
	  controller: function () {
	    UserEditFormComponent.$inject = ["EventEmitter"];
	    function UserEditFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, UserEditFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(UserEditFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.user = this.user || {};
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onUserChanged(this.EventEmitter({
	          user: this.user
	        }));
	      }
	    }]);
	
	    return UserEditFormComponent;
	  }()
	};

/***/ },
/* 613 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/user-edit-form/user-edit-form.html';
	var html = "<form name=$ctrl.userForm layout=column flex ng-submit=$ctrl.onSubmit() novalidate> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Manage Account</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-wrap> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>First Name</label> <input ng-model=$ctrl.user.FirstName name=firstName required> <div ng-messages=$ctrl.userForm.firstName.$error md-auto-hide=false> <div ng-message=required> First name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Last Name</label> <input ng-model=$ctrl.user.LastName name=lastName required> <div ng-messages=$ctrl.userForm.lastName.$error md-auto-hide=false> <div ng-message=required> Last name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Email</label> <input ng-model=$ctrl.user.Email name=email type=email required> <div ng-messages=$ctrl.userForm.email.$error md-auto-hide=false> <div ng-message=required> Email address is required. </div> <div ng-message=email> Email address must be valid. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-sm=50> <label>Username</label> <input ng-model=$ctrl.user.Username name=username data-user-id={{$ctrl.user.UserId}} required min-length=5 unique-username ng-readonly=true> <div ng-messages=$ctrl.userForm.username.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> <div ng-message=minLength> Username does not meet minimum length requirements. </div> <div ng-message=uniqueUsername> Username is already taken! Please choose a unique username. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 permission permission-only=\"['COMPANY_ADMIN','SYS_ADMIN']\" ng-if=::$ctrl.showAccessLevel> <label>Level of Access</label> <md-select name=accessLevel ng-model=$ctrl.user.LevelOfAccess required> <md-option ng-repeat=\"accessLevel in $ctrl.accessLevels\" ng-value={{accessLevel.id}}> {{accessLevel.desc}} </md-option> </md-select> <div ng-messages=$ctrl.userForm.accessLevel.$error md-auto-hide=false> <div ng-message=required> Access level is required. </div> </div> </md-input-container> <md-card-actions flex=100 layout=row layout-align=\"end end\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.userForm.$valid> Save Changes </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userList = __webpack_require__(615);
	
	var _userList2 = _interopRequireDefault(_userList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.account.user-list', []).component('userList', _userList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _userList = __webpack_require__(616);
	
	var _userList2 = _interopRequireDefault(_userList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _userList2.default,
	  bindings: {
	    users: '<',
	    selectedUsers: '<',
	    userLockoutChanged: '&',
	    locked: '<',
	    query: '<',
	    queryChanged: '&',
	    searchTextChanged: '&',
	    showColumns: '<'
	  },
	  controller: function () {
	    UserListComponent.$inject = ["EventEmitter"];
	    function UserListComponent(EventEmitter) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, UserListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.onQueryChange(_extends({}, _this.query, {
	          page: page,
	          take: take
	        }));
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.onQueryChange(_extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        }));
	      };
	    }
	
	    _createClass(UserListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }, {
	      key: 'setUserLocked',
	      value: function setUserLocked(user) {
	        this.userLockoutChanged(this.EventEmitter({
	          userId: user.UserId,
	          isLocked: !user.IsLocked
	        }));
	      }
	    }, {
	      key: 'onQueryChange',
	      value: function onQueryChange(query) {
	        this.queryChanged(this.EventEmitter({
	          query: query
	        }));
	      }
	    }, {
	      key: 'onSearchTextChanged',
	      value: function onSearchTextChanged(searchText) {
	        this.searchTextChanged(this.EventEmitter({
	          searchText: searchText
	        }));
	      }
	    }, {
	      key: 'shouldShowColumn',
	      value: function shouldShowColumn(columnName) {
	        if (!(this.showColumns && this.showColumns.length)) {
	          return false;
	        }
	
	        return this.showColumns.indexOf(columnName) > -1;
	      }
	    }]);
	
	    return UserListComponent;
	  }()
	};

/***/ },
/* 616 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/user-list/user-list.html';
	var html = "<md-card-content layout=column flex> <md-input-container class=md-block> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onSearchTextChanged($ctrl.searchText)> </md-input-container> <div layout=column flex ng-show=\"$ctrl.users.Data && $ctrl.users.Count\"> <md-table-container layout=column flex> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedUsers md-progress=$ctrl.promise> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=FirstName><span>First Name</span></th> <th md-column md-order-by=LastName><span>Last Name</span></th> <th md-column md-order-by=Username><span>Username</span></th> <th md-column md-order-by=LevelOfAccess><span>Level of Access</span></th> <th md-column md-order-by=IsLocked><span>Locked out</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"user in $ctrl.users.Data\" md-select=user> <td md-cell>{{user.FirstName}}</td> <td md-cell>{{user.LastName}}</td> <td md-cell>{{user.Username}}</td> <td md-cell>{{user.LevelOfAccess}}</td> <td md-cell stop-event=click> <md-checkbox ng-model=user.IsLocked ng-click=$ctrl.setUserLocked(user) aria-label=\"Locked out\"></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.users.Count}} md-page-select=true md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Users per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.users.Data && $ctrl.users.Count\"> <p class=md-body-1> There are no users matching the specified criteria. </p> </div> </md-card-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _message = __webpack_require__(618);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _bulkUsageData = __webpack_require__(619);
	
	var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);
	
	var _dashboard = __webpack_require__(622);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _message3 = __webpack_require__(624);
	
	var _message4 = _interopRequireDefault(_message3);
	
	var _messageEdit = __webpack_require__(627);
	
	var _messageEdit2 = _interopRequireDefault(_messageEdit);
	
	__webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.dashboard', [_angularUiRouter2.default, _bulkUsageData2.default, _message4.default, _messageEdit2.default]).component('dashboard', _dashboard2.default).service('MessageService', _message2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('dashboard', {
	    parent: 'app',
	    url: '/dashboard',
	    component: 'dashboard',
	    data: {
	      permissions: {
	        except: ['' + _roles.REGULATOR],
	        redirectTo: 'adverseEvents'
	      }
	    },
	    resolve: {
	      adminMessage: ["MessageService", function adminMessage(MessageService) {
	        return MessageService.getAdminMessage().then(function (r) {
	          return r.data;
	        });
	      }],
	      alerts: ["AlertService", function alerts(AlertService) {
	        return AlertService.getAlerts().then(function (r) {
	          return r.data;
	        });
	      }],
	      companyMessage: ["$log", "MessageService", function companyMessage($log, MessageService) {
	        return MessageService.getCompanyMessage().then(function (r) {
	          return r.data;
	        }).catch(function (error) {
	          return $log.error(error);
	        });
	      }],
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      }
	    }
	  });
	}]).name;

/***/ },
/* 618 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MessageService = function () {
	  MessageService.$inject = ["$http"];
	  function MessageService($http) {
	    'ngInject';
	
	    _classCallCheck(this, MessageService);
	
	    this.$http = $http;
	  }
	
	  _createClass(MessageService, [{
	    key: 'getAdminMessage',
	    value: function getAdminMessage() {
	      return this.$http.get('/api/message/load_nasc_message');
	    }
	  }, {
	    key: 'getCompanyMessage',
	    value: function getCompanyMessage() {
	      return this.$http.get('/api/message/load_company_message');
	    }
	  }, {
	    key: 'updateAdminMessage',
	    value: function updateAdminMessage(message) {
	      return this.$http.put('/api/message/nasc', {
	        message: message
	      });
	    }
	  }, {
	    key: 'updateCompanyMessage',
	    value: function updateCompanyMessage(message) {
	      return this.$http.put('/api/message/company', {
	        message: message
	      });
	    }
	  }]);
	
	  return MessageService;
	}();
	
	exports.default = MessageService;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _bulkUsageData = __webpack_require__(620);
	
	var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.dashboard.bulk-usage-data', []).component('bulkUsageData', _bulkUsageData2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _bulkUsageData = __webpack_require__(621);
	
	var _bulkUsageData2 = _interopRequireDefault(_bulkUsageData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _bulkUsageData2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    usages: '<',
	    onUsagesSubmitted: '&'
	  },
	  controller: function () {
	    BulkUsageDataComponent.$inject = ["EventEmitter", "UsageDataService"];
	    function BulkUsageDataComponent(EventEmitter, UsageDataService) {
	      'ngInject';
	
	      _classCallCheck(this, BulkUsageDataComponent);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        UsageDataService: UsageDataService
	      });
	    }
	
	    _createClass(BulkUsageDataComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.Q4Value = 0;
	        this.query = _extends({}, (0, _query.getQuery)(), {
	          take: 5
	        });
	        this.limitOptions = [5, 10, 25, 50];
	        this.getQ4Value();
	      }
	    }, {
	      key: 'getQ4Value',
	      value: function getQ4Value() {
	        var _this = this;
	
	        var promise = this.UsageDataService.getQ4Value(this.usages[0].ProductId, this.usages[0].UsageYear - 1);
	
	        return promise.then(function (result) {
	          _this.Q4Value = result.data;
	        });
	      }
	    }, {
	      key: 'showWarning',
	      value: function showWarning(value1, value2) {
	        if ((value1 - value2) / value2 > 1) {
	          return true;
	        } else if ((value2 - value1) / value1 > 1) {
	          return true;
	        }
	        return false;
	      }
	    }, {
	      key: 'showWarningMessage',
	      value: function showWarningMessage() {
	        var errors = document.getElementsByClassName('error-icon');
	        if (errors.length > 0) {
	          if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
	            return false;
	          }
	          return true;
	        }
	        return false;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onUsagesSubmitted(this.EventEmitter({
	          usages: this.usages
	        }));
	      }
	    }]);
	
	    return BulkUsageDataComponent;
	  }()
	};

/***/ },
/* 621 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/common/bulk-usage-data/bulk-usage-data.html';
	var html = "<form name=$ctrl.usageForm flex=100 ng-submit=$ctrl.onSubmit() novalidate> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Shipping Data</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> </div> <div layout=column> <p flex layout-padding class=md-body-1> Please update the following number of units shipped: </p> <md-table-container flex=noshrink> <table md-table> <thead md-head md-order=query.order> <tr md-row> <th md-column md-order-by=ProductName><span>Product Name</span></th> <th md-column md-order-by=SKU style=max-width:50px><span>SKU</span></th> <th md-column md-order-by=UsageYear style=max-width:50px><span>Year</span></th> <th md-column style=max-width:50px><span>Q1</span></th> <th md-column style=max-width:50px><span>Q2</span></th> <th md-column style=max-width:50px><span>Q3</span></th> <th md-column style=max-width:50px><span>Q4</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"usage in $ctrl.usages | orderBy: query.order | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\"> <td md-cell> <div layout=column flex> <md-input-container class=md-block> <input class=input-label ng-model=usage.ProductName ng-disabled=true aria-label=\"Usage Product Name\"> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=md-block> <input class=input-label ng-model=usage.SKU ng-disabled=true aria-label=\"Usage SKU\"> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=md-block> <input class=input-label ng-model=usage.UsageYear ng-disabled=true aria-label=\"Usage Year\"> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"$index == 0 && (usage.Q1 && $ctrl.Q4Value) !== null\"> <div ng-if=\"$ctrl.showWarning(usage.Q1, $ctrl.Q4Value)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <div ng-if=\"$index > 0 && (usage.Q1 && $ctrl.usages[$index - 1].Q4) !== null\"> <div ng-if=\"$ctrl.showWarning(usage.Q1, $ctrl.usages[$index - 1].Q4)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-if=\"$index == 0\" ng-model=usage.Q1 ng-style=\"(usage.Q1 && $ctrl.Q4Value) !== null && $ctrl.showWarning(usage.Q1, $ctrl.Q4Value) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q1_{{$index}} type=number aria-label=\"Q1 Usage\"> <input ng-if=\"$index > 0\" ng-model=usage.Q1 ng-style=\"(usage.Q1 && $ctrl.usages[$index - 1].Q4) !== null && $ctrl.showWarning(usage.Q1, $ctrl.usages[$index - 1].Q4) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q1_{{$index}} type=number aria-label=\"Q1 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q1_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q2 && usage.Q1) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q2, usage.Q1)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q2 ng-style=\"(usage.Q2 && usage.Q1) !== null && $ctrl.showWarning(usage.Q2, usage.Q1) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q2_{{$index}} type=number aria-label=\"Q2 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q2_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q3 && usage.Q2) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q3, usage.Q2)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q3 ng-style=\"(usage.Q3 && usage.Q2) !== null && $ctrl.showWarning(usage.Q3, usage.Q2) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q3_{{$index}} type=number aria-label=\"Q3 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q3_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q4 && usage.Q3) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q4, usage.Q3)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q4 ng-style=\"(usage.Q4 && usage.Q3) !== null && $ctrl.showWarning(usage.Q4, usage.Q3) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q4_{{$index}} type=number aria-label=\"Q4 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q4_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> </tr> </tbody> </table> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.usages.length}} md-label=\"{ rowsPerPage: 'Usages per page:' }\"> </md-table-pagination> </md-table-container> <div layout=row layout-padding layout-align=\"end center\"> <div ng-if=$ctrl.showWarningMessage() style=display:flex;width:50%> <md-icon md-font-set=material-icons class=\"error-icon warning-message\" style=\"margin:36px 11px 0 0\"> warning </md-icon> <h5> Warning: This value differs from the previous quarter by more than 100%. Please confirm this is correct before clicking ‘Update Shipping Data’. </h5> </div> <md-button class=\"md-raised md-accent\" type=submit ng-disabled=!$ctrl.usageForm.$valid>Update Shipping Data</md-button> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _dashboard = __webpack_require__(623);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _dashboard2.default,
	  bindings: {
	    adminMessage: '<',
	    alerts: '<',
	    companyMessage: '<',
	    flex: '<',
	    layout: '<'
	  },
	  controller: function () {
	    DashboardComponent.$inject = ["$mdDialog", "$scope", "$state", "AccountService", "AdverseEventService", "AdverseEventsService", "AuthService", "CompanyService", "LoadingService", "MessageService", "RegulatorService", "ReportService", "ToastService", "UsageDataService"];
	    function DashboardComponent($mdDialog, $scope, $state, AccountService, AdverseEventService, AdverseEventsService, AuthService, CompanyService, LoadingService, MessageService, RegulatorService, ReportService, ToastService, UsageDataService) {
	      'ngInject';
	
	      _classCallCheck(this, DashboardComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        AdverseEventService: AdverseEventService,
	        AdverseEventsService: AdverseEventsService,
	        AuthService: AuthService,
	        CompanyService: CompanyService,
	        LoadingService: LoadingService,
	        MessageService: MessageService,
	        RegulatorService: RegulatorService,
	        ReportService: ReportService,
	        ToastService: ToastService,
	        UsageDataService: UsageDataService
	      });
	    }
	
	    _createClass(DashboardComponent, [{
	      key: 'showUsages',
	      value: function showUsages(quarterOnly) {
	        var _this = this;
	
	        var promise = void 0;
	        if (quarterOnly) {
	          promise = this.UsageDataService.getMissingQuarterUsageData();
	        } else {
	          promise = this.UsageDataService.getMissingUsageData();
	        }
	
	        promise.then(function (r) {
	          var usages = r.data;
	
	          if (usages && usages.length) {
	            var scope = _angular2.default.extend(_this.$scope.$new(true), {
	              usages: usages,
	              onUsageDataUpdated: function onUsageDataUpdated($event) {
	                return _this.onUsageDataUpdated($event);
	              }
	            });
	
	            _this.$mdDialog.show({
	              clickOutsideToClose: true,
	              fullscreen: true,
	              scope: scope,
	              template: '\n          <md-dialog class="flex-85" style="max-height: 90%">\n            <md-dialog-content>\n              <dialog-close/>\n              <bulk-usage-data\n                usages="usages"\n                on-usages-submitted="onUsageDataUpdated($event)">\n              </bulk-usage-data>\n            </md-dialog-content>\n          </md-dialog>\n          '
	            });
	          } else {
	            _this.$mdDialog.show(_this.$mdDialog.alert().clickOutsideToClose(true).textContent('You are currently in compliance. No further action is required.').ariaLabel('No action required').ok('OK'));
	          }
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onUsageDataUpdated',
	      value: function onUsageDataUpdated($event) {
	        var _this2 = this;
	
	        if ($event && $event.usages) {
	          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
	            _this2.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
	            _this2.$mdDialog.hide();
	            _this2.$state.reload();
	          }).catch(function (error) {
	            return _this2.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showAttestment',
	      value: function showAttestment() {
	        var _this3 = this;
	
	        this.AdverseEventsService.getOpenAdverseEventsPreviousMonth().then(function (r) {
	          var adverseEvents = r.data;
	          var scope = _angular2.default.extend(_this3.$scope.$new(true), {
	            adverseEvents: adverseEvents,
	            onAttested: function onAttested($event) {
	              return _this3.onAttested($event);
	            }
	          });
	
	          _this3.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: '\n            <md-dialog class="flex-75" style="max-height: 75%">\n              <md-dialog-content>\n                <dialog-close/>\n                <attest\n                  adverse-events="adverseEvents"\n                  on-attested="onAttested($event)">\n                </attest>\n              </md-dialog-content>\n            </md-dialog>\n          '
	          });
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onAttested',
	      value: function onAttested(_ref) {
	        var _this4 = this;
	
	        var signature = _ref.signature;
	
	        if (signature) {
	          this.AdverseEventService.attest(signature).then(function () {
	            _this4.ToastService.showSuccess(_messages.ADVERSE_EVENT_ATTESTED);
	            _this4.$mdDialog.hide();
	            _this4.$state.reload();
	          }).catch(function (error) {
	            return _this4.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showCompanyAdd',
	      value: function showCompanyAdd() {
	        var _this5 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onCompanyAdded: function onCompanyAdded($event) {
	            return _this5.onCompanyAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <company-add-form\n                on-company-changed="onCompanyAdded($event)">\n              </company-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onCompanyAdded',
	      value: function onCompanyAdded(_ref2) {
	        var _this6 = this;
	
	        var company = _ref2.company;
	
	        if (company) {
	          this.CompanyService.add(company).then(function (r) {
	            _this6.$mdDialog.hide();
	            _this6.ToastService.showSuccess(_messages.COMPANY_ADDED);
	
	            var companyId = r.data.Id;
	            _this6.$state.go('company', { id: companyId });
	          }).catch(function (error) {
	            return _this6.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'showUserAdd',
	      value: function showUserAdd() {
	        var _this7 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          accessLevels: this.AuthService.getAccessLevels(),
	          onUserAdded: function onUserAdded($event) {
	            return _this7.onUserAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n        <md-dialog class="flex-50">\n          <md-dialog-content>\n            <dialog-close/>\n            <user-add-form\n              require-user-type-selection="true"\n              access-levels="accessLevels"\n              on-user-changed="onUserAdded($event)">\n            </user-add-form>\n          </md-dialog-content>\n        </md-dialog>\n        '
	        });
	      }
	    }, {
	      key: 'onUserAdded',
	      value: function onUserAdded(_ref3) {
	        var _this8 = this;
	
	        var user = _ref3.user;
	
	        if (user) {
	          this.AccountService.addAccount(user).then(function () {
	            _this8.$mdDialog.hide();
	            _this8.ToastService.showSuccess(_messages.USER_ADDED);
	          }).catch(function (error) {
	            return _this8.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'alertClicked',
	      value: function alertClicked(_ref4) {
	        var alert = _ref4.alert;
	
	        if (alert) {
	          if (alert.AlertTypeID === 1) {
	            this.$state.go('products', { search: 'missing_info' });
	          } else if (alert.AlertTypeID === 2) {
	            this.$state.go('adverseEvents', { search: 'status_open' });
	          } else if (alert.AlertTypeID === 3) {
	            if (this.AuthService.isSysAdmin) {
	              this.$state.go('products', { search: 'missing_sales' });
	            } else {
	              this.showUsages(false);
	            }
	          } else if (alert.AlertTypeID === 4) {
	            if (this.AuthService.isSysAdmin) {
	              this.$state.go('memberCompliance');
	            } else {
	              this.showAttestment();
	            }
	          }
	        }
	      }
	    }, {
	      key: 'showEditMessage',
	      value: function showEditMessage(messageType) {
	        var action = messageType === 'SYSTEM' ? this.onSystemMessageChanged.bind(this) : this.onCompanyMessageChanged.bind(this);
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          message: messageType === 'SYSTEM' ? this.adminMessage : this.companyMessage,
	          title: messageType === 'SYSTEM' ? 'NASC Message' : 'Company Message',
	          onMessageChanged: function onMessageChanged($event) {
	            return action($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <message-edit message="message"\n                title="title"\n                on-message-changed="onMessageChanged($event)">\n              </message-edit>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onSystemMessageChanged',
	      value: function onSystemMessageChanged(_ref5) {
	        var _this9 = this;
	
	        var message = _ref5.message;
	
	        this.MessageService.updateAdminMessage(message).then(function () {
	          _this9.$mdDialog.hide();
	          _this9.ToastService.showSuccess(_messages.SYSTEM_MESSAGE_CHANGED);
	          _this9.$state.reload();
	        }).catch(function (error) {
	          return _this9.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onCompanyMessageChanged',
	      value: function onCompanyMessageChanged(_ref6) {
	        var _this10 = this;
	
	        var message = _ref6.message;
	
	        this.MessageService.updateCompanyMessage(message).then(function () {
	          _this10.$mdDialog.hide();
	          _this10.ToastService.showSuccess(_messages.COMPANY_MESSAGE_CHANGED);
	          _this10.$state.reload();
	        }).catch(function (error) {
	          return _this10.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'showRegulatorAdd',
	      value: function showRegulatorAdd() {
	        var _this11 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          onRegulatorAdded: function onRegulatorAdded($event) {
	            return _this11.onRegulatorAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <regulator-add-form\n                dialog-title="Add New Regulator"\n                submit-title="Add Regulator"\n                on-regulator-changed="onRegulatorAdded($event)">\n              </regulator-add-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onRegulatorAdded',
	      value: function onRegulatorAdded(_ref7) {
	        var _this12 = this;
	
	        var regulator = _ref7.regulator;
	
	        if (regulator) {
	          this.RegulatorService.add(regulator).then(function () {
	            _this12.ToastService.showSuccess(_messages.REGULATOR_ADDED);
	            _this12.$mdDialog.hide();
	            _this12.$state.reload();
	          }).catch(function (error) {
	            return _this12.ToastService.showError(error);
	          });
	        }
	      }
	    }]);
	
	    return DashboardComponent;
	  }()
	};

/***/ },
/* 623 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/dashboard/dashboard.html';
	var html = "<section layout-padding layout=column flex> <section layout=row layout-wrap> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add Supplement\" ui-sref=productCreate permission permission-only=\"['USER','COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Supplement </md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Treat\" ui-sref=treatProductCreate permission permission-only=\"['USER', 'COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Treat </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add Adverse Event\" ui-sref=adverseEventCreate permission permission-only=\"['USER','COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Adverse Event </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"AE Attest\" ng-click=$ctrl.showAttestment() permission permission-only=\"'COMPANY_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>assignment</md-icon> AE Attest </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Update Shipping Data\" ng-click=$ctrl.showUsages(true) permission permission-only=\"['USER','COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>sync</md-icon> Update Shipping Data </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add Company\" ng-click=$ctrl.showCompanyAdd() permission permission-only=\"'SYS_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Company </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add User\" ng-click=$ctrl.showUserAdd() permission permission-only=\"'SYS_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add User </md-button> <md-button class=\"md-button-lg md-raised md-accent\" aria-label=\"Add Regulator\" ng-click=$ctrl.showRegulatorAdd() permission permission-only=\"'SYS_ADMIN'\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Regulator </md-button> </section> <section layout=row layout-padding layout-wrap permission permission-only=\"['USER','COMPANY_ADMIN']\"> <alert flex=100 layout=column flex-gt-md=60 flex-order=1 alerts=$ctrl.alerts on-alert-clicked=$ctrl.alertClicked($event)> </alert> <message layout=column flex=100 flex-gt-md=40 flex-order=2 permission permission-only=\"['USER','COMPANY_ADMIN']\" content=$ctrl.adminMessage title=\"NASC Message\"> </message> <md-card flex=100 flex-gt-md=60 flex-order=4 flex-order-gt-md=3 ng-if=false> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>User Reports</span> </div> </md-toolbar> <section layout=column layout-padding> <section layout=column layout-gt-lg=row> <md-input-container class=md-block flex-gt-lg=33 flex=100> <label>Report Type</label> <md-select ng-model=$ctrl.selectedReportType> <md-option ng-repeat=\"reportType in $ctrl.reportTypes\" value={{reportType}}> {{reportType}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-lg=33 flex=100> <label>Product Category</label> <md-select ng-model=$ctrl.selectedProductCategory> <md-option ng-repeat=\"category in $ctrl.productCategories\" value={{category.name}}> {{category.name}} </md-option> </md-select> </md-input-container> <div flex hide-sm hide-xs></div> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.refreshReport() aria-label=\"Refresh Report\"> Refresh Report </md-button> </section> </section> <div layout=column flex> <highchart id=marketTrendRpt config=$ctrl.chartConfig flex></highchart> </div> </md-card> <div flex=100 flex-gt-md=60 flex-order=4 flex-order-gt-md=3></div> <message layout=column flex=100 flex-gt-md=40 flex-order=3 flex-order-gt-md=4 permission permission-only=\"['USER','COMPANY_ADMIN']\" content=$ctrl.companyMessage title=\"Company Message\"> <action-buttons> <md-button class=\"md-accent md-fab md-mini\" permission permission-only=\"'COMPANY_ADMIN'\" ng-click=\"$ctrl.showEditMessage('COMPANY')\"> <md-tooltip md-direction=top>Edit Company Message</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> </action-buttons> </message> </section> <section layout=row layout-padding layout-wrap permission permission-only=\"'SYS_ADMIN'\"> <alert layout=column flex=100 flex-gt-md=60 alerts=$ctrl.alerts on-alert-clicked=$ctrl.alertClicked($event)> </alert> <message layout=column flex=100 flex-gt-md=40 ng-if=$ctrl.adminMessage content=$ctrl.adminMessage title=\"NASC Message\"> <action-buttons> <md-button class=\"md-accent md-fab md-mini\" ng-click=\"$ctrl.showEditMessage('SYSTEM')\" permission permission-only=\"'SYS_ADMIN'\"> <md-tooltip md-direction=top>Edit NASC Message</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> </action-buttons> </message> </section> </section>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _message = __webpack_require__(625);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.dashboard.message', []).component('message', _message2.default).name;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _message = __webpack_require__(626);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _message2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    content: '<',
	    title: '@'
	  },
	  controller: function MessageComponent() {
	    'ngInject';
	
	    _classCallCheck(this, MessageComponent);
	  }
	};

/***/ },
/* 626 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/dashboard/message/message.html';
	var html = "<md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.title}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <p flex class=md-body-1>{{$ctrl.content || 'There is currently no message configured.'}}</p> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messageEdit = __webpack_require__(628);
	
	var _messageEdit2 = _interopRequireDefault(_messageEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.dashboard.message-edit', []).component('messageEdit', _messageEdit2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messageEdit = __webpack_require__(629);
	
	var _messageEdit2 = _interopRequireDefault(_messageEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _messageEdit2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    message: '<',
	    title: '<',
	    onMessageChanged: '&'
	  },
	  controller: function () {
	    MessageEditComponent.$inject = ["EventEmitter"];
	    function MessageEditComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, MessageEditComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(MessageEditComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onMessageChanged(this.EventEmitter({
	          message: this.message
	        }));
	      }
	    }]);
	
	    return MessageEditComponent;
	  }()
	};

/***/ },
/* 629 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/dashboard/message-edit/message-edit.html';
	var html = "<form name=$ctrl.messageForm flex novalidate> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.title}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <md-input-container class=md-block flex=100> <label>Please enter the message below:</label> <textarea ng-model=$ctrl.message required name=message md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow></textarea> <div ng-messages=$ctrl.messageForm.message.$error md-auto-hide=false> <div ng-message=required> Message is required. </div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-disabled=!$ctrl.messageForm.$valid ng-click=$ctrl.onSubmit()> Save Changes </md-button> </div> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 630 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _product = __webpack_require__(632);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _copy = __webpack_require__(634);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	var _information = __webpack_require__(637);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _loadingAdminForm = __webpack_require__(643);
	
	var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);
	
	var _loadingAdminList = __webpack_require__(646);
	
	var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);
	
	var _maintenanceAdminForm = __webpack_require__(649);
	
	var _maintenanceAdminForm2 = _interopRequireDefault(_maintenanceAdminForm);
	
	var _maintenanceAdminList = __webpack_require__(652);
	
	var _maintenanceAdminList2 = _interopRequireDefault(_maintenanceAdminList);
	
	var _ingredientForm = __webpack_require__(655);
	
	var _ingredientForm2 = _interopRequireDefault(_ingredientForm);
	
	var _ingredientList = __webpack_require__(658);
	
	var _ingredientList2 = _interopRequireDefault(_ingredientList);
	
	var _signOff = __webpack_require__(661);
	
	var _signOff2 = _interopRequireDefault(_signOff);
	
	var _usageData = __webpack_require__(664);
	
	var _usageData2 = _interopRequireDefault(_usageData);
	
	__webpack_require__(667);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product', [_angularUiRouter2.default, _copy2.default, _information2.default, _loadingAdminForm2.default, _loadingAdminList2.default, _maintenanceAdminForm2.default, _maintenanceAdminList2.default, _ingredientForm2.default, _ingredientList2.default, _signOff2.default, _usageData2.default]).component('product', _product2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('productEdit', {
	    parent: 'app',
	    url: '/products/{id:int}',
	    component: 'product',
	    resolve: {
	      product: ["$stateParams", "ProductService", function product($stateParams, ProductService) {
	        return ProductService.getProduct($stateParams.id).then(function (r) {
	          return r.data;
	        });
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      // TODO: Refactor to OData call
	      categories: ["ProductService", function categories(ProductService) {
	        return ProductService.getCategories().then(function (r) {
	          return r.data;
	        });
	      }],
	      frequencies: ["ProductService", function frequencies(ProductService) {
	        return ProductService.getFrequencies().then(function (r) {
	          return r.data.map(function (f) {
	            var obj = {};
	            obj.Name = f.Name;
	            obj.Value = +f.Value;
	            return obj;
	          });
	        });
	      }],
	      administrationUnits: ["ProductService", function administrationUnits(ProductService) {
	        return ProductService.getAdministrationUnitsForSupplements().then(function (r) {
	          return r.data;
	        });
	      }],
	      weightUnits: ["ProductService", function weightUnits(ProductService) {
	        return ProductService.getWeightUnits().then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  }).state('productCreate', {
	    parent: 'app',
	    url: '/products/create',
	    component: 'product',
	    resolve: {
	      product: ["currentUser", function product(currentUser) {
	        return {
	          ProductId: 0,
	          MemberId: currentUser.MemberId
	        };
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      // TODO: Refactor to OData call
	      categories: ["ProductService", function categories(ProductService) {
	        return ProductService.getCategories().then(function (r) {
	          return r.data;
	        });
	      }],
	      frequencies: ["ProductService", function frequencies(ProductService) {
	        return ProductService.getFrequencies().then(function (r) {
	          return r.data.map(function (f) {
	            var obj = {};
	            obj.Name = f.Name;
	            obj.Value = +f.Value;
	            return obj;
	          });
	        });
	      }],
	      administrationUnits: ["ProductService", function administrationUnits(ProductService) {
	        return ProductService.getAdministrationUnitsForSupplements().then(function (r) {
	          return r.data;
	        });
	      }],
	      weightUnits: ["ProductService", function weightUnits(ProductService) {
	        return ProductService.getWeightUnits().then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _product = __webpack_require__(633);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _product2.default,
	  bindings: {
	    product: '<',
	    productLabel: '<',
	    animalTypes: '<',
	    categories: '<',
	    frequencies: '<',
	    administrationUnits: '<',
	    weightUnits: '<'
	  },
	  controller: function () {
	    ProductComponent.$inject = ["$mdDialog", "$scope", "$state", "ameLightbox", "AuthService", "ArrayService", "IngredientService", "LoadingService", "ProductService", "ToastService", "Upload"];
	    function ProductComponent($mdDialog, $scope, $state, ameLightbox, AuthService, ArrayService, IngredientService, LoadingService, ProductService, ToastService, Upload) {
	      'ngInject';
	
	      _classCallCheck(this, ProductComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        ameLightbox: ameLightbox,
	        ArrayService: ArrayService,
	        AuthService: AuthService,
	        IngredientService: IngredientService,
	        LoadingService: LoadingService,
	        ProductService: ProductService,
	        ToastService: ToastService,
	        Upload: Upload
	      });
	    }
	
	    _createClass(ProductComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        // Make sure we're on the right page for the product type
	        if (this.product.IsTreat) {
	          this.$state.go('treatProductEdit', { id: this.product.ProductId }, { reload: true });
	          return;
	        }
	
	        this.product.tblDoses = this.product.tblDoses || [];
	        this.product.tblUsages = this.product.tblUsages || [];
	        this.selectedLoadingAdministrations = [];
	        this.selectedMaintenanceAdministrations = [];
	        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, this.product.DateIntroduced, this.product.tblUsages);
	
	        this.selectedIngredients = [];
	        this.labelChanged = false;
	        this.duplicateAdministration = false;
	        this.product.tblProduct_UserIngredient = this.product.tblProduct_UserIngredient || [];
	
	        this.maxDate = new Date();
	
	        this.copyAreas = ['Product Information', 'Administrations', 'Product Ingredients']; // CG 11/15/2023 removed Usage Data from this list. We should not copy Usage between products.
	      }
	    }, {
	      key: 'onLoadingDoseRequiredChanged',
	      value: function onLoadingDoseRequiredChanged($event) {
	        if ($event && !$event.loadingDoseRequired) {
	          this.product.tblDoses = this.product.tblDoses.filter(function (d) {
	            return d.Isloading === false;
	          });
	        }
	      }
	    }, {
	      key: 'signOff',
	      value: function signOff() {
	        var _this = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          productId: this.product.ProductId,
	          units: this.unitPerContainer,
	          chosenUnits: this.chosenUnits,
	          isTreat: false,
	          onSignedOff: function onSignedOff($event) {
	            return _this.onSignedOff($event);
	          }
	        });
	
	        if (this.product.tblProduct_UserIngredient.length === 0) {
	          this.ToastService.showWarning('Must specify Ingredients before signing off');
	        } else if (this.product.tblDoses.length === 0) {
	          this.ToastService.showWarning('Must specify Directions for Use before signing off');
	        } else {
	          this.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: '\n            <md-dialog class="flex-50">\n              <md-dialog-content>\n                <dialog-close/>\n                <sign-off product-id="productId"\n                  units="units" chosen-units="chosenUnits"\n                  is-treat="false"\n                  on-signed-off="onSignedOff($event)">\n                </sign-off>\n              </md-dialog-content>\n            </md-dialog>\n            '
	          });
	        }
	      }
	    }, {
	      key: 'saveProduct',
	      value: function saveProduct() {
	        var _this2 = this;
	
	        var promise = void 0;
	        if (this.product.ProductId) {
	          promise = this.ProductService.update(this.product);
	        } else {
	          promise = this.ProductService.create(this.product);
	        }
	
	        return promise.then(function (r) {
	          _this2.product.ProductId = _this2.product.ProductId || r.data.Id;
	        }).then(function () {
	          return _this2.saveProductLabel();
	        });
	      }
	    }, {
	      key: 'onSignedOff',
	      value: function onSignedOff(_ref) {
	        var _this3 = this;
	
	        var signature = _ref.signature;
	
	        if (signature) {
	          this.LoadingService.start();
	          this.saveProduct().then(function () {
	            return _this3.ProductService.signOff(_this3.product.ProductId, signature);
	          }).then(function () {
	            _this3.$mdDialog.hide();
	            _this3.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_ADDED);
	            _this3.$state.go('productEdit', { id: _this3.product.ProductId }, { reload: true });
	          }).catch(function (error) {
	            return _this3.ToastService.showError(error);
	          }).finally(function () {
	            return _this3.LoadingService.stop();
	          });
	        }
	      }
	    }, {
	      key: 'showCopy',
	      value: function showCopy() {
	        var _this4 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          copyAreas: this.copyAreas,
	          isTreat: false,
	          onCopied: function onCopied($event) {
	            return _this4.onCopied($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-copy copy-areas="copyAreas" is-treat="isTreat"\n                on-copied="onCopied($event)">\n              </product-copy>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onCopied',
	      value: function onCopied($event) {
	        var _this5 = this;
	
	        var selectedCopyAreas = $event.copyAreas;
	
	        this.ProductService.getProduct($event.product.ProductId).then(function (p) {
	          var copyFromProduct = p.data;
	
	          if (selectedCopyAreas && selectedCopyAreas.length) {
	            _this5.product = _extends({}, _this5.ProductService.copyProduct(_this5.product, copyFromProduct, selectedCopyAreas));
	          }
	
	          _this5.ToastService.showSuccess(_messages.PRODUCT_COPIED);
	          _this5.$mdDialog.hide();
	        }).catch(function (error) {
	          return _this5.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'dateFirstSoldChanged',
	      value: function dateFirstSoldChanged($event) {
	        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, $event.dateFirstSold, this.product.tblUsages);
	      }
	    }, {
	      key: 'saveChanges',
	      value: function saveChanges() {
	        var _this6 = this;
	
	        var saveMessage = this.product.ProductId ? _messages.PRODUCT_EDITED : _messages.PRODUCT_ADDED;
	        this.LoadingService.start();
	        this.saveProduct().then(function () {
	          _this6.ToastService.showSuccess(saveMessage);
	          _this6.$state.go('productEdit', { id: _this6.product.ProductId }, { reload: true });
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        }).finally(function () {
	          return _this6.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'saveProductLabel',
	      value: function saveProductLabel() {
	        if (this.productLabel && this.productLabel instanceof File) {
	          return this.ProductService.uploadLabel(this.product.ProductId, this.productLabel);
	        }
	
	        return Promise.resolve(true);
	      }
	    }, {
	      key: 'setLabelImage',
	      value: function setLabelImage(_ref2) {
	        var productLabel = _ref2.productLabel;
	
	        this.productLabel = productLabel;
	
	        if (productLabel) {
	          this.ToastService.showSuccess(_messages.PRODUCT_LABEL_CHANGED);
	        }
	      }
	    }, {
	      key: 'onAdministrationAdded',
	      value: function onAdministrationAdded(_ref3) {
	        var administration = _ref3.administration,
	            shouldClose = _ref3.shouldClose;
	
	        if (administration) {
	          this.product.tblDoses = this.ArrayService.add(this.product.tblDoses, administration);
	
	          this.ToastService.showSuccess(_messages.ADMINISTRATION_ADDED);
	          if (shouldClose) {
	            this.$mdDialog.hide();
	          }
	        }
	      }
	    }, {
	      key: 'onAdministrationEdited',
	      value: function onAdministrationEdited(_ref4) {
	        var administration = _ref4.administration,
	            index = _ref4.index;
	
	        if (administration && index !== null) {
	          this.product.tblDoses = this.ArrayService.update(this.product.tblDoses, administration, index);
	
	          this.ToastService.showSuccess(_messages.ADMINISTRATION_EDITED);
	          this.$mdDialog.hide();
	          this.selectedLoadingAdministrations = [];
	          this.selectedMaintenanceAdministrations = [];
	        }
	      }
	    }, {
	      key: 'maintenanceAdministrationAdd',
	      value: function maintenanceAdministrationAdd() {
	        var _this7 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: undefined,
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          units: this.unitPerContainer,
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          administrationChanged: function administrationChanged($event) {
	            return _this7.onAdministrationAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <maintenance-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Add Administration"\n                show-additional-button="true"\n                administration-changed="administrationChanged($event)">\n              </maintenance-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'maintenanceAdministrationEdit',
	      value: function maintenanceAdministrationEdit(administration) {
	        var _this8 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: _angular2.default.copy(administration),
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          units: this.unitPerContainer,
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          index: this.product.tblDoses.indexOf(administration),
	          administrationChanged: function administrationChanged($event) {
	            return _this8.onAdministrationEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <maintenance-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                administration-changed="administrationChanged($event)"\n                index="index">\n              </maintenance-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'maintenanceAdministrationDelete',
	      value: function maintenanceAdministrationDelete(administrations) {
	        var _this9 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected maintenance administration(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          try {
	            for (var i = administrations.length - 1; i >= 0; i -= 1) {
	              _this9.product.tblDoses = _this9.ArrayService.remove(_this9.product.tblDoses, administrations[i]);
	            }
	
	            _this9.ToastService.showSuccess(_messages.ADMINISTRATION_DELETED);
	            _this9.selectedMaintenanceAdministrations = [];
	          } catch (e) {
	            _this9.ToastService.showError();
	          }
	        });
	      }
	    }, {
	      key: 'loadingAdministrationAdd',
	      value: function loadingAdministrationAdd() {
	        var _this10 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: undefined,
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          administrationChanged: function administrationChanged($event) {
	            return _this10.onAdministrationAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <loading-admin-form\n                administration="administration"\n                administrations="administrations"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Add Administration"\n                show-additional-button="true"\n                administration-changed="administrationChanged($event)">\n              </loading-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'loadingAdministrationEdit',
	      value: function loadingAdministrationEdit(administration) {
	        var _this11 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: _angular2.default.copy(administration),
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          index: this.product.tblDoses.indexOf(administration),
	          administrationChanged: function administrationChanged($event) {
	            return _this11.onAdministrationEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <loading-admin-form\n                administration="administration"\n                administrations="administrations"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                index="index"\n                administration-changed="administrationChanged($event)">\n              </loading-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'loadingAdministrationDelete',
	      value: function loadingAdministrationDelete(administrations) {
	        var _this12 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected loading administration(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          try {
	            for (var i = administrations.length - 1; i >= 0; i -= 1) {
	              _this12.product.tblDoses = _this12.ArrayService.remove(_this12.product.tblDoses, administrations[i]);
	            }
	
	            _this12.ToastService.showSuccess(_messages.ADMINISTRATION_DELETED);
	            _this12.selectedLoadingAdministrations = [];
	          } catch (e) {
	            _this12.ToastService.showError();
	          }
	        });
	      }
	    }, {
	      key: 'onIngredientAdded',
	      value: function onIngredientAdded(_ref5) {
	        var ingredient = _ref5.ingredient,
	            shouldClose = _ref5.shouldClose;
	
	        if (ingredient) {
	          this.product.tblProduct_UserIngredient = this.ArrayService.add(this.product.tblProduct_UserIngredient, ingredient);
	          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_ADDED);
	          if (shouldClose) {
	            this.$mdDialog.hide();
	          }
	        }
	      }
	    }, {
	      key: 'onIngredientEdited',
	      value: function onIngredientEdited(_ref6) {
	        var ingredient = _ref6.ingredient,
	            index = _ref6.index;
	
	        if (ingredient && index !== null) {
	          this.product.tblProduct_UserIngredient = this.ArrayService.update(this.product.tblProduct_UserIngredient, ingredient, index);
	          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_EDITED);
	          this.$mdDialog.hide();
	          this.selectedIngredients = [];
	        }
	      }
	    }, {
	      key: 'ingredientAdd',
	      value: function ingredientAdd() {
	        var _this13 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          companyId: this.product.MemberId,
	          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
	          unitsDisplay: this.unitsDisplay,
	          weightUnits: this.weightUnits,
	          ingredientChanged: function ingredientChanged($event) {
	            return _this13.onIngredientAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Add Ingredient"\n                show-additional-button="true"\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientEdit',
	      value: function ingredientEdit(ingredient) {
	        var _this14 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredient: _angular2.default.copy(ingredient),
	          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
	          companyId: this.product.MemberId,
	          index: this.product.tblProduct_UserIngredient.indexOf(ingredient),
	          unitsDisplay: this.unitsDisplay,
	          weightUnits: this.weightUnits,
	          ingredientChanged: function ingredientChanged($event) {
	            return _this14.onIngredientEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredient="ingredient"\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)"\n                index="index">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientDelete',
	      value: function ingredientDelete(ingredients) {
	        var _this15 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected ingredient(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          try {
	            for (var i = ingredients.length - 1; i >= 0; i -= 1) {
	              _this15.product.tblProduct_UserIngredient = _this15.ArrayService.remove(_this15.product.tblProduct_UserIngredient, ingredients[i]);
	            }
	
	            _this15.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_DELETED);
	            _this15.selectedIngredients = [];
	          } catch (e) {
	            _this15.ToastService.showError();
	          }
	        });
	      }
	    }, {
	      key: 'unitsDisplay',
	      get: function get() {
	        return this.ProductService.getUnitsDisplay(this.product);
	      }
	    }, {
	      key: 'unitPerContainer',
	      get: function get() {
	        return this.product.UnitPerContainer;
	      }
	    }, {
	      key: 'chosenUnits',
	      get: function get() {
	        return this.product.ProductForm;
	      }
	    }, {
	      key: 'labelValid',
	      get: function get() {
	        return this.productLabel || this.product.FileLabelName;
	      }
	    }, {
	      key: 'shouldBeLocked',
	      get: function get() {
	        if (this.AuthService.isSysAdmin) {
	          return false;
	        }
	
	        return this.product.Signature && this.product.Signature.length > 0;
	      }
	    }]);
	
	    return ProductComponent;
	  }()
	};

/***/ },
/* 633 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/product.html';
	var html = "<ng-form name=$ctrl.productForm flex layout=column novalidate> <div flex layout=column> <div layout-padding> <information administration-units=::$ctrl.administrationUnits categories=::$ctrl.categories copy-areas=::$ctrl.copyAreas product=$ctrl.product units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer on-loading-dose-required-changed=$ctrl.onLoadingDoseRequiredChanged($event) on-date-first-sold-changed=$ctrl.dateFirstSoldChanged($event) show-header=true view-only=false locked=::$ctrl.shouldBeLocked on-product-label-changed=$ctrl.setLabelImage($event) label-valid=$ctrl.labelValid> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-raised md-accent no-print\" aria-label=\"Copy Existing Product\" ng-if=::!$ctrl.product.ProductId ng-click=$ctrl.showCopy() permission permission-except=\"'SYS_ADMIN'\"> <md-icon md-font-set=material-icons>content_copy</md-icon> Copy Existing Product </md-button> </action-buttons> </information> <loading-admin-list administrations=$ctrl.product.tblDoses selected-administrations=$ctrl.selectedLoadingAdministrations ng-show=$ctrl.product.HasLoading units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer show-header=true locked=::$ctrl.shouldBeLocked> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.loadingAdministrationAdd()> <md-tooltip md-direction=top>Add Loading Administration</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedLoadingAdministrations && $ctrl.selectedLoadingAdministrations.length === 1\" ng-click=$ctrl.loadingAdministrationEdit($ctrl.selectedLoadingAdministrations[0])> <md-tooltip md-direction=top>Edit Loading Administration</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedLoadingAdministrations && $ctrl.selectedLoadingAdministrations.length\" ng-click=$ctrl.loadingAdministrationDelete($ctrl.selectedLoadingAdministrations)> <md-tooltip md-direction=top>Delete Loading Administration(s)</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </action-buttons> </loading-admin-list> <maintenance-admin-list administrations=$ctrl.product.tblDoses selected-administrations=$ctrl.selectedMaintenanceAdministrations units=$ctrl.unitPerContainer units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer show-header=true locked=::$ctrl.shouldBeLocked> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.maintenanceAdministrationAdd()> <md-tooltip md-direction=top>Add Maintenance Administration</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedMaintenanceAdministrations && $ctrl.selectedMaintenanceAdministrations.length === 1\" ng-click=$ctrl.maintenanceAdministrationEdit($ctrl.selectedMaintenanceAdministrations[0])> <md-tooltip md-direction=top>Edit Maintenance Administration</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedMaintenanceAdministrations && $ctrl.selectedMaintenanceAdministrations.length\" ng-click=$ctrl.maintenanceAdministrationDelete($ctrl.selectedMaintenanceAdministrations)> <md-tooltip md-direction=top>Delete Maintenance Administration(s)</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </action-buttons> </maintenance-admin-list> <product-ingredient-list ingredients=$ctrl.product.tblProduct_UserIngredient selected-ingredients=$ctrl.selectedIngredients show-header=true units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer locked=::$ctrl.shouldBeLocked> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.ingredientAdd()> <md-tooltip md-direction=top>Add Ingredient</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length === 1\" ng-click=$ctrl.ingredientEdit($ctrl.selectedIngredients[0])> <md-tooltip md-direction=top>Edit Ingredient</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length\" ng-click=$ctrl.ingredientDelete($ctrl.selectedIngredients)> <md-tooltip md-direction=top>Delete Ingredient</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </action-buttons> </product-ingredient-list> <usage-data usages=$ctrl.product.tblUsages show-guidance=true show-header=true locked=::$ctrl.shouldBeLocked> </usage-data> </div> </div> </ng-form> <footer class=no-print> <div layout=column layout-align=\"center center\"> <div ng-messages=\"$ctrl.productForm.$error || !$ctrl.labelValid\" style=color:#b53b0a;text-align:center> <div ng-message-exp=\"['minlength', 'maxlength', 'required']\"> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please ensure that all required fields are provided before saving. </div> <div ng-message=error> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please resolve all validation errors before saving. </div> <div ng-show=!$ctrl.labelValid> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please ensure that the product label is added before saving. </div> </div> <div layout=row flex> <md-button class=\"md-raised md-accent md-button-md\" aria-label=\"Save Product\" ng-click=$ctrl.saveChanges() ng-disabled=\"!$ctrl.productForm.$valid || !$ctrl.labelValid\"> <md-icon md-font-set=material-icons>save</md-icon>Save Product </md-button> <md-button class=\"md-raised md-accent md-button-md\" aria-label=\"Sign Off\" ng-click=$ctrl.signOff() ng-disabled=\"!$ctrl.productForm.$valid || !$ctrl.labelValid\" ng-if=::!$ctrl.shouldBeLocked permission permission-only=\"'COMPANY_ADMIN'\"> <md-icon md-font-set=material-icons>lock</md-icon>Sign Off </md-button> </div> </div> </footer>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _copy = __webpack_require__(635);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.copy', []).component('productCopy', _copy2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _copy = __webpack_require__(636);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _copy2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    copyAreas: '<',
	    isTreat: '<',
	    onCopied: '&'
	  },
	  controller: function () {
	    CopyComponent.$inject = ["EventEmitter", "ProductService"];
	    function CopyComponent(EventEmitter, ProductService) {
	      'ngInject';
	
	      _classCallCheck(this, CopyComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter, ProductService: ProductService });
	    }
	
	    _createClass(CopyComponent, [{
	      key: 'searchProductsByNameForCopy',
	      value: function searchProductsByNameForCopy(name, isTreat) {
	        return this.ProductService.searchProductsByNameForCopy(name, isTreat).then(function (p) {
	          return p.data;
	        });
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onCopied(this.EventEmitter({
	          product: this.selectedProduct,
	          copyAreas: this.selectedCopyAreas
	        }));
	      }
	    }]);
	
	    return CopyComponent;
	  }()
	};

/***/ },
/* 636 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/copy/copy.html';
	var html = "<form name=$ctrl.copyProductForm novalidate> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Copy Product</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <md-autocomplete flex=100 md-selected-item=$ctrl.selectedProduct md-search-text=$ctrl.productSearchText md-items=\"item in $ctrl.searchProductsByNameForCopy($ctrl.productSearchText, $ctrl.isTreat)\" md-item-text=item.ProductName md-min-length=2 md-floating-label=\"Product to Copy\" name=selectedProduct required> <md-item-template> <span md-highlight-text=$ctrl.productSearchText md-highlight-flags=^i>{{item.ProductName}}</span> </md-item-template> <md-not-found> No products matching \"{{$ctrl.productSearchText}}\" were found. </md-not-found> <div ng-messages=$ctrl.copyProductForm.selectedProduct.$error md-auto-hide=false> <div ng-message=required> Product selection is required. </div> </div> </md-autocomplete> <md-input-container class=md-block flex=100> <label>Choose which information you wish to copy:</label> <md-select ng-model=$ctrl.selectedCopyAreas name=copyAreas multiple=multiple required> <md-option ng-repeat=\"copy in $ctrl.copyAreas\" value={{copy}}> {{copy}} </md-option> </md-select> <div ng-messages=$ctrl.copyProductForm.copyAreas.$error md-auto-hide=false> <div ng-message=required> Copy selection is required. </div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <div> <b>Important Note:</b> When copying an existing product because of a formulation change, please remember for “Date First Sold” you will choose the date the new product formula was first shipped to market. </div> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.copyProductForm.$valid ng-click=$ctrl.onSubmit()> Copy Product </md-button> </div> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _information = __webpack_require__(638);
	
	var _information2 = _interopRequireDefault(_information);
	
	var _productLabelDownload = __webpack_require__(640);
	
	var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.information', [_productLabelDownload2.default]).component('information', _information2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _information = __webpack_require__(639);
	
	var _information2 = _interopRequireDefault(_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _information2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administrationUnits: '<',
	    categories: '<',
	    copyAreas: '<',
	    onProductLabelChanged: '&',
	    locked: '<',
	    viewOnly: '<',
	    product: '<',
	    unitsDisplay: '<',
	    onLoadingDoseRequiredChanged: '&',
	    onDateFirstSoldChanged: '&',
	    showHeader: '<',
	    labelValid: '<'
	  },
	  controller: function () {
	    InformationComponent.$inject = ["EventEmitter"];
	    function InformationComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, InformationComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(InformationComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.labelChanged = false;
	        this.maxDate = new Date();
	      }
	    }, {
	      key: 'loadingDoseRequiredChanged',
	      value: function loadingDoseRequiredChanged(required) {
	        this.onLoadingDoseRequiredChanged(this.EventEmitter({
	          loadingDoseRequired: required
	        }));
	      }
	    }, {
	      key: 'dateFirstSoldChanged',
	      value: function dateFirstSoldChanged(dateFirstSold) {
	        this.onDateFirstSoldChanged(this.EventEmitter({
	          dateFirstSold: dateFirstSold
	        }));
	      }
	    }, {
	      key: 'productLabelChanged',
	      value: function productLabelChanged(_ref) {
	        var productLabel = _ref.productLabel;
	
	        this.labelChanged = true;
	        this.onProductLabelChanged(this.EventEmitter({
	          productLabel: productLabel
	        }));
	      }
	    }]);
	
	    return InformationComponent;
	  }()
	};

/***/ },
/* 639 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/information/information.html';
	var html = "<ng-form name=$ctrl.productInformationForm flex=100> <md-card> <md-toolbar ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Product Information</span> <md-icon md-font-set=material-icons class=warning ng-show=\"$ctrl.productInformationForm.$invalid || !$ctrl.labelValid\">error</md-icon> <span flex></span> <md-icon ng-show=\"::$ctrl.locked && !$ctrl.viewOnly\" style=color:#f9eaa4 md-font-set=material-icons>lock</md-icon> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding ng-if=\"::$ctrl.locked && !$ctrl.viewOnly\"> <p class=md-body-1 style=background-color:#f9eaa4> <b>This product is signed off and locked.</b> You can only modify the Product Name, SKU, UPC and label. If you wish to modify anything more than that, you will need to contact your account manager.<br/>To update shipping data, return to the product list and click “Update Shipping”, or if you need to update multiple products at once, go the dashboard and click “Update Shipping Data”. </p> </div> <div layout-padding> <div flex=100 layout-sm=column layout=row layout-wrap class=gutter> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Select one or more Product Categories</label> <md-select multiple=multiple required ng-model=$ctrl.product.ProductCategoryIds name=category ng-disabled=::$ctrl.locked> <md-option ng-repeat=\"category in $ctrl.categories\" value={{category.id}}> {{category.name}} </md-option> </md-select> <div ng-messages=$ctrl.productInformationForm.category.$error md-auto-hide=true> <div ng-message=required> Product category is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-md=50> <label>Date First Sold</label> <md-datepicker ng-model=$ctrl.product.DateIntroduced md-max-date=$ctrl.maxDate ng-change=$ctrl.dateFirstSoldChanged($ctrl.product.DateIntroduced) required name=dateIntroduced ng-disabled=::$ctrl.locked md-current-view=year> </md-datepicker> <div ng-messages=$ctrl.productInformationForm.dateIntroduced.$error md-auto-hide=false> <div ng-message=valid>Date first sold must be a valid date.</div> <div ng-message=required> Date first sold is required. </div> <div ng-message=maxdate> Date first sold cannot exceed current date. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Product Name</label> <input ng-model=$ctrl.product.ProductName name=productName required ng-disabled=::$ctrl.viewOnly> <div ng-messages=$ctrl.productInformationForm.productName.$error md-auto-hide=true> <div ng-message=required> Product name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=50 flex-gt-md=25> <label>Product SKU#</label> <input ng-model=$ctrl.product.SKU name=sku required ng-disabled=::$ctrl.viewOnly> <div ng-messages=$ctrl.productInformationForm.sku.$error md-auto-hide=true> <div ng-message=required> SKU# is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=50 flex-gt-md=25> <label>Product UPC#</label> <input ng-model=$ctrl.product.UPC name=upc ng-disabled=::$ctrl.viewOnly> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>What is the administration unit of the product?</label> <md-select required ng-model=$ctrl.product.ProductForm name=productForm ng-disabled=::$ctrl.locked> <md-option ng-repeat=\"unit in $ctrl.administrationUnits\" value={{unit.Name}}> {{unit.Name}} </md-option> </md-select> <div ng-messages=$ctrl.productInformationForm.productForm.$error md-auto-hide=false> <div ng-message=required> Administration unit is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>How many <span style=color:#000;font-weight:700>{{$ctrl.unitsDisplay}}</span> are there in a container?</label> <input ng-model=$ctrl.product.UnitPerContainer required name=unitPerContainer type=number ng-disabled=::$ctrl.locked> <div ng-messages=$ctrl.productInformationForm.unitPerContainer.$error md-auto-hide=false> <div ng-message=required> Units per container is required. </div> <div ng-message=number> Units per container must be numeric. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Warnings</label> <textarea ng-model=$ctrl.product.WarningNote md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow name=warningNote ng-disabled=::$ctrl.locked class=no-print>\r\n            </textarea> <p class=\"print-only md-body-1\">{{$ctrl.product.WarningNote}}</p> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Suggested Use</label> <textarea ng-model=$ctrl.product.FeedingNote md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow name=suggestedUse ng-disabled=::$ctrl.locked class=no-print>\r\n          </textarea> <p class=\"print-only md-body-1\">{{$ctrl.product.FeedingNote}}</p> </md-input-container> <md-input-container class=\"md-block md-input-has-value\" flex=100 flex-gt-md=50> <label>Is a loading dose required?</label> <md-radio-group ng-model=$ctrl.product.HasLoading ng-change=$ctrl.loadingDoseRequiredChanged($ctrl.product.HasLoading) ng-disabled=::$ctrl.locked> <md-radio-button ng-value=false class=md-primary>No</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <md-input-container class=\"md-block md-input-has-value\" flex=100 flex-gt-md=50 style=margin-top:70px> <label>Is this a single use item that contains approximately<br/>1-4 administrations such as a syringe (paste)<br/>or a single dental stick?</label> <md-radio-group ng-model=$ctrl.product.TakeAsNeeded ng-disabled=::$ctrl.locked> <md-radio-button ng-value=false class=md-primary>No</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <md-input-container class=\"md-block md-input-has-value\" flex=100 flex-gt-md=50 style=margin-top:40px> <label>Is this bulk product (not in retail packaging) intended<br/>for other businesses, farms, etc.?</label> <md-radio-group ng-model=$ctrl.product.IsBulkQty ng-disabled=::$ctrl.locked> <md-radio-button ng-value=false class=md-primary>No</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <md-input-container class=\"md-block md-input-has-value\" flex=100 flex-gt-md=50 style=margin-top:40px> <label>Is this a sample product (not for retail sale) designed<br/>for customers to try prior to purchase?</label> <md-radio-group ng-model=$ctrl.product.IsSample ng-disabled=::$ctrl.locked> <md-radio-button ng-value=false class=md-primary>No</md-radio-button> <md-radio-button ng-value=true class=md-primary>Yes</md-radio-button> </md-radio-group> </md-input-container> <div layout=column flex=100 flex-gt-md=50> <product-label-download product=::$ctrl.product label-changed=$ctrl.labelChanged> </product-label-download> <product-label-upload locked=::$ctrl.viewOnly on-product-label-changed=$ctrl.productLabelChanged($event) label-text=\"Upload Product Label *\" is-abbreviated=false label-class=\"md-button md-raised md-accent\" show-preview=true layout=row button-width=50> </product-label-upload> <md-input-container class=md-block flex=100 flex-gt-sm=33> <div ng-if=\"$ctrl.labelValid === undefined || $ctrl.labelValid === 'undefined'\"> <div class=md-input-message-animation> Product Label is required. </div> </div> </md-input-container> </div> </div> </div> </md-card> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productLabelDownload = __webpack_require__(641);
	
	var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.productLabelDownload', []).component('productLabelDownload', _productLabelDownload2.default).name;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _productLabelDownload = __webpack_require__(642);
	
	var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _productLabelDownload2.default,
	  bindings: {
	    product: '<',
	    labelChanged: '<'
	  },
	  controller: function () {
	    ProductLabelDownloadComponent.$inject = ["ameLightbox", "ProductsService", "ToastService"];
	    function ProductLabelDownloadComponent(ameLightbox, ProductsService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ProductLabelDownloadComponent);
	
	      Object.assign(this, {
	        ameLightbox: ameLightbox,
	        ProductsService: ProductsService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(ProductLabelDownloadComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        var _this = this;
	
	        if (this.product.FileLabelName && this.product.ProductId) {
	          if (this.product.FileLabelName.endsWith('.pdf')) {
	            this.fileType = 'pdf';
	
	            this.ProductsService.getLabel(this.product.ProductId).then(function (r) {
	              _this.download = r.data;
	            });
	          } else {
	            this.fileType = 'image';
	          }
	        }
	      }
	    }, {
	      key: 'previewLabelImage',
	      value: function previewLabelImage(productId) {
	        var _this2 = this;
	
	        this.ProductsService.getLabelImage(productId).then(function (r) {
	          _this2.ameLightbox.show([r.data], {
	            buttonClass: 'ng-hide',
	            keyboard: false,
	            showDots: false
	          });
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return ProductLabelDownloadComponent;
	  }()
	};

/***/ },
/* 642 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/information/product-label-download/product-label-download.html';
	var html = "<label style=color:rgba(0,0,0,.38)>Product Label *</label> <div ng-if=\"!$ctrl.labelChanged && $ctrl.fileType\"> <div ng-switch=$ctrl.fileType> <div ng-switch-when=image> <md-button class=md-primary ng-click=$ctrl.previewLabelImage($ctrl.product.ProductId)>{{$ctrl.product.FileLabelName}}</md-button> </div> <div ng-switch-when=pdf> <md-button class=md-primary ng-href={{$ctrl.download.DownloadUrl}} ng-if=\"$ctrl.download && $ctrl.download.DownloadUrl\">{{$ctrl.product.FileLabelName}}</md-button> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loadingAdminForm = __webpack_require__(644);
	
	var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.loadingAdminForm', []).component('loadingAdminForm', _loadingAdminForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loadingAdminForm = __webpack_require__(645);
	
	var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _loadingAdminForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administration: '<',
	    administrations: '<',
	    animalTypes: '<',
	    frequencies: '<',
	    unitsDisplay: '<',
	    submitTitle: '@',
	    administrationChanged: '&',
	    index: '<',
	    showAdditionalButton: '<'
	  },
	  controller: function () {
	    LoadingAdminFormComponent.$inject = ["AnimalTypeService", "EventEmitter"];
	    function LoadingAdminFormComponent(AnimalTypeService, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, LoadingAdminFormComponent);
	
	      Object.assign(this, { AnimalTypeService: AnimalTypeService, EventEmitter: EventEmitter });
	    }
	
	    _createClass(LoadingAdminFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit(shouldClose) {
	        var administration = _extends({
	          Isloading: true
	        }, this.administration);
	
	        if (!administration.DoseId) {
	          this.administrations.push(administration);
	        }
	
	        this.administrationChanged(this.EventEmitter({
	          administration: administration,
	          index: this.index,
	          shouldClose: shouldClose
	        }));
	
	        this.validateDuplicates();
	      }
	    }, {
	      key: 'getMinimumAnimalWeight',
	      value: function getMinimumAnimalWeight(species) {
	        return this.AnimalTypeService.minimumAnimalWeight(species);
	      }
	    }, {
	      key: 'getMaximumAnimalWeight',
	      value: function getMaximumAnimalWeight(species) {
	        return this.AnimalTypeService.maximumAnimalWeight(species);
	      }
	    }, {
	      key: 'validateDuplicates',
	      value: function validateDuplicates() {
	        var _this = this;
	
	        var isValid = true;
	
	        if (this.administration) {
	          var arrayIndex = this.administrations.findIndex(function (d) {
	            return d.Isloading === true && d.Species === _this.administration.Species && d.MinWeight === _this.administration.MinWeight && d.MaxWeight === _this.administration.MaxWeight && d.DoseAmount === _this.administration.DoseAmount && d.DosePerDay === _this.administration.DosePerDay && d.LoadingPeriod === _this.administration.LoadingPeriod;
	          });
	
	          if (arrayIndex !== -1 && arrayIndex !== this.index) {
	            isValid = false;
	          }
	        }
	
	        this.loadingAdministrationForm.$setValidity('duplicate', isValid);
	      }
	    }]);
	
	    return LoadingAdminFormComponent;
	  }()
	};

/***/ },
/* 645 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/loading-admin-form/loading-admin-form.html';
	var html = "<form name=$ctrl.loadingAdministrationForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Directions for use (Loading)</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout=row layout-sm=column layout-wrap> <md-input-container flex=100> <label>Intended Species</label> <md-select ng-model=$ctrl.administration.Species name=animalType required ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" value={{animalType.AnimalTypeName}}> {{animalType.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.loadingAdministrationForm.animalType.$error md-auto-hide=false> <div ng-message=required> Intended species is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Min. Weight (lbs)</label> <input required type=number min={{$ctrl.getMinimumAnimalWeight($ctrl.administration.Species)}} max={{$ctrl.getMaximumAnimalWeight($ctrl.administration.Species)}} name=minWeight ng-model=$ctrl.administration.MinWeight less-than=$ctrl.administration.MaxWeight ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.loadingAdministrationForm.minWeight.$error md-auto-hide=false> <div ng-message=required> Minimum weight is required. </div> <div ng-message-exp=\"['min', 'max']\"> {{ $ctrl.administration.Species || 'Animal' }} weight must be between {{ $ctrl.getMinimumAnimalWeight($ctrl.administration.Species) | number:1.2 }} and {{ $ctrl.getMaximumAnimalWeight($ctrl.administration.Species) | number:1.2 }} lbs. </div> <div ng-message=lessThan> Minimum weight must not exceed maximum weight. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Max. Weight (lbs)</label> <input required type=number name=maxWeight min={{$ctrl.getMinimumAnimalWeight($ctrl.administration.Species)}} max={{$ctrl.getMaximumAnimalWeight($ctrl.administration.Species)}} ng-model=$ctrl.administration.MaxWeight greater-than=$ctrl.administration.MinWeight ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.loadingAdministrationForm.maxWeight.$error md-auto-hide=false> <div ng-message=required> Maximum weight is required. </div> <div ng-message-exp=\"['min', 'max']\"> {{ $ctrl.administration.Species || 'Animal' }} weight must be between {{ $ctrl.getMinimumAnimalWeight($ctrl.administration.Species) | number:0 }} and {{ $ctrl.getMaximumAnimalWeight($ctrl.administration.Species) | number:0 }} lbs. </div> <div ng-message=greaterThan> Maximum weight must be less than minimum weight. </div> </div> </md-input-container> <md-input-container flex=100> <label>How many <span style=color:#000;font-weight:700>{{$ctrl.unitsDisplay}}</span> for this weight range? </label> <input required type=number name=dose ng-model=$ctrl.administration.DoseAmount ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.loadingAdministrationForm.dose.$error md-auto-hide=false> <div ng-message=required> Dose is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Administration Frequency</label> <md-select required name=frequency ng-model=$ctrl.administration.DosePerDay ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"frequency in $ctrl.frequencies\" ng-value={{frequency.Value}}> {{frequency.Name}} </md-option> </md-select> <div ng-messages=$ctrl.loadingAdministrationForm.frequency.$error md-auto-hide=false> <div ng-message=required> Administration frequency is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Loading Period (days)</label> <input required type=number name=loadingPeriod min=1 ng-model=$ctrl.administration.LoadingPeriod ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.loadingAdministrationForm.loadingPeriod.$error md-auto-hide=false> <div ng-message=required> Loading period is required. </div> <div ng-message=min> Loading period must exceed 0 days. </div> </div> </md-input-container> <div flex=100 layout-align=\"center center\"> <div ng-messages=$ctrl.loadingAdministrationForm.$error style=color:#b53b0a;text-align:center> <div ng-message=duplicate> <md-icon md-font-set=material-icons class=warning>error</md-icon> Cannot submit a duplicate administration. </div> </div> </div> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(false) ng-if=$ctrl.showAdditionalButton ng-disabled=!$ctrl.loadingAdministrationForm.$valid> {{$ctrl.submitTitle}} </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(true) ng-disabled=!$ctrl.loadingAdministrationForm.$valid> {{$ctrl.submitTitle}} and Close </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loadingAdminList = __webpack_require__(647);
	
	var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.loadingAdminList', []).component('loadingAdminList', _loadingAdminList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _loadingAdminList = __webpack_require__(648);
	
	var _loadingAdminList2 = _interopRequireDefault(_loadingAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _loadingAdminList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administrations: '<',
	    selectedAdministrations: '<',
	    unitsDisplay: '<',
	    unitPerContainer: '<',
	    locked: '<',
	    showHeader: '<'
	  },
	  controller: function () {
	    LoadingAdminListComponent.$inject = ["EventEmitter"];
	    function LoadingAdminListComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, LoadingAdminListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(LoadingAdminListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === true;
	        });
	      }
	    }, {
	      key: '$onChanges',
	      value: function $onChanges() {
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === true;
	        });
	      }
	    }]);
	
	    return LoadingAdminListComponent;
	  }()
	};

/***/ },
/* 648 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/loading-admin-list/loading-admin-list.html';
	var html = "<md-card> <md-toolbar class=\"md-table-toolbar alternate\" ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Directions for use (Loading)</span> <span ng-if=$ctrl.unitsDisplay>&nbsp;in</span> <span ng-if=$ctrl.unitsDisplay>&nbsp;{{$ctrl.unitsDisplay}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div flex ng-show=\"$ctrl.administrations && $ctrl.administrations.length\"> <md-table-container> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedAdministrations> <thead md-head> <tr md-row> <th md-column><span>Species</span></th> <th md-column><span>Min. Weight</span></th> <th md-column><span>Max. Weight</span></th> <th md-column><span>Dose</span></th> <th md-column><span>Administrations/Day</span></th> <th md-column><span>Loading Period (days)</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"administration in $ctrl.administrations | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\" md-select=administration> <td md-cell>{{administration.Species}}</td> <td md-cell>{{administration.MinWeight}}</td> <td md-cell>{{administration.MaxWeight}}</td> <td md-cell>{{administration.DoseAmount}}</td> <td md-cell>{{administration.DosePerDay}}</td> <td md-cell>{{administration.LoadingPeriod}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.administrations.length}} md-label=\"{ rowsPerPage: 'Administrations per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.administrations && $ctrl.administrations.length\"> <p class=md-body-1> There are no loading administrations currently associated with this product. </p> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _maintenanceAdminForm = __webpack_require__(650);
	
	var _maintenanceAdminForm2 = _interopRequireDefault(_maintenanceAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.maintenanceAdminForm', []).component('maintenanceAdminForm', _maintenanceAdminForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _maintenanceAdminForm = __webpack_require__(651);
	
	var _maintenanceAdminForm2 = _interopRequireDefault(_maintenanceAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _maintenanceAdminForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administration: '<',
	    administrations: '<',
	    units: '<',
	    animalTypes: '<',
	    frequencies: '<',
	    submitTitle: '@',
	    unitsDisplay: '<',
	    administrationChanged: '&',
	    index: '<',
	    showAdditionalButton: '<'
	  },
	  controller: function () {
	    MaintenanceAdminFormComponent.$inject = ["AnimalTypeService", "EventEmitter"];
	    function MaintenanceAdminFormComponent(AnimalTypeService, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, MaintenanceAdminFormComponent);
	
	      Object.assign(this, {
	        AnimalTypeService: AnimalTypeService,
	        EventEmitter: EventEmitter
	      });
	    }
	
	    _createClass(MaintenanceAdminFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit(shouldClose) {
	        var administration = _extends({
	          Isloading: false
	        }, this.administration);
	
	        if (!administration.DoseId) {
	          this.administrations.push(administration);
	        }
	
	        this.administrationChanged(this.EventEmitter({
	          administration: administration,
	          index: this.index,
	          shouldClose: shouldClose
	        }));
	
	        this.validateDuplicates();
	      }
	    }, {
	      key: 'getMinimumAnimalWeight',
	      value: function getMinimumAnimalWeight(species) {
	        return this.AnimalTypeService.minimumAnimalWeight(species);
	      }
	    }, {
	      key: 'getMaximumAnimalWeight',
	      value: function getMaximumAnimalWeight(species) {
	        return this.AnimalTypeService.maximumAnimalWeight(species);
	      }
	    }, {
	      key: 'calculateAdminDays',
	      value: function calculateAdminDays() {
	        return Math.round(this.units / (this.administration.DoseAmount * this.administration.DosePerDay));
	      }
	    }, {
	      key: 'validateDuplicates',
	      value: function validateDuplicates() {
	        var _this = this;
	
	        var isValid = true;
	
	        if (this.administration) {
	          var arrayIndex = this.administrations.findIndex(function (d) {
	            return d.Isloading === false && d.Species === _this.administration.Species && d.MinWeight === _this.administration.MinWeight && d.MaxWeight === _this.administration.MaxWeight && d.DoseAmount === _this.administration.DoseAmount && d.DosePerDay === _this.administration.DosePerDay;
	          });
	
	          if (arrayIndex !== -1 && arrayIndex !== this.index) {
	            isValid = false;
	          }
	        }
	
	        this.maintenanceAdministrationForm.$setValidity('duplicate', isValid);
	      }
	    }]);
	
	    return MaintenanceAdminFormComponent;
	  }()
	};

/***/ },
/* 651 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/maintenance-admin-form/maintenance-admin-form.html';
	var html = "<form name=$ctrl.maintenanceAdministrationForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Directions for use (Maintenance)</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout=row layout-sm=column layout-wrap> <md-input-container flex=100> <label>Intended Species</label> <md-select name=animalType ng-model=$ctrl.administration.Species required ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" value={{animalType.AnimalTypeName}}> {{animalType.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.maintenanceAdministrationForm.animalType.$error md-auto-hide=false> <div ng-message=required> Intended species is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Min. Weight (lbs)</label> <input name=minWeight ng-model=$ctrl.administration.MinWeight min={{$ctrl.getMinimumAnimalWeight($ctrl.administration.Species)}} max={{$ctrl.getMaximumAnimalWeight($ctrl.administration.Species)}} required type=number less-than=$ctrl.administration.MaxWeight ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.maintenanceAdministrationForm.minWeight.$error md-auto-hide=false> <div ng-message=required> Minimum weight is required. </div> <div ng-message-exp=\"['min', 'max']\"> {{ $ctrl.administration.Species || 'Animal' }} weight must be between {{ $ctrl.getMinimumAnimalWeight($ctrl.administration.Species) | number:1.2 }} and {{ $ctrl.getMaximumAnimalWeight($ctrl.administration.Species) | number:1.2 }} lbs. </div> <div ng-message=lessThan> Minimum weight must not exceed maximum weight. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50> <label>Max. Weight (lbs)</label> <input name=maxWeight ng-model=$ctrl.administration.MaxWeight min={{$ctrl.getMinimumAnimalWeight($ctrl.administration.Species)}} max={{$ctrl.getMaximumAnimalWeight($ctrl.administration.Species)}} required type=number greater-than=$ctrl.administration.MinWeight ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.maintenanceAdministrationForm.maxWeight.$error md-auto-hide=false> <div ng-message=required> Maximum weight is required. </div> <div ng-message-exp=\"['min', 'max']\"> {{ $ctrl.administration.Species || 'Animal' }} weight must be between {{ $ctrl.getMinimumAnimalWeight($ctrl.administration.Species) | number:0 }} and {{ $ctrl.getMaximumAnimalWeight($ctrl.administration.Species) | number:0 }} lbs. </div> <div ng-message=greaterThan> Maximum weight must be less than minimum weight. </div> </div> </md-input-container> <md-input-container flex=100> <label>How many <span style=color:#000;font-weight:700>{{$ctrl.unitsDisplay}}</span> for this weight range? </label> <input name=dose ng-model=$ctrl.administration.DoseAmount required type=number ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.maintenanceAdministrationForm.dose.$error md-auto-hide=false> <div ng-message=required> Dose is required. </div> </div> </md-input-container> <md-input-container flex=50> <label>Administration Frequency</label> <md-select name=frequency ng-model=$ctrl.administration.DosePerDay required ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"frequency in $ctrl.frequencies\" ng-value={{frequency.Value}}> {{frequency.Name}} </md-option> </md-select> <div ng-messages=$ctrl.maintenanceAdministrationForm.frequency.$error md-auto-hide=false> <div ng-message=required> Administration frequency is required. </div> </div> </md-input-container> <md-input-container flex=50> <label> <md-icon md-font-set=material-icons style=color:none!important>event</md-icon> Administration Days (calculated) </label> <input name=admin_days ng-value=\"$ctrl.administration.DosePerDay !== null\r\n        && $ctrl.administration.DosePerDay !== undefined && $ctrl.administration.DoseAmount ? $ctrl.calculateAdminDays() : ''\" ng-readonly=true> </md-input-container> <div flex=100 layout-align=\"center center\"> <div ng-messages=$ctrl.maintenanceAdministrationForm.$error style=color:#b53b0a;text-align:center> <div ng-message=duplicate> <md-icon md-font-set=material-icons class=warning>error</md-icon> Cannot submit a duplicate administration. </div> </div> </div> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(false) ng-if=$ctrl.showAdditionalButton ng-disabled=!$ctrl.maintenanceAdministrationForm.$valid> {{$ctrl.submitTitle}} </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(true) ng-disabled=!$ctrl.maintenanceAdministrationForm.$valid> {{$ctrl.submitTitle}} and Close </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _maintenanceAdminList = __webpack_require__(653);
	
	var _maintenanceAdminList2 = _interopRequireDefault(_maintenanceAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.maintenanceAdminList', []).component('maintenanceAdminList', _maintenanceAdminList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _maintenanceAdminList = __webpack_require__(654);
	
	var _maintenanceAdminList2 = _interopRequireDefault(_maintenanceAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _maintenanceAdminList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administrations: '<',
	    selectedAdministrations: '<',
	    units: '<',
	    unitsDisplay: '<',
	    unitPerContainer: '<',
	    locked: '<',
	    showHeader: '<'
	  },
	  controller: function () {
	    MaintenanceAdminListComponent.$inject = ["EventEmitter"];
	    function MaintenanceAdminListComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, MaintenanceAdminListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(MaintenanceAdminListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === false;
	        });
	      }
	    }, {
	      key: '$onChanges',
	      value: function $onChanges() {
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === false;
	        });
	      }
	    }]);
	
	    return MaintenanceAdminListComponent;
	  }()
	};

/***/ },
/* 654 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/maintenance-admin-list/maintenance-admin-list.html';
	var html = "<md-card> <md-toolbar class=\"md-table-toolbar alternate\" ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Directions for use (Maintenance)</span> <span ng-if=$ctrl.unitsDisplay>&nbsp;in</span> <span ng-if=$ctrl.unitsDisplay>&nbsp;{{$ctrl.unitsDisplay}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div flex ng-show=\"$ctrl.administrations && $ctrl.administrations.length\"> <md-table-container> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedAdministrations> <thead md-head> <tr md-row> <th md-column><span>Species</span></th> <th md-column><span>Min. Weight</span></th> <th md-column><span>Max. Weight</span></th> <th md-column><span>Dose</span></th> <th md-column><span>Administrations/Day</span></th> <th md-column><span>Administration Days</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"administration in $ctrl.administrations | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\" md-select=administration md-on-deselect=$ctrl.rowDeselected md-on-select=$ctrl.rowSelected> <td md-cell>{{administration.Species}}</td> <td md-cell>{{administration.MinWeight}}</td> <td md-cell>{{administration.MaxWeight}}</td> <td md-cell>{{administration.DoseAmount}}</td> <td md-cell>{{administration.DosePerDay}}</td> <td md-cell>{{($ctrl.units / (administration.DosePerDay * administration.DoseAmount)) | number : 0}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.administrations.length}} md-label=\"{ rowsPerPage: 'Administrations per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.administrations && $ctrl.administrations.length\"> <p class=md-body-1> There are no maintenance administrations currently associated with this product. </p> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ingredientForm = __webpack_require__(656);
	
	var _ingredientForm2 = _interopRequireDefault(_ingredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.ingredientForm', []).component('productIngredientForm', _ingredientForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ingredientForm = __webpack_require__(657);
	
	var _ingredientForm2 = _interopRequireDefault(_ingredientForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _ingredientForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    companyId: '<',
	    ingredient: '<',
	    ingredients: '<',
	    submitTitle: '@',
	    unitsDisplay: '<',
	    weightUnits: '<',
	    ingredientChanged: '&',
	    index: '<',
	    showAdditionalButton: '<',
	    disallowActiveIngredients: '<'
	  },
	  controller: function () {
	    IngredientFormComponent.$inject = ["EventEmitter"];
	    function IngredientFormComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, IngredientFormComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(IngredientFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        if (this.ingredient) {
	          this.selectedIngredient = this.ingredient;
	        } else if (this.disallowActiveIngredients) {
	          this.ingredient = {
	            Active: false
	          };
	        }
	
	        this.ingredients = this.ingredients || [];
	      }
	    }, {
	      key: 'ingredientTypeChanged',
	      value: function ingredientTypeChanged(isActive) {
	        this.validateDuplicates();
	
	        if (!isActive) {
	          this.ingredient = _extends({}, this.ingredient, {
	            Weight: null,
	            WeightUnit: null
	          });
	        }
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit(shouldClose) {
	        var ingredient = _extends({}, this.selectedIngredient, this.ingredient);
	
	        this.ingredients.push(ingredient);
	
	        this.ingredientChanged(this.EventEmitter({
	          ingredient: ingredient,
	          shouldClose: shouldClose,
	          index: this.index
	        }));
	
	        this.ingredient = {};
	
	        this.selectedIngredient = null;
	        this.ingredientSearchText = '';
	      }
	    }, {
	      key: 'selectedSearchIngredientChanged',
	      value: function selectedSearchIngredientChanged($event) {
	        this.selectedIngredient = $event.selectedIngredient;
	        if (this.disallowActiveIngredients) {
	          this.ingredient = _extends({}, this.selectedIngredient, {
	            Active: false
	          });
	        }
	        this.validateDuplicates();
	      }
	    }, {
	      key: 'validateDuplicates',
	      value: function validateDuplicates() {
	        var _this = this;
	
	        var isValid = true;
	
	        if (this.selectedIngredient) {
	          // Business rule - ensure no duplicates
	          var index = this.ingredients.findIndex(function (i) {
	            return i.UserIngredientId === _this.selectedIngredient.UserIngredientId;
	          });
	
	          if (index !== -1 && this.index !== index) {
	            isValid = false;
	          }
	        }
	
	        this.ingredientForm.$setValidity('duplicate', isValid);
	      }
	    }]);
	
	    return IngredientFormComponent;
	  }()
	};

/***/ },
/* 657 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/ingredient-form/ingredient-form.html';
	var html = "<form name=$ctrl.ingredientForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Ingredient</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout-padding layout=row layout-sm=column layout-wrap> <p class=md-body-1> If you are trying to add an ingredient that is not on the list, please submit the ingredient name using the feedback button or send an email to your account manager.<br/><br/> Make sure you are on the correct product entry page for your product type.<br/><br/> <span ng-hide=$ctrl.disallowActiveIngredients>For the purposes of NAERS, food supplements and health supplements will have active and inactive ingredients. Please note that for health supplements with a <b>proprietary blend</b>, you must list the name and amount of each active ingredient that makes up the blend.<br/><br/></span> <span ng-hide=!$ctrl.disallowActiveIngredients>For treats, enter all ingredients from the ingredient statement as inactive.</span> </p> <ingredient-autocomplete flex ingredient-type=user label-text=\"Search for Ingredient by Name\" search-text=$ctrl.ingredientSearchText selected-ingredient=$ctrl.selectedIngredient search-display-property=UserIngredientName on-ingredient-selected=$ctrl.selectedSearchIngredientChanged($event) company-id=$ctrl.companyId> </ingredient-autocomplete> <md-input-container class=\"md-block md-input-has-value\" flex=100> <label>Type of Ingredient</label> <md-radio-group ng-model=$ctrl.ingredient.Active name=active ng-change=$ctrl.ingredientTypeChanged($ctrl.ingredient.Active) flex=100 required> <md-radio-button ng-value=true class=md-primary ng-disabled=$ctrl.disallowActiveIngredients ng-hide=$ctrl.disallowActiveIngredients>Active Ingredient</md-radio-button> <md-radio-button ng-value=false class=md-primary>Inactive Ingredient</md-radio-button> </md-radio-group> </md-input-container> <md-input-container flex=100 flex-gt-sm=50 ng-if=$ctrl.ingredient.Active> <label>One {{$ctrl.unitsDisplay}} contains:</label> <input ng-model=$ctrl.ingredient.Weight required name=weight type=number ng-change=$ctrl.validateDuplicates()> <div ng-messages=$ctrl.ingredientForm.weight.$error md-auto-hide=false> <div ng-message=required> Ingredient measurement is required. </div> </div> </md-input-container> <md-input-container flex=100 flex-gt-sm=50 ng-if=$ctrl.ingredient.Active> <label>Ingredient Unit</label> <md-select ng-model=$ctrl.ingredient.WeightUnit required name=unit ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"unit in $ctrl.weightUnits\" value={{unit.Value}}> {{unit.Name}} </md-option> </md-select> <div ng-messages=$ctrl.ingredientForm.unit.$error md-auto-hide=false> <div ng-message=required> Ingredient unit of measurement is required. </div> </div> </md-input-container> <div flex layout-align=\"center center\"> <div ng-messages=$ctrl.ingredientForm.$error style=color:#b53b0a;text-align:center> <div ng-message=duplicate> <md-icon md-font-set=material-icons class=warning>error</md-icon> Cannot submit a duplicate ingredient. </div> </div> </div> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(false) ng-if=$ctrl.showAdditionalButton ng-disabled=\"!$ctrl.ingredientForm.$valid || !$ctrl.selectedIngredient\"> {{$ctrl.submitTitle}} </md-button> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(true) ng-disabled=\"!$ctrl.ingredientForm.$valid || !$ctrl.selectedIngredient\"> {{$ctrl.submitTitle}} and Close </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _ingredientList = __webpack_require__(659);
	
	var _ingredientList2 = _interopRequireDefault(_ingredientList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.ingredientList', []).component('productIngredientList', _ingredientList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _ingredientList = __webpack_require__(660);
	
	var _ingredientList2 = _interopRequireDefault(_ingredientList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _ingredientList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    ingredients: '<',
	    locked: '<',
	    selectedIngredients: '<',
	    unitsDisplay: '<',
	    unitPerContainer: '<',
	    showHeader: '<'
	  },
	  controller: function () {
	    IngredientListComponent.$inject = ["EventEmitter"];
	    function IngredientListComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, IngredientListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(IngredientListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	      }
	    }]);
	
	    return IngredientListComponent;
	  }()
	};

/***/ },
/* 660 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/ingredient-list/ingredient-list.html';
	var html = "<md-card> <md-toolbar class=\"md-table-toolbar alternate\" ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Ingredients</span> <span ng-if=$ctrl.unitsDisplay>&nbsp;per 1 {{$ctrl.unitsDisplay}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div flex ng-show=\"$ctrl.ingredients && $ctrl.ingredients.length\"> <md-table-container> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedIngredients> <thead md-head> <tr md-row> <th md-column><span>Ingredient Name</span></th> <th md-column><span>Amount</span></th> <th md-column><span>Weight Unit</span></th> <th md-column><span>Active</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"ingredient in $ctrl.ingredients | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\" md-select=ingredient> <td md-cell>{{ingredient.UserIngredientName}}</td> <td md-cell>{{ingredient.Weight | number: 2}}</td> <td md-cell>{{ingredient.WeightUnit}}</td> <td md-cell> <md-checkbox ng-model=ingredient.Active ng-disabled=true aria-label=Active></md-checkbox> </td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.ingredients.length}} md-label=\"{ rowsPerPage: 'Ingredients per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.ingredients && $ctrl.ingredients.length\"> <p class=md-body-1> There are no ingredients currently associated with this product. </p> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signOff = __webpack_require__(662);
	
	var _signOff2 = _interopRequireDefault(_signOff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.signOff', []).component('signOff', _signOff2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _signOff = __webpack_require__(663);
	
	var _signOff2 = _interopRequireDefault(_signOff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _signOff2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    onSignedOff: '&',
	    units: '<',
	    chosenUnits: '<',
	    isTreat: '<'
	  },
	  controller: function () {
	    SignOffComponent.$inject = ["EventEmitter"];
	    function SignOffComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, SignOffComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(SignOffComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.onSignedOff(this.EventEmitter({
	          signature: this.signature
	        }));
	      }
	    }]);
	
	    return SignOffComponent;
	  }()
	};

/***/ },
/* 663 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/sign-off/sign-off.html';
	var html = "<form name=$ctrl.signatureForm ng-submit=$ctrl.onSubmit() novalidate> <div layout=column> <md-toolbar> <div class=md-toolbar-tools> <span class=md-truncate>Sign and Finalize</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <p flex class=md-body-1 style=padding-bottom:0> <b>Warning:</b> If you click yes to finalize your product, you will not be able to edit any of your product information. You WILL be able to upload new labels and edit shipping data. Please be sure <b>ALL</b> product information is correct before clicking yes, including: </p><div style=padding-top:0> <ul class=md-body-1 style=margin-top:25px> <li>The chosen unit(s): <b>{{$ctrl.chosenUnits}}</b></li> <li style=margin-top:5px>The number of <b>{{$ctrl.chosenUnits}}</b> per container: <b>{{$ctrl.units}}</b></li> <li style=margin-top:5px ng-if=!$ctrl.isTreat>The <b>Directions for Use</b></li> <li style=margin-top:5px ng-if=$ctrl.isTreat>The <b>Species</b></li> <li style=margin-top:5px>The <b>Ingredients per 1 {{$ctrl.chosenUnits}}</b></li> <li style=margin-top:5px ng-if=::!$ctrl.isTreat>The calculated <b>Administration Days</b> (how long the product will last)</li> </ul> <p class=md-body-1 style=margin-top:30px>Are you sure you want to finalize this product?</p> </div> <md-input-container class=md-block flex=100> <label>Signature</label> <input ng-model=$ctrl.signature name=signature required> <div ng-messages=$ctrl.signatureForm.signature.$error md-auto-hide=false> <div ng-message=required> Signature is required. </div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.signatureForm.$valid> Sign and Finalize </md-button> </div> <p></p> </div> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _usageData = __webpack_require__(665);
	
	var _usageData2 = _interopRequireDefault(_usageData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.usageDataForm', []).component('usageData', _usageData2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _usageData = __webpack_require__(666);
	
	var _usageData2 = _interopRequireDefault(_usageData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _usageData2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    dialogTitle: '@',
	    locked: '<',
	    showGuidance: '<',
	    usages: '<',
	    showHeader: '<',
	    showActionButtons: '<',
	    usageDataChanged: '&',
	    missingMessage: '@'
	  },
	  controller: function () {
	    UsageDataFormComponent.$inject = ["EventEmitter", "UsageDataService"];
	    function UsageDataFormComponent(EventEmitter, UsageDataService) {
	      'ngInject';
	
	      _classCallCheck(this, UsageDataFormComponent);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        UsageDataService: UsageDataService
	      });
	    }
	
	    _createClass(UsageDataFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.Q4Value = 0;
	        this.getQ4Value();
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = [5, 10, 25, 50];
	
	        if (!(this.dialogTitle && this.dialogTitle.length)) {
	          this.dialogTitle = 'Number of Units Shipped (Shipping Data)';
	        }
	      }
	    }, {
	      key: 'getQ4Value',
	      value: function getQ4Value() {
	        var _this = this;
	
	        var promise = this.UsageDataService.getQ4Value(this.usages[0].ProductId, this.usages[0].UsageYear - 1);
	
	        return promise.then(function (result) {
	          _this.Q4Value = result.data;
	        });
	      }
	    }, {
	      key: 'showWarning',
	      value: function showWarning(value1, value2) {
	        if ((value1 - value2) / value2 > 1) {
	          return true;
	        } else if ((value2 - value1) / value1 > 1) {
	          return true;
	        }
	        return false;
	      }
	    }, {
	      key: 'showWarningMessage',
	      value: function showWarningMessage() {
	        var errors = document.getElementsByClassName('error-icon');
	        if (errors.length > 0) {
	          if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
	            return false;
	          }
	          return true;
	        }
	        return false;
	      }
	    }, {
	      key: 'calculateUsageTotal',
	      value: function calculateUsageTotal(usage) {
	        return +usage.Q1 + +usage.Q2 + +usage.Q3 + +usage.Q4;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        this.usageDataChanged(this.EventEmitter({
	          usages: this.usages
	        }));
	      }
	    }]);
	
	    return UsageDataFormComponent;
	  }()
	};

/***/ },
/* 666 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/usage-data/usage-data.html';
	var html = "<ng-form name=$ctrl.usageForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.dialogTitle}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout=column ng-show=\"$ctrl.usages && $ctrl.usages.length\"> <p class=md-body-1 layout-padding ng-show=::$ctrl.showGuidance> Please enter the number of units shipped for each quarter. If you do not have quarterly data then enter annual data under “Q4”, and 0 for all other applicable quarters. </p> <md-table-container flex=noshrink> <table md-table> <thead md-head> <tr md-row> <th md-column><span>&nbsp;</span></th> <th md-column style=max-width:50px><span>Q1</span></th> <th md-column style=max-width:50px><span>Q2</span></th> <th md-column style=max-width:50px><span>Q3</span></th> <th md-column style=max-width:50px><span>Q4</span></th> <th md-column><span>Total</span></th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"usage in $ctrl.usages | orderBy : 'UsageYear' | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\"> <td md-cell md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=md-block> <input class=\"input-label md-primary\" ng-model=usage.UsageYear ng-disabled=true aria-label=\"Usage Year\"> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"$index == 0 && (usage.Q1 && $ctrl.Q4Value) !== null\"> <div ng-if=\"$ctrl.showWarning(usage.Q1, $ctrl.Q4Value)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <div ng-if=\"$index > 0 && (usage.Q1 && $ctrl.usages[$index - 1].Q4) !== null\"> <div ng-if=\"$ctrl.showWarning(usage.Q1, $ctrl.usages[$index - 1].Q4)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-if=\"$index == 0\" ng-model=usage.Q1 ng-style=\"(usage.Q1 && $ctrl.Q4Value) !== null && $ctrl.showWarning(usage.Q1, $ctrl.usages[$index - 1].Q4) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q1_{{$index}} type=number ng-disabled=::$ctrl.locked aria-label=\"Q1 Usage\"> <input ng-if=\"$index > 0\" ng-model=usage.Q1 ng-style=\"(usage.Q1 && $ctrl.usages[$index - 1].Q4) !== null && $ctrl.showWarning(usage.Q1, $ctrl.usages[$index - 1].Q4) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q1_{{$index}} type=number ng-disabled=::$ctrl.locked aria-label=\"Q1 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q1_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q2 && usage.Q1) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q2, usage.Q1)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q2 ng-style=\"(usage.Q2 && usage.Q1) !== null && $ctrl.showWarning(usage.Q2, usage.Q1) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q2_{{$index}} type=number ng-disabled=::$ctrl.locked aria-label=\"Q2 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q2_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q3 && usage.Q2) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q3, usage.Q2)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q3 ng-style=\"(usage.Q3 && usage.Q2) !== null && $ctrl.showWarning(usage.Q3, usage.Q2) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q3_{{$index}} type=number ng-disabled=::$ctrl.locked aria-label=\"Q3 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q3_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell style=max-width:50px> <div layout=column flex> <md-input-container class=\"md-block full-input-container\" flex=100> <div style=display:flex> <div ng-if=\"(usage.Q4 && usage.Q3) !== null\" md-auto-hide=false> <div ng-if=\"$ctrl.showWarning(usage.Q4, usage.Q3)\"> <md-icon md-font-set=material-icons class=error-icon> <md-tooltip> Warning: This value differs by more than 100% from the previous quarter. Please confirm this is correct. </md-tooltip> warning </md-icon> </div> </div> <input ng-model=usage.Q4 ng-style=\"(usage.Q4 && usage.Q3) !== null && $ctrl.showWarning(usage.Q4, usage.Q3) ? {'border' : '1px solid #f1cf2c'} : {'border-color' : 'rgba(0, 0, 0, 0.12)'}\" ng-change=$ctrl.showWarningMessage() name=usage_q4_{{$index}} type=number ng-disabled=::$ctrl.locked aria-label=\"Q4 Usage\"> </div> <div ng-messages=\"$ctrl.usageForm['usage_q4_' + $index].$error\" md-auto-hide=false> <div ng-message=number> Entry must be numeric. </div> </div> </md-input-container> </div> </td> <td md-cell md-cell style=max-width:50px> <label>{{ $ctrl.calculateUsageTotal(usage) | number: 2}}</label> </td> </tr> </tbody> </table> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.usages.length}} md-label=\"{ rowsPerPage: 'Usages per page:' }\"> </md-table-pagination> </md-table-container> <md-card-actions flex=100 layout=row layout-align=\"end center\" ng-if=::$ctrl.showActionButtons> <div ng-if=$ctrl.showWarningMessage() style=display:flex;width:50%;margin-right:13px> <md-icon md-font-set=material-icons class=\"error-icon warning-message\" style=\"margin:36px 11px 0 0\"> warning </md-icon> <h5> Warning: This value differs from the previous quarter by more than 100%. Please confirm this is correct before clicking ‘Update Shipping Data’. </h5> </div> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=$ctrl.usageForm.$invalid ng-click=$ctrl.onSubmit()> Update Shipping Data </md-button> </md-card-actions> </md-card-content> <div layout-padding flex ng-hide=\"$ctrl.usages && $ctrl.usages.length\"> <p class=md-body-1> {{ $ctrl.missingMessage && $ctrl.missingMessage.length ? $ctrl.missingMessage : 'There is no shipping data currently associated with this product. Please update the Date First Sold field in Product Information prior to updating this data.' }} </p> </div> </md-card> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 667 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _treatProduct = __webpack_require__(669);
	
	var _treatProduct2 = _interopRequireDefault(_treatProduct);
	
	var _copy = __webpack_require__(634);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	var _treatInformation = __webpack_require__(671);
	
	var _treatInformation2 = _interopRequireDefault(_treatInformation);
	
	var _treatAdminForm = __webpack_require__(674);
	
	var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);
	
	var _treatAdminList = __webpack_require__(677);
	
	var _treatAdminList2 = _interopRequireDefault(_treatAdminList);
	
	var _ingredientForm = __webpack_require__(655);
	
	var _ingredientForm2 = _interopRequireDefault(_ingredientForm);
	
	var _ingredientList = __webpack_require__(658);
	
	var _ingredientList2 = _interopRequireDefault(_ingredientList);
	
	var _signOff = __webpack_require__(661);
	
	var _signOff2 = _interopRequireDefault(_signOff);
	
	var _usageData = __webpack_require__(664);
	
	var _usageData2 = _interopRequireDefault(_usageData);
	
	__webpack_require__(667);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.treatProduct', [_angularUiRouter2.default, _copy2.default, _treatInformation2.default, _treatAdminForm2.default, _treatAdminList2.default, _ingredientForm2.default, _ingredientList2.default, _signOff2.default, _usageData2.default]).component('treatProduct', _treatProduct2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('treatProductEdit', {
	    parent: 'app',
	    url: '/products/treat/{id:int}',
	    component: 'treatProduct',
	    resolve: {
	      product: ["$stateParams", "ProductService", function product($stateParams, ProductService) {
	        return ProductService.getProduct($stateParams.id).then(function (r) {
	          return r.data;
	        });
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      // TODO: Refactor to OData call
	      frequencies: ["ProductService", function frequencies(ProductService) {
	        return ProductService.getFrequencies().then(function (r) {
	          return r.data.map(function (f) {
	            var obj = {};
	            obj.Name = f.Name;
	            obj.Value = +f.Value;
	            return obj;
	          });
	        });
	      }],
	      administrationUnits: ["ProductService", function administrationUnits(ProductService) {
	        return ProductService.getAdministrationUnitsForTreats().then(function (r) {
	          return r.data;
	        });
	      }],
	      weightUnits: ["ProductService", function weightUnits(ProductService) {
	        return ProductService.getWeightUnits().then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  }).state('treatProductCreate', {
	    parent: 'app',
	    url: '/products/createTreat',
	    component: 'treatProduct',
	    resolve: {
	      product: ["currentUser", function product(currentUser) {
	        return {
	          ProductId: 0,
	          MemberId: currentUser.MemberId,
	          IsTreat: 1,
	          ProductForm: 'Treat(s)'
	        };
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      // TODO: Refactor to OData call
	      frequencies: ["ProductService", function frequencies(ProductService) {
	        return ProductService.getFrequencies().then(function (r) {
	          return r.data.map(function (f) {
	            var obj = {};
	            obj.Name = f.Name;
	            obj.Value = +f.Value;
	            return obj;
	          });
	        });
	      }],
	      administrationUnits: ["ProductService", function administrationUnits(ProductService) {
	        return ProductService.getAdministrationUnitsForTreats().then(function (r) {
	          return r.data;
	        });
	      }],
	      weightUnits: ["ProductService", function weightUnits(ProductService) {
	        return ProductService.getWeightUnits().then(function (r) {
	          return r.data;
	        });
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _treatProduct = __webpack_require__(670);
	
	var _treatProduct2 = _interopRequireDefault(_treatProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _treatProduct2.default,
	  bindings: {
	    product: '<',
	    productLabel: '<',
	    animalTypes: '<',
	    categories: '<',
	    frequencies: '<',
	    administrationUnits: '<',
	    weightUnits: '<'
	  },
	  controller: function () {
	    TreatProductComponent.$inject = ["$mdDialog", "$scope", "$state", "ameLightbox", "AuthService", "ArrayService", "IngredientService", "LoadingService", "ProductService", "ToastService", "Upload"];
	    function TreatProductComponent($mdDialog, $scope, $state, ameLightbox, AuthService, ArrayService, IngredientService, LoadingService, ProductService, ToastService, Upload) {
	      'ngInject';
	
	      _classCallCheck(this, TreatProductComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        ameLightbox: ameLightbox,
	        ArrayService: ArrayService,
	        AuthService: AuthService,
	        IngredientService: IngredientService,
	        LoadingService: LoadingService,
	        ProductService: ProductService,
	        ToastService: ToastService,
	        Upload: Upload
	      });
	    }
	
	    _createClass(TreatProductComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        // Make sure we're on the right page for the product type
	        if (!this.product.IsTreat) {
	          this.$state.go('productEdit', { id: this.product.ProductId }, { reload: true });
	          return;
	        }
	
	        this.product.tblDoses = this.product.tblDoses || [];
	        this.product.tblUsages = this.product.tblUsages || [];
	        this.selectedTreatAdministrations = [];
	        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, this.product.DateIntroduced, this.product.tblUsages);
	
	        this.selectedIngredients = [];
	        this.labelChanged = false;
	        this.duplicateAdministration = false;
	        this.product.tblProduct_UserIngredient = this.product.tblProduct_UserIngredient || [];
	
	        this.maxDate = new Date();
	
	        this.copyAreas = ['Product Information', 'Administrations', 'Product Ingredients']; // CG 11/15/2023 removed Usage Data from this list. We should not copy Usage between products.
	      }
	    }, {
	      key: 'signOff',
	      value: function signOff() {
	        var _this = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          productId: this.product.ProductId,
	          units: this.unitPerContainer,
	          chosenUnits: this.chosenUnits,
	          isTreat: true,
	          onSignedOff: function onSignedOff($event) {
	            return _this.onSignedOff($event);
	          }
	        });
	
	        if (this.product.tblProduct_UserIngredient.length === 0) {
	          this.ToastService.showWarning('Must specify Ingredients before signing off');
	        } else if (this.product.tblDoses.length === 0) {
	          this.ToastService.showWarning('Must specify Directions for Use before signing off');
	        } else {
	          this.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: '\n            <md-dialog class="flex-50">\n              <md-dialog-content>\n                <dialog-close/>\n                <sign-off product-id="productId"\n                  units="units" chosen-units="chosenUnits"\n                  is-treat="true"\n                  on-signed-off="onSignedOff($event)">\n                </sign-off>\n              </md-dialog-content>\n            </md-dialog>\n            '
	          });
	        }
	      }
	    }, {
	      key: 'saveProduct',
	      value: function saveProduct() {
	        var _this2 = this;
	
	        var promise = void 0;
	        if (this.product.ProductId) {
	          promise = this.ProductService.update(this.product);
	        } else {
	          promise = this.ProductService.create(this.product);
	        }
	
	        return promise.then(function (r) {
	          _this2.product.ProductId = _this2.product.ProductId || r.data.Id;
	        }).then(function () {
	          return _this2.saveProductLabel();
	        });
	      }
	    }, {
	      key: 'onSignedOff',
	      value: function onSignedOff(_ref) {
	        var _this3 = this;
	
	        var signature = _ref.signature;
	
	        if (signature) {
	          this.LoadingService.start();
	          this.saveProduct().then(function () {
	            return _this3.ProductService.signOff(_this3.product.ProductId, signature);
	          }).then(function () {
	            _this3.$mdDialog.hide();
	            _this3.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_ADDED);
	            _this3.$state.go('treatProductEdit', { id: _this3.product.ProductId }, { reload: true });
	          }).catch(function (error) {
	            return _this3.ToastService.showError(error);
	          }).finally(function () {
	            return _this3.LoadingService.stop();
	          });
	        }
	      }
	    }, {
	      key: 'showCopy',
	      value: function showCopy() {
	        var _this4 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          copyAreas: this.copyAreas,
	          isTreat: true,
	          onCopied: function onCopied($event) {
	            return _this4.onCopied($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-copy copy-areas="copyAreas" is-treat="isTreat"\n                on-copied="onCopied($event)">\n              </product-copy>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'onCopied',
	      value: function onCopied($event) {
	        var _this5 = this;
	
	        var selectedCopyAreas = $event.copyAreas;
	
	        this.ProductService.getProduct($event.product.ProductId).then(function (p) {
	          var copyFromProduct = p.data;
	
	          if (selectedCopyAreas && selectedCopyAreas.length) {
	            _this5.product = _extends({}, _this5.ProductService.copyProduct(_this5.product, copyFromProduct, selectedCopyAreas));
	          }
	
	          _this5.ToastService.showSuccess(_messages.PRODUCT_COPIED);
	          _this5.$mdDialog.hide();
	        }).catch(function (error) {
	          return _this5.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'dateFirstSoldChanged',
	      value: function dateFirstSoldChanged($event) {
	        this.product.tblUsages = this.ProductService.transformUsages(this.product.ProductId, $event.dateFirstSold, this.product.tblUsages);
	      }
	    }, {
	      key: 'saveChanges',
	      value: function saveChanges() {
	        var _this6 = this;
	
	        var saveMessage = this.product.ProductId ? _messages.PRODUCT_EDITED : _messages.PRODUCT_ADDED;
	        this.LoadingService.start();
	        this.saveProduct().then(function () {
	          _this6.ToastService.showSuccess(saveMessage);
	          _this6.$state.go('treatProductEdit', { id: _this6.product.ProductId }, { reload: true });
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        }).finally(function () {
	          return _this6.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'saveProductLabel',
	      value: function saveProductLabel() {
	        if (this.productLabel && this.productLabel instanceof File) {
	          return this.ProductService.uploadLabel(this.product.ProductId, this.productLabel);
	        }
	
	        return Promise.resolve(true);
	      }
	    }, {
	      key: 'setLabelImage',
	      value: function setLabelImage(_ref2) {
	        var productLabel = _ref2.productLabel;
	
	        this.productLabel = productLabel;
	
	        if (productLabel) {
	          this.ToastService.showSuccess(_messages.PRODUCT_LABEL_CHANGED);
	        }
	      }
	    }, {
	      key: 'onAdministrationAdded',
	      value: function onAdministrationAdded(_ref3) {
	        var administration = _ref3.administration,
	            shouldClose = _ref3.shouldClose;
	
	        if (administration) {
	          this.product.tblDoses = this.ArrayService.add(this.product.tblDoses, administration);
	
	          this.ToastService.showSuccess(_messages.ADMINISTRATION_ADDED);
	          if (shouldClose) {
	            this.$mdDialog.hide();
	          }
	        }
	      }
	    }, {
	      key: 'onAdministrationEdited',
	      value: function onAdministrationEdited(_ref4) {
	        var administration = _ref4.administration,
	            index = _ref4.index;
	
	        if (administration && index !== null) {
	          this.product.tblDoses = this.ArrayService.update(this.product.tblDoses, administration, index);
	
	          this.ToastService.showSuccess(_messages.ADMINISTRATION_EDITED);
	          this.$mdDialog.hide();
	          this.selectedTreatAdministrations = [];
	        }
	      }
	    }, {
	      key: 'treatAdministrationAdd',
	      value: function treatAdministrationAdd() {
	        var _this7 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: undefined,
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          units: this.unitPerContainer,
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          administrationChanged: function administrationChanged($event) {
	            return _this7.onAdministrationAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <treat-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Add Species"\n                show-additional-button="true"\n                administration-changed="administrationChanged($event)">\n              </treat-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'treatAdministrationEdit',
	      value: function treatAdministrationEdit(administration) {
	        var _this8 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          administration: _angular2.default.copy(administration),
	          administrations: _angular2.default.copy(this.product.tblDoses),
	          units: this.unitPerContainer,
	          animalTypes: this.animalTypes,
	          frequencies: this.frequencies,
	          unitsDisplay: this.unitsDisplay,
	          index: this.product.tblDoses.indexOf(administration),
	          administrationChanged: function administrationChanged($event) {
	            return _this8.onAdministrationEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <treat-admin-form\n                administration="administration"\n                administrations="administrations"\n                units="units"\n                animal-types="animalTypes"\n                frequencies="frequencies"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                administration-changed="administrationChanged($event)"\n                index="index">\n              </treat-admin-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'treatAdministrationDelete',
	      value: function treatAdministrationDelete(administrations) {
	        var _this9 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected treat administration(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          try {
	            for (var i = administrations.length - 1; i >= 0; i -= 1) {
	              _this9.product.tblDoses = _this9.ArrayService.remove(_this9.product.tblDoses, administrations[i]);
	            }
	
	            _this9.ToastService.showSuccess(_messages.ADMINISTRATION_DELETED);
	            _this9.selectedTreatAdministrations = [];
	          } catch (e) {
	            _this9.ToastService.showError();
	          }
	        });
	      }
	    }, {
	      key: 'onIngredientAdded',
	      value: function onIngredientAdded(_ref5) {
	        var ingredient = _ref5.ingredient,
	            shouldClose = _ref5.shouldClose;
	
	        if (ingredient) {
	          this.product.tblProduct_UserIngredient = this.ArrayService.add(this.product.tblProduct_UserIngredient, ingredient);
	          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_ADDED);
	          if (shouldClose) {
	            this.$mdDialog.hide();
	          }
	        }
	      }
	    }, {
	      key: 'onIngredientEdited',
	      value: function onIngredientEdited(_ref6) {
	        var ingredient = _ref6.ingredient,
	            index = _ref6.index;
	
	        if (ingredient && index !== null) {
	          this.product.tblProduct_UserIngredient = this.ArrayService.update(this.product.tblProduct_UserIngredient, ingredient, index);
	          this.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_EDITED);
	          this.$mdDialog.hide();
	          this.selectedIngredients = [];
	        }
	      }
	    }, {
	      key: 'ingredientAdd',
	      value: function ingredientAdd() {
	        var _this10 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          companyId: this.product.MemberId,
	          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
	          unitsDisplay: this.unitsDisplay,
	          weightUnits: this.weightUnits,
	          ingredientChanged: function ingredientChanged($event) {
	            return _this10.onIngredientAdded($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Add Ingredient"\n                show-additional-button="true"\n                disallow-active-ingredients="true"\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientEdit',
	      value: function ingredientEdit(ingredient) {
	        var _this11 = this;
	
	        var scope = _angular2.default.extend(this.$scope.$new(true), {
	          ingredient: _angular2.default.copy(ingredient),
	          ingredients: _angular2.default.copy(this.product.tblProduct_UserIngredient),
	          companyId: this.product.MemberId,
	          index: this.product.tblProduct_UserIngredient.indexOf(ingredient),
	          unitsDisplay: this.unitsDisplay,
	          weightUnits: this.weightUnits,
	          ingredientChanged: function ingredientChanged($event) {
	            return _this11.onIngredientEdited($event);
	          }
	        });
	
	        this.$mdDialog.show({
	          clickOutsideToClose: true,
	          fullscreen: true,
	          scope: scope,
	          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <product-ingredient-form\n                ingredient="ingredient"\n                ingredients="ingredients"\n                weight-units="weightUnits"\n                units-display="unitsDisplay"\n                submit-title="Save Changes"\n                disallow-active-ingredients="true\n                company-id="companyId"\n                ingredient-changed="ingredientChanged($event)"\n                index="index">\n              </product-ingredient-form>\n            </md-dialog-content>\n          </md-dialog>\n          '
	        });
	      }
	    }, {
	      key: 'ingredientDelete',
	      value: function ingredientDelete(ingredients) {
	        var _this12 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once deleted, the selected ingredient(s) cannot be recovered!').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          try {
	            for (var i = ingredients.length - 1; i >= 0; i -= 1) {
	              _this12.product.tblProduct_UserIngredient = _this12.ArrayService.remove(_this12.product.tblProduct_UserIngredient, ingredients[i]);
	            }
	
	            _this12.ToastService.showSuccess(_messages.PRODUCT_INGREDIENT_DELETED);
	            _this12.selectedIngredients = [];
	          } catch (e) {
	            _this12.ToastService.showError();
	          }
	        });
	      }
	    }, {
	      key: 'unitsDisplay',
	      get: function get() {
	        return this.ProductService.getUnitsDisplay(this.product);
	      }
	    }, {
	      key: 'unitPerContainer',
	      get: function get() {
	        return this.product.UnitPerContainer;
	      }
	    }, {
	      key: 'chosenUnits',
	      get: function get() {
	        return this.product.ProductForm;
	      }
	    }, {
	      key: 'labelValid',
	      get: function get() {
	        return this.productLabel || this.product.FileLabelName;
	      }
	    }, {
	      key: 'shouldBeLocked',
	      get: function get() {
	        if (this.AuthService.isSysAdmin) {
	          return false;
	        }
	
	        return this.product.Signature && this.product.Signature.length > 0;
	      }
	    }]);
	
	    return TreatProductComponent;
	  }()
	};

/***/ },
/* 670 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/treat-product.html';
	var html = "<ng-form name=$ctrl.treatProductForm flex layout=column novalidate> <div flex layout=column> <div layout-padding ng-if=\"::!$ctrl.locked && !$ctrl.viewOnly && !$ctrl.product.ProductId\"> <p class=md-body-1 style=background-color:#f9eaa4> This page is designed for a true traditional treat — a food that provides occasional enjoyment, training, entertainment, or other purposes and is not intended or represented to be a food or health supplement.<br/><br/>If your product is a food supplement or health supplement, please exit and choose “Add Supplement.” If you are unsure, please contact your account manager. </p> </div> <div layout-padding> <treat-information administration-units=::$ctrl.administrationUnits categories=::$ctrl.categories copy-areas=::$ctrl.copyAreas product=$ctrl.product units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer on-date-first-sold-changed=$ctrl.dateFirstSoldChanged($event) show-header=true view-only=false locked=::$ctrl.shouldBeLocked on-product-label-changed=$ctrl.setLabelImage($event) label-valid=$ctrl.labelValid> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-raised md-accent no-print\" aria-label=\"Copy Existing Product\" ng-if=::!$ctrl.product.ProductId ng-click=$ctrl.showCopy() permission permission-except=\"'SYS_ADMIN'\"> <md-icon md-font-set=material-icons>content_copy</md-icon> Copy Existing Product </md-button> </action-buttons> </treat-information> <treat-admin-list administrations=$ctrl.product.tblDoses selected-administrations=$ctrl.selectedTreatAdministrations units=$ctrl.unitPerContainer units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer show-header=true locked=::$ctrl.shouldBeLocked> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.treatAdministrationAdd()> <md-tooltip md-direction=top>Add Species</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedTreatAdministrations && $ctrl.selectedTreatAdministrations.length === 1\" ng-click=$ctrl.treatAdministrationEdit($ctrl.selectedTreatAdministrations[0])> <md-tooltip md-direction=top>Edit Species</md-tooltip> <md-icon md-font-set=material-icons>mode_edit</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedTreatAdministrations && $ctrl.selectedTreatAdministrations.length\" ng-click=$ctrl.treatAdministrationDelete($ctrl.selectedTreatAdministrations)> <md-tooltip md-direction=top>Delete Species</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </action-buttons> </treat-admin-list> <product-ingredient-list ingredients=$ctrl.product.tblProduct_UserIngredient selected-ingredients=$ctrl.selectedIngredients show-header=true units-display=$ctrl.unitsDisplay unit-per-container=$ctrl.unitPerContainer locked=::$ctrl.shouldBeLocked> <action-buttons ng-if=::!$ctrl.shouldBeLocked> <md-button class=\"md-accent md-fab md-mini\" ng-click=$ctrl.ingredientAdd()> <md-tooltip md-direction=top>Add Ingredient</md-tooltip> <md-icon md-font-set=material-icons>add</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedIngredients && $ctrl.selectedIngredients.length\" ng-click=$ctrl.ingredientDelete($ctrl.selectedIngredients)> <md-tooltip md-direction=top>Delete Ingredient</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </action-buttons> </product-ingredient-list> <usage-data usages=$ctrl.product.tblUsages show-guidance=true show-header=true locked=::$ctrl.shouldBeLocked> </usage-data> </div> </div> </ng-form> <footer class=no-print> <div layout=column layout-align=\"center center\"> <div ng-messages=\"$ctrl.treatProductForm.$error || !$ctrl.labelValid\" style=color:#b53b0a;text-align:center> <div ng-message-exp=\"['minlength', 'maxlength', 'required']\"> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please ensure that all required fields are provided before saving. </div> <div ng-message=error> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please resolve all validation errors before saving. </div> <div ng-show=!$ctrl.labelValid> <md-icon md-font-set=material-icons class=warning>error</md-icon> Please ensure that the product label is added before saving. </div> </div> <div layout=row flex> <md-button class=\"md-raised md-accent md-button-md\" aria-label=\"Save Product\" ng-click=$ctrl.saveChanges() ng-disabled=\"!$ctrl.treatProductForm.$valid || !$ctrl.labelValid\"> <md-icon md-font-set=material-icons>save</md-icon>Save Treat </md-button> <md-button class=\"md-raised md-accent md-button-md\" aria-label=\"Sign Off\" ng-click=$ctrl.signOff() ng-disabled=\"!$ctrl.treatProductForm.$valid || !$ctrl.labelValid\" ng-if=::!$ctrl.shouldBeLocked permission permission-only=\"'COMPANY_ADMIN'\"> <md-icon md-font-set=material-icons>lock</md-icon>Sign Off </md-button> </div> </div> </footer>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _treatInformation = __webpack_require__(672);
	
	var _treatInformation2 = _interopRequireDefault(_treatInformation);
	
	var _productLabelDownload = __webpack_require__(640);
	
	var _productLabelDownload2 = _interopRequireDefault(_productLabelDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.treatInformation', [_productLabelDownload2.default]).component('treatInformation', _treatInformation2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _treatInformation = __webpack_require__(673);
	
	var _treatInformation2 = _interopRequireDefault(_treatInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _treatInformation2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administrationUnits: '<',
	    categories: '<',
	    copyAreas: '<',
	    onProductLabelChanged: '&',
	    locked: '<',
	    viewOnly: '<',
	    product: '<',
	    unitsDisplay: '<',
	    onDateFirstSoldChanged: '&',
	    showHeader: '<',
	    labelValid: '<'
	  },
	  controller: function () {
	    TreatInformationComponent.$inject = ["EventEmitter"];
	    function TreatInformationComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, TreatInformationComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(TreatInformationComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.labelChanged = false;
	        this.maxDate = new Date();
	      }
	    }, {
	      key: 'dateFirstSoldChanged',
	      value: function dateFirstSoldChanged(dateFirstSold) {
	        this.onDateFirstSoldChanged(this.EventEmitter({
	          dateFirstSold: dateFirstSold
	        }));
	      }
	    }, {
	      key: 'productLabelChanged',
	      value: function productLabelChanged(_ref) {
	        var productLabel = _ref.productLabel;
	
	        this.labelChanged = true;
	        this.onProductLabelChanged(this.EventEmitter({
	          productLabel: productLabel
	        }));
	      }
	    }]);
	
	    return TreatInformationComponent;
	  }()
	};

/***/ },
/* 673 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/information/treat-information.html';
	var html = "<ng-form name=$ctrl.productTreatInformationForm flex=100> <md-card> <md-toolbar ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Treat Information</span> <md-icon md-font-set=material-icons class=warning ng-show=\"$ctrl.productTreatInformationForm.$invalid || !$ctrl.labelValid\">error</md-icon> <span flex></span> <md-icon ng-show=\"::$ctrl.locked && !$ctrl.viewOnly\" style=color:#f9eaa4 md-font-set=material-icons>lock</md-icon> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding ng-if=\"::$ctrl.locked && !$ctrl.viewOnly\"> <p class=md-body-1 style=background-color:#f9eaa4> <b>This product is signed off and locked.</b> You can only modify the Product Name, SKU, UPC and label. If you wish to modify anything more than that, you will need to contact your account manager.<br/>To update shipping data, return to the product list and click “Update Shipping”, or if you need to update multiple products at once, go the dashboard and click “Update Shipping Data”. </p> </div> <div layout-padding> <div flex=100 layout-sm=column layout=row layout-wrap class=gutter> <md-input-container flex=100 flex-gt-md=100> <label>Date First Sold</label> <md-datepicker ng-model=$ctrl.product.DateIntroduced md-max-date=$ctrl.maxDate ng-change=$ctrl.dateFirstSoldChanged($ctrl.product.DateIntroduced) required name=dateIntroduced ng-disabled=::$ctrl.locked md-current-view=year> </md-datepicker> <div ng-messages=$ctrl.productTreatInformationForm.dateIntroduced.$error md-auto-hide=false> <div ng-message=valid>Date first sold must be a valid date.</div> <div ng-message=required> Date first sold is required. </div> <div ng-message=maxdate> Date first sold cannot exceed current date. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Product Name</label> <input ng-model=$ctrl.product.ProductName name=productName required ng-disabled=::$ctrl.viewOnly> <div ng-messages=$ctrl.productTreatInformationForm.productName.$error md-auto-hide=true> <div ng-message=required> Product name is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=50 flex-gt-md=25> <label>Product SKU#</label> <input ng-model=$ctrl.product.SKU name=sku required ng-disabled=::$ctrl.viewOnly> <div ng-messages=$ctrl.productTreatInformationForm.sku.$error md-auto-hide=true> <div ng-message=required> SKU# is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=50 flex-gt-md=25> <label>Product UPC#</label> <input ng-model=$ctrl.product.UPC name=upc ng-disabled=::$ctrl.viewOnly> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>What is the administration unit of the product?</label> <md-select required ng-model=$ctrl.product.ProductForm name=productForm ng-disabled=true> <md-option ng-repeat=\"unit in $ctrl.administrationUnits\" value={{unit.Name}}> {{unit.Name}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>How many <span style=color:#000;font-weight:700>{{$ctrl.unitsDisplay}}</span> are there in a container?</label> <input ng-model=$ctrl.product.UnitPerContainer required name=unitPerContainer type=number ng-disabled=::$ctrl.locked> <div ng-messages=$ctrl.productTreatInformationForm.unitPerContainer.$error md-auto-hide=false> <div ng-message=required> Units per container is required. </div> <div ng-message=number> Units per container must be numeric. </div> </div> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Warnings (if any)</label> <textarea ng-model=$ctrl.product.WarningNote md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow name=warningNote ng-disabled=::$ctrl.locked class=no-print>\r\n            </textarea> <p class=\"print-only md-body-1\">{{$ctrl.product.WarningNote}}</p> </md-input-container> <md-input-container class=md-block flex=100 flex-gt-md=50> <label>Suggested Use (if any)</label> <textarea ng-model=$ctrl.product.FeedingNote md-maxlength=500 maxlength=500 rows=5 md-select-on-focus md-no-autogrow name=suggestedUse ng-disabled=::$ctrl.locked class=no-print>\r\n          </textarea> <p class=\"print-only md-body-1\">{{$ctrl.product.FeedingNote}}</p> </md-input-container> <div layout=column flex=100 flex-gt-md=50> <product-label-download product=::$ctrl.product label-changed=$ctrl.labelChanged> </product-label-download> <product-label-upload locked=::$ctrl.viewOnly on-product-label-changed=$ctrl.productLabelChanged($event) label-text=\"Upload Product Label *\" is-abbreviated=false label-class=\"md-button md-raised md-accent\" show-preview=true layout=row button-width=50> </product-label-upload> <md-input-container class=md-block flex=100 flex-gt-sm=33> <div ng-if=\"$ctrl.labelValid === undefined || $ctrl.labelValid === 'undefined'\"> <div class=md-input-message-animation> Product Label is required. </div> </div> </md-input-container> </div> </div> </div> </md-card> </ng-form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _treatAdminForm = __webpack_require__(675);
	
	var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.treatAdminForm', []).component('treatAdminForm', _treatAdminForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _treatAdminForm = __webpack_require__(676);
	
	var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _treatAdminForm2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administration: '<',
	    administrations: '<',
	    units: '<',
	    animalTypes: '<',
	    frequencies: '<',
	    submitTitle: '@',
	    unitsDisplay: '<',
	    administrationChanged: '&',
	    index: '<',
	    showAdditionalButton: '<'
	  },
	  controller: function () {
	    TreatAdminFormComponent.$inject = ["AnimalTypeService", "EventEmitter"];
	    function TreatAdminFormComponent(AnimalTypeService, EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, TreatAdminFormComponent);
	
	      Object.assign(this, {
	        AnimalTypeService: AnimalTypeService,
	        EventEmitter: EventEmitter
	      });
	    }
	
	    _createClass(TreatAdminFormComponent, [{
	      key: 'onSubmit',
	      value: function onSubmit(shouldClose) {
	        var administration = _extends({
	          Isloading: false,
	          MinWeight: this.AnimalTypeService.minimumAnimalWeight(this.administration.Species),
	          MaxWeight: this.AnimalTypeService.maximumAnimalWeight(this.administration.Species),
	          DoseAmount: 1,
	          DosePerDay: 1.00
	        }, this.administration);
	
	        if (!administration.DoseId) {
	          this.administrations.push(administration);
	        }
	
	        this.administrationChanged(this.EventEmitter({
	          administration: administration,
	          index: this.index,
	          shouldClose: shouldClose
	        }));
	
	        this.validateDuplicates();
	      }
	    }, {
	      key: 'getMinimumAnimalWeight',
	      value: function getMinimumAnimalWeight(species) {
	        return this.AnimalTypeService.minimumAnimalWeight(species);
	      }
	    }, {
	      key: 'getMaximumAnimalWeight',
	      value: function getMaximumAnimalWeight(species) {
	        return this.AnimalTypeService.maximumAnimalWeight(species);
	      }
	    }, {
	      key: 'calculateAdminDays',
	      value: function calculateAdminDays() {
	        return Math.round(this.units / (this.administration.DoseAmount * this.administration.DosePerDay));
	      }
	    }, {
	      key: 'validateDuplicates',
	      value: function validateDuplicates() {
	        var _this = this;
	
	        var isValid = true;
	
	        if (this.administration) {
	          var arrayIndex = this.administrations.findIndex(function (d) {
	            return d.Isloading === false && d.Species === _this.administration.Species;
	          });
	
	          if (arrayIndex !== -1 && arrayIndex !== this.index) {
	            isValid = false;
	          }
	        }
	
	        this.treatAdministrationForm.$setValidity('duplicate', isValid);
	      }
	    }]);
	
	    return TreatAdminFormComponent;
	  }()
	};

/***/ },
/* 676 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/treat-admin-form/treat-admin-form.html';
	var html = "<form name=$ctrl.treatAdministrationForm flex=100 novalidate> <md-card> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Intended Species (Treat)</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <md-card-content layout=row layout-sm=column layout-wrap> <md-input-container flex=100> <label>Intended Species</label> <md-select name=animalType ng-model=$ctrl.administration.Species required ng-change=$ctrl.validateDuplicates()> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" value={{animalType.AnimalTypeName}}> {{animalType.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.treatAdministrationForm.animalType.$error md-auto-hide=false> <div ng-message=required> Intended species is required. </div> </div> </md-input-container> <div flex=100 layout-align=\"center center\"> <div ng-messages=$ctrl.treatAdministrationForm.$error style=color:#b53b0a;text-align:center> <div ng-message=duplicate> <md-icon md-font-set=material-icons class=warning>error</md-icon> Cannot submit a duplicate species. </div> </div> </div> <md-card-actions flex=100 layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-click=$ctrl.onSubmit(true) ng-disabled=!$ctrl.treatAdministrationForm.$valid> {{$ctrl.submitTitle}} </md-button> </md-card-actions> </md-card-content> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _treatAdminList = __webpack_require__(678);
	
	var _treatAdminList2 = _interopRequireDefault(_treatAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.product.treatAdminList', []).component('treatAdminList', _treatAdminList2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(408);
	
	var _treatAdminList = __webpack_require__(679);
	
	var _treatAdminList2 = _interopRequireDefault(_treatAdminList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _treatAdminList2.default,
	  transclude: {
	    actionButtons: '?actionButtons'
	  },
	  bindings: {
	    administrations: '<',
	    selectedAdministrations: '<',
	    units: '<',
	    unitsDisplay: '<',
	    unitPerContainer: '<',
	    locked: '<',
	    showHeader: '<'
	  },
	  controller: function () {
	    TreatAdminListComponent.$inject = ["EventEmitter"];
	    function TreatAdminListComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, TreatAdminListComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(TreatAdminListComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.query = (0, _query.getQuery)();
	        this.limitOptions = (0, _query.getLimitOptions)();
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === false;
	        });
	      }
	    }, {
	      key: '$onChanges',
	      value: function $onChanges() {
	        this.administrations = this.administrations.filter(function (a) {
	          return a.Isloading === false;
	        });
	      }
	    }]);
	
	    return TreatAdminListComponent;
	  }()
	};

/***/ },
/* 679 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/product/treat-admin-list/treat-admin-list.html';
	var html = "<md-card> <md-toolbar class=\"md-table-toolbar alternate\" ng-if=$ctrl.showHeader> <div class=md-toolbar-tools> <span class=md-truncate>Intended Species (Treat)</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div flex ng-show=\"$ctrl.administrations && $ctrl.administrations.length\"> <md-table-container> <table md-table multiple=::!$ctrl.locked md-row-select=::!$ctrl.locked ng-model=$ctrl.selectedAdministrations> <thead md-head> <tr md-row> <th md-column><span>Species</span></th> </tr> </thead> <tbody md-body> <tr md-row md-auto-select ng-repeat=\"administration in $ctrl.administrations | limitTo: $ctrl.query.take : ($ctrl.query.page - 1) * $ctrl.query.take\" md-select=administration md-on-deselect=$ctrl.rowDeselected md-on-select=$ctrl.rowSelected> <td md-cell>{{administration.Species}}</td> </tr> </tbody> </table> </md-table-container> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.administrations.length}} md-label=\"{ rowsPerPage: 'Administrations per page:' }\"> </md-table-pagination> </div> <div layout-padding flex ng-hide=\"$ctrl.administrations && $ctrl.administrations.length\"> <p class=md-body-1> There are no species currently associated with this product. </p> </div> </md-card>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _query = __webpack_require__(408);
	
	var _products = __webpack_require__(681);
	
	var _products2 = _interopRequireDefault(_products);
	
	var _products3 = __webpack_require__(682);
	
	var _products4 = _interopRequireDefault(_products3);
	
	var _productSearch = __webpack_require__(684);
	
	var _productSearch2 = _interopRequireDefault(_productSearch);
	
	var _productLabelPreview = __webpack_require__(687);
	
	var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);
	
	__webpack_require__(691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.products', [_angularUiRouter2.default, _productLabelPreview2.default, _productSearch2.default]).component('products', _products4.default).service('ProductsService', _products2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('products', {
	    parent: 'app',
	    url: '/products',
	    component: 'products',
	    data: {
	      permissions: {
	        except: [_roles.REGULATOR],
	        redirectTo: 'app'
	      }
	    },
	    params: {
	      search: {
	        value: 'default'
	      }
	    },
	    resolve: {
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      },
	      user: ["currentUser", function user(currentUser) {
	        return currentUser;
	      }],
	      query: function query() {
	        return (0, _query.getQuery)();
	      },
	      limitOptions: function limitOptions() {
	        return (0, _query.getLimitOptions)();
	      },
	      alerts: ["ProductsService", function alerts(ProductsService) {
	        return ProductsService.getAlerts().then(function (r) {
	          return r.data;
	        });
	      }],
	      animalTypes: ["AnimalTypeService", function animalTypes(AnimalTypeService) {
	        return AnimalTypeService.getAnimalTypes().then(function (r) {
	          return r.data;
	        });
	      }],
	      products: ["$stateParams", "query", "ProductsService", function products($stateParams, query, ProductsService) {
	        ProductsService.setQuery(query);
	
	        if (!$stateParams.search) {
	          return ProductsService.getProducts().then(function (r) {
	            return r.data;
	          });
	        }
	
	        if ($stateParams.search === 'missing_sales') {
	          return ProductsService.getProductsMissingSalesData().then(function (r) {
	            return r.data;
	          });
	        } else if ($stateParams.search === 'missing_info') {
	          return ProductsService.getProductsMissingProductInfo().then(function (r) {
	            return r.data;
	          });
	        }
	
	        return ProductsService.getProducts().then(function (r) {
	          return r.data;
	        });
	      }],
	      // TODO: Refactor to OData call
	      categories: ["ProductService", function categories(ProductService) {
	        return ProductService.getCategories().then(function (r) {
	          return r.data;
	        });
	      }],
	      administrationUnits: ["ProductService", function administrationUnits(ProductService) {
	        return ProductService.getAdministrationUnits().then(function (r) {
	          return r.data;
	        });
	      }],
	      searchCriteria: ["$stateParams", function searchCriteria($stateParams) {
	        var selectedSearchType = 'All Products';
	        if ($stateParams.search === 'missing_sales') {
	          selectedSearchType = 'Missing - Containers Shipped Data';
	        } else if ($stateParams.search === 'missing_info') {
	          selectedSearchType = 'Missing - Product Information';
	        }
	
	        return {
	          selectedSearchType: selectedSearchType
	        };
	      }],
	      searchTypes: ["ProductsService", function searchTypes(ProductsService) {
	        return ProductsService.getSearchTypes();
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _roles = __webpack_require__(402);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductsService = function () {
	  ProductsService.$inject = ["$http"];
	  function ProductsService($http) {
	    'ngInject';
	
	    _classCallCheck(this, ProductsService);
	
	    this.$http = $http;
	  }
	
	  _createClass(ProductsService, [{
	    key: 'setQuery',
	    value: function setQuery(query) {
	      this.query = query;
	    }
	  }, {
	    key: 'getProducts',
	    value: function getProducts() {
	      return this.$http.get('/api/product/search_all', {
	        params: _extends({}, this.query)
	      });
	    }
	  }, {
	    key: 'getProductsBySpecies',
	    value: function getProductsBySpecies(species) {
	      return this.$http.get('/api/product/search_by_species', {
	        params: _extends({}, this.query, {
	          selectedSpecies: species
	        })
	      });
	    }
	  }, {
	    key: 'getProductsByMember',
	    value: function getProductsByMember(memberId) {
	      return this.$http.get('/api/product/search_by_member', {
	        params: _extends({}, this.query, {
	          memberId: memberId
	        })
	      });
	    }
	  }, {
	    key: 'getProductsByIngredient',
	    value: function getProductsByIngredient(ingredientId) {
	      return this.$http.get('/api/product/search_by_ingredient', {
	        params: _extends({}, this.query, {
	          userIngredientId: ingredientId
	        })
	      });
	    }
	  }, {
	    key: 'getProductsBySystemIngredient',
	    value: function getProductsBySystemIngredient(ingredientId) {
	      return this.$http.get('/api/product/search_by_system_ingredient', {
	        params: _extends({}, this.query, {
	          systemIngredientId: ingredientId
	        })
	      });
	    }
	  }, {
	    key: 'getProductsMissingProductInfo',
	    value: function getProductsMissingProductInfo() {
	      return this.$http.get('/api/product/search_by_missing_product_info', {
	        params: _extends({}, this.query)
	      });
	    }
	  }, {
	    key: 'getProductsMissingSalesData',
	    value: function getProductsMissingSalesData() {
	      return this.$http.get('/api/product/search_by_missing_sale_data', {
	        params: _extends({}, this.query)
	      });
	    }
	  }, {
	    key: 'getAlerts',
	    value: function getAlerts() {
	      return this.$http.get('/api/alert/load_alert_product');
	    }
	  }, {
	    key: 'updateMissingUsages',
	    value: function updateMissingUsages(usages) {
	      return this.$http.post('/api/usage/update_missing_usage', {
	        usages: usages
	      });
	    }
	  }, {
	    key: 'removeSignature',
	    value: function removeSignature(productId) {
	      return this.$http.delete('/api/product/' + productId + '/sign');
	    }
	  }, {
	    key: 'setDiscontinuedStatus',
	    value: function setDiscontinuedStatus(productId, isDiscontinued) {
	      return this.$http.put('/api/product/' + productId + '/discontinue', {
	        productId: productId,
	        isDiscontinued: isDiscontinued
	      });
	    }
	  }, {
	    key: 'getSearchTypes',
	    value: function getSearchTypes() {
	      return [{
	        name: 'All Products',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Ingredient Name',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by Species',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Missing - Containers Shipped Data',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Missing - Product Information',
	        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
	      }, {
	        name: 'Search by System Ingredient Name',
	        permission: '' + _roles.SYS_ADMIN
	      }, {
	        name: 'Search by Member',
	        permission: '' + _roles.SYS_ADMIN
	      }];
	    }
	  }, {
	    key: 'getLabelThumbnail',
	    value: function getLabelThumbnail(productId) {
	      return this.$http.get('/api/product_label/' + productId + '/thumbnail');
	    }
	  }, {
	    key: 'getLabel',
	    value: function getLabel(productId) {
	      return this.$http.get('/api/product_label/' + productId + '/request');
	    }
	  }, {
	    key: 'getLabelImage',
	    value: function getLabelImage(productId) {
	      return this.$http.get('/api/product_label/' + productId);
	    }
	  }]);
	
	  return ProductsService;
	}();
	
	exports.default = ProductsService;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _messages = __webpack_require__(442);
	
	var _products = __webpack_require__(683);
	
	var _products2 = _interopRequireDefault(_products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _products2.default,
	  bindings: {
	    flex: '@',
	    layout: '@',
	    alerts: '<',
	    administrationUnits: '<',
	    animalTypes: '<',
	    categories: '<',
	    user: '<',
	    products: '<',
	    searchCriteria: '<',
	    searchTypes: '<',
	    query: '<',
	    limitOptions: '<'
	  },
	  controller: function () {
	    ProductsComponent.$inject = ["$mdDialog", "$mdMenu", "$scope", "$state", "AccountService", "AuthService", "LoadingService", "ProductService", "ProductsService", "ToastService", "UsageDataService"];
	    function ProductsComponent($mdDialog, $mdMenu, $scope, $state, AccountService, AuthService, LoadingService, ProductService, ProductsService, ToastService, UsageDataService) {
	      'ngInject';
	
	      var _this = this;
	
	      _classCallCheck(this, ProductsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $mdMenu: $mdMenu,
	        $scope: $scope,
	        $state: $state,
	        AccountService: AccountService,
	        AuthService: AuthService,
	        LoadingService: LoadingService,
	        ProductService: ProductService,
	        ProductsService: ProductsService,
	        ToastService: ToastService,
	        UsageDataService: UsageDataService
	      });
	
	      this.onPaginationChanged = function (page, take) {
	        _this.query = _extends({}, _this.query, {
	          page: page,
	          take: take
	        });
	
	        _this.refreshResults();
	      };
	
	      this.onOrderChanged = function (order) {
	        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
	        var orderBy = order.replace('-', '');
	
	        _this.query = _extends({}, _this.query, {
	          direction: direction,
	          orderBy: orderBy
	        });
	
	        _this.refreshResults();
	      };
	    }
	
	    _createClass(ProductsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.searchCriteria = this.searchCriteria || {};
	        this.selectedProducts = [];
	      }
	    }, {
	      key: 'refreshResults',
	      value: function refreshResults() {
	        var _this2 = this;
	
	        this.ProductsService.setQuery(this.query);
	        this.promise = undefined;
	        switch (this.searchCriteria.selectedSearchType) {
	          case 'Search by Ingredient Name':
	            if (this.searchCriteria.selectedUserIngredient) {
	              this.promise = this.ProductsService.getProductsByIngredient(this.searchCriteria.selectedUserIngredient.UserIngredientId);
	            }
	            break;
	          case 'Search by System Ingredient Name':
	            if (this.searchCriteria.selectedSystemIngredient) {
	              this.promise = this.ProductsService.getProductsBySystemIngredient(this.searchCriteria.selectedSystemIngredient.SystemIngredientId);
	            }
	            break;
	          case 'Search by Member':
	            if (this.searchCriteria.selectedCompany) {
	              this.promise = this.ProductsService.getProductsByMember(this.searchCriteria.selectedCompany.MemberId);
	            }
	            break;
	          case 'Search by Species':
	            if (this.searchCriteria.selectedSpecies) {
	              this.promise = this.ProductsService.getProductsBySpecies(this.searchCriteria.selectedSpecies);
	            }
	            break;
	          case 'Missing - Containers Shipped Data':
	            this.promise = this.ProductsService.getProductsMissingSalesData();
	            break;
	          case 'Missing - Product Information':
	            this.promise = this.ProductsService.getProductsMissingProductInfo();
	            break;
	          default:
	            this.promise = this.ProductsService.getProducts();
	        }
	
	        this.promise = this.promise || this.ProductsService.getProducts();
	
	        this.promise.then(function (r) {
	          _this2.products = {
	            Count: r.data.Count,
	            Data: r.data.Data
	          };
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onSearchChanged',
	      value: function onSearchChanged(_ref) {
	        var searchCriteria = _ref.searchCriteria;
	
	        this.searchCriteria = searchCriteria;
	        this.query = _extends({}, this.query, {
	          searchText: this.searchCriteria.searchText
	        });
	
	        this.refreshResults();
	      }
	    }, {
	      key: 'getSignatureImage',
	      value: function getSignatureImage(signature) {
	        return signature && signature.length ? 'lock' : 'lock_open';
	      }
	    }, {
	      key: 'onEditClicked',
	      value: function onEditClicked(productId) {
	        this.$state.go('productEdit', { id: productId });
	      }
	    }, {
	      key: 'deleteSignature',
	      value: function deleteSignature(product) {
	        var _this3 = this;
	
	        if (this.AuthService.isSysAdmin && product.Signature && product.Signature.length) {
	          var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once confirmed, the product signature will be removed.').ok('Remove Signature').cancel('Cancel');
	
	          this.$mdDialog.show(confirm).then(function () {
	            _this3.ProductsService.removeSignature(product.ProductId).then(function () {
	              product.Signature = null;
	              _this3.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_DELETED);
	            }).catch(function (error) {
	              return _this3.ToastService.showError(error);
	            });
	          });
	        }
	      }
	    }, {
	      key: 'setDiscontinued',
	      value: function setDiscontinued(product) {
	        var _this4 = this;
	
	        if (!product.Discontinued) {
	          var confirm = this.$mdDialog.confirm().title('Are you sure you want to discontinue this product?').textContent(_messages.PRODUCT_DISCONTINUATION_GUIDANCE).ok('Discontinue Product').cancel('Cancel');
	
	          this.$mdDialog.show(confirm).then(function () {
	            // In this instance WITH the dialog, the value of product.Discontinued is correctly updated by the time we get here
	            _this4.ProductsService.setDiscontinuedStatus(product.ProductId, product.Discontinued).then(function () {
	              _this4.ToastService.showSuccess(_messages.PRODUCT_DISCONTINUED_EDITED);
	            }).catch(function (error) {
	              return _this4.ToastService.showError(error);
	            });
	          }).catch(function () {
	            product.Discontinued = false;
	            return false;
	          });
	        } else {
	          // In this instance WITHOUT the dialog, the value of product.Discontinued hasn't had a chance to update yet so we have to pass its inverse
	          this.ProductsService.setDiscontinuedStatus(product.ProductId, !product.Discontinued).then(function () {
	            _this4.ToastService.showSuccess(_messages.PRODUCT_DISCONTINUED_EDITED);
	          }).catch(function (error) {
	            return _this4.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'onViewClicked',
	      value: function onViewClicked(productId, index) {
	        var _this5 = this;
	
	        this.LoadingService.start();
	        this.ProductService.getProduct(productId).then(function (r) {
	          var product = r.data;
	
	          var scope = _angular2.default.extend(_this5.$scope.$new(true), {
	            product: product,
	            units: _this5.products.Data[index].UnitPerContainer,
	            categories: _this5.categories,
	            administrationUnits: _this5.administrationUnits,
	            administrations: product.tblDoses,
	            showUsageGuidance: false,
	            unitsDisplay: _this5.ProductService.getUnitsDisplay(product),
	            locked: true,
	            viewOnly: true
	          });
	
	          _this5.LoadingService.stop();
	
	          _this5.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: product.IsTreat ? '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <treat-information\n                  administration-units="administrationUnits" \n                  categories="categories"\n                  product="product"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  view-only="viewOnly"\n                  label-valid="true"\n                  show-header="true">\n                </treat-information>\n                <treat-admin-list flex\n                  units="units"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </treat-admin-list>\n                <product-ingredient-list flex ingredients="product.tblProduct_UserIngredient"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </product-ingredient-list>\n                <usage-data flex usages="product.tblUsages" show-guidance="showUsageGuidance"\n                  locked="locked"\n                  show-header="true">\n                </usage-data>\n              </md-dialog-content>\n            </md-dialog>\n          ' : '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <information\n                  administration-units="administrationUnits" \n                  categories="categories"\n                  product="product"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  view-only="viewOnly"\n                  label-valid="true"\n                  show-header="true">\n                </information>\n                <loading-admin-list flex\n                  ng-show="product.HasLoading"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </loading-admin-list>\n                <maintenance-admin-list flex\n                  units="units"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </maintenance-admin-list>\n                <product-ingredient-list flex ingredients="product.tblProduct_UserIngredient"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </product-ingredient-list>\n                <usage-data flex usages="product.tblUsages" show-guidance="showUsageGuidance"\n                  locked="locked"\n                  show-header="true">\n                </usage-data>\n              </md-dialog-content>\n            </md-dialog>\n          '
	          });
	        }).catch(function (error) {
	          return _this5.ToastService.showError(error);
	        }).finally(function () {
	          return _this5.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'showUsages',
	      value: function showUsages(quarterOnly) {
	        var _this6 = this;
	
	        var promise = void 0;
	        if (quarterOnly) {
	          promise = this.UsageDataService.getMissingQuarterUsageData();
	        } else {
	          promise = this.UsageDataService.getMissingUsageData();
	        }
	
	        promise.then(function (r) {
	          var usages = r.data;
	
	          if (usages && usages.length) {
	            var scope = _angular2.default.extend(_this6.$scope.$new(true), {
	              usages: usages,
	              onUsageDataUpdated: function onUsageDataUpdated($event) {
	                return _this6.onUsageDataUpdated($event);
	              }
	            });
	
	            _this6.$mdDialog.show({
	              clickOutsideToClose: true,
	              fullscreen: true,
	              scope: scope,
	              template: '\n          <md-dialog class="flex-85" style="max-height: 90%">\n            <md-dialog-content>\n              <dialog-close/>\n              <bulk-usage-data\n                usages="usages"\n                on-usages-submitted="onUsageDataUpdated($event)">\n              </bulk-usage-data>\n            </md-dialog-content>\n          </md-dialog>\n          '
	            });
	          } else {
	            _this6.$mdDialog.show(_this6.$mdDialog.alert().clickOutsideToClose(true).textContent('You are currently in compliance. No further action is required.').ariaLabel('No action required').ok('OK'));
	          }
	        }).catch(function (error) {
	          return _this6.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onUsageDataUpdated',
	      value: function onUsageDataUpdated($event) {
	        var _this7 = this;
	
	        if ($event && $event.usages) {
	          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
	            _this7.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
	            _this7.$mdDialog.hide();
	            _this7.$state.reload();
	          }).catch(function (error) {
	            return _this7.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'onEditProductUsageClicked',
	      value: function onEditProductUsageClicked(product) {
	        var _this8 = this;
	
	        this.ProductService.getProduct(product.ProductId).then(function (r) {
	          var scope = _angular2.default.extend(_this8.$scope.$new(true), {
	            dialogTitle: product.ProductName + ' - Number of Units Shipped (Shipping Data)',
	            usages: _this8.ProductService.transformUsages(product.ProductId, product.DateIntroduced, r.data.tblUsages),
	            usageDataChanged: function usageDataChanged($event) {
	              return _this8.onProductUsageDataUpdated($event);
	            }
	          });
	
	          _this8.$mdDialog.show({
	            clickOutsideToClose: true,
	            fullscreen: true,
	            scope: scope,
	            template: '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content>\n                <dialog-close/>\n                <usage-data usages="usages"\n                  show-guidance="true"\n                  show-header="true"\n                  dialog-title="{{dialogTitle}}"\n                  show-action-buttons="true"\n                  usage-data-changed="usageDataChanged($event)"\n                  missing-message="Shipping data is currently in compliance for this product.">\n                </usage-data>\n              </md-dialog-content>\n          </md-dialog>'
	          });
	        }).catch(function (error) {
	          return _this8.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onProductUsageDataUpdated',
	      value: function onProductUsageDataUpdated($event) {
	        var _this9 = this;
	
	        if ($event && $event.usages) {
	          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
	            _this9.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
	            _this9.$mdDialog.hide();
	          }).catch(function (error) {
	            return _this9.ToastService.showError(error);
	          });
	        }
	      }
	    }, {
	      key: 'alertClicked',
	      value: function alertClicked(_ref2) {
	        var alert = _ref2.alert;
	
	        if (alert) {
	          if (alert.AlertTypeID === 1) {
	            this.searchCriteria = _extends({}, this.searchCriteria, {
	              selectedSearchType: 'Missing - Product Information'
	            });
	
	            this.refreshResults();
	          } else if (alert.AlertTypeID === 3) {
	            if (this.AuthService.isSysAdmin) {
	              this.searchCriteria = _extends({}, this.searchCriteria, {
	                selectedSearchType: 'Missing - Containers Shipped Data'
	              });
	
	              this.refreshResults();
	            } else {
	              this.showUsages(false);
	            }
	          }
	        }
	      }
	    }, {
	      key: 'saveProductLabel',
	      value: function saveProductLabel(_ref3) {
	        var _this10 = this;
	
	        var productId = _ref3.productId,
	            productLabel = _ref3.productLabel;
	
	        this.LoadingService.start();
	        this.ProductService.uploadLabel(productId, productLabel).then(function () {
	          _this10.ToastService.showSuccess(_messages.PRODUCT_LABEL_COMMITTED);
	          _this10.$state.reload();
	        }).catch(function (error) {
	          return _this10.ToastService.showError(error);
	        }).finally(function () {
	          return _this10.LoadingService.stop();
	        });
	      }
	    }, {
	      key: 'updateDiscontinuedSetting',
	      value: function updateDiscontinuedSetting(showDiscontinuedProducts) {
	        var _this11 = this;
	
	        this.AccountService.updateDiscontinuedPreference(this.user.UserId, showDiscontinuedProducts).then(function () {
	          _this11.ToastService.showSuccess(_messages.DISCONTINUED_PREFERENCE_CHANGED);
	          _this11.$state.reload();
	        }).catch(function (error) {
	          return _this11.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'onDeleteClicked',
	      value: function onDeleteClicked(products) {
	        var _this12 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent(_messages.PRODUCT_DELETE_GUIDANCE).ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = products.length - 1; i >= 0; i -= 1) {
	            promises.push(_this12.ProductService.delete(products[i].ProductId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this12.ToastService.showSuccess(_messages.PRODUCT_DELETED);
	            _this12.refreshResults();
	            _this12.selectedProducts = [];
	          }).catch(function (error) {
	            return _this12.ToastService.showError(error);
	          });
	        });
	      }
	    }, {
	      key: 'onBulkUnsignClicked',
	      value: function onBulkUnsignClicked(products) {
	        var _this13 = this;
	
	        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once confirmed, the product signature(s) will be removed.').ok('Delete').cancel('Cancel');
	
	        this.$mdDialog.show(confirm).then(function () {
	          var promises = [];
	          for (var i = products.length - 1; i >= 0; i -= 1) {
	            promises.push(_this13.ProductsService.removeSignature(products[i].ProductId));
	          }
	
	          Promise.all(promises).then(function () {
	            _this13.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_DELETED);
	            _this13.refreshResults();
	            _this13.selectedProducts = [];
	          }).catch(function (error) {
	            return _this13.ToastService.showError(error);
	          });
	        });
	      }
	    }]);
	
	    return ProductsComponent;
	  }()
	};

/***/ },
/* 683 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/products/products.html';
	var html = "<div layout=column layout-padding flex> <section layout=column flex> <div layout=row layout-xs=column layout-sm=column> <alert alerts=$ctrl.alerts on-alert-clicked=$ctrl.alertClicked($event) flex=100 flex-gt-sm=60> </alert> <div flex=100 flex-md=40 flex-offset-md=0 flex-lg=25 flex-offset-lg=15 flex-offset-gt-lg=20 flex-gt-lg=20 layout=column> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Supplement\" ui-sref=productCreate permission permission-only=\"['USER', 'COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Supplement </md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Add Treat\" ui-sref=treatProductCreate permission permission-only=\"['USER', 'COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>add</md-icon> Add Treat </md-button> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Update Shipping Data\" ng-click=$ctrl.showUsages(true) permission permission-only=\"['USER', 'COMPANY_ADMIN']\" flex-xs=100> <md-icon md-font-set=material-icons>refresh</md-icon> Update Shipping Data </md-button> </div> </div> <md-card layout=column flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Product Management</span> <div flex></div> <md-checkbox hide-xs ng-model=$ctrl.user.Is_Show_Discontiuned ng-change=$ctrl.updateDiscontinuedSetting($ctrl.user.Is_Show_Discontiuned) style=font-size:16px>Show Discontinued Products</md-checkbox> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedProducts && $ctrl.selectedProducts.length\" ng-click=$ctrl.onBulkUnsignClicked($ctrl.selectedProducts)> <md-tooltip md-direction=top>Unsign Product</md-tooltip> <md-icon md-font-set=material-icons>lock_open</md-icon> </md-button> <md-button class=\"md-accent md-fab md-mini\" ng-if=\"$ctrl.selectedProducts && $ctrl.selectedProducts.length\" ng-click=$ctrl.onDeleteClicked($ctrl.selectedProducts)> <md-tooltip md-direction=top>Delete Product</md-tooltip> <md-icon md-font-set=material-icons>delete</md-icon> </md-button> </div> </md-toolbar> <product-search animal-types=::$ctrl.animalTypes search-criteria-changed=$ctrl.onSearchChanged($event) search-types=::$ctrl.searchTypes search-criteria=$ctrl.searchCriteria> </product-search> <md-table-container> <table md-table md-progress=$ctrl.promise id=product-search multiple=true md-row-select=::$ctrl.AuthService.isSysAdmin ng-model=$ctrl.selectedProducts> <thead md-head md-order=$ctrl.query.order md-on-reorder=$ctrl.onOrderChanged> <tr md-row> <th md-column md-order-by=MemberName permission permission-only=\"'SYS_ADMIN'\"><span>Company</span></th> <th md-column md-order-by=AECount><span>AEs</span></th> <th md-column md-order-by=ProductName><span>Product Name</span></th> <th md-column md-order-by=SKU><span>SKU</span></th> <th md-column md-order-by=DateIntroduced hide show-gt-md><span>Market Date</span></th> <th md-column md-order-by=ProductForm hide show-gt-md><span>Product Form</span></th> <th md-column md-order-by=Discontinued hide show-gt-md><span>Discontinued</span></th> <th md-column md-order-by=Signature><span>Signed Off</span></th> <th md-column style=text-align:center>Label</th> <th md-column permission permission-only=\"['USER', 'COMPANY_ADMIN']\">&nbsp;</th> <th md-column>&nbsp;</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"product in $ctrl.products.Data\" ng-value={{$index}} class=product-row ng-click=\"$ctrl.onViewClicked(product.ProductId, $index)\" md-select=product> <td md-cell permission permission-only=\"'SYS_ADMIN'\">{{product.MemberName}}</td> <td md-cell>{{product.AECount}}</td> <td md-cell>{{product.ProductName}}</td> <td md-cell>{{product.SKU}}</td> <td md-cell hide show-gt-md>{{product.DateIntroduced | date:'MMM-yy'}}</td> <td md-cell hide show-gt-md>{{product.ProductForm}}</td> <td md-cell stop-event=click hide show-gt-md> <md-checkbox ng-model=product.Discontinued ng-click=$ctrl.setDiscontinued(product) aria-label=Discontinued ng-disabled=\"::!($ctrl.AuthService.isSysAdmin || $ctrl.AuthService.isCompanyAdmin)\"></md-checkbox> </td> <td md-cell stop-event=click> <md-button aria-label=\"Sign Off Status\" class=md-icon-button> <md-icon class=md-primary ng-click=$ctrl.deleteSignature(product)> {{$ctrl.getSignatureImage(product.Signature)}} </md-icon> </md-button> </td> <td md-cell stop-event=click> <div layout=column layout-align=\"center center\"> <product-label-preview product=product ng-if=product.hasLabel> </product-label-preview> <product-label-upload on-product-label-changed=$ctrl.saveProductLabel($event) label-class=md-icon-button icon-class=md-primary product-id=product.ProductId show-preview=false is-abbreviated=true flex button-width=100> </product-label-upload> </div> </td> <td md-cell stop-event=click permission permission-only=\"['USER', 'COMPANY_ADMIN']\"> <a href ng-click=$ctrl.onEditProductUsageClicked(product) class=md-primary>Update<br/>Shipping</a> </td> <td md-cell stop-event=click> <a href ng-show=\"product.IsTreat == false\" ui-sref=\"productEdit({id: product.ProductId})\" class=md-primary>Edit</a> <a href ng-show=\"product.IsTreat == true\" ui-sref=\"treatProductEdit({id: product.ProductId})\" class=md-primary>Edit</a> </td> </tr> </tbody> </table> </md-table-container> <div layout=row layout-align=\"center center\" flex> <p class=md-body-1 ng-hide=\"$ctrl.products.Data && $ctrl.products.Data.length\"> There are no products matching the specified criteria. </p> </div> <md-table-pagination md-limit=$ctrl.query.take md-limit-options=$ctrl.limitOptions md-page=$ctrl.query.page md-total={{$ctrl.products.Count}} md-on-paginate=$ctrl.onPaginationChanged md-label=\"{ rowsPerPage: 'Products per page:' }\"> </md-table-pagination> </md-card> </section> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productSearch = __webpack_require__(685);
	
	var _productSearch2 = _interopRequireDefault(_productSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.products.productSearch', []).component('productSearch', _productSearch2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _productSearch = __webpack_require__(686);
	
	var _productSearch2 = _interopRequireDefault(_productSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _productSearch2.default,
	  bindings: {
	    animalTypes: '<',
	    searchCriteria: '<',
	    searchCriteriaChanged: '&',
	    searchTypes: '<'
	  },
	  controller: function () {
	    ProductSearchComponent.$inject = ["EventEmitter"];
	    function ProductSearchComponent(EventEmitter) {
	      'ngInject';
	
	      _classCallCheck(this, ProductSearchComponent);
	
	      Object.assign(this, { EventEmitter: EventEmitter });
	    }
	
	    _createClass(ProductSearchComponent, [{
	      key: '$onChanges',
	      value: function $onChanges(changes) {
	        if (changes.searchCriteria) {
	          this.searchCriteria = Object.assign({}, this.searchCriteria);
	        }
	      }
	    }, {
	      key: 'onChange',
	      value: function onChange() {
	        this.searchCriteriaChanged(this.EventEmitter({
	          searchCriteria: this.searchCriteria
	        }));
	      }
	    }, {
	      key: 'selectedUserIngredientChanged',
	      value: function selectedUserIngredientChanged($event) {
	        this.searchCriteria.selectedUserIngredient = $event.selectedIngredient;
	        this.onChange();
	      }
	    }, {
	      key: 'selectedSystemIngredientChanged',
	      value: function selectedSystemIngredientChanged($event) {
	        this.searchCriteria.selectedSystemIngredient = $event.selectedIngredient;
	        this.onChange();
	      }
	    }, {
	      key: 'selectedMemberChanged',
	      value: function selectedMemberChanged($event) {
	        this.searchCriteria.selectedCompany = $event.company;
	        this.onChange();
	      }
	    }]);
	
	    return ProductSearchComponent;
	  }()
	};

/***/ },
/* 686 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/products/product-search/product-search.html';
	var html = "<form name=$ctrl.productSearchForm flex=100 novalidate> <div layout-padding layout-wrap layout=column layout-gt-xs=row flex> <md-input-container class=md-block flex=100 flex-gt-xs=50> <label>Choose a Search</label> <md-select ng-model=$ctrl.searchCriteria.selectedSearchType ng-change=$ctrl.onChange()> <md-option ng-repeat=\"searchType in $ctrl.searchTypes\" value={{searchType.name}} permission permission-only=searchType.permission> {{searchType.name}} </md-option> </md-select> </md-input-container> <ng-switch on=$ctrl.searchCriteria.selectedSearchType flex=100 flex-gt-xs=50> <div flex ng-switch-when=\"Search by Ingredient Name\"> <ingredient-autocomplete ingredient-type=user label-text=\"Search for Ingredient By Name\" search-display-property=UserIngredientName on-ingredient-selected=$ctrl.selectedUserIngredientChanged($event)> </ingredient-autocomplete> </div> <div flex ng-switch-when=\"Search by System Ingredient Name\"> <ingredient-autocomplete ingredient-type=system label-text=\"Search for System Ingredient By Name\" search-display-property=SystemIngredientName on-ingredient-selected=$ctrl.selectedSystemIngredientChanged($event)> </ingredient-autocomplete> </div> <div flex ng-switch-when=\"Search by Member\"> <company-autocomplete on-company-selected=$ctrl.selectedMemberChanged($event)> </company-autocomplete> </div> <div flex ng-switch-when=\"Search by Species\"> <md-input-container class=md-block flex=100> <label>Species</label> <md-select ng-model=$ctrl.searchCriteria.selectedSpecies name=animalType required ng-change=$ctrl.onChange()> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" value={{animalType.AnimalTypeName}}> {{animalType.AnimalTypeName}} </md-option> </md-select> <div ng-messages=$ctrl.productSearchForm.animalType.$error md-auto-hide=false> <div ng-message=required> Species is required. </div> </div> </md-input-container> </div> </ng-switch> <md-input-container class=md-block flex=100> <label>Quick Search</label> <md-icon md-font-set=material-icons class=md-primary>search</md-icon> <input name=searchText ng-model=$ctrl.searchCriteria.searchText ng-model-options=\"{ debounce: 250 }\" ng-change=$ctrl.onChange()> </md-input-container> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _productLabelPreview = __webpack_require__(688);
	
	var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('common.components.productLabelPreview', []).component('productLabelPreview', _productLabelPreview2.default).name;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _productLabelPreview = __webpack_require__(689);
	
	var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _productLabelPreview2.default,
	  bindings: {
	    product: '<'
	  },
	  controller: function () {
	    ProductLabelDownloadComponent.$inject = ["$log", "ameLightbox", "ProductsService", "ToastService"];
	    function ProductLabelDownloadComponent($log, ameLightbox, ProductsService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ProductLabelDownloadComponent);
	
	      Object.assign(this, {
	        $log: $log,
	        ameLightbox: ameLightbox,
	        ProductsService: ProductsService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(ProductLabelDownloadComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        var _this = this;
	
	        if (this.product.hasPDFLabel) {
	          this.ProductsService.getLabel(this.product.ProductId).then(function (r) {
	            _this.label = r.data;
	          }).catch(function () {
	            _this.$log.error('Unable to get product label PDF download link! Product ID: ' + _this.product.ProductId + ')');
	          });
	        } else {
	          this.ProductsService.getLabelThumbnail(this.product.ProductId).then(function (r) {
	            _this.imageArr = r.data;
	          }).catch(function () {
	            _this.$log.error('Unable to get product label thumbnail! Product ID: ' + _this.product.ProductId + ')');
	          });
	        }
	      }
	    }, {
	      key: 'previewLabelImage',
	      value: function previewLabelImage(productId) {
	        var _this2 = this;
	
	        this.ProductsService.getLabelImage(productId).then(function (r) {
	          _this2.ameLightbox.show([r.data], {
	            buttonClass: 'ng-hide',
	            keyboard: false,
	            showDots: false
	          });
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }]);
	
	    return ProductLabelDownloadComponent;
	  }()
	};

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/products/product-label-preview/product-label-preview.html';
	var html = "<md-button ng-href={{$ctrl.label.DownloadUrl}} ng-if=\"$ctrl.product.hasPDFLabel && $ctrl.label\" aria-label=\"Download Product Label\" class=md-icon-button> <md-tooltip>Download Product Label</md-tooltip> <md-icon md-font-set=material-icons class=md-primary> insert_drive_file </md-icon> </md-button> <img style=width:50px;height:50px;margin:2px src=" + __webpack_require__(690) + " ng-if=\"$ctrl.product.hasLabel && !$ctrl.product.hasPDFLabel\" ng-src={{$ctrl.imageArr}} ng-click=$ctrl.previewLabelImage($ctrl.product.ProductId)> ";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "67ddcddbac52ddbc73f15c1b68ff8111.gif";

/***/ },
/* 691 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _reports = __webpack_require__(693);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _adminsByCategoryArea = __webpack_require__(695);
	
	var _adminsByCategoryArea2 = _interopRequireDefault(_adminsByCategoryArea);
	
	var _adminsByCategoryBar = __webpack_require__(699);
	
	var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);
	
	var _adminsByCategoryPie = __webpack_require__(703);
	
	var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);
	
	var _adminTrend = __webpack_require__(707);
	
	var _adminTrend2 = _interopRequireDefault(_adminTrend);
	
	var _ingredientRisk = __webpack_require__(711);
	
	var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);
	
	var _reportForm = __webpack_require__(718);
	
	var _reportForm2 = _interopRequireDefault(_reportForm);
	
	var _riskByYear = __webpack_require__(722);
	
	var _riskByYear2 = _interopRequireDefault(_riskByYear);
	
	var _seriousRiskByYear = __webpack_require__(726);
	
	var _seriousRiskByYear2 = _interopRequireDefault(_seriousRiskByYear);
	
	var _systemMetrics = __webpack_require__(730);
	
	var _systemMetrics2 = _interopRequireDefault(_systemMetrics);
	
	__webpack_require__(734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports', [_angularUiRouter2.default, _adminsByCategoryArea2.default, _adminsByCategoryBar2.default, _adminsByCategoryPie2.default, _adminTrend2.default, _ingredientRisk2.default, _reportForm2.default, _riskByYear2.default, _seriousRiskByYear2.default, _systemMetrics2.default]).component('reports', _reports2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('reports', {
	    parent: 'app',
	    url: '/reports',
	    component: 'reports',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    },
	    resolve: {
	      reportTypes: ["ReportService", function reportTypes(ReportService) {
	        return ReportService.getReportTypes().filter(function (r) {
	          return r.enabled;
	        }).sort(function (a, b) {
	          var nameA = a.name.toLowerCase();
	          var nameB = b.name.toLowerCase();
	          if (nameA < nameB) return -1;
	          if (nameA > nameB) return 1;
	          return 0;
	        });
	      }],
	      flex: function flex() {
	        return '100';
	      },
	      layout: function layout() {
	        return 'column';
	      }
	    }
	  });
	}]).name;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reports = __webpack_require__(694);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _reports2.default,
	  bindings: {
	    reportTypes: '<',
	    chartConfig: '<',
	    flex: '<',
	    layout: '<'
	  },
	  controller: function () {
	    ReportsComponent.$inject = ["$mdDialog", "$scope", "$state", "ReportService"];
	    function ReportsComponent($mdDialog, $scope, $state, ReportService) {
	      'ngInject';
	
	      _classCallCheck(this, ReportsComponent);
	
	      Object.assign(this, {
	        $mdDialog: $mdDialog,
	        $scope: $scope,
	        $state: $state,
	        ReportService: ReportService
	      });
	    }
	
	    _createClass(ReportsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.setSelectedReportFromState();
	      }
	    }, {
	      key: 'setSelectedReportFromState',
	      value: function setSelectedReportFromState() {
	        var _this = this;
	
	        var reportType = this.reportTypes.filter(function (f) {
	          return f.state === _this.$state.current.name;
	        });
	        if (reportType && reportType.length) {
	          this.selectedReport = reportType[0];
	        }
	      }
	    }, {
	      key: 'onReportChanged',
	      value: function onReportChanged(reportType) {
	        if (reportType) {
	          this.$state.go(reportType.state);
	        }
	      }
	    }]);
	
	    return ReportsComponent;
	  }()
	};

/***/ },
/* 694 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/reports.html';
	var html = "<div layout=column layout-padding flex> <div flex layout=column> <md-card flex=100> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>Reports</span> </div> </md-toolbar> <div layout=column layout-padding> <div layout=column> <md-input-container class=md-block> <label>Report Type</label> <md-select ng-model=$ctrl.selectedReport ng-change=$ctrl.onReportChanged($ctrl.selectedReport) placeholder=\"-- Select a Report --\"> <md-option ng-repeat=\"reportType in $ctrl.reportTypes\" ng-value=reportType> {{reportType.name}} </md-option> </md-select> </md-input-container> <ui-view layout=column flex></ui-view> </div> </div> </md-card></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _adminsByCategoryArea = __webpack_require__(696);
	
	var _adminsByCategoryArea2 = _interopRequireDefault(_adminsByCategoryArea);
	
	var _adminsByCategoryArea3 = __webpack_require__(698);
	
	var _adminsByCategoryArea4 = _interopRequireDefault(_adminsByCategoryArea3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.administrationsByCategoryArea', [_angularUiRouter2.default]).component('administrationsByCategoryArea', _adminsByCategoryArea2.default).service('AdminsByCategoryAreaService', _adminsByCategoryArea4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('administrationsByCategoryArea', {
	    parent: 'reports',
	    url: '/administrations-by-category-area',
	    component: 'administrationsByCategoryArea',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminsByCategoryArea = __webpack_require__(697);
	
	var _adminsByCategoryArea2 = _interopRequireDefault(_adminsByCategoryArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminsByCategoryArea2.default,
	  controller: function () {
	    AdministrationsByCategoryAreaComponent.$inject = ["$scope", "LoadingService", "AdminsByCategoryAreaService", "ToastService"];
	    function AdministrationsByCategoryAreaComponent($scope, LoadingService, AdminsByCategoryAreaService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdministrationsByCategoryAreaComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        AdminsByCategoryAreaService: AdminsByCategoryAreaService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AdministrationsByCategoryAreaComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = {
	          chart: {
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'Administrations By Category'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'datetime',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
	          },
	          yAxis: [{
	            title: {
	              text: 'Administrations (mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value} mil',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }],
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          },
	          legend: {
	            itemWidth: 180,
	            itemDistance: 0,
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            series: {
	              dataLabels: {
	                enabled: false
	              }
	            },
	            area: {
	              stacking: 'normal',
	              lineColor: '#666666',
	              lineWidth: 1,
	              marker: {
	                enabled: false
	              }
	            }
	          }
	        };
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.AdminsByCategoryAreaService.getReport(params).then(function (series) {
	          _this.chartConfig.series = series;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return AdministrationsByCategoryAreaComponent;
	  }()
	};

/***/ },
/* 697 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admins-by-category-area/admins-by-category-area.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 698 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminsByCategoryAreaService = function () {
	  AdminsByCategoryAreaService.$inject = ["$http"];
	  function AdminsByCategoryAreaService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdminsByCategoryAreaService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(AdminsByCategoryAreaService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      return this.$http.get('/api/report/data_y_c_admin', {
	        params: _extends({
	          chartType: 'area'
	        }, params)
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	
	  return AdminsByCategoryAreaService;
	}();
	
	exports.default = AdminsByCategoryAreaService;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _adminsByCategoryBar = __webpack_require__(700);
	
	var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);
	
	var _adminsByCategoryBar3 = __webpack_require__(702);
	
	var _adminsByCategoryBar4 = _interopRequireDefault(_adminsByCategoryBar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.administrationsByCategoryBar', [_angularUiRouter2.default]).component('administrationsByCategoryBar', _adminsByCategoryBar2.default).service('AdminsByCategoryBarService', _adminsByCategoryBar4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('administrationsByCategoryBar', {
	    parent: 'reports',
	    url: '/administrations-by-category-bar',
	    component: 'administrationsByCategoryBar',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminsByCategoryBar = __webpack_require__(701);
	
	var _adminsByCategoryBar2 = _interopRequireDefault(_adminsByCategoryBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminsByCategoryBar2.default,
	  controller: function () {
	    AdministrationsByCategoryBarComponent.$inject = ["$scope", "LoadingService", "AdminsByCategoryBarService", "ToastService"];
	    function AdministrationsByCategoryBarComponent($scope, LoadingService, AdminsByCategoryBarService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdministrationsByCategoryBarComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        AdminsByCategoryBarService: AdminsByCategoryBarService,
	        ToastService: ToastService
	      });
	
	      // window.Highcharts.theme = {
	      //   colors: ['#f45b5b', '#8085e9', '#8d4654', '#7798BF', '#aaeeee',
	      //     '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
	      //   chart: {
	      //     backgroundColor: null,
	      //     style: {
	      //       fontFamily: 'Signika, serif'
	      //     }
	      //   },
	      //   title: {
	      //     style: {
	      //       color: 'black',
	      //       fontSize: '16px',
	      //       fontWeight: 'bold'
	      //     }
	      //   },
	      //   subtitle: {
	      //     style: {
	      //       color: 'black'
	      //     }
	      //   },
	      //   tooltip: {
	      //     borderWidth: 0
	      //   },
	      //   legend: {
	      //     itemStyle: {
	      //       fontWeight: 'bold',
	      //       fontSize: '13px'
	      //     }
	      //   },
	      //   xAxis: {
	      //     labels: {
	      //       style: {
	      //         color: '#6e6e70'
	      //       }
	      //     }
	      //   },
	      //   yAxis: {
	      //     labels: {
	      //       style: {
	      //         color: '#6e6e70'
	      //       }
	      //     }
	      //   },
	      //   plotOptions: {
	      //     series: {
	      //       shadow: true
	      //     },
	      //     candlestick: {
	      //       lineColor: '#404048'
	      //     },
	      //     map: {
	      //       shadow: false
	      //     }
	      //   },
	
	      //   // Highstock specific
	      //   navigator: {
	      //     xAxis: {
	      //       gridLineColor: '#D0D0D8'
	      //     }
	      //   },
	      //   rangeSelector: {
	      //     buttonTheme: {
	      //       fill: 'white',
	      //       stroke: '#C0C0C8',
	      //       'stroke-width': 1,
	      //       states: {
	      //         select: {
	      //           fill: '#D0D0D8'
	      //         }
	      //       }
	      //     }
	      //   },
	      //   scrollbar: {
	      //     trackBorderColor: '#C0C0C8'
	      //   },
	
	      //   // General
	      //   background2: '#E0E0E8'
	      // };
	      // window.Highcharts.setOptions(window.Highcharts.theme);
	    }
	
	    _createClass(AdministrationsByCategoryBarComponent, [{
	      key: 'getChartConfig',
	      value: function getChartConfig() {
	        return {
	          chart: {
	            type: 'column',
	            inverted: true,
	            marginLeft: 225,
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'Administrations by Product Category'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: [{
	            type: 'category',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            }
	          }],
	          yAxis: [{
	            title: {
	              text: 'Administrations (mils)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }],
	          legend: {
	            align: 'center',
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            pie: {
	              size: 500,
	              allowPointSelect: true,
	              cursor: 'pointer',
	              dataLabels: {
	                enabled: true,
	                format: '{point.name}: {point.percentage:.1f}%',
	                style: {
	                  fontSize: '14px'
	                }
	              },
	              showInLegend: true
	            },
	            column: {
	              stacking: 'normal',
	              align: 'top',
	              pointPadding: 0,
	              groupPadding: 0.1,
	              borderWidth: 0,
	              dataLabels: {
	                enabled: true,
	                format: '{point.y:,.2f}'
	              }
	            }
	          },
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          }
	        };
	      }
	    }, {
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = this.getChartConfig();
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.AdminsByCategoryBarService.getReport(params).then(function (_ref2) {
	          var series = _ref2.series,
	              drilldown = _ref2.drilldown;
	
	          _this.chartConfig = undefined;
	          _this.$scope.$apply();
	          _this.chartConfig = _this.getChartConfig();
	          _this.chartConfig.series = series;
	          _this.chartConfig.drilldown = drilldown;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return AdministrationsByCategoryBarComponent;
	  }()
	};

/***/ },
/* 701 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admins-by-category-bar/admins-by-category-bar.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 702 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminsByCategoryBarService = function () {
	  AdminsByCategoryBarService.$inject = ["$http"];
	  function AdminsByCategoryBarService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdminsByCategoryBarService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(AdminsByCategoryBarService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      var pData = this.$http.get('/api/report/data_a_c_admin', {
	        params: _extends({
	          chartType: 'column'
	        }, params)
	      });
	
	      var pDrilldown = this.$http.get('/api/report/data_a_y_c_admin', {
	        params: _extends({
	          chartType: 'pie'
	        }, params)
	      });
	
	      return Promise.all([pData, pDrilldown]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            pDataResult = _ref2[0],
	            pDrilldownResult = _ref2[1];
	
	        var series = pDataResult.data;
	        var drilldown = { series: pDrilldownResult.data };
	
	        return { series: series, drilldown: drilldown };
	      });
	    }
	  }]);
	
	  return AdminsByCategoryBarService;
	}();
	
	exports.default = AdminsByCategoryBarService;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _adminsByCategoryPie = __webpack_require__(704);
	
	var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);
	
	var _adminsByCategoryPie3 = __webpack_require__(706);
	
	var _adminsByCategoryPie4 = _interopRequireDefault(_adminsByCategoryPie3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.administrationsByCategoryPie', [_angularUiRouter2.default]).component('administrationsByCategoryPie', _adminsByCategoryPie2.default).service('AdminsByCategoryPieService', _adminsByCategoryPie4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('administrationsByCategoryPie', {
	    parent: 'reports',
	    url: '/administrations-by-category-pie',
	    component: 'administrationsByCategoryPie',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminsByCategoryPie = __webpack_require__(705);
	
	var _adminsByCategoryPie2 = _interopRequireDefault(_adminsByCategoryPie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminsByCategoryPie2.default,
	  controller: function () {
	    AdministrationsByCategoryPieComponent.$inject = ["$scope", "LoadingService", "AdminsByCategoryPieService", "ToastService"];
	    function AdministrationsByCategoryPieComponent($scope, LoadingService, AdminsByCategoryPieService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdministrationsByCategoryPieComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        AdminsByCategoryPieService: AdminsByCategoryPieService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AdministrationsByCategoryPieComponent, [{
	      key: 'getChartConfig',
	      value: function getChartConfig() {
	        return {
	          title: {
	            text: 'Administrations by Product Category'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'category'
	          },
	          yAxis: {
	            title: {
	              text: 'Administrations (in mils)'
	            }
	          },
	          legend: {
	            itemWidth: 180,
	            itemDistance: 0,
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            pie: {
	              size: 500,
	              allowPointSelect: true,
	              cursor: 'pointer',
	              dataLabels: {
	                enabled: true,
	                format: '{point.name}: {point.percentage:.1f}%',
	                style: {
	                  fontSize: '14px'
	                }
	              },
	              showInLegend: true
	            }
	          },
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
	            footerFormat: '</table>',
	            shared: true,
	            useHTML: true
	          }
	        };
	      }
	    }, {
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = this.getChartConfig();
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.AdminsByCategoryPieService.getReport(params).then(function (_ref2) {
	          var series = _ref2.series,
	              drilldown = _ref2.drilldown;
	
	          _this.chartConfig = undefined;
	          _this.$scope.$apply();
	          _this.chartConfig = _extends({}, _this.getChartConfig(), {
	            series: series,
	            drilldown: drilldown
	          });
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return AdministrationsByCategoryPieComponent;
	  }()
	};

/***/ },
/* 705 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admins-by-category-pie/admins-by-category-pie.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 706 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminsByCategoryPieService = function () {
	  AdminsByCategoryPieService.$inject = ["$http"];
	  function AdminsByCategoryPieService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdminsByCategoryPieService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(AdminsByCategoryPieService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      var pData = this.$http.get('/api/report/data_c_admin', {
	        params: _extends({
	          chartType: 'pie'
	        }, params)
	      });
	
	      var pDrilldown = this.$http.get('/api/report/data_c_a_admin', {
	        params: _extends({
	          chartType: 'pie'
	        }, params)
	      });
	
	      return Promise.all([pData, pDrilldown]).then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            pDataResult = _ref2[0],
	            pDrilldownResult = _ref2[1];
	
	        var series = pDataResult.data;
	        var drilldown = { series: pDrilldownResult.data };
	
	        return { series: series, drilldown: drilldown };
	      });
	    }
	  }]);
	
	  return AdminsByCategoryPieService;
	}();
	
	exports.default = AdminsByCategoryPieService;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _adminTrend = __webpack_require__(708);
	
	var _adminTrend2 = _interopRequireDefault(_adminTrend);
	
	var _adminTrend3 = __webpack_require__(710);
	
	var _adminTrend4 = _interopRequireDefault(_adminTrend3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.adminTrend', [_angularUiRouter2.default]).component('administrationTrend', _adminTrend2.default).service('AdminTrendService', _adminTrend4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('administrationTrend', {
	    parent: 'reports',
	    url: '/administrations-trend',
	    component: 'administrationTrend',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _adminTrend = __webpack_require__(709);
	
	var _adminTrend2 = _interopRequireDefault(_adminTrend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _adminTrend2.default,
	  controller: function () {
	    AdminTrendComponent.$inject = ["$scope", "LoadingService", "AdminTrendService", "ToastService"];
	    function AdminTrendComponent($scope, LoadingService, AdminTrendService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, AdminTrendComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        AdminTrendService: AdminTrendService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(AdminTrendComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = {
	          chart: {
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'Administrations Trend'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'datetime',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
	          },
	          yAxis: [{
	            title: {
	              text: 'Administrations (mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value} mil',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }],
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          },
	          legend: {
	            layout: 'vertical',
	            align: 'left',
	            x: 100,
	            verticalAlign: 'top',
	            y: 20,
	            floating: true,
	            itemWidth: 180,
	            itemDistance: 0,
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            series: {
	              dataLabels: {
	                enabled: false
	              }
	            },
	            area: {
	              fillOpacity: 0.2,
	              stacking: 'normal',
	              lineColor: '#666666',
	              lineWidth: 1,
	              marker: {
	                enabled: false
	              }
	            }
	          }
	        };
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.AdminTrendService.getReport(params).then(function (series) {
	          _this.chartConfig.series = series;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return AdminTrendComponent;
	  }()
	};

/***/ },
/* 709 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admin-trend/admin-trend.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden> </highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 710 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminTrendService = function () {
	  AdminTrendService.$inject = ["$http"];
	  function AdminTrendService($http) {
	    'ngInject';
	
	    _classCallCheck(this, AdminTrendService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(AdminTrendService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      return this.$http.get('/api/report/data_a_y_admin', {
	        params: _extends({}, params)
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	
	  return AdminTrendService;
	}();
	
	exports.default = AdminTrendService;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _ingredientRisk = __webpack_require__(712);
	
	var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);
	
	var _ingredientRisk3 = __webpack_require__(714);
	
	var _ingredientRisk4 = _interopRequireDefault(_ingredientRisk3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.ingredient-risk', [_angularUiRouter2.default]).component('ingredientRiskReport', _ingredientRisk2.default).service('IngredientRiskService', _ingredientRisk4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('ingredientRisk', {
	    parent: 'reports',
	    url: '/ingredient-risk',
	    component: 'ingredientRiskReport',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messages = __webpack_require__(442);
	
	var _ingredientRisk = __webpack_require__(713);
	
	var _ingredientRisk2 = _interopRequireDefault(_ingredientRisk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _ingredientRisk2.default,
	  bindings: {},
	  controller: function () {
	    IngredientRiskComponent.$inject = ["LoadingService", "IngredientRiskService", "ToastService"];
	    function IngredientRiskComponent(LoadingService, IngredientRiskService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, IngredientRiskComponent);
	
	      Object.assign(this, {
	        LoadingService: LoadingService,
	        IngredientRiskService: IngredientRiskService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(IngredientRiskComponent, [{
	      key: 'downloadReport',
	      value: function downloadReport() {
	        var _this = this;
	
	        if (this.selectedIngredient) {
	          this.LoadingService.start();
	
	          this.IngredientRiskService.getReport(this.selectedIngredient.SystemIngredientId).then(function () {
	            return _this.ToastService.showSuccess(_messages.INGREDIENT_RISK_REPORT_GENERATED);
	          }).catch(function (error) {
	            return _this.ToastService.showError(error);
	          }).finally(function () {
	            return _this.LoadingService.stop();
	          });
	        }
	      }
	    }, {
	      key: 'selectedIngredientChanged',
	      value: function selectedIngredientChanged(_ref) {
	        var selectedIngredient = _ref.selectedIngredient;
	
	        this.selectedIngredient = selectedIngredient;
	      }
	    }]);
	
	    return IngredientRiskComponent;
	  }()
	};

/***/ },
/* 713 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/ingredient-risk/ingredient-risk.html';
	var html = "<div layout=column> <ingredient-autocomplete ingredient-type=system label-text=\"Search by Ingredient Name\" search-display-property=SystemIngredientName on-ingredient-selected=$ctrl.selectedIngredientChanged($event)> </ingredient-autocomplete> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-disabled=!$ctrl.selectedIngredient ng-click=$ctrl.downloadReport($ctrl.selectedIngredient) aria-label=\"Download Report\"> Download Report </md-button> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _fileSaver = __webpack_require__(715);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IngredientRiskService = function () {
	  IngredientRiskService.$inject = ["$http"];
	  function IngredientRiskService($http) {
	    'ngInject';
	
	    _classCallCheck(this, IngredientRiskService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(IngredientRiskService, [{
	    key: 'getReport',
	    value: function getReport(systemIngredientId) {
	      return this.$http.get('/api/report/ingredient_risk/' + systemIngredientId, { responseType: 'blob' }).then(function (r) {
	        if (r && r.headers('File-Name')) {
	          _fileSaver2.default.saveAs(r.data, r.headers('File-Name'));
	        }
	      });
	    }
	  }]);
	
	  return IngredientRiskService;
	}();
	
	exports.default = IngredientRiskService;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(716) !== null) && (__webpack_require__(717) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 716 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 717 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _reportForm = __webpack_require__(719);
	
	var _reportForm2 = _interopRequireDefault(_reportForm);
	
	__webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.app.reports.reportForm', []).component('reportForm', _reportForm2.default).value('EventEmitter', function (payload) {
	  return { $event: payload };
	}).name;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _odataFilterBuilder = __webpack_require__(441);
	
	var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);
	
	var _query = __webpack_require__(408);
	
	var _reportForm = __webpack_require__(720);
	
	var _reportForm2 = _interopRequireDefault(_reportForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _reportForm2.default,
	  bindings: {
	    onReportGenerated: '&'
	  },
	  controller: function () {
	    ReportFormComponent.$inject = ["EventEmitter", "AnimalTypeService", "CategoryService", "CompanyService", "IngredientService", "ProductService", "ReportService", "SessionService", "ToastService"];
	    function ReportFormComponent(EventEmitter, AnimalTypeService, CategoryService, CompanyService, IngredientService, ProductService, ReportService, SessionService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ReportFormComponent);
	
	      Object.assign(this, {
	        EventEmitter: EventEmitter,
	        AnimalTypeService: AnimalTypeService,
	        CategoryService: CategoryService,
	        CompanyService: CompanyService,
	        IngredientService: IngredientService,
	        ProductService: ProductService,
	        ReportService: ReportService,
	        SessionService: SessionService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(ReportFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        var _this = this;
	
	        this.params = this.SessionService.reportParams || {};
	        this.params.ingredientIds = this.params.ingredientIds || [];
	        this.params.memberIds = this.params.memberIds || [];
	        this.params.productIds = this.params.productIds || [];
	
	        this.CategoryService.search({
	          orderBy: 'ProductCategoryName',
	          direction: 'asc'
	        }).then(function (r) {
	          _this.categories = (0, _query.transformODataResponse)(r).Data;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	
	        this.AnimalTypeService.getAnimalTypes().then(function (r) {
	          _this.animalTypes = r.data;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        });
	
	        this.years = this.ReportService.getYears();
	      }
	    }, {
	      key: 'transformChip',
	      value: function transformChip(chip) {
	        if (_angular2.default.isObject(chip)) {
	          return chip;
	        }
	
	        return { name: chip, type: 'new' };
	      }
	    }, {
	      key: 'searchMembers',
	      value: function searchMembers(memberName) {
	        var _this2 = this;
	
	        return this.CompanyService.search({
	          orderBy: 'MemberName',
	          direction: 'asc',
	          filter: (0, _odataFilterBuilder2.default)().contains('MemberName', memberName)
	        }).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        }).catch(function (error) {
	          return _this2.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'searchProducts',
	      value: function searchProducts(productName) {
	        var _this3 = this;
	
	        return this.ProductService.search({
	          orderBy: 'ProductName',
	          direction: 'asc',
	          filter: (0, _odataFilterBuilder2.default)().contains('ProductName', productName)
	        }).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        }).catch(function (error) {
	          return _this3.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'searchIngredients',
	      value: function searchIngredients(ingredientName) {
	        var _this4 = this;
	
	        return this.IngredientService.searchSystemIngredients({
	          orderBy: 'SystemIngredientName',
	          direction: 'asc',
	          filter: (0, _odataFilterBuilder2.default)().contains('SystemIngredientName', ingredientName)
	        }).then(function (r) {
	          return (0, _query.transformODataResponse)(r).Data;
	        }).catch(function (error) {
	          return _this4.ToastService.showError(error);
	        });
	      }
	    }, {
	      key: 'resetForm',
	      value: function resetForm() {
	        this.reportForm.$setPristine();
	        this.reportForm.$setUntouched();
	        this.params = {};
	        this.params.ingredientIds = [];
	        this.params.memberIds = [];
	        this.params.productIds = [];
	        this.persistParams();
	      }
	    }, {
	      key: 'persistParams',
	      value: function persistParams() {
	        this.SessionService.reportParams = this.params;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit(params) {
	        this.persistParams();
	        this.onReportGenerated(this.EventEmitter({
	          params: _extends({}, params, {
	            ingredientIds: params.ingredientIds && params.ingredientIds.map(function (ingredient) {
	              return ingredient.SystemIngredientId;
	            }) || [],
	            productIds: params.productIds && params.productIds.map(function (product) {
	              return product.ProductId;
	            }) || [],
	            memberIds: params.memberIds && params.memberIds.map(function (product) {
	              return product.MemberId;
	            }) || []
	          })
	        }));
	      }
	    }, {
	      key: 'toggleYears',
	      value: function toggleYears() {
	        if (this.allYearsSelected) {
	          this.allYearsSelected = false;
	          this.params.yearIds = [];
	        } else {
	          this.allYearsSelected = true;
	          this.params.yearIds = this.years;
	        }
	      }
	    }, {
	      key: 'toggleCategories',
	      value: function toggleCategories() {
	        if (this.allCategoriesSelected) {
	          this.allCategoriesSelected = false;
	          this.params.productCategoryIds = [];
	        } else {
	          this.allCategoriesSelected = true;
	          this.params.productCategoryIds = this.categories.map(function (c) {
	            return c.ProductCategoryId;
	          });
	        }
	      }
	    }, {
	      key: 'toggleSpecies',
	      value: function toggleSpecies() {
	        if (this.allSpeciesSelected) {
	          this.allSpeciesSelected = false;
	          this.params.specieIds = [];
	        } else {
	          this.allSpeciesSelected = true;
	          this.params.specieIds = this.animalTypes.map(function (c) {
	            return c.AnimalTypeId;
	          });
	        }
	      }
	    }]);
	
	    return ReportFormComponent;
	  }()
	};

/***/ },
/* 720 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/report-form/report-form.html';
	var html = "<form name=$ctrl.reportForm flex ng-submit=$ctrl.onSubmit($ctrl.params) novalidate> <div layout-gt-sm=row layout=column> <md-input-container class=md-block flex-gt-sm=25> <label>Years</label> <md-select ng-model=$ctrl.params.yearIds multiple=multiple name=years> <md-button class=btn-select-all value=all ng-click=$ctrl.toggleYears()>Select All</md-button> <md-option ng-repeat=\"year in $ctrl.years\" ng-value=year> {{year}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm=25> <label>Categories</label> <md-select ng-model=$ctrl.params.productCategoryIds multiple=multiple name=categories> <md-button class=btn-select-all value=all ng-click=$ctrl.toggleCategories()>Select All</md-button> <md-option ng-repeat=\"category in $ctrl.categories\" ng-value={{category.ProductCategoryId}}> {{category.ProductCategoryName}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm=25> <label>Species</label> <md-select ng-model=$ctrl.params.specieIds multiple=multiple name=animalTypes> <md-button class=btn-select-all value=all ng-click=$ctrl.toggleSpecies()>Select All</md-button> <md-option ng-repeat=\"animalType in $ctrl.animalTypes\" ng-value={{animalType.AnimalTypeId}}> {{animalType.AnimalTypeName}} </md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm=25> <label>Product Status</label> <md-select ng-model=$ctrl.params.discontinuedOption name=productStatus> <md-option value=1 selected=selected>All</md-option> <md-option value=2>Active</md-option> <md-option value=3>Discontinued</md-option> </md-select> </md-input-container> </div> <div layout=column layout-gt-sm=row layout-wrap> <md-chips ng-model=$ctrl.params.productIds md-autocomplete-snap md-require-match=true md-transform-chip=$ctrl.transformChip($chip) flex-gt-sm=100> <md-autocomplete md-search-text=$ctrl.productSearchText md-items=\"item in $ctrl.searchProducts($ctrl.productSearchText)\" md-item-text=item.ProductName placeholder=\"Search for a product\" secondary-placeholder=Products> <span md-highlight-text=$ctrl.productSearchText>{{item.ProductName}}</span> </md-autocomplete> <md-chip-template> <span>{{$chip.ProductName}}</span> </md-chip-template> </md-chips> <md-chips ng-model=$ctrl.params.ingredientIds md-autocomplete-snap md-require-match=true md-transform-chip=$ctrl.transformChip($chip) flex-gt-sm=100> <md-autocomplete md-search-text=$ctrl.ingredientSearchText md-items=\"item in $ctrl.searchIngredients($ctrl.ingredientSearchText)\" md-item-text=item.SystemIngredientName placeholder=\"Search for a system ingredient\" secondary-placeholder=\"System Ingredients\"> <span md-highlight-text=$ctrl.ingredientSearchText>{{item.SystemIngredientName}}</span> </md-autocomplete> <md-chip-template> <span>{{$chip.SystemIngredientName}}</span> </md-chip-template> </md-chips> <md-chips ng-model=$ctrl.params.memberIds md-autocomplete-snap md-require-match=true md-transform-chip=$ctrl.transformChip($chip) flex-gt-sm=100> <md-autocomplete md-search-text=$ctrl.memberSearchText md-items=\"item in $ctrl.searchMembers($ctrl.memberSearchText)\" md-item-text=item.MemberName placeholder=\"Search for a member\" secondary-placeholder=Members> <span md-highlight-text=$ctrl.memberSearchText>{{item.MemberName}}</span> </md-autocomplete> <md-chip-template> <span>{{$chip.MemberName}}</span> </md-chip-template> </md-chips> </div> <div layout=row layout-align=\"end center\"> <md-button class=md-raised type=button ng-disabled=$ctrl.reportForm.$pristine ng-click=$ctrl.resetForm()> Reset Form </md-button> <md-button class=\"md-raised md-accent\" type=submit ng-disabled=!$ctrl.reportForm.$valid> Generate Report </md-button> </div> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 721 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _riskByYear = __webpack_require__(723);
	
	var _riskByYear2 = _interopRequireDefault(_riskByYear);
	
	var _riskByYear3 = __webpack_require__(725);
	
	var _riskByYear4 = _interopRequireDefault(_riskByYear3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.riskByYear', [_angularUiRouter2.default]).component('riskByYear', _riskByYear2.default).service('RiskByYearService', _riskByYear4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('riskByYear', {
	    parent: 'reports',
	    url: '/risk-by-year',
	    component: 'riskByYear',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _riskByYear = __webpack_require__(724);
	
	var _riskByYear2 = _interopRequireDefault(_riskByYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _riskByYear2.default,
	  controller: function () {
	    RiskByYearComponent.$inject = ["$scope", "LoadingService", "RiskByYearService", "ToastService"];
	    function RiskByYearComponent($scope, LoadingService, RiskByYearService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, RiskByYearComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        RiskByYearService: RiskByYearService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(RiskByYearComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = {
	          chart: {
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'Report Rate Per Million Administrations Sold'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'datetime',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
	          },
	          yAxis: [{
	            title: {
	              text: 'Risk (case / million)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }, {
	            title: {
	              text: 'Administrations (mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            opposite: true
	          }],
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          },
	          legend: {
	            layout: 'vertical',
	            align: 'left',
	            x: 100,
	            verticalAlign: 'top',
	            y: 20,
	            floating: true,
	            itemWidth: 180,
	            itemDistance: 0,
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            series: {
	              dataLabels: {
	                enabled: false
	              }
	            },
	            area: {
	              fillOpacity: 0.2,
	              lineColor: '#666666',
	              lineWidth: 1,
	              marker: {
	                enabled: false
	              }
	            }
	          }
	        };
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.RiskByYearService.getReport(params).then(function (series) {
	          _this.chartConfig.series = series;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return RiskByYearComponent;
	  }()
	};

/***/ },
/* 724 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/risk-by-year/risk-by-year.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart config=$ctrl.chartConfig class=naers-report ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 725 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RiskByYearService = function () {
	  RiskByYearService.$inject = ["$http"];
	  function RiskByYearService($http) {
	    'ngInject';
	
	    _classCallCheck(this, RiskByYearService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(RiskByYearService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      return this.$http.get('/api/report/data_a_y_risk', {
	        params: _extends({}, params)
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	
	  return RiskByYearService;
	}();
	
	exports.default = RiskByYearService;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _seriousRiskByYear = __webpack_require__(727);
	
	var _seriousRiskByYear2 = _interopRequireDefault(_seriousRiskByYear);
	
	var _seriousRiskByYear3 = __webpack_require__(729);
	
	var _seriousRiskByYear4 = _interopRequireDefault(_seriousRiskByYear3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.seriousRiskByYear', [_angularUiRouter2.default]).component('seriousRiskByYear', _seriousRiskByYear2.default).service('SeriousRiskByYearService', _seriousRiskByYear4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('seriousRiskByYear', {
	    parent: 'reports',
	    url: '/serious-risk-by-year',
	    component: 'seriousRiskByYear',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _seriousRiskByYear = __webpack_require__(728);
	
	var _seriousRiskByYear2 = _interopRequireDefault(_seriousRiskByYear);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _seriousRiskByYear2.default,
	  controller: function () {
	    SeriousRiskByYearComponent.$inject = ["$scope", "LoadingService", "SeriousRiskByYearService", "ToastService"];
	    function SeriousRiskByYearComponent($scope, LoadingService, SeriousRiskByYearService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, SeriousRiskByYearComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        SeriousRiskByYearService: SeriousRiskByYearService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(SeriousRiskByYearComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = {
	          chart: {
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'Serious AE Report Rate Per Million Administrations Sold'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'datetime',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
	          },
	          yAxis: [{
	            title: {
	              text: 'Risk (case per mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }, {
	            title: {
	              text: 'Administrations (mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            opposite: true
	          }],
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          },
	          legend: {
	            layout: 'vertical',
	            align: 'left',
	            x: 100,
	            verticalAlign: 'top',
	            y: 20,
	            floating: true,
	            itemWidth: 180,
	            itemDistance: 0,
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            series: {
	              dataLabels: {
	                enabled: false
	              }
	            },
	            area: {
	              fillOpacity: 0.2,
	              lineColor: '#666666',
	              lineWidth: 1,
	              marker: {
	                enabled: false
	              }
	            }
	          }
	        };
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.SeriousRiskByYearService.getReport(params).then(function (series) {
	          _this.chartConfig.series = series;
	        }).catch(function (error) {
	          _this.ToastService.showError(error);
	          _this.$scope.$apply();
	        }).finally(function () {
	          return _this.LoadingService.stop();
	        });
	      }
	    }]);
	
	    return SeriousRiskByYearComponent;
	  }()
	};

/***/ },
/* 728 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/serious-risk-by-year/serious-risk-by-year.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart config=$ctrl.chartConfig class=naers-report ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 729 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RiskByYearService = function () {
	  RiskByYearService.$inject = ["$http"];
	  function RiskByYearService($http) {
	    'ngInject';
	
	    _classCallCheck(this, RiskByYearService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(RiskByYearService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      return this.$http.get('/api/report/data_a_y_srisk', {
	        params: _extends({}, params)
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	
	  return RiskByYearService;
	}();
	
	exports.default = RiskByYearService;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(402);
	
	var _systemMetrics = __webpack_require__(731);
	
	var _systemMetrics2 = _interopRequireDefault(_systemMetrics);
	
	var _systemMetrics3 = __webpack_require__(733);
	
	var _systemMetrics4 = _interopRequireDefault(_systemMetrics3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.reports.systemMetrics', [_angularUiRouter2.default]).component('systemMetrics', _systemMetrics2.default).service('SystemMetricsService', _systemMetrics4.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('systemMetrics', {
	    parent: 'reports',
	    url: '/system-metrics',
	    component: 'systemMetrics',
	    data: {
	      permissions: {
	        only: [_roles.SYS_ADMIN],
	        redirectTo: 'dashboard'
	      }
	    }
	  });
	}]).name;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _systemMetrics = __webpack_require__(732);
	
	var _systemMetrics2 = _interopRequireDefault(_systemMetrics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _systemMetrics2.default,
	  controller: function () {
	    SystemMetricsComponent.$inject = ["$scope", "LoadingService", "SystemMetricsService", "ToastService"];
	    function SystemMetricsComponent($scope, LoadingService, SystemMetricsService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, SystemMetricsComponent);
	
	      Object.assign(this, {
	        $scope: $scope,
	        LoadingService: LoadingService,
	        SystemMetricsService: SystemMetricsService,
	        ToastService: ToastService
	      });
	    }
	
	    _createClass(SystemMetricsComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.chartConfig = {
	          chart: {
	            zoomType: 'xy'
	          },
	          title: {
	            text: 'System Metric Report'
	          },
	          subtitle: {
	            text: 'NASC Adverse Event Reporting System'
	          },
	          xAxis: {
	            type: 'datetime',
	            title: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              style: {
	                fontSize: '14px'
	              }
	            },
	            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
	          },
	          yAxis: [{
	            title: {
	              text: 'Administrations (mil)',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[1],
	                fontSize: '14px'
	              }
	            }
	          }, {
	            title: {
	              text: 'Count',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            labels: {
	              format: '{value}',
	              style: {
	                color: window.Highcharts.getOptions().colors[0],
	                fontSize: '14px'
	              }
	            },
	            opposite: true
	          }],
	          tooltip: {
	            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f} </b></td></tr>',
	            footerFormat: '</table>',
	            split: true,
	            useHTML: true
	          },
	          legend: {
	            itemStyle: {
	              fontSize: '14px'
	            }
	          },
	          plotOptions: {
	            series: {
	              dataLabels: {
	                enabled: false
	              }
	            },
	            area: {
	              fillOpacity: 0.2,
	              lineColor: '#666666',
	              lineWidth: 1,
	              marker: {
	                enabled: false
	              }
	            },
	            spline: {
	              marker: {
	                radius: 4,
	                lineColor: '#666666',
	                lineWidth: 1
	              }
	            }
	          }
	        };
	      }
	    }, {
	      key: 'generateReport',
	      value: function generateReport(_ref) {
	        var _this = this;
	
	        var params = _ref.params;
	
	        this.LoadingService.start();
	        this.SystemMetricsService.getReport(params).then(function (series) {
	          _this.chartConfig.series = series;
	        }).catch(function (error) {
	          return _this.ToastService.showError(error);
	        }).finally(function () {
	          _this.LoadingService.stop();
	          _this.$scope.$apply();
	        });
	      }
	    }]);
	
	    return SystemMetricsComponent;
	  }()
	};

/***/ },
/* 732 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/system-metrics/system-metrics.html';
	var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart config=$ctrl.chartConfig class=naers-report ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SystemMetricsService = function () {
	  SystemMetricsService.$inject = ["$http"];
	  function SystemMetricsService($http) {
	    'ngInject';
	
	    _classCallCheck(this, SystemMetricsService);
	
	    Object.assign(this, {
	      $http: $http
	    });
	  }
	
	  _createClass(SystemMetricsService, [{
	    key: 'getReport',
	    value: function getReport(params) {
	      return this.$http.get('/api/report/data_m_y_admin', {
	        params: _extends({}, params)
	      }).then(function (r) {
	        return r.data;
	      });
	    }
	  }]);
	
	  return SystemMetricsService;
	}();
	
	exports.default = SystemMetricsService;

/***/ },
/* 734 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _auth = __webpack_require__(736);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _forgotPassword = __webpack_require__(739);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _login = __webpack_require__(742);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _resetPassword = __webpack_require__(746);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPasswordFrompin = __webpack_require__(750);
	
	var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);
	
	__webpack_require__(754);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.auth', [_angularUiRouter2.default, _forgotPassword2.default, _login2.default, _resetPassword2.default, _resetPasswordFrompin2.default]).component('auth', _auth2.default).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('auth', {
	    url: '/auth',
	    component: 'auth',
	    resolve: {
	      layout: function layout() {
	        return 'column';
	      },
	      flex: function flex() {
	        return '100';
	      }
	    }
	  });
	
	  $urlRouterProvider.otherwise('/auth/login');
	}]).name;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _auth = __webpack_require__(737);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _auth2.default,
	  bindings: {
	    layout: '@',
	    flex: '@'
	  },
	  controller: function () {
	    function AuthComponent() {
	      'ngInject';
	
	      _classCallCheck(this, AuthComponent);
	    }
	
	    _createClass(AuthComponent, [{
	      key: 'getBackgroundImage',
	      value: function getBackgroundImage() {
	        var imagePaths = ['images/background-horse.jpg', 'images/background-dog.jpg', 'images/background-cat.jpg'];
	
	        var randomImage = imagePaths[Math.floor(Math.random() * imagePaths.length)];
	        return randomImage;
	      }
	    }]);
	
	    return AuthComponent;
	  }()
	};

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/auth/auth.html';
	var html = "<md-content md-scroll-y flex layout=column> <div id=login background-image={{::$ctrl.getBackgroundImage()}} flex=noshrink> <section layout=column layout-margin flex-xs=100 flex-offset-sm=10 flex-sm=60 flex-offset-gt-sm=15 flex-md=50 flex-gt-md=35> <div class=welcome> <img src=" + __webpack_require__(738) + " id=naers-logo alt=NAERS> <div class=welcome-text> <header>Welcome to NAERS<sup>&trade;</sup></header> <header>NASC Adverse Event Reporting System</header> </div> </div> <ui-view></ui-view> <span id=siteseal style=text-align:center> <script async src=\"https://seal.godaddy.com/getSeal?sealID=PfHgJsNsFQDL88DKvidH2q0NWIhGQvatBZnhxw8UKQVfkjxcmwmnFHVK0Wk\"></script> </span> </section> </div> </md-content>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a50f17151707b8ee0ebbc151fcf0946e.png";

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _forgotPassword = __webpack_require__(740);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.auth.forgotPassword', [_angularUiRouter2.default]).component('forgotPassword', _forgotPassword2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('forgotPassword', {
	    parent: 'auth',
	    url: '/forgot-password',
	    params: {
	      userName: null
	    },
	    component: 'forgotPassword',
	    resolve: {
	      userName: ["$stateParams", function userName($stateParams) {
	        return $stateParams.userName;
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _forgotPassword = __webpack_require__(741);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _forgotPassword2.default,
	  bindings: {
	    userName: '<'
	  },
	  controller: function () {
	    ForgotPasswordComponent.$inject = ["$state", "AuthService", "ToastService"];
	    function ForgotPasswordComponent($state, AuthService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ForgotPasswordComponent);
	
	      Object.assign(this, { $state: $state, AuthService: AuthService, ToastService: ToastService });
	    }
	
	    _createClass(ForgotPasswordComponent, [{
	      key: '$onInit',
	      value: function $onInit() {}
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        var _this = this;
	
	        try {
	          this.AuthService.forgotPassword(this.userName).then(function () {
	            _this.$state.go('resetPasswordFromPin', { userName: _this.userName });
	          });
	        } catch (e) {
	          this.ToastService.showError();
	        }
	      }
	    }]);
	
	    return ForgotPasswordComponent;
	  }()
	};

/***/ },
/* 741 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/auth/forgot-password/forgot-password.html';
	var html = "<form name=$ctrl.forgotPasswordForm flex=100 ng-submit=$ctrl.onSubmit() novalidate> <md-card class=round flex layout-padding> <p class=md-body-1> To reset your password, please enter your username. An email with a PIN to reset your password will be sent to the email address associated with this user. </p> <md-input-container class=md-block flex> <label>Username</label> <input ng-model=$ctrl.userName name=userName type=text required> <div ng-messages=$ctrl.forgotPasswordForm.userName.$error> <div ng-message=required> Username is required. </div> </div> </md-input-container>  <div layout=row layout-sm=column layout-xs=column layout-align=\"end center\"> <md-button ui-sref=login>Cancel</md-button> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.forgotPasswordForm.$valid>Send Reset PIN</md-button> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(743);
	
	var _login2 = _interopRequireDefault(_login);
	
	__webpack_require__(745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.login', [_angularUiRouter2.default]).component('login', _login2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    parent: 'auth',
	    url: '/login',
	    component: 'login'
	  });
	}]).name;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _login = __webpack_require__(744);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _login2.default,
	  controller: function () {
	    LoginFormComponent.$inject = ["$state", "AuthService", "ToastService"];
	    function LoginFormComponent($state, AuthService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, LoginFormComponent);
	
	      Object.assign(this, { $state: $state, AuthService: AuthService, ToastService: ToastService });
	    }
	
	    _createClass(LoginFormComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.loginEnabled = true;
	        this.loginError = {};
	      }
	    }, {
	      key: 'forgotPassword',
	      value: function forgotPassword() {
	        this.$state.go('forgotPassword', { userName: this.userName });
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        var _this = this;
	
	        this.loginEnabled = false;
	        this.loginError = {};
	        this.AuthService.login({
	          userName: this.userName,
	          password: this.password
	        }).then(function () {
	          _this.$state.go('app');
	        }).catch(function (e) {
	          if (e && e.data && e.data.error_description) {
	            if (e.data.error_description === 'Invalid Credentials') {
	              // const msg = 'The username or password you entered is incorrect.';
	              // this.ToastService.showError(e, msg);
	              _this.loginError.invalidCredentials = true;
	            } else if (e.data.error_description === 'Force Password Reset') {
	              _this.$state.go('resetPassword', { userName: _this.userName });
	            } else {
	              _this.ToastService.showError(e, e.data.error_description);
	            }
	          } else {
	            _this.ToastService.showError(e);
	          }
	
	          _this.loginEnabled = true;
	        });
	      }
	    }]);
	
	    return LoginFormComponent;
	  }()
	};

/***/ },
/* 744 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/auth/login/login.html';
	var html = "<form name=$ctrl.loginForm ng-submit=$ctrl.onSubmit() novalidate> <md-card class=round id=login-form flex layout-padding> <md-input-container class=md-block> <label>Username</label> <md-icon md-font-set=material-icons class=md-primary>person</md-icon> <input ng-model=$ctrl.userName type=text name=userName tabindex=1 ng-change=$ctrl.onLoginChanged() required> <div ng-messages=$ctrl.loginForm.userName.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> </div> </md-input-container> <md-input-container class=md-block> <label>Password</label> <md-icon md-font-set=material-icons class=md-primary>lock</md-icon> <input ng-model=$ctrl.password type=password tabindex=2 name=password ng-change=$ctrl.onLoginChanged() required> <div ng-messages=$ctrl.loginForm.password.$error md-auto-hide=false> <div ng-message=required> Password is required. </div> </div> </md-input-container> <span ng-if=$ctrl.loginError.invalidCredentials class=\"md-caption login-error\"> The username or password you entered is incorrect. </span> <div layout=row layout-sm=column layout-xs=column layout-align=\"end center\"> <md-button ng-click=$ctrl.forgotPassword() tabindex=4>Forgot password?</md-button> <md-button class=\"md-raised md-accent\" aria-label=\"Log In\" type=submit tabindex=3 ng-disabled=\"!$ctrl.loginForm.$valid || !$ctrl.loginEnabled\">Log In</md-button> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 745 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _resetPassword = __webpack_require__(747);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _resetPassword3 = __webpack_require__(748);
	
	var _resetPassword4 = _interopRequireDefault(_resetPassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.auth.resetPassword', [_angularUiRouter2.default]).component('resetPassword', _resetPassword4.default).service('ResetPasswordService', _resetPassword2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('resetPassword', {
	    parent: 'auth',
	    url: '/reset-password',
	    params: {
	      userName: null
	    },
	    component: 'resetPassword',
	    resolve: {
	      layout: function layout() {
	        return 'column';
	      },
	      flex: function flex() {
	        return '100';
	      },
	      credentials: ["$stateParams", function credentials($stateParams) {
	        return {
	          UserName: $stateParams.userName
	        };
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 747 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResetPasswordService = function () {
	  ResetPasswordService.$inject = ["$http"];
	  function ResetPasswordService($http) {
	    'ngInject';
	
	    _classCallCheck(this, ResetPasswordService);
	
	    this.$http = $http;
	  }
	
	  _createClass(ResetPasswordService, [{
	    key: 'changePassword',
	    value: function changePassword(credentials) {
	      return this.$http.post('/api/account/password_reset', credentials);
	    }
	  }]);
	
	  return ResetPasswordService;
	}();
	
	exports.default = ResetPasswordService;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messages = __webpack_require__(442);
	
	var _resetPassword = __webpack_require__(749);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _resetPassword2.default,
	  bindings: {
	    credentials: '<'
	  },
	  controller: function () {
	    ResetPasswordComponent.$inject = ["$state", "ResetPasswordService", "ToastService"];
	    function ResetPasswordComponent($state, ResetPasswordService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ResetPasswordComponent);
	
	      Object.assign(this, { $state: $state, ResetPasswordService: ResetPasswordService, ToastService: ToastService });
	    }
	
	    _createClass(ResetPasswordComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.resetInvalidPasswordMessage();
	      }
	    }, {
	      key: 'resetInvalidPasswordMessage',
	      value: function resetInvalidPasswordMessage() {
	        this.invalidNewPassword = false;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        var _this = this;
	
	        this.invalidNewPassword = false;
	        this.ResetPasswordService.changePassword(_extends({}, this.credentials)).then(function () {
	          _this.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
	          _this.$state.go('login');
	        }).catch(function (error) {
	          if (error && error.data && error.data.Message) {
	            if (error.data.Message === 'Invalid New Password') {
	              _this.invalidNewPassword = true;
	            }
	          } else {
	            _this.ToastService.showError(error);
	          }
	        });
	      }
	    }]);
	
	    return ResetPasswordComponent;
	  }()
	};

/***/ },
/* 749 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/auth/reset-password/reset-password.html';
	var html = "<form name=$ctrl.resetPasswordForm flex=100 ng-submit=$ctrl.onSubmit() novalidate> <md-card class=round flex layout-padding> <p class=md-body-1 style=text-align:center> Your password has expired. Please reset it to login. </p> <md-input-container class=md-block flex=100> <label>Username</label> <input ng-model=$ctrl.credentials.UserName name=userName type=text required> <div ng-messages=$ctrl.resetPasswordForm.userName.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Current Password</label> <input ng-model=$ctrl.credentials.OldPassword name=currentPassword type=password required> <div ng-messages=$ctrl.resetPasswordForm.currentPassword.$error md-auto-hide=false> <div ng-message=required> Current password is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>New Password</label> <input ng-model=$ctrl.credentials.NewPassword name=newPassword ng-change=$ctrl.resetInvalidPasswordMessage() type=password required strong-password compare-to-not-equal=$ctrl.credentials.OldPassword> <div ng-messages=$ctrl.resetPasswordForm.newPassword.$error md-auto-hide=false> <div ng-message=required> New password is required. </div> <div ng-message=strongPassword> Password must be at least eight characters long, containing at least one uppercase character, one lowercase character, and one digit (0-9). </div> <div ng-message=compareToNotEqual> New password must not match the old password. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Confirm Password</label> <input ng-model=$ctrl.credentials.NewPasswordConfirm name=newPasswordConfirm ng-change=$ctrl.resetInvalidPasswordMessage() type=password required compare-to=$ctrl.credentials.NewPassword> <div ng-messages=$ctrl.resetPasswordForm.newPasswordConfirm.$error md-auto-hide=false> <div ng-message=required> Password confirmation is required. </div> <div ng-message=compareTo> Password confirmation must match new password. </div> </div> </md-input-container> <span ng-if=$ctrl.invalidNewPassword class=\"md-caption login-error\"> Your new password is invalid. Please choose a different password. </span> <div layout=row layout-sm=column layout-xs=column layout-align=\"end center\"> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.resetPasswordForm.$valid>Submit</md-button> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(302);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _resetPasswordFrompin = __webpack_require__(751);
	
	var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);
	
	var _resetPasswordFrompin3 = __webpack_require__(752);
	
	var _resetPasswordFrompin4 = _interopRequireDefault(_resetPasswordFrompin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('components.auth.resetPasswordFromPin', [_angularUiRouter2.default]).component('resetPasswordFromPin', _resetPasswordFrompin4.default).service('ResetPasswordFromPinService', _resetPasswordFrompin2.default).config(["$stateProvider", function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('resetPasswordFromPin', {
	    parent: 'auth',
	    url: '/reset-password-frompin',
	    params: {
	      userName: null
	    },
	    component: 'resetPasswordFromPin',
	    resolve: {
	      layout: function layout() {
	        return 'column';
	      },
	      flex: function flex() {
	        return '100';
	      },
	      credentials: ["$stateParams", function credentials($stateParams) {
	        return {
	          UserName: $stateParams.userName
	        };
	      }]
	    }
	  });
	}]).name;

/***/ },
/* 751 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ResetPasswordFromPinService = function () {
	  ResetPasswordFromPinService.$inject = ["$http"];
	  function ResetPasswordFromPinService($http) {
	    'ngInject';
	
	    _classCallCheck(this, ResetPasswordFromPinService);
	
	    this.$http = $http;
	  }
	
	  _createClass(ResetPasswordFromPinService, [{
	    key: 'changePasswordFromPin',
	    value: function changePasswordFromPin(credentials) {
	      return this.$http.post('/api/account/password_reset_from_pin', credentials);
	    }
	  }]);
	
	  return ResetPasswordFromPinService;
	}();
	
	exports.default = ResetPasswordFromPinService;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _messages = __webpack_require__(442);
	
	var _resetPasswordFrompin = __webpack_require__(753);
	
	var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	  templateUrl: _resetPasswordFrompin2.default,
	  bindings: {
	    credentials: '<'
	  },
	  controller: function () {
	    ResetPasswordFromPinComponent.$inject = ["$state", "ResetPasswordFromPinService", "ToastService"];
	    function ResetPasswordFromPinComponent($state, ResetPasswordFromPinService, ToastService) {
	      'ngInject';
	
	      _classCallCheck(this, ResetPasswordFromPinComponent);
	
	      Object.assign(this, { $state: $state, ResetPasswordFromPinService: ResetPasswordFromPinService, ToastService: ToastService });
	    }
	
	    _createClass(ResetPasswordFromPinComponent, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.resetErrorMessages();
	      }
	    }, {
	      key: 'resetErrorMessages',
	      value: function resetErrorMessages() {
	        this.invalidUsername = false;
	        this.invalidNewPassword = false;
	        this.invalidPIN = false;
	        this.expiredPIN = false;
	      }
	    }, {
	      key: 'onSubmit',
	      value: function onSubmit() {
	        var _this = this;
	
	        this.invalidUsername = false;
	        this.invalidNewPassword = false;
	        this.invalidPIN = false;
	        this.expiredPIN = false;
	        this.ResetPasswordFromPinService.changePasswordFromPin(_extends({}, this.credentials)).then(function () {
	          _this.ToastService.showSuccess(_messages.PASSWORD_RESET);
	          _this.$state.go('login');
	        }).catch(function (error) {
	          if (error && error.data && error.data.Message) {
	            if (error.data.Message === 'Invalid New Password') {
	              _this.invalidNewPassword = true;
	            } else if (error.data.Message === 'Invalid PIN') {
	              _this.invalidPIN = true;
	            } else if (error.data.Message === 'Expired PIN') {
	              _this.expiredPIN = true;
	            }
	          } else if (error && error.statusText === 'Not Found') {
	            _this.invalidUsername = true;
	          } else {
	            _this.ToastService.showError(error);
	          }
	        });
	      }
	    }]);
	
	    return ResetPasswordFromPinComponent;
	  }()
	};

/***/ },
/* 753 */
/***/ function(module, exports) {

	var path = 'C:/Projects/repos/NAERS-Web/src/components/auth/reset-password-frompin/reset-password-frompin.html';
	var html = "<form name=$ctrl.resetPasswordFromPinForm flex=100 ng-submit=$ctrl.onSubmit() novalidate> <md-card class=round flex layout-padding> <p class=md-body-1 style=text-align:center> Please enter the PIN emailed to you and set your new password. </p> <md-input-container class=md-block flex=100> <label>Username</label> <input ng-model=$ctrl.credentials.UserName name=userName type=text required> <div ng-messages=$ctrl.resetPasswordFromPinForm.userName.$error md-auto-hide=false> <div ng-message=required> Username is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Password Reset PIN (emailed to you)</label> <input ng-model=$ctrl.credentials.PasswordResetPIN name=passwordResetPIN required> <div ng-messages=$ctrl.resetPasswordFromPinForm.passwordResetPIN.$error md-auto-hide=false> <div ng-message=required> Password Reset PIN is required. </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>New Password</label> <input ng-model=$ctrl.credentials.NewPassword name=newPassword ng-change=$ctrl.resetInvalidPasswordMessage() type=password required> <div ng-messages=$ctrl.resetPasswordFromPinForm.newPassword.$error md-auto-hide=false> <div ng-message=required> New password is required. </div> <div ng-message=strongPassword> Password must be at least eight characters long, containing at least one uppercase character, one lowercase character, and one digit (0-9). </div> </div> </md-input-container> <md-input-container class=md-block flex=100> <label>Confirm Password</label> <input ng-model=$ctrl.credentials.NewPasswordConfirm name=newPasswordConfirm ng-change=$ctrl.resetInvalidPasswordMessage() type=password required compare-to=$ctrl.credentials.NewPassword> <div ng-messages=$ctrl.resetPasswordFromPinForm.newPasswordConfirm.$error md-auto-hide=false> <div ng-message=required> Password confirmation is required. </div> <div ng-message=compareTo> Password confirmation must match new password. </div> </div> </md-input-container> <span ng-if=$ctrl.invalidUsername class=\"md-caption login-error\"> The username is invalid. Please enter the username emailed to you. </span> <span ng-if=$ctrl.invalidNewPassword class=\"md-caption login-error\"> Your new password is invalid. Please choose a different password. </span> <span ng-if=$ctrl.invalidPIN class=\"md-caption login-error\"> The PIN you entered does not match the PIN sent to you. </span> <span ng-if=$ctrl.expiredPIN class=\"md-caption login-error\"> The password reset PIN has expired. Please use Forgot Password to request a new one. </span> <div layout=row layout-sm=column layout-xs=column layout-align=\"end center\"> <md-button ui-sref=login>Cancel</md-button> <md-button type=submit class=\"md-raised md-accent\" ng-disabled=!$ctrl.resetPasswordFromPinForm.$valid>Reset Password</md-button> </div> </md-card> </form>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },
/* 754 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 755 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/* eslint-disable quote-props */
	exports.default = ["$mdThemingProvider", function ($mdThemingProvider) {
	  'ngInject';
	
	  var customPrimary = {
	    '50': '#085796',
	    '100': '#0965ae',
	    '200': '#0b72c6',
	    '300': '#0c80df',
	    '400': '#128ef2',
	    '500': '#2a99f4',
	    '600': '#5ab1f6',
	    '700': '#72bcf8',
	    '800': '#8bc8f9',
	    '900': '#a3d3fa',
	    'A100': '#5ab1f6',
	    'A200': '#42A5F5',
	    'A400': '#2a99f4',
	    'A700': '#bbdffb'
	  };
	
	  $mdThemingProvider.definePalette('customPrimary', customPrimary);
	
	  var customAccent = {
	    '50': '#7c6808',
	    '100': '#947c0a',
	    '200': '#ac900b',
	    '300': '#c4a40d',
	    '400': '#dbb80f',
	    '500': '#efca14',
	    '600': '#f3d444',
	    '700': '#f4da5c',
	    '800': '#f6df74',
	    '900': '#f7e58c',
	    'A100': '#f3d444',
	    'A200': '#F1CF2C',
	    'A400': '#efca14',
	    'A700': '#f9eaa4'
	  };
	
	  $mdThemingProvider.definePalette('customAccent', customAccent);
	
	  var customWarn = {
	    '50': '#fcd3c3',
	    '100': '#fac1ab',
	    '200': '#f9b092',
	    '300': '#f89e7a',
	    '400': '#f68d62',
	    '500': '#F57B4A',
	    '600': '#f46932',
	    '700': '#f2581a',
	    '800': '#e64b0d',
	    '900': '#ce430b',
	    'A100': '#fde5db',
	    'A200': '#fef6f3',
	    'A400': '#ffffff',
	    'A700': '#b53b0a'
	  };
	
	  $mdThemingProvider.definePalette('customWarn', customWarn);
	
	  $mdThemingProvider.theme('default').primaryPalette('customPrimary').accentPalette('customAccent').warnPalette('customWarn');
	
	  /* Note that theming is diabled for performance reasons. The output CSS
	  has been captured and copied to sass/material-theme.css. The resulting output
	  will be loaded via ExtractTextPlugin in the production webpack build.
	  */
	  $mdThemingProvider.disableTheming();
	}];

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var environment = __webpack_require__(397);
	
	var HttpInterceptor = function () {
	  _createClass(HttpInterceptor, null, [{
	    key: 'factory',
	
	    /* @ngInject */
	    value: ["$q", "$state", "SessionService", function factory($q, $state, SessionService) {
	      return new HttpInterceptor($q, $state, SessionService);
	    }]
	  }]);
	
	  function HttpInterceptor($q, $state, SessionService) {
	    var _this = this;
	
	    _classCallCheck(this, HttpInterceptor);
	
	    Object.assign(this, { $q: $q, $state: $state, SessionService: SessionService });
	
	    this.request = function (config) {
	      if (config.url.indexOf('api') !== -1 || config.url.indexOf('token') !== -1 || config.url.indexOf('odata') !== -1) {
	        config.url = '' + environment.baseUrl + config.url;
	      }
	
	      config.headers = config.headers || {};
	      config.timeout = 60000;
	      var token = _this.SessionService.authToken;
	
	      if (token) {
	        config.headers.Authorization = 'Bearer ' + token;
	      }
	
	      return config;
	    };
	
	    // TODO: implement 401 redirect when not on login page
	    this.responseError = function (rejection) {
	      if (rejection.status === 401) {
	        _this.SessionService.destroy();
	        _this.$state.go('login');
	      }
	
	      return _this.$q.reject(rejection);
	    };
	  }
	
	  return HttpInterceptor;
	}();
	
	/* @ngInject */
	
	
	exports.default = function ($httpProvider) {
	  $httpProvider.defaults.headers.delete = { 'Content-Type': 'application/json' };
	  $httpProvider.defaults.useXDomain = true;
	  $httpProvider.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
	  delete $httpProvider.defaults.headers.common['X-Requested-With'];
	  $httpProvider.interceptors.push(HttpInterceptor.factory);
	};
	exports.default.$inject = ["$httpProvider"];

/***/ },
/* 757 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable no-restricted-syntax */
	/* eslint-disable no-cond-assign */
	/* eslint-disable no-continue */
	/* eslint-disable consistent-return */
	
	// Crude datetime pattern match.. can't use ISO8601 because service
	// is also returning some numeric values, e.g. usage data, as strings
	// eslint-disable-next-line no-useless-escape
	var pattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{3})?$/;
	
	var convertDateStringsToDates = function convertDateStringsToDates(input) {
	  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') return input;
	
	  for (var key in input) {
	    if (!Object.prototype.hasOwnProperty.call(input, key)) continue;
	
	    var value = input[key];
	    var match = void 0;
	
	    if (typeof value === 'string' && (match = value.match(pattern))) {
	      // Date string is one day off when converted to date object, below code forces fix
	      var d = new Date(match[0]);
	      input[key] = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
	    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      convertDateStringsToDates(value);
	    }
	  }
	};
	
	/* @ngInject */
	
	exports.default = function ($httpProvider) {
	  $httpProvider.defaults.transformResponse.push(function (response) {
	    convertDateStringsToDates(response);
	    return response;
	  });
	};
	exports.default.$inject = ["$httpProvider"];

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	configurePermissions.$inject = ["AuthService", "PermPermissionStore", "PermRoleStore"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configurePermissions;
	
	var _roles = __webpack_require__(402);
	
	function configurePermissions(AuthService, PermPermissionStore, PermRoleStore) {
	  'ngInject';
	
	  PermRoleStore.defineRole(_roles.ANONYMOUS, function () {
	    return !AuthService.isLoggedIn;
	  });
	  // eslint-disable-next-line max-len
	  PermRoleStore.defineRole(_roles.USER, function () {
	    return AuthService.isLoggedIn && !AuthService.isCompanyAdmin && !AuthService.isSysAdmin && !AuthService.isRegulator;
	  });
	  PermRoleStore.defineRole(_roles.REGULATOR, function () {
	    return AuthService.isRegulator;
	  });
	  PermRoleStore.defineRole(_roles.REGULATOR_ADMIN, function () {
	    return AuthService.isRegulatorAdmin;
	  });
	  PermRoleStore.defineRole(_roles.COMPANY_ADMIN, function () {
	    return AuthService.isCompanyAdmin;
	  });
	  PermRoleStore.defineRole(_roles.SYS_ADMIN, function () {
	    return AuthService.isSysAdmin;
	  });
	}

/***/ },
/* 759 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
]);


// WEBPACK FOOTER //
// bundle.c7376181024b4c467384.js